/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from "@graphql-typed-document-node/core";
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T
> = { [_ in K]?: never };
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never;
    };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  /** An ISO 8601-encoded date */
  ISO8601Date: { input: any; output: any };
  /** An ISO 8601-encoded datetime */
  ISO8601DateTime: { input: any; output: any };
  /** Represents untyped JSON */
  JSON: { input: any; output: any };
};

export type AdministrationTeam = Team & {
  __typename?: "AdministrationTeam";
  id: Scalars["ID"]["output"];
  members: Array<User>;
  name: Scalars["String"]["output"];
};

export type Apartment = RecordInterface & {
  __typename?: "Apartment";
  activeServiceCasesCount: Scalars["Int"]["output"];
  address: Scalars["String"]["output"];
  archived?: Maybe<Scalars["Boolean"]["output"]>;
  availableFieldGroups: Array<FieldGroup>;
  canUpdate: Scalars["Boolean"]["output"];
  cases: CaseList;
  city: Scalars["String"]["output"];
  createdAt: Scalars["ISO8601DateTime"]["output"];
  currentTenancy?: Maybe<Tenancy>;
  documents?: Maybe<Array<Document>>;
  fieldGroups: Array<ApartmentFieldGroup>;
  id: Scalars["ID"]["output"];
  inactive?: Maybe<Scalars["Boolean"]["output"]>;
  inactiveDescription?: Maybe<Scalars["String"]["output"]>;
  inactiveEndDate?: Maybe<Scalars["String"]["output"]>;
  inactiveStartDate?: Maybe<Scalars["String"]["output"]>;
  key?: Maybe<Scalars["String"]["output"]>;
  messages: MessageList;
  nextTenancy?: Maybe<Tenancy>;
  occupancy: Array<Tenancy>;
  postalCode: Scalars["String"]["output"];
  previousTenancy?: Maybe<Tenancy>;
  property: Property;
  publicId: Scalars["String"]["output"];
  tenancies: TenancyList;
  tenancy?: Maybe<Tenancy>;
  updatedAt: Scalars["ISO8601DateTime"]["output"];
};

export type ApartmentCasesArgs = {
  orderBy?: InputMaybe<CaseOrderByEnum>;
  where?: InputMaybe<CaseWhereInput>;
};

export type ApartmentMessagesArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<MessageOrderByEnum>;
  where?: InputMaybe<MessageWhereInput>;
};

export type ApartmentOccupancyArgs = {
  within: AvailableWithinInput;
};

export type ApartmentTenancyArgs = {
  id: Scalars["ID"]["input"];
};

export type ApartmentFieldGroup = {
  __typename?: "ApartmentFieldGroup";
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
  position: Scalars["Int"]["output"];
  values: Array<FieldValue>;
};

export type ApartmentList = {
  __typename?: "ApartmentList";
  availability: Array<Availability>;
  count: Scalars["Int"]["output"];
  records: Array<Apartment>;
  total: Scalars["Int"]["output"];
};

export type ApartmentListAvailabilityArgs = {
  within: AvailableWithinInput;
};

export enum ApartmentOrderByEnum {
  AddressAsc = "address_ASC",
  AddressDesc = "address_DESC",
  CityAsc = "city_ASC",
  CityDesc = "city_DESC",
  CurrentTenantCprAsc = "currentTenantCpr_ASC",
  CurrentTenantCprDesc = "currentTenantCpr_DESC",
  CurrentTenantDepositAmountAsc = "currentTenantDepositAmount_ASC",
  CurrentTenantDepositAmountDesc = "currentTenantDepositAmount_DESC",
  CurrentTenantDepositDueDateAsc = "currentTenantDepositDueDate_ASC",
  CurrentTenantDepositDueDateDesc = "currentTenantDepositDueDate_DESC",
  CurrentTenantEmailAsc = "currentTenantEmail_ASC",
  CurrentTenantEmailDesc = "currentTenantEmail_DESC",
  CurrentTenantEndDateAsc = "currentTenantEndDate_ASC",
  CurrentTenantEndDateDesc = "currentTenantEndDate_DESC",
  CurrentTenantNameAsc = "currentTenantName_ASC",
  CurrentTenantNameDesc = "currentTenantName_DESC",
  CurrentTenantPhoneAsc = "currentTenantPhone_ASC",
  CurrentTenantPhoneDesc = "currentTenantPhone_DESC",
  CurrentTenantRequestedEndDateAsc = "currentTenantRequestedEndDate_ASC",
  CurrentTenantRequestedEndDateDesc = "currentTenantRequestedEndDate_DESC",
  CurrentTenantStartDateAsc = "currentTenantStartDate_ASC",
  CurrentTenantStartDateDesc = "currentTenantStartDate_DESC",
  KeyAsc = "key_ASC",
  KeyDesc = "key_DESC",
  NextTenantCprAsc = "nextTenantCpr_ASC",
  NextTenantCprDesc = "nextTenantCpr_DESC",
  NextTenantDepositAmountAsc = "nextTenantDepositAmount_ASC",
  NextTenantDepositAmountDesc = "nextTenantDepositAmount_DESC",
  NextTenantDepositDueDateAsc = "nextTenantDepositDueDate_ASC",
  NextTenantDepositDueDateDesc = "nextTenantDepositDueDate_DESC",
  NextTenantEmailAsc = "nextTenantEmail_ASC",
  NextTenantEmailDesc = "nextTenantEmail_DESC",
  NextTenantEndDateAsc = "nextTenantEndDate_ASC",
  NextTenantEndDateDesc = "nextTenantEndDate_DESC",
  NextTenantNameAsc = "nextTenantName_ASC",
  NextTenantNameDesc = "nextTenantName_DESC",
  NextTenantPhoneAsc = "nextTenantPhone_ASC",
  NextTenantPhoneDesc = "nextTenantPhone_DESC",
  NextTenantRequestedEndDateAsc = "nextTenantRequestedEndDate_ASC",
  NextTenantRequestedEndDateDesc = "nextTenantRequestedEndDate_DESC",
  NextTenantStartDateAsc = "nextTenantStartDate_ASC",
  NextTenantStartDateDesc = "nextTenantStartDate_DESC",
  OwnerAsc = "owner_ASC",
  OwnerDesc = "owner_DESC",
  PreviousTenantCprAsc = "previousTenantCpr_ASC",
  PreviousTenantCprDesc = "previousTenantCpr_DESC",
  PreviousTenantDepositAmountAsc = "previousTenantDepositAmount_ASC",
  PreviousTenantDepositAmountDesc = "previousTenantDepositAmount_DESC",
  PreviousTenantDepositDueDateAsc = "previousTenantDepositDueDate_ASC",
  PreviousTenantDepositDueDateDesc = "previousTenantDepositDueDate_DESC",
  PreviousTenantEmailAsc = "previousTenantEmail_ASC",
  PreviousTenantEmailDesc = "previousTenantEmail_DESC",
  PreviousTenantEndDateAsc = "previousTenantEndDate_ASC",
  PreviousTenantEndDateDesc = "previousTenantEndDate_DESC",
  PreviousTenantNameAsc = "previousTenantName_ASC",
  PreviousTenantNameDesc = "previousTenantName_DESC",
  PreviousTenantPhoneAsc = "previousTenantPhone_ASC",
  PreviousTenantPhoneDesc = "previousTenantPhone_DESC",
  PreviousTenantRequestedEndDateAsc = "previousTenantRequestedEndDate_ASC",
  PreviousTenantRequestedEndDateDesc = "previousTenantRequestedEndDate_DESC",
  PreviousTenantStartDateAsc = "previousTenantStartDate_ASC",
  PreviousTenantStartDateDesc = "previousTenantStartDate_DESC",
  PropertyAsc = "property_ASC",
  PropertyDesc = "property_DESC",
  PublicIdAsc = "publicId_ASC",
  PublicIdDesc = "publicId_DESC",
}

export enum ApartmentStatusEnum {
  Active = "active",
  Archived = "archived",
}

/** Autogenerated return type of ApartmentUpdateMutation. */
export type ApartmentUpdateMutationPayload = {
  __typename?: "ApartmentUpdateMutationPayload";
  apartment?: Maybe<Apartment>;
  errors: Array<Scalars["String"]["output"]>;
};

export type ApartmentWhereInput = {
  activeCases?: InputMaybe<Scalars["Boolean"]["input"]>;
  byArchived?: InputMaybe<Scalars["Boolean"]["input"]>;
  byAvailableWithin?: InputMaybe<AvailableWithinInput>;
  byOwner?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  byProperty?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  byStatus?: InputMaybe<Array<ApartmentStatusEnum>>;
  search?: InputMaybe<Scalars["String"]["input"]>;
};

export type AttachmentCategory = {
  __typename?: "AttachmentCategory";
  createdAt: Scalars["ISO8601DateTime"]["output"];
  id: Scalars["ID"]["output"];
  nameDa: Scalars["String"]["output"];
  nameEn: Scalars["String"]["output"];
  updatedAt: Scalars["ISO8601DateTime"]["output"];
};

export type Availability = {
  __typename?: "Availability";
  apartmentId: Scalars["ID"]["output"];
  from?: Maybe<Scalars["ISO8601Date"]["output"]>;
  to?: Maybe<Scalars["ISO8601Date"]["output"]>;
};

export type AvailableResponsibleTeam = {
  __typename?: "AvailableResponsibleTeam";
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
  users: Array<CaseUser>;
};

export type AvailableWithinInput = {
  minDays?: InputMaybe<Scalars["Int"]["input"]>;
  periodEnd?: InputMaybe<Scalars["ISO8601Date"]["input"]>;
  periodStart: Scalars["ISO8601Date"]["input"];
  slack?: InputMaybe<Scalars["Int"]["input"]>;
};

export type BankAccount = {
  __typename?: "BankAccount";
  account?: Maybe<Scalars["String"]["output"]>;
  bankName?: Maybe<Scalars["String"]["output"]>;
  reg?: Maybe<Scalars["String"]["output"]>;
};

export type BaseInspectionInput = {
  caseId: Scalars["ID"]["input"];
  cleaning?: InputMaybe<Scalars["String"]["input"]>;
  keys: Array<CaseInspectionKeyInput>;
  landlordSignature?: InputMaybe<Scalars["String"]["input"]>;
  meterReadings: Array<CaseInspectionMeterReadingInput>;
  other?: InputMaybe<Scalars["String"]["input"]>;
  tenantSignature?: InputMaybe<Scalars["String"]["input"]>;
};

export type Case = RecordInterface & {
  __typename?: "Case";
  apartment?: Maybe<Apartment>;
  attention: CaseAttentionEnum;
  awaiting?: Maybe<Scalars["String"]["output"]>;
  calendarDate?: Maybe<Scalars["String"]["output"]>;
  calendarRange: DateRange;
  children: Array<Case>;
  company?: Maybe<Company>;
  completeBefore?: Maybe<Scalars["String"]["output"]>;
  createdAt: Scalars["ISO8601DateTime"]["output"];
  icon: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  inspection?: Maybe<Inspection>;
  name: Scalars["String"]["output"];
  parent?: Maybe<Case>;
  property?: Maybe<Property>;
  requester?: Maybe<User>;
  responsible?: Maybe<User>;
  scheduledDate?: Maybe<Scalars["String"]["output"]>;
  scheduledTime?: Maybe<Scalars["String"]["output"]>;
  shortName: Scalars["String"]["output"];
  startAfter?: Maybe<Scalars["String"]["output"]>;
  state: Scalars["String"]["output"];
  stateLastChangedAt?: Maybe<Scalars["ISO8601DateTime"]["output"]>;
  stateText: Scalars["String"]["output"];
  tenancy?: Maybe<Tenancy>;
  tenantWillAttend?: Maybe<Scalars["Boolean"]["output"]>;
  type: CaseTypeEnum;
  updatedAt: Scalars["ISO8601DateTime"]["output"];
};

export type CaseApplicationInput = {
  comment?: InputMaybe<Scalars["String"]["input"]>;
  endDate?: InputMaybe<Scalars["ISO8601Date"]["input"]>;
  leaveDate?: InputMaybe<Scalars["ISO8601Date"]["input"]>;
};

export type CaseAttachment = {
  __typename?: "CaseAttachment";
  category?: Maybe<AttachmentCategory>;
  createdAt: Scalars["ISO8601DateTime"]["output"];
  fileName: Scalars["String"]["output"];
  fileSize: Scalars["Int"]["output"];
  fileType: Scalars["String"]["output"];
  headSignedUrl: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  isImage: Scalars["Boolean"]["output"];
  isPdf: Scalars["Boolean"]["output"];
  largeUrl: Scalars["String"]["output"];
  originalUrl: Scalars["String"]["output"];
  thumbUrl: Scalars["String"]["output"];
};

export type CaseAttentionCondition = {
  __typename?: "CaseAttentionCondition";
  texts: Array<Scalars["String"]["output"]>;
};

export enum CaseAttentionEnum {
  Critical = "critical",
  Important = "important",
  Normal = "normal",
  Success = "success",
}

export type CaseCheck = RecordInterface & {
  __typename?: "CaseCheck";
  case: Case;
  createdAt: Scalars["ISO8601DateTime"]["output"];
  id: Scalars["ID"]["output"];
  label: Scalars["String"]["output"];
  type: Scalars["String"]["output"];
  updatedAt: Scalars["ISO8601DateTime"]["output"];
  value?: Maybe<Scalars["Boolean"]["output"]>;
};

export type CaseCheckInput = {
  _destroy?: InputMaybe<Scalars["Boolean"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  label?: InputMaybe<Scalars["String"]["input"]>;
};

export type CaseComment = {
  __typename?: "CaseComment";
  assets: Array<File>;
  createdAt: Scalars["ISO8601DateTime"]["output"];
  emailMessage: Scalars["Boolean"]["output"];
  id: Scalars["ID"]["output"];
  important: Scalars["Boolean"]["output"];
  mayReply: Scalars["Boolean"]["output"];
  message: Scalars["String"]["output"];
  readAt?: Maybe<Scalars["ISO8601DateTime"]["output"]>;
  recipient?: Maybe<User>;
  sender: User;
  smsMessage: Scalars["Boolean"]["output"];
  stateDescription: Scalars["String"]["output"];
  stateFrom?: Maybe<Scalars["String"]["output"]>;
  stateTo?: Maybe<Scalars["String"]["output"]>;
  subject?: Maybe<Scalars["String"]["output"]>;
  type: CaseCommentTypeEnum;
};

/** Autogenerated return type of CaseCommentReadMutation. */
export type CaseCommentReadMutationPayload = {
  __typename?: "CaseCommentReadMutationPayload";
  errors: Array<Scalars["String"]["output"]>;
};

export enum CaseCommentTypeEnum {
  /** Cancelled */
  Cancelled = "CANCELLED",
  /** Comment */
  Comment = "COMMENT",
  /** Completed */
  Completed = "COMPLETED",
  /** Created */
  Created = "CREATED",
  /** Message */
  Message = "MESSAGE",
  /** Share Created */
  ShareCreated = "SHARE_CREATED",
  /** Share Revoked */
  ShareRevoked = "SHARE_REVOKED",
  /** Share Sent */
  ShareSent = "SHARE_SENT",
  /** State Changed */
  StateChanged = "STATE_CHANGED",
}

export type CaseCommentUserOption = {
  __typename?: "CaseCommentUserOption";
  id: Scalars["ID"]["output"];
  label: Scalars["String"]["output"];
};

export type CaseContractAttributesInput = {
  apartment?: InputMaybe<Scalars["String"]["input"]>;
  endDate?: InputMaybe<Scalars["ISO8601Date"]["input"]>;
  endTenancyTerms?: InputMaybe<Scalars["String"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  residents?: InputMaybe<Array<CaseContractResidentInput>>;
  startDate?: InputMaybe<Scalars["ISO8601Date"]["input"]>;
  tenancyRoles?: InputMaybe<Array<CaseContractRoleInput>>;
  type?: InputMaybe<Scalars["String"]["input"]>;
};

export type CaseContractResidentInput = {
  email?: InputMaybe<Scalars["String"]["input"]>;
  name: Scalars["String"]["input"];
  phone?: InputMaybe<Scalars["String"]["input"]>;
};

export type CaseContractRole = {
  __typename?: "CaseContractRole";
  email?: Maybe<Scalars["String"]["output"]>;
  primary: Scalars["Boolean"]["output"];
};

export type CaseContractRoleInput = {
  email: Scalars["String"]["input"];
  primary: Scalars["Boolean"]["input"];
};

export type CaseContractSettings = {
  __typename?: "CaseContractSettings";
  apartment?: Maybe<Scalars["String"]["output"]>;
  endDate?: Maybe<Scalars["ISO8601Date"]["output"]>;
  endTenancyTerms?: Maybe<EndTenancyTermsEnum>;
  locale?: Maybe<ContractLocaleEnum>;
  residents: Array<Resident>;
  startDate?: Maybe<Scalars["ISO8601Date"]["output"]>;
  tenancyRoles: Array<CaseContractRole>;
  type?: Maybe<ContractTypeEnum>;
};

/** Autogenerated return type of CaseCreateMutation. */
export type CaseCreateMutationPayload = {
  __typename?: "CaseCreateMutationPayload";
  errors: Array<Scalars["String"]["output"]>;
  result?: Maybe<CaseInterface>;
};

export type CaseDataAttributesInput = {
  contractAttributes?: InputMaybe<CaseContractAttributesInput>;
  depositAmount?: InputMaybe<Scalars["Int"]["input"]>;
  economic?: InputMaybe<CaseEconomicInput>;
  intervalAmount?: InputMaybe<Scalars["Int"]["input"]>;
  signatures?: InputMaybe<CaseSignaturesInput>;
  startDate?: InputMaybe<Scalars["ISO8601Date"]["input"]>;
  terminationAttributes?: InputMaybe<CaseDataTerminationAttributesInput>;
};

export type CaseDataTerminationAttributesInput = {
  endDate?: InputMaybe<Scalars["ISO8601Date"]["input"]>;
};

export type CaseDefinition = {
  __typename?: "CaseDefinition";
  canCreate: Scalars["Boolean"]["output"];
  cases: CaseList;
  icon: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
  states: Array<Scalars["String"]["output"]>;
  type: CaseTypeEnum;
};

export type CaseDefinitionCasesArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<CaseOrderByEnum>;
  where?: InputMaybe<CaseWhereInput>;
};

export type CaseEconomicInput = {
  debtor?: InputMaybe<Scalars["ID"]["input"]>;
};

/** Autogenerated return type of CaseEndTenancyUpdateReasonsMutation. */
export type CaseEndTenancyUpdateReasonsMutationPayload = {
  __typename?: "CaseEndTenancyUpdateReasonsMutationPayload";
  errors: Array<Scalars["String"]["output"]>;
  result?: Maybe<CaseInterface>;
};

export enum CaseEventEnum {
  AddAttachment = "add_attachment",
  AddComment = "add_comment",
  AddFollower = "add_follower",
  AddTimelog = "add_timelog",
  Await = "await",
  Cancel = "cancel",
  CancelContract = "cancel_contract",
  CancelScheduled = "cancel_scheduled",
  ChangeContract = "change_contract",
  ChangeEndDate = "change_end_date",
  ChangeResponsible = "change_responsible",
  ChangeServiceTeam = "change_service_team",
  ChangeTask = "change_task",
  Complete = "complete",
  CompleteInspection = "complete_inspection",
  ConfigureRepeat = "configure_repeat",
  Create = "create",
  CreateContract = "create_contract",
  LandlordSignContract = "landlord_sign_contract",
  PopulateContract = "populate_contract",
  ProcessInspection = "process_inspection",
  Receive = "receive",
  RemoveAttachment = "remove_attachment",
  RemoveFollower = "remove_follower",
  Reopen = "reopen",
  RequestTenantInformation = "request_tenant_information",
  Reschedule = "reschedule",
  SaveInspection = "save_inspection",
  Schedule = "schedule",
  SendContract = "send_contract",
  SendTenantInformation = "send_tenant_information",
  Start = "start",
  TenantSignContract = "tenant_sign_contract",
  TenantWillAttendNo = "tenant_will_attend_no",
  TenantWillAttendYes = "tenant_will_attend_yes",
  ToggleCheck = "toggle_check",
  UpdateAttachment = "update_attachment",
  UpdateEconomic = "update_economic",
}

export type CaseEventInput = {
  addFollowerId?: InputMaybe<Scalars["ID"]["input"]>;
  applicationAttributes?: InputMaybe<CaseApplicationInput>;
  attachTenant?: InputMaybe<Scalars["Boolean"]["input"]>;
  attachmentAsset?: InputMaybe<Scalars["String"]["input"]>;
  attachmentCategoryId?: InputMaybe<Scalars["ID"]["input"]>;
  attachmentRemove?: InputMaybe<Scalars["ID"]["input"]>;
  attachmentUpdateIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  awaiting?: InputMaybe<Scalars["ISO8601Date"]["input"]>;
  cancelledMessage?: InputMaybe<Scalars["String"]["input"]>;
  checkToggleId?: InputMaybe<Scalars["ID"]["input"]>;
  checksAttributes?: InputMaybe<Array<CaseCheckInput>>;
  commentAssets?: InputMaybe<Array<Scalars["String"]["input"]>>;
  commentImportant?: InputMaybe<Scalars["String"]["input"]>;
  commentMessage?: InputMaybe<Scalars["String"]["input"]>;
  commentRecipientId?: InputMaybe<Scalars["ID"]["input"]>;
  completeBefore?: InputMaybe<Scalars["ISO8601Date"]["input"]>;
  completedDate?: InputMaybe<Scalars["ISO8601Date"]["input"]>;
  contractData?: InputMaybe<Scalars["JSON"]["input"]>;
  dataAttributes?: InputMaybe<CaseDataAttributesInput>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  endTenancyReasonIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  endTenancyReasonNotes?: InputMaybe<Scalars["JSON"]["input"]>;
  removeFollowerId?: InputMaybe<Scalars["ID"]["input"]>;
  repeatPeriod?: InputMaybe<Scalars["String"]["input"]>;
  repeatResponsible?: InputMaybe<Scalars["Boolean"]["input"]>;
  repeatSteps?: InputMaybe<Scalars["Int"]["input"]>;
  responsibleId?: InputMaybe<Scalars["ID"]["input"]>;
  scheduledDate?: InputMaybe<Scalars["ISO8601Date"]["input"]>;
  scheduledTime?: InputMaybe<Scalars["String"]["input"]>;
  serviceTeamId?: InputMaybe<Scalars["ID"]["input"]>;
  startAfter?: InputMaybe<Scalars["ISO8601Date"]["input"]>;
  template?: InputMaybe<Scalars["ID"]["input"]>;
  timelogAccountId?: InputMaybe<Scalars["ID"]["input"]>;
  timelogCategoryId?: InputMaybe<Scalars["ID"]["input"]>;
  timelogDate?: InputMaybe<Scalars["ISO8601Date"]["input"]>;
  timelogHoursWithoutMinutes?: InputMaybe<Scalars["Int"]["input"]>;
  timelogMinutesWithoutHours?: InputMaybe<Scalars["Int"]["input"]>;
  timelogNote?: InputMaybe<Scalars["String"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
};

export type CaseInspectionKeyInput = {
  count: Scalars["Int"]["input"];
  description: Scalars["String"]["input"];
  keyId?: InputMaybe<Scalars["Int"]["input"]>;
  keyMissing?: InputMaybe<Scalars["Int"]["input"]>;
};

export type CaseInspectionMeterReadingInput = {
  id: Scalars["ID"]["input"];
  value: Scalars["Float"]["input"];
};

/** Autogenerated return type of CaseInspectionProcessMutation. */
export type CaseInspectionProcessMutationPayload = {
  __typename?: "CaseInspectionProcessMutationPayload";
  errors: Array<Scalars["String"]["output"]>;
  result?: Maybe<CaseInterface>;
};

/** Autogenerated return type of CaseInspectionSaveMutation. */
export type CaseInspectionSaveMutationPayload = {
  __typename?: "CaseInspectionSaveMutationPayload";
  errors: Array<Scalars["String"]["output"]>;
  result?: Maybe<CaseInterface>;
};

export type CaseInterface = {
  apartment?: Maybe<Apartment>;
  archivedAt?: Maybe<Scalars["ISO8601DateTime"]["output"]>;
  archivedBy?: Maybe<CaseUser>;
  assignableServiceTeams: Array<ServiceTeam>;
  attachments: Array<CaseAttachment>;
  attention: CaseAttentionEnum;
  availableFollowers: Array<CaseUser>;
  availableResponsibleTeams: Array<AvailableResponsibleTeam>;
  availableResponsibleUsers: Array<CaseUser>;
  availableTeams: Array<Team>;
  availableTimelogAccounts: Array<TimelogAccount>;
  awaiting?: Maybe<Scalars["String"]["output"]>;
  body: Scalars["String"]["output"];
  calendarDate?: Maybe<Scalars["String"]["output"]>;
  calendarRange: DateRange;
  canAddAttachment: Scalars["Boolean"]["output"];
  canAddComment: Scalars["Boolean"]["output"];
  canAddFollower: Scalars["Boolean"]["output"];
  canAddTimelog: Scalars["Boolean"]["output"];
  canAwait: Scalars["Boolean"]["output"];
  canCancel: Scalars["Boolean"]["output"];
  canChangeResponsible: Scalars["Boolean"]["output"];
  canComplete: Scalars["Boolean"]["output"];
  canConfigureRepeat: Scalars["Boolean"]["output"];
  canRemoveAttachment: Scalars["Boolean"]["output"];
  canRemoveFollower: Scalars["Boolean"]["output"];
  canReopen: Scalars["Boolean"]["output"];
  canSendCommentAsSms: Scalars["Boolean"]["output"];
  canShare: Scalars["Boolean"]["output"];
  canShowAttention: Scalars["Boolean"]["output"];
  canShowTimelogs: Scalars["Boolean"]["output"];
  canToggleCheck: Scalars["Boolean"]["output"];
  canUpdate: Scalars["Boolean"]["output"];
  cancelledMessage?: Maybe<Scalars["String"]["output"]>;
  checks?: Maybe<Array<CaseCheck>>;
  commentUsers: Array<CaseCommentUserOption>;
  comments: Array<CaseComment>;
  company?: Maybe<Company>;
  completeBefore?: Maybe<Scalars["String"]["output"]>;
  completed?: Maybe<Scalars["Boolean"]["output"]>;
  completedDate?: Maybe<Scalars["ISO8601DateTime"]["output"]>;
  createdAt: Scalars["ISO8601DateTime"]["output"];
  displayName: Scalars["String"]["output"];
  flaggedByCurrentUser: Scalars["Boolean"]["output"];
  followers: Array<Follower>;
  icon: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  inspected?: Maybe<Scalars["Boolean"]["output"]>;
  inspection?: Maybe<Inspection>;
  isArchived: Scalars["Boolean"]["output"];
  isAttending?: Maybe<Scalars["Boolean"]["output"]>;
  isService: Scalars["Boolean"]["output"];
  mayAddAttachment: Scalars["Boolean"]["output"];
  mayAddComment: Scalars["Boolean"]["output"];
  mayAddFollower: Scalars["Boolean"]["output"];
  mayAddTimelog: Scalars["Boolean"]["output"];
  mayAwait: Scalars["Boolean"]["output"];
  mayCancel: Scalars["Boolean"]["output"];
  mayChangeResponsible: Scalars["Boolean"]["output"];
  mayComplete: Scalars["Boolean"]["output"];
  mayConfigureRepeat: Scalars["Boolean"]["output"];
  mayCreate: Scalars["Boolean"]["output"];
  mayRemoveAttachment: Scalars["Boolean"]["output"];
  mayRemoveFollower: Scalars["Boolean"]["output"];
  mayReopen: Scalars["Boolean"]["output"];
  mayToggleCheck: Scalars["Boolean"]["output"];
  name: Scalars["String"]["output"];
  parent?: Maybe<CaseInterface>;
  processing?: Maybe<Scalars["Boolean"]["output"]>;
  property?: Maybe<Property>;
  repeatPeriod?: Maybe<Scalars["String"]["output"]>;
  repeatResponsible: Scalars["Boolean"]["output"];
  repeatSteps?: Maybe<Scalars["Int"]["output"]>;
  repeating: Scalars["Boolean"]["output"];
  requester?: Maybe<User>;
  responsible?: Maybe<CaseUser>;
  scheduledDate?: Maybe<Scalars["String"]["output"]>;
  scheduledTime?: Maybe<Scalars["String"]["output"]>;
  serviceDate?: Maybe<Scalars["ISO8601Date"]["output"]>;
  serviceEmployee?: Maybe<Scalars["String"]["output"]>;
  serviceTeam?: Maybe<ServiceTeam>;
  serviceTime?: Maybe<Scalars["String"]["output"]>;
  shareableDocuments: Array<Document>;
  shares: Array<CaseShare>;
  shortName: Scalars["String"]["output"];
  startAfter?: Maybe<Scalars["String"]["output"]>;
  state: Scalars["String"]["output"];
  stateLastChangedAt?: Maybe<Scalars["ISO8601DateTime"]["output"]>;
  stateText: Scalars["String"]["output"];
  tenancy?: Maybe<Tenancy>;
  tenantMayAttend: Scalars["Boolean"]["output"];
  tenantWillAttend?: Maybe<Scalars["Boolean"]["output"]>;
  timelogAccount?: Maybe<TimelogAccount>;
  timelogs: Array<Timelog>;
  title: Scalars["String"]["output"];
  titleRaw?: Maybe<Scalars["String"]["output"]>;
  totalCommentsCount: Scalars["Int"]["output"];
  type: CaseTypeEnum;
  unreadCommentsCount: Scalars["Int"]["output"];
  updatedAt: Scalars["ISO8601DateTime"]["output"];
  whyAttention: Array<CaseAttentionCondition>;
};

export type CaseInterfaceAvailableTeamsArgs = {
  forAssignment?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type CaseInterfaceCommentsArgs = {
  commentTypes?: InputMaybe<Array<CaseCommentTypeEnum>>;
};

export type CaseList = {
  __typename?: "CaseList";
  count: Scalars["Int"]["output"];
  records: Array<CaseInterface>;
  total: Scalars["Int"]["output"];
};

export enum CaseOrderByEnum {
  ApartmentPublicIdAsc = "apartmentPublicId_ASC",
  ApartmentPublicIdDesc = "apartmentPublicId_DESC",
  ApartmentAsc = "apartment_ASC",
  ApartmentDesc = "apartment_DESC",
  AwaitingAsc = "awaiting_ASC",
  AwaitingDesc = "awaiting_DESC",
  CompleteBeforeAsc = "completeBefore_ASC",
  CompleteBeforeDesc = "completeBefore_DESC",
  CreatedAtAsc = "createdAt_ASC",
  CreatedAtDesc = "createdAt_DESC",
  IdAsc = "id_ASC",
  IdDesc = "id_DESC",
  OwnerAsc = "owner_ASC",
  OwnerDesc = "owner_DESC",
  PropertyAsc = "property_ASC",
  PropertyDesc = "property_DESC",
  RequesterAsc = "requester_ASC",
  RequesterDesc = "requester_DESC",
  ScheduledDateAsc = "scheduledDate_ASC",
  ScheduledDateDesc = "scheduledDate_DESC",
  ServiceTeamAsc = "serviceTeam_ASC",
  ServiceTeamDesc = "serviceTeam_DESC",
  StartAfterAsc = "startAfter_ASC",
  StartAfterDesc = "startAfter_DESC",
  StateAsc = "state_ASC",
  StateDesc = "state_DESC",
  TenancyEndDateAsc = "tenancyEndDate_ASC",
  TenancyEndDateDesc = "tenancyEndDate_DESC",
  TenancyStartDateAsc = "tenancyStartDate_ASC",
  TenancyStartDateDesc = "tenancyStartDate_DESC",
  TypeAsc = "type_ASC",
  TypeDesc = "type_DESC",
  UpdatedAtAsc = "updatedAt_ASC",
  UpdatedAtDesc = "updatedAt_DESC",
}

/** Autogenerated return type of CasePlanningUpdateMutation. */
export type CasePlanningUpdateMutationPayload = {
  __typename?: "CasePlanningUpdateMutationPayload";
  errors: Array<Scalars["String"]["output"]>;
  result?: Maybe<CaseInterface>;
};

/** Autogenerated return type of CaseScheduleMutation. */
export type CaseScheduleMutationPayload = {
  __typename?: "CaseScheduleMutationPayload";
  errors: Array<Scalars["String"]["output"]>;
  result?: Maybe<CaseInterface>;
};

export type CaseShare = {
  __typename?: "CaseShare";
  createdAt: Scalars["ISO8601DateTime"]["output"];
  deliveries: Array<CaseShareDelivery>;
  description: Scalars["String"]["output"];
  expiresAt: Scalars["ISO8601DateTime"]["output"];
  id: Scalars["ID"]["output"];
  isActive: Scalars["Boolean"]["output"];
  note: Scalars["String"]["output"];
  openedAt: Array<Scalars["ISO8601DateTime"]["output"]>;
  revokedAt?: Maybe<Scalars["ISO8601DateTime"]["output"]>;
  selection: CaseShareSelection;
  url: Scalars["String"]["output"];
};

export enum CaseShareChannelEnum {
  /** Email */
  Email = "EMAIL",
  /** SMS */
  Sms = "SMS",
}

/** Autogenerated return type of CaseShareCreateMutation. */
export type CaseShareCreateMutationPayload = {
  __typename?: "CaseShareCreateMutationPayload";
  errors: Array<Scalars["String"]["output"]>;
  result?: Maybe<CaseShare>;
};

export type CaseShareDelivery = {
  __typename?: "CaseShareDelivery";
  channel: CaseShareChannelEnum;
  recipient: Scalars["String"]["output"];
  sentAt: Scalars["ISO8601DateTime"]["output"];
};

export type CaseShareGroup = {
  __typename?: "CaseShareGroup";
  all: Scalars["Boolean"]["output"];
  fieldIds: Array<Scalars["ID"]["output"]>;
  id: Scalars["ID"]["output"];
};

export type CaseShareGroupInput = {
  all?: InputMaybe<Scalars["Boolean"]["input"]>;
  fieldIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  id: Scalars["ID"]["input"];
};

export type CaseShareGroups = {
  __typename?: "CaseShareGroups";
  apartment: Array<CaseShareGroup>;
  property: Array<CaseShareGroup>;
};

export type CaseShareGroupsInput = {
  apartment?: InputMaybe<Array<CaseShareGroupInput>>;
  property?: InputMaybe<Array<CaseShareGroupInput>>;
};

export type CaseShareItems = {
  __typename?: "CaseShareItems";
  all: Scalars["Boolean"]["output"];
  ids: Array<Scalars["ID"]["output"]>;
};

export type CaseShareItemsInput = {
  all?: InputMaybe<Scalars["Boolean"]["input"]>;
  ids?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

/** Autogenerated return type of CaseShareRevokeMutation. */
export type CaseShareRevokeMutationPayload = {
  __typename?: "CaseShareRevokeMutationPayload";
  errors: Array<Scalars["String"]["output"]>;
  result?: Maybe<CaseShare>;
};

export type CaseShareSelection = {
  __typename?: "CaseShareSelection";
  apartment: Scalars["Boolean"]["output"];
  attachments: CaseShareItems;
  case: Scalars["Boolean"]["output"];
  comments: Scalars["Boolean"]["output"];
  documents: CaseShareItems;
  fieldGroups: CaseShareGroups;
  inspection: Scalars["Boolean"]["output"];
  property: Scalars["Boolean"]["output"];
  tenant: Scalars["Boolean"]["output"];
};

export type CaseShareSelectionInput = {
  apartment?: InputMaybe<Scalars["Boolean"]["input"]>;
  attachments?: InputMaybe<CaseShareItemsInput>;
  case?: InputMaybe<Scalars["Boolean"]["input"]>;
  comments?: InputMaybe<Scalars["Boolean"]["input"]>;
  documents?: InputMaybe<CaseShareItemsInput>;
  fieldGroups?: InputMaybe<CaseShareGroupsInput>;
  inspection?: InputMaybe<Scalars["Boolean"]["input"]>;
  property?: InputMaybe<Scalars["Boolean"]["input"]>;
  tenant?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** Autogenerated return type of CaseShareSendMutation. */
export type CaseShareSendMutationPayload = {
  __typename?: "CaseShareSendMutationPayload";
  errors: Array<Scalars["String"]["output"]>;
  result?: Maybe<CaseShare>;
};

export type CaseSignature = {
  __typename?: "CaseSignature";
  signature?: Maybe<Scalars["String"]["output"]>;
  signedAt: Scalars["ISO8601Date"]["output"];
  signedBy?: Maybe<Scalars["String"]["output"]>;
  signerRole: Scalars["String"]["output"];
};

export type CaseSignaturesInput = {
  landlordSignature: Scalars["String"]["input"];
};

export enum CaseTypeEnum {
  CleaningService = "cleaning_service",
  CreateTenancy = "create_tenancy",
  EndTenancy = "end_tenancy",
  FindTenancyAdministration = "find_tenancy_administration",
  MiscAdministration = "misc_administration",
  MiscService = "misc_service",
  MovingInService = "moving_in_service",
  MovingInTenancy = "moving_in_tenancy",
  MovingOutService = "moving_out_service",
  MovingOutTenancy = "moving_out_tenancy",
  MovingSettlementAdministration = "moving_settlement_administration",
  PreparationService = "preparation_service",
  RequestTenancy = "request_tenancy",
  StartTenancy = "start_tenancy",
  UtilityAdministration = "utility_administration",
}

/** Autogenerated return type of CaseUpdateMutation. */
export type CaseUpdateMutationPayload = {
  __typename?: "CaseUpdateMutationPayload";
  errors: Array<Scalars["String"]["output"]>;
  result?: Maybe<CaseInterface>;
};

export type CaseUser = {
  __typename?: "CaseUser";
  email: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
  phone?: Maybe<Scalars["String"]["output"]>;
  protected: Scalars["Boolean"]["output"];
};

export type CaseWhereAndInput = {
  and?: InputMaybe<Array<CaseWhereAndInput>>;
  archived?: InputMaybe<Scalars["Boolean"]["input"]>;
  awaiting?: InputMaybe<Scalars["Boolean"]["input"]>;
  byAttention?: InputMaybe<CaseAttentionEnum>;
  byState?: InputMaybe<Array<Scalars["String"]["input"]>>;
  byType?: InputMaybe<Array<Scalars["String"]["input"]>>;
  cancelled?: InputMaybe<Scalars["Boolean"]["input"]>;
  completed?: InputMaybe<Scalars["Boolean"]["input"]>;
  or?: InputMaybe<Array<CaseWhereOrInput>>;
  unplanned?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type CaseWhereInput = {
  allForCurrentUser?: InputMaybe<Scalars["Boolean"]["input"]>;
  and?: InputMaybe<Array<CaseWhereAndInput>>;
  archived?: InputMaybe<Scalars["Boolean"]["input"]>;
  awaiting?: InputMaybe<Scalars["Boolean"]["input"]>;
  awaitingForCurrentUser?: InputMaybe<Scalars["Boolean"]["input"]>;
  byApartment?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  byAssignedServiceTeam?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  byAttention?: InputMaybe<CaseAttentionEnum>;
  byParent?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  byProperty?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  byRequester?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  byResponsible?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  byServiceTeam?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  byState?: InputMaybe<Array<Scalars["String"]["input"]>>;
  byType?: InputMaybe<Array<Scalars["String"]["input"]>>;
  calendarDateRange?: InputMaybe<DateRangeInput>;
  cancelled?: InputMaybe<Scalars["Boolean"]["input"]>;
  commentsForCurrentUser?: InputMaybe<Scalars["Boolean"]["input"]>;
  completed?: InputMaybe<Scalars["Boolean"]["input"]>;
  criticalForCurrentUser?: InputMaybe<Scalars["Boolean"]["input"]>;
  flaggedForCurrentUser?: InputMaybe<Scalars["Boolean"]["input"]>;
  importantForCurrentUser?: InputMaybe<Scalars["Boolean"]["input"]>;
  newForCurrentUser?: InputMaybe<Scalars["Boolean"]["input"]>;
  notAwaitingForCurrentUser?: InputMaybe<Scalars["Boolean"]["input"]>;
  or?: InputMaybe<Array<CaseWhereOrInput>>;
  search?: InputMaybe<Scalars["String"]["input"]>;
  unplanned?: InputMaybe<Scalars["Boolean"]["input"]>;
  withActiveShares?: InputMaybe<Scalars["Boolean"]["input"]>;
  withTenancy?: InputMaybe<Scalars["Boolean"]["input"]>;
  withoutResponsible?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type CaseWhereOrInput = {
  and?: InputMaybe<Array<CaseWhereAndInput>>;
  archived?: InputMaybe<Scalars["Boolean"]["input"]>;
  awaiting?: InputMaybe<Scalars["Boolean"]["input"]>;
  byAttention?: InputMaybe<CaseAttentionEnum>;
  byState?: InputMaybe<Array<Scalars["String"]["input"]>>;
  byType?: InputMaybe<Array<Scalars["String"]["input"]>>;
  cancelled?: InputMaybe<Scalars["Boolean"]["input"]>;
  completed?: InputMaybe<Scalars["Boolean"]["input"]>;
  or?: InputMaybe<Array<CaseWhereOrInput>>;
  unplanned?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type CleaningService = CaseInterface & {
  __typename?: "CleaningService";
  apartment?: Maybe<Apartment>;
  archivedAt?: Maybe<Scalars["ISO8601DateTime"]["output"]>;
  archivedBy?: Maybe<CaseUser>;
  assignableServiceTeams: Array<ServiceTeam>;
  attachments: Array<CaseAttachment>;
  attention: CaseAttentionEnum;
  availableFollowers: Array<CaseUser>;
  availableResponsibleTeams: Array<AvailableResponsibleTeam>;
  availableResponsibleUsers: Array<CaseUser>;
  availableTeams: Array<Team>;
  availableTimelogAccounts: Array<TimelogAccount>;
  awaiting?: Maybe<Scalars["String"]["output"]>;
  body: Scalars["String"]["output"];
  calendarDate?: Maybe<Scalars["String"]["output"]>;
  calendarRange: DateRange;
  canAddAttachment: Scalars["Boolean"]["output"];
  canAddComment: Scalars["Boolean"]["output"];
  canAddFollower: Scalars["Boolean"]["output"];
  canAddTimelog: Scalars["Boolean"]["output"];
  canAwait: Scalars["Boolean"]["output"];
  canCancel: Scalars["Boolean"]["output"];
  canCancelScheduled: Scalars["Boolean"]["output"];
  canChangeResponsible: Scalars["Boolean"]["output"];
  canChangeServiceTeam: Scalars["Boolean"]["output"];
  canChangeTask: Scalars["Boolean"]["output"];
  canComplete: Scalars["Boolean"]["output"];
  canConfigureRepeat: Scalars["Boolean"]["output"];
  canReceive: Scalars["Boolean"]["output"];
  canRemoveAttachment: Scalars["Boolean"]["output"];
  canRemoveFollower: Scalars["Boolean"]["output"];
  canReopen: Scalars["Boolean"]["output"];
  canReschedule: Scalars["Boolean"]["output"];
  canSchedule: Scalars["Boolean"]["output"];
  canSendCommentAsSms: Scalars["Boolean"]["output"];
  canShare: Scalars["Boolean"]["output"];
  canShowAttention: Scalars["Boolean"]["output"];
  canShowTimelogs: Scalars["Boolean"]["output"];
  canTenantWillAttendNo: Scalars["Boolean"]["output"];
  canTenantWillAttendYes: Scalars["Boolean"]["output"];
  canToggleCheck: Scalars["Boolean"]["output"];
  canUpdate: Scalars["Boolean"]["output"];
  cancelledMessage?: Maybe<Scalars["String"]["output"]>;
  checks?: Maybe<Array<CaseCheck>>;
  commentUsers: Array<CaseCommentUserOption>;
  comments: Array<CaseComment>;
  company?: Maybe<Company>;
  completeBefore?: Maybe<Scalars["String"]["output"]>;
  completed?: Maybe<Scalars["Boolean"]["output"]>;
  completedDate?: Maybe<Scalars["ISO8601DateTime"]["output"]>;
  createdAt: Scalars["ISO8601DateTime"]["output"];
  displayName: Scalars["String"]["output"];
  flaggedByCurrentUser: Scalars["Boolean"]["output"];
  followers: Array<Follower>;
  icon: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  inspected?: Maybe<Scalars["Boolean"]["output"]>;
  inspection?: Maybe<Inspection>;
  isArchived: Scalars["Boolean"]["output"];
  isAttending?: Maybe<Scalars["Boolean"]["output"]>;
  isService: Scalars["Boolean"]["output"];
  mayAddAttachment: Scalars["Boolean"]["output"];
  mayAddComment: Scalars["Boolean"]["output"];
  mayAddFollower: Scalars["Boolean"]["output"];
  mayAddTimelog: Scalars["Boolean"]["output"];
  mayAwait: Scalars["Boolean"]["output"];
  mayCancel: Scalars["Boolean"]["output"];
  mayCancelScheduled: Scalars["Boolean"]["output"];
  mayChangeResponsible: Scalars["Boolean"]["output"];
  mayChangeServiceTeam: Scalars["Boolean"]["output"];
  mayChangeTask: Scalars["Boolean"]["output"];
  mayComplete: Scalars["Boolean"]["output"];
  mayConfigureRepeat: Scalars["Boolean"]["output"];
  mayCreate: Scalars["Boolean"]["output"];
  mayReceive: Scalars["Boolean"]["output"];
  mayRemoveAttachment: Scalars["Boolean"]["output"];
  mayRemoveFollower: Scalars["Boolean"]["output"];
  mayReopen: Scalars["Boolean"]["output"];
  mayReschedule: Scalars["Boolean"]["output"];
  maySchedule: Scalars["Boolean"]["output"];
  mayTenantWillAttendNo: Scalars["Boolean"]["output"];
  mayTenantWillAttendYes: Scalars["Boolean"]["output"];
  mayToggleCheck: Scalars["Boolean"]["output"];
  name: Scalars["String"]["output"];
  parent?: Maybe<CaseInterface>;
  processing?: Maybe<Scalars["Boolean"]["output"]>;
  property?: Maybe<Property>;
  repeatPeriod?: Maybe<Scalars["String"]["output"]>;
  repeatResponsible: Scalars["Boolean"]["output"];
  repeatSteps?: Maybe<Scalars["Int"]["output"]>;
  repeating: Scalars["Boolean"]["output"];
  requester?: Maybe<User>;
  responsible?: Maybe<CaseUser>;
  scheduledDate?: Maybe<Scalars["String"]["output"]>;
  scheduledTime?: Maybe<Scalars["String"]["output"]>;
  serviceDate?: Maybe<Scalars["ISO8601Date"]["output"]>;
  serviceEmployee?: Maybe<Scalars["String"]["output"]>;
  serviceTeam?: Maybe<ServiceTeam>;
  serviceTime?: Maybe<Scalars["String"]["output"]>;
  shareableDocuments: Array<Document>;
  shares: Array<CaseShare>;
  shortName: Scalars["String"]["output"];
  startAfter?: Maybe<Scalars["String"]["output"]>;
  state: Scalars["String"]["output"];
  stateLastChangedAt?: Maybe<Scalars["ISO8601DateTime"]["output"]>;
  stateText: Scalars["String"]["output"];
  tenancy?: Maybe<Tenancy>;
  tenantMayAttend: Scalars["Boolean"]["output"];
  tenantWillAttend?: Maybe<Scalars["Boolean"]["output"]>;
  timelogAccount?: Maybe<TimelogAccount>;
  timelogs: Array<Timelog>;
  title: Scalars["String"]["output"];
  titleRaw?: Maybe<Scalars["String"]["output"]>;
  totalCommentsCount: Scalars["Int"]["output"];
  type: CaseTypeEnum;
  unreadCommentsCount: Scalars["Int"]["output"];
  updatedAt: Scalars["ISO8601DateTime"]["output"];
  whyAttention: Array<CaseAttentionCondition>;
};

export type CleaningServiceAvailableTeamsArgs = {
  forAssignment?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type CleaningServiceCommentsArgs = {
  commentTypes?: InputMaybe<Array<CaseCommentTypeEnum>>;
};

export type Company = RecordInterface & {
  __typename?: "Company";
  address?: Maybe<Scalars["String"]["output"]>;
  city?: Maybe<Scalars["String"]["output"]>;
  createdAt: Scalars["ISO8601DateTime"]["output"];
  email?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  isAdministrator: Scalars["Boolean"]["output"];
  isOwner: Scalars["Boolean"]["output"];
  name: Scalars["String"]["output"];
  phone?: Maybe<Scalars["String"]["output"]>;
  postalCode?: Maybe<Scalars["String"]["output"]>;
  updatedAt: Scalars["ISO8601DateTime"]["output"];
  vat?: Maybe<Scalars["String"]["output"]>;
};

export type CompanyList = {
  __typename?: "CompanyList";
  count: Scalars["Int"]["output"];
  records: Array<Company>;
  total: Scalars["Int"]["output"];
};

export enum CompanyOrderByEnum {
  AddressAsc = "address_ASC",
  AddressDesc = "address_DESC",
  CityAsc = "city_ASC",
  CityDesc = "city_DESC",
  EmailAsc = "email_ASC",
  EmailDesc = "email_DESC",
  NameAsc = "name_ASC",
  NameDesc = "name_DESC",
  PhoneAsc = "phone_ASC",
  PhoneDesc = "phone_DESC",
  VatAsc = "vat_ASC",
  VatDesc = "vat_DESC",
}

export type CompanyWhereByPropertyServiceInput = {
  property: Scalars["ID"]["input"];
  service: Scalars["String"]["input"];
};

export type CompanyWhereInput = {
  administrators?: InputMaybe<Scalars["Boolean"]["input"]>;
  byPropertyService?: InputMaybe<CompanyWhereByPropertyServiceInput>;
  search?: InputMaybe<Scalars["String"]["input"]>;
};

export enum ContractFieldTypeEnum {
  Boolean = "boolean",
  Date = "date",
  Datetime = "datetime",
  Float = "float",
  Integer = "integer",
  String = "string",
}

export type ContractForm = {
  __typename?: "ContractForm";
  sections: Array<ContractFormSection>;
  type: Scalars["String"]["output"];
};

export type ContractFormCondition = {
  __typename?: "ContractFormCondition";
  field: Scalars["String"]["output"];
  is: Scalars["String"]["output"];
};

export type ContractFormField = {
  __typename?: "ContractFormField";
  computed?: Maybe<Scalars["JSON"]["output"]>;
  condition?: Maybe<ContractFormCondition>;
  currency: Scalars["Boolean"]["output"];
  follows?: Maybe<Scalars["String"]["output"]>;
  label?: Maybe<Scalars["String"]["output"]>;
  multiline: Scalars["Boolean"]["output"];
  name: Scalars["String"]["output"];
  options: Array<ContractFormOption>;
  readonly: Scalars["Boolean"]["output"];
  required: Scalars["Boolean"]["output"];
  requiredWhen?: Maybe<ContractFormCondition>;
  suffix?: Maybe<Scalars["String"]["output"]>;
  type: ContractFieldTypeEnum;
};

export type ContractFormOption = {
  __typename?: "ContractFormOption";
  label?: Maybe<Scalars["String"]["output"]>;
  value: Scalars["String"]["output"];
};

export type ContractFormSection = {
  __typename?: "ContractFormSection";
  fields: Array<ContractFormField>;
  key: Scalars["String"]["output"];
  ordered: Scalars["Boolean"]["output"];
  repeating: Scalars["Boolean"]["output"];
  title?: Maybe<Scalars["String"]["output"]>;
};

export enum ContractLocaleEnum {
  Da = "da",
  En = "en",
}

export type ContractOptions = {
  __typename?: "ContractOptions";
  endTenancyTerms: Array<EndTenancyTermsEnum>;
  locales: Array<ContractLocaleEnum>;
  types: Array<ContractTypeEnum>;
};

export enum ContractTypeEnum {
  ContractA9 = "contract_a9",
  ContractA10 = "contract_a10",
  ContractStandard = "contract_standard",
}

export type CreateTenancy = CaseInterface & {
  __typename?: "CreateTenancy";
  apartment?: Maybe<Apartment>;
  archivedAt?: Maybe<Scalars["ISO8601DateTime"]["output"]>;
  archivedBy?: Maybe<CaseUser>;
  assignableServiceTeams: Array<ServiceTeam>;
  attachments: Array<CaseAttachment>;
  attention: CaseAttentionEnum;
  availableDebtorCount: Scalars["Int"]["output"];
  availableFollowers: Array<CaseUser>;
  availableResponsibleTeams: Array<AvailableResponsibleTeam>;
  availableResponsibleUsers: Array<CaseUser>;
  availableTeams: Array<Team>;
  availableTemplates: Array<DocumentTemplate>;
  availableTimelogAccounts: Array<TimelogAccount>;
  awaiting?: Maybe<Scalars["String"]["output"]>;
  body: Scalars["String"]["output"];
  calendarDate?: Maybe<Scalars["String"]["output"]>;
  calendarRange: DateRange;
  canAddAttachment: Scalars["Boolean"]["output"];
  canAddComment: Scalars["Boolean"]["output"];
  canAddFollower: Scalars["Boolean"]["output"];
  canAddTimelog: Scalars["Boolean"]["output"];
  canAwait: Scalars["Boolean"]["output"];
  canCancel: Scalars["Boolean"]["output"];
  canCancelContract: Scalars["Boolean"]["output"];
  canChangeContract: Scalars["Boolean"]["output"];
  canChangeResponsible: Scalars["Boolean"]["output"];
  canComplete: Scalars["Boolean"]["output"];
  canConfigureRepeat: Scalars["Boolean"]["output"];
  canCreateContract: Scalars["Boolean"]["output"];
  canLandlordSignContract: Scalars["Boolean"]["output"];
  canPopulateContract: Scalars["Boolean"]["output"];
  canRemoveAttachment: Scalars["Boolean"]["output"];
  canRemoveFollower: Scalars["Boolean"]["output"];
  canReopen: Scalars["Boolean"]["output"];
  canSendCommentAsSms: Scalars["Boolean"]["output"];
  canSendContract: Scalars["Boolean"]["output"];
  canShare: Scalars["Boolean"]["output"];
  canShowAttention: Scalars["Boolean"]["output"];
  canShowEndTenancyTerms: Scalars["Boolean"]["output"];
  canShowMovingInCaseResponsible: Scalars["Boolean"]["output"];
  canShowTimelogs: Scalars["Boolean"]["output"];
  canToggleCheck: Scalars["Boolean"]["output"];
  canUpdate: Scalars["Boolean"]["output"];
  canUpdateEconomic: Scalars["Boolean"]["output"];
  cancelledMessage?: Maybe<Scalars["String"]["output"]>;
  checks?: Maybe<Array<CaseCheck>>;
  commentUsers: Array<CaseCommentUserOption>;
  comments: Array<CaseComment>;
  company?: Maybe<Company>;
  completeBefore?: Maybe<Scalars["String"]["output"]>;
  completed?: Maybe<Scalars["Boolean"]["output"]>;
  completedDate?: Maybe<Scalars["ISO8601DateTime"]["output"]>;
  contract?: Maybe<Document>;
  contractForm?: Maybe<ContractForm>;
  contractSettings: CaseContractSettings;
  contractValues?: Maybe<Scalars["JSON"]["output"]>;
  createdAt: Scalars["ISO8601DateTime"]["output"];
  daysBetween?: Maybe<Scalars["String"]["output"]>;
  depositAmount?: Maybe<Scalars["Int"]["output"]>;
  displayName: Scalars["String"]["output"];
  economicDebtor?: Maybe<EconomicDebtor>;
  endDate?: Maybe<Scalars["ISO8601Date"]["output"]>;
  endTenancyTermsText?: Maybe<Scalars["String"]["output"]>;
  flaggedByCurrentUser: Scalars["Boolean"]["output"];
  followers: Array<Follower>;
  hasCompleteSettings: Scalars["Boolean"]["output"];
  hasEconomicAgreement: Scalars["Boolean"]["output"];
  icon: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  inspected?: Maybe<Scalars["Boolean"]["output"]>;
  inspection?: Maybe<Inspection>;
  intervalAmount?: Maybe<Scalars["Int"]["output"]>;
  isArchived: Scalars["Boolean"]["output"];
  isAttending?: Maybe<Scalars["Boolean"]["output"]>;
  isContractIssued: Scalars["Boolean"]["output"];
  isService: Scalars["Boolean"]["output"];
  mayAddAttachment: Scalars["Boolean"]["output"];
  mayAddComment: Scalars["Boolean"]["output"];
  mayAddFollower: Scalars["Boolean"]["output"];
  mayAddTimelog: Scalars["Boolean"]["output"];
  mayAwait: Scalars["Boolean"]["output"];
  mayCancel: Scalars["Boolean"]["output"];
  mayCancelContract: Scalars["Boolean"]["output"];
  mayChangeContract: Scalars["Boolean"]["output"];
  mayChangeResponsible: Scalars["Boolean"]["output"];
  mayComplete: Scalars["Boolean"]["output"];
  mayConfigureRepeat: Scalars["Boolean"]["output"];
  mayCreate: Scalars["Boolean"]["output"];
  mayCreateContract: Scalars["Boolean"]["output"];
  mayLandlordSignContract: Scalars["Boolean"]["output"];
  mayPopulateContract: Scalars["Boolean"]["output"];
  mayRemoveAttachment: Scalars["Boolean"]["output"];
  mayRemoveFollower: Scalars["Boolean"]["output"];
  mayReopen: Scalars["Boolean"]["output"];
  maySendContract: Scalars["Boolean"]["output"];
  mayTenantSignContract: Scalars["Boolean"]["output"];
  mayToggleCheck: Scalars["Boolean"]["output"];
  mayUpdateEconomic: Scalars["Boolean"]["output"];
  movingInCase?: Maybe<MovingInTenancy>;
  name: Scalars["String"]["output"];
  parent?: Maybe<CaseInterface>;
  processing?: Maybe<Scalars["Boolean"]["output"]>;
  property?: Maybe<Property>;
  repeatPeriod?: Maybe<Scalars["String"]["output"]>;
  repeatResponsible: Scalars["Boolean"]["output"];
  repeatSteps?: Maybe<Scalars["Int"]["output"]>;
  repeating: Scalars["Boolean"]["output"];
  requester?: Maybe<User>;
  requiresCprNumber: Scalars["Boolean"]["output"];
  responsible?: Maybe<CaseUser>;
  scheduledDate?: Maybe<Scalars["String"]["output"]>;
  scheduledTime?: Maybe<Scalars["String"]["output"]>;
  serviceDate?: Maybe<Scalars["ISO8601Date"]["output"]>;
  serviceEmployee?: Maybe<Scalars["String"]["output"]>;
  serviceTeam?: Maybe<ServiceTeam>;
  serviceTime?: Maybe<Scalars["String"]["output"]>;
  shareableDocuments: Array<Document>;
  shares: Array<CaseShare>;
  shortName: Scalars["String"]["output"];
  signatures: Array<CaseSignature>;
  startAfter?: Maybe<Scalars["String"]["output"]>;
  startDate?: Maybe<Scalars["ISO8601Date"]["output"]>;
  state: Scalars["String"]["output"];
  stateLastChangedAt?: Maybe<Scalars["ISO8601DateTime"]["output"]>;
  stateText: Scalars["String"]["output"];
  tenancy?: Maybe<Tenancy>;
  tenantMayAttend: Scalars["Boolean"]["output"];
  tenantWillAttend?: Maybe<Scalars["Boolean"]["output"]>;
  timelogAccount?: Maybe<TimelogAccount>;
  timelogs: Array<Timelog>;
  title: Scalars["String"]["output"];
  titleRaw?: Maybe<Scalars["String"]["output"]>;
  totalCommentsCount: Scalars["Int"]["output"];
  type: CaseTypeEnum;
  unreadCommentsCount: Scalars["Int"]["output"];
  updatedAt: Scalars["ISO8601DateTime"]["output"];
  whyAttention: Array<CaseAttentionCondition>;
};

export type CreateTenancyAvailableTeamsArgs = {
  forAssignment?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type CreateTenancyCommentsArgs = {
  commentTypes?: InputMaybe<Array<CaseCommentTypeEnum>>;
};

export type DateRange = {
  __typename?: "DateRange";
  from?: Maybe<Scalars["String"]["output"]>;
  to?: Maybe<Scalars["String"]["output"]>;
};

export type DateRangeInput = {
  from: Scalars["String"]["input"];
  to?: InputMaybe<Scalars["String"]["input"]>;
};

/** Autogenerated return type of DeleteInspectionAnswerMutation. */
export type DeleteInspectionAnswerMutationPayload = {
  __typename?: "DeleteInspectionAnswerMutationPayload";
  errors: Array<Scalars["String"]["output"]>;
};

/** Autogenerated return type of DeletePaymentMutation. */
export type DeletePaymentMutationPayload = {
  __typename?: "DeletePaymentMutationPayload";
  errors: Array<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
};

/** Autogenerated return type of DeleteTextMacroMutation. */
export type DeleteTextMacroMutationPayload = {
  __typename?: "DeleteTextMacroMutationPayload";
  errors: Array<Scalars["String"]["output"]>;
  id: Scalars["Int"]["output"];
};

export type Document = {
  __typename?: "Document";
  contentBase64?: Maybe<Scalars["String"]["output"]>;
  createdAt: Scalars["ISO8601DateTime"]["output"];
  id: Scalars["ID"]["output"];
  title: Scalars["String"]["output"];
  type: DocumentTypeEnum;
  url: Scalars["String"]["output"];
};

export type DocumentTemplate = {
  __typename?: "DocumentTemplate";
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
};

export enum DocumentTypeEnum {
  Contract = "contract",
  Generic = "generic",
  Inspection = "inspection",
  Photo = "photo",
}

export type EconomicDebtor = {
  __typename?: "EconomicDebtor";
  address?: Maybe<Scalars["String"]["output"]>;
  addressText?: Maybe<Scalars["String"]["output"]>;
  city?: Maybe<Scalars["String"]["output"]>;
  country?: Maybe<Scalars["String"]["output"]>;
  email?: Maybe<Scalars["String"]["output"]>;
  externalId: Scalars["Int"]["output"];
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
  postalCode?: Maybe<Scalars["String"]["output"]>;
};

export type EconomicDebtorList = {
  __typename?: "EconomicDebtorList";
  count: Scalars["Int"]["output"];
  records: Array<EconomicDebtor>;
  total: Scalars["Int"]["output"];
};

export type EconomicDebtorWhereInput = {
  byName?: InputMaybe<Scalars["ID"]["input"]>;
  byTenancy?: InputMaybe<Scalars["ID"]["input"]>;
  withSubscriptionId?: InputMaybe<Scalars["ID"]["input"]>;
};

/** Autogenerated return type of EconomicResyncMutation. */
export type EconomicResyncMutationPayload = {
  __typename?: "EconomicResyncMutationPayload";
  success: Scalars["Boolean"]["output"];
};

export type EconomicSubscriber = {
  __typename?: "EconomicSubscriber";
  canceledAt?: Maybe<Scalars["ISO8601Date"]["output"]>;
  debtor: EconomicDebtor;
  id: Scalars["ID"]["output"];
  intervalEndAt?: Maybe<Scalars["ISO8601Date"]["output"]>;
  intervalStartAt?: Maybe<Scalars["ISO8601Date"]["output"]>;
  price: Scalars["Float"]["output"];
  signedUpAt?: Maybe<Scalars["ISO8601Date"]["output"]>;
  subscription: EconomicSubscription;
};

export type EconomicSubscriberList = {
  __typename?: "EconomicSubscriberList";
  count: Scalars["Int"]["output"];
  records: Array<EconomicSubscriber>;
  total: Scalars["Int"]["output"];
};

export type EconomicSubscriberWhereInput = {
  byTenancy?: InputMaybe<Scalars["ID"]["input"]>;
};

export type EconomicSubscription = {
  __typename?: "EconomicSubscription";
  id: Scalars["ID"]["output"];
  intervalType?: Maybe<EconomicSubscriptionIntervalEnum>;
  name: Scalars["String"]["output"];
  subscribers: Array<EconomicSubscriber>;
};

export enum EconomicSubscriptionIntervalEnum {
  /** Eight-weekly interval */
  EightWeeks = "EightWeeks",
  /** Penta-yearly interval */
  FiveYears = "FiveYears",
  /** Four-weekly interval */
  FourWeeks = "FourWeeks",
  /** Quad-yearly interval */
  FourYears = "FourYears",
  /** Half-yearly interval */
  HalfYear = "HalfYear",
  /** Monthly interval */
  Month = "Month",
  /** Quarterly interval */
  Quarter = "Quarter",
  /** Tri-yearly interval */
  ThreeYears = "ThreeYears",
  /** Bi-monthly interval */
  TwoMonths = "TwoMonths",
  /** Bi-weekly interval */
  TwoWeeks = "TwoWeeks",
  /** Bi-yearly interval */
  TwoYears = "TwoYears",
  /** Weekly interval */
  Week = "Week",
  /** Yearly interval */
  Year = "Year",
}

export type EconomicSubscriptionList = {
  __typename?: "EconomicSubscriptionList";
  count: Scalars["Int"]["output"];
  records: Array<EconomicSubscription>;
  total: Scalars["Int"]["output"];
};

export type EconomicSubscriptionWhereInput = {
  byName?: InputMaybe<Scalars["String"]["input"]>;
  byOwner?: InputMaybe<Scalars["ID"]["input"]>;
};

export type EndTenancy = CaseInterface & {
  __typename?: "EndTenancy";
  apartment?: Maybe<Apartment>;
  applicationEndDate?: Maybe<Scalars["ISO8601Date"]["output"]>;
  archivedAt?: Maybe<Scalars["ISO8601DateTime"]["output"]>;
  archivedBy?: Maybe<CaseUser>;
  assignableServiceTeams: Array<ServiceTeam>;
  attachments: Array<CaseAttachment>;
  attention: CaseAttentionEnum;
  availableFollowers: Array<CaseUser>;
  availableResponsibleTeams: Array<AvailableResponsibleTeam>;
  availableResponsibleUsers: Array<CaseUser>;
  availableTeams: Array<Team>;
  availableTimelogAccounts: Array<TimelogAccount>;
  awaiting?: Maybe<Scalars["String"]["output"]>;
  body: Scalars["String"]["output"];
  calendarDate?: Maybe<Scalars["String"]["output"]>;
  calendarRange: DateRange;
  canAddAttachment: Scalars["Boolean"]["output"];
  canAddComment: Scalars["Boolean"]["output"];
  canAddFollower: Scalars["Boolean"]["output"];
  canAddTimelog: Scalars["Boolean"]["output"];
  canAwait: Scalars["Boolean"]["output"];
  canCancel: Scalars["Boolean"]["output"];
  canChangeEndDate: Scalars["Boolean"]["output"];
  canChangeResponsible: Scalars["Boolean"]["output"];
  canComplete: Scalars["Boolean"]["output"];
  canConfigureRepeat: Scalars["Boolean"]["output"];
  canReceive: Scalars["Boolean"]["output"];
  canRemoveAttachment: Scalars["Boolean"]["output"];
  canRemoveFollower: Scalars["Boolean"]["output"];
  canReopen: Scalars["Boolean"]["output"];
  canSendCommentAsSms: Scalars["Boolean"]["output"];
  canShare: Scalars["Boolean"]["output"];
  canShowAttention: Scalars["Boolean"]["output"];
  canShowMovingOutCase: Scalars["Boolean"]["output"];
  canShowMovingOutCaseResponsible: Scalars["Boolean"]["output"];
  canShowTimelogs: Scalars["Boolean"]["output"];
  canToggleCheck: Scalars["Boolean"]["output"];
  canUpdate: Scalars["Boolean"]["output"];
  canUpdateReasons: Scalars["Boolean"]["output"];
  cancelled: Scalars["Boolean"]["output"];
  cancelledMessage?: Maybe<Scalars["String"]["output"]>;
  checks?: Maybe<Array<CaseCheck>>;
  comment?: Maybe<Scalars["String"]["output"]>;
  commentUsers: Array<CaseCommentUserOption>;
  comments: Array<CaseComment>;
  company?: Maybe<Company>;
  completeBefore?: Maybe<Scalars["String"]["output"]>;
  completed?: Maybe<Scalars["Boolean"]["output"]>;
  completedDate?: Maybe<Scalars["ISO8601DateTime"]["output"]>;
  createdAt: Scalars["ISO8601DateTime"]["output"];
  displayName: Scalars["String"]["output"];
  earlyEndDate: Scalars["Boolean"]["output"];
  endDate?: Maybe<Scalars["ISO8601Date"]["output"]>;
  endDateByTerms?: Maybe<Scalars["ISO8601Date"]["output"]>;
  endDateChanged: Scalars["Boolean"]["output"];
  flaggedByCurrentUser: Scalars["Boolean"]["output"];
  followers: Array<Follower>;
  icon: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  inspected?: Maybe<Scalars["Boolean"]["output"]>;
  inspection?: Maybe<Inspection>;
  isArchived: Scalars["Boolean"]["output"];
  isAttending?: Maybe<Scalars["Boolean"]["output"]>;
  isService: Scalars["Boolean"]["output"];
  lastRentDate?: Maybe<Scalars["ISO8601Date"]["output"]>;
  leaveDate?: Maybe<Scalars["ISO8601Date"]["output"]>;
  mayAddAttachment: Scalars["Boolean"]["output"];
  mayAddComment: Scalars["Boolean"]["output"];
  mayAddFollower: Scalars["Boolean"]["output"];
  mayAddTimelog: Scalars["Boolean"]["output"];
  mayAwait: Scalars["Boolean"]["output"];
  mayCancel: Scalars["Boolean"]["output"];
  mayChangeEndDate: Scalars["Boolean"]["output"];
  mayChangeResponsible: Scalars["Boolean"]["output"];
  mayComplete: Scalars["Boolean"]["output"];
  mayConfigureRepeat: Scalars["Boolean"]["output"];
  mayCreate: Scalars["Boolean"]["output"];
  mayReceive: Scalars["Boolean"]["output"];
  mayRemoveAttachment: Scalars["Boolean"]["output"];
  mayRemoveFollower: Scalars["Boolean"]["output"];
  mayReopen: Scalars["Boolean"]["output"];
  mayToggleCheck: Scalars["Boolean"]["output"];
  mayUpdateReasons: Scalars["Boolean"]["output"];
  name: Scalars["String"]["output"];
  parent?: Maybe<CaseInterface>;
  processing?: Maybe<Scalars["Boolean"]["output"]>;
  property?: Maybe<Property>;
  reasons: Array<EndTenancyReasonSelection>;
  repeatPeriod?: Maybe<Scalars["String"]["output"]>;
  repeatResponsible: Scalars["Boolean"]["output"];
  repeatSteps?: Maybe<Scalars["Int"]["output"]>;
  repeating: Scalars["Boolean"]["output"];
  requester?: Maybe<User>;
  responsible?: Maybe<CaseUser>;
  scheduledDate?: Maybe<Scalars["String"]["output"]>;
  scheduledTime?: Maybe<Scalars["String"]["output"]>;
  serviceDate?: Maybe<Scalars["ISO8601Date"]["output"]>;
  serviceEmployee?: Maybe<Scalars["String"]["output"]>;
  serviceTeam?: Maybe<ServiceTeam>;
  serviceTime?: Maybe<Scalars["String"]["output"]>;
  shareableDocuments: Array<Document>;
  shares: Array<CaseShare>;
  shortName: Scalars["String"]["output"];
  startAfter?: Maybe<Scalars["String"]["output"]>;
  state: Scalars["String"]["output"];
  stateLastChangedAt?: Maybe<Scalars["ISO8601DateTime"]["output"]>;
  stateText: Scalars["String"]["output"];
  tenancy?: Maybe<Tenancy>;
  tenantMayAttend: Scalars["Boolean"]["output"];
  tenantWillAttend?: Maybe<Scalars["Boolean"]["output"]>;
  terms: TenancyTerms;
  timelogAccount?: Maybe<TimelogAccount>;
  timelogs: Array<Timelog>;
  title: Scalars["String"]["output"];
  titleRaw?: Maybe<Scalars["String"]["output"]>;
  totalCommentsCount: Scalars["Int"]["output"];
  type: CaseTypeEnum;
  unreadCommentsCount: Scalars["Int"]["output"];
  updatedAt: Scalars["ISO8601DateTime"]["output"];
  whyAttention: Array<CaseAttentionCondition>;
};

export type EndTenancyAvailableTeamsArgs = {
  forAssignment?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type EndTenancyCommentsArgs = {
  commentTypes?: InputMaybe<Array<CaseCommentTypeEnum>>;
};

/** Autogenerated return type of EndTenancyMutation. */
export type EndTenancyMutationPayload = {
  __typename?: "EndTenancyMutationPayload";
  case?: Maybe<EndTenancy>;
  errors?: Maybe<Array<Scalars["String"]["output"]>>;
};

export type EndTenancyReason = {
  __typename?: "EndTenancyReason";
  id: Scalars["ID"]["output"];
  isOther: Scalars["Boolean"]["output"];
  label: Scalars["String"]["output"];
  labelDa: Scalars["String"]["output"];
  labelEn: Scalars["String"]["output"];
  position: Scalars["Int"]["output"];
};

export type EndTenancyReasonSelection = {
  __typename?: "EndTenancyReasonSelection";
  id: Scalars["ID"]["output"];
  label: Scalars["String"]["output"];
  note?: Maybe<Scalars["String"]["output"]>;
};

export type EndTenancyReasonSelectionInput = {
  id: Scalars["ID"]["input"];
  note?: InputMaybe<Scalars["String"]["input"]>;
};

export enum EndTenancyTermsEnum {
  Flex_1Month = "flex_1_month",
  Flex_3Months = "flex_3_months",
  FlexNone = "flex_none",
  Standard_1Month = "standard_1_month",
  Standard_1Month_14Days = "standard_1_month_14_days",
  Standard_3Months = "standard_3_months",
  Standard_3Months_14Days = "standard_3_months_14_days",
}

export type Field = RecordInterface & {
  __typename?: "Field";
  availableInApartment: Scalars["Boolean"]["output"];
  availableInHome: Scalars["Boolean"]["output"];
  availableInProperty: Scalars["Boolean"]["output"];
  availableInService: Scalars["Boolean"]["output"];
  availableInTenancy: Scalars["Boolean"]["output"];
  createdAt: Scalars["ISO8601DateTime"]["output"];
  enumOptions: Array<FieldEnumOption>;
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
  nameDa: Scalars["String"]["output"];
  nameEn: Scalars["String"]["output"];
  position: Scalars["Int"]["output"];
  updatedAt: Scalars["ISO8601DateTime"]["output"];
  valueType: FieldValueTypeEnum;
};

export type FieldEnumOption = {
  __typename?: "FieldEnumOption";
  id: Scalars["ID"]["output"];
  position: Scalars["Int"]["output"];
  value: Scalars["String"]["output"];
};

export type FieldGroup = {
  __typename?: "FieldGroup";
  fields: Array<Field>;
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
  nameDa: Scalars["String"]["output"];
  nameEn: Scalars["String"]["output"];
  position: Scalars["Int"]["output"];
};

export type FieldGroupList = {
  __typename?: "FieldGroupList";
  count: Scalars["Int"]["output"];
  records: Array<FieldGroup>;
  total: Scalars["Int"]["output"];
};

export type FieldList = {
  __typename?: "FieldList";
  count: Scalars["Int"]["output"];
  records: Array<Field>;
  total: Scalars["Int"]["output"];
};

export type FieldValue = {
  createdAt: Scalars["ISO8601DateTime"]["output"];
  field: Field;
  id: Scalars["ID"]["output"];
  updatedAt: Scalars["ISO8601DateTime"]["output"];
};

export type FieldValueBoolean = FieldValue & {
  __typename?: "FieldValueBoolean";
  createdAt: Scalars["ISO8601DateTime"]["output"];
  field: Field;
  id: Scalars["ID"]["output"];
  updatedAt: Scalars["ISO8601DateTime"]["output"];
  value?: Maybe<Scalars["Boolean"]["output"]>;
};

export type FieldValueDatetime = FieldValue & {
  __typename?: "FieldValueDatetime";
  createdAt: Scalars["ISO8601DateTime"]["output"];
  field: Field;
  id: Scalars["ID"]["output"];
  updatedAt: Scalars["ISO8601DateTime"]["output"];
  value?: Maybe<Scalars["ISO8601DateTime"]["output"]>;
};

export type FieldValueEnum = FieldValue & {
  __typename?: "FieldValueEnum";
  createdAt: Scalars["ISO8601DateTime"]["output"];
  field: Field;
  fieldEnumOptionId?: Maybe<Scalars["ID"]["output"]>;
  id: Scalars["ID"]["output"];
  updatedAt: Scalars["ISO8601DateTime"]["output"];
  value?: Maybe<Scalars["String"]["output"]>;
};

export type FieldValueInput = {
  booleanValue?: InputMaybe<Scalars["Boolean"]["input"]>;
  datetimeValue?: InputMaybe<Scalars["ISO8601DateTime"]["input"]>;
  enumValue?: InputMaybe<Scalars["String"]["input"]>;
  fieldId: Scalars["ID"]["input"];
  numberValue?: InputMaybe<Scalars["Float"]["input"]>;
  textValue?: InputMaybe<Scalars["String"]["input"]>;
};

export type FieldValueNumber = FieldValue & {
  __typename?: "FieldValueNumber";
  createdAt: Scalars["ISO8601DateTime"]["output"];
  field: Field;
  id: Scalars["ID"]["output"];
  updatedAt: Scalars["ISO8601DateTime"]["output"];
  value?: Maybe<Scalars["Float"]["output"]>;
};

export type FieldValueText = FieldValue & {
  __typename?: "FieldValueText";
  createdAt: Scalars["ISO8601DateTime"]["output"];
  field: Field;
  id: Scalars["ID"]["output"];
  updatedAt: Scalars["ISO8601DateTime"]["output"];
  value?: Maybe<Scalars["String"]["output"]>;
};

export enum FieldValueTypeEnum {
  Boolean = "boolean",
  Datetime = "datetime",
  Enum = "enum",
  Number = "number",
  Text = "text",
}

export type File = {
  __typename?: "File";
  createdAt: Scalars["ISO8601DateTime"]["output"];
  fileName: Scalars["String"]["output"];
  fileSize: Scalars["Int"]["output"];
  fileType: Scalars["String"]["output"];
  headSignedUrl: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  isImage: Scalars["Boolean"]["output"];
  isPdf: Scalars["Boolean"]["output"];
  largeUrl: Scalars["String"]["output"];
  thumbUrl: Scalars["String"]["output"];
  url: Scalars["String"]["output"];
};

export type FindTenancyAdministration = CaseInterface & {
  __typename?: "FindTenancyAdministration";
  apartment?: Maybe<Apartment>;
  archivedAt?: Maybe<Scalars["ISO8601DateTime"]["output"]>;
  archivedBy?: Maybe<CaseUser>;
  assignableServiceTeams: Array<ServiceTeam>;
  attachments: Array<CaseAttachment>;
  attention: CaseAttentionEnum;
  availableFollowers: Array<CaseUser>;
  availableResponsibleTeams: Array<AvailableResponsibleTeam>;
  availableResponsibleUsers: Array<CaseUser>;
  availableTeams: Array<Team>;
  availableTimelogAccounts: Array<TimelogAccount>;
  awaiting?: Maybe<Scalars["String"]["output"]>;
  body: Scalars["String"]["output"];
  calendarDate?: Maybe<Scalars["String"]["output"]>;
  calendarRange: DateRange;
  canAddAttachment: Scalars["Boolean"]["output"];
  canAddComment: Scalars["Boolean"]["output"];
  canAddFollower: Scalars["Boolean"]["output"];
  canAddTimelog: Scalars["Boolean"]["output"];
  canAwait: Scalars["Boolean"]["output"];
  canCancel: Scalars["Boolean"]["output"];
  canChangeResponsible: Scalars["Boolean"]["output"];
  canChangeTask: Scalars["Boolean"]["output"];
  canComplete: Scalars["Boolean"]["output"];
  canConfigureRepeat: Scalars["Boolean"]["output"];
  canReceive: Scalars["Boolean"]["output"];
  canRemoveAttachment: Scalars["Boolean"]["output"];
  canRemoveFollower: Scalars["Boolean"]["output"];
  canReopen: Scalars["Boolean"]["output"];
  canSendCommentAsSms: Scalars["Boolean"]["output"];
  canShare: Scalars["Boolean"]["output"];
  canShowAttention: Scalars["Boolean"]["output"];
  canShowRentInfo: Scalars["Boolean"]["output"];
  canShowTimelogs: Scalars["Boolean"]["output"];
  canToggleCheck: Scalars["Boolean"]["output"];
  canUpdate: Scalars["Boolean"]["output"];
  cancelledMessage?: Maybe<Scalars["String"]["output"]>;
  checks?: Maybe<Array<CaseCheck>>;
  commentUsers: Array<CaseCommentUserOption>;
  comments: Array<CaseComment>;
  company?: Maybe<Company>;
  completeBefore?: Maybe<Scalars["String"]["output"]>;
  completed?: Maybe<Scalars["Boolean"]["output"]>;
  completedDate?: Maybe<Scalars["ISO8601DateTime"]["output"]>;
  createdAt: Scalars["ISO8601DateTime"]["output"];
  depositAmount?: Maybe<Scalars["Int"]["output"]>;
  displayName: Scalars["String"]["output"];
  flaggedByCurrentUser: Scalars["Boolean"]["output"];
  followers: Array<Follower>;
  icon: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  inspected?: Maybe<Scalars["Boolean"]["output"]>;
  inspection?: Maybe<Inspection>;
  intervalAmount?: Maybe<Scalars["Int"]["output"]>;
  isArchived: Scalars["Boolean"]["output"];
  isAttending?: Maybe<Scalars["Boolean"]["output"]>;
  isService: Scalars["Boolean"]["output"];
  mayAddAttachment: Scalars["Boolean"]["output"];
  mayAddComment: Scalars["Boolean"]["output"];
  mayAddFollower: Scalars["Boolean"]["output"];
  mayAddTimelog: Scalars["Boolean"]["output"];
  mayAwait: Scalars["Boolean"]["output"];
  mayCancel: Scalars["Boolean"]["output"];
  mayChangeResponsible: Scalars["Boolean"]["output"];
  mayChangeTask: Scalars["Boolean"]["output"];
  mayComplete: Scalars["Boolean"]["output"];
  mayConfigureRepeat: Scalars["Boolean"]["output"];
  mayCreate: Scalars["Boolean"]["output"];
  mayReceive: Scalars["Boolean"]["output"];
  mayRemoveAttachment: Scalars["Boolean"]["output"];
  mayRemoveFollower: Scalars["Boolean"]["output"];
  mayReopen: Scalars["Boolean"]["output"];
  mayToggleCheck: Scalars["Boolean"]["output"];
  moveInDate?: Maybe<Scalars["String"]["output"]>;
  name: Scalars["String"]["output"];
  parent?: Maybe<CaseInterface>;
  processing?: Maybe<Scalars["Boolean"]["output"]>;
  property?: Maybe<Property>;
  repeatPeriod?: Maybe<Scalars["String"]["output"]>;
  repeatResponsible: Scalars["Boolean"]["output"];
  repeatSteps?: Maybe<Scalars["Int"]["output"]>;
  repeating: Scalars["Boolean"]["output"];
  requester?: Maybe<User>;
  responsible?: Maybe<CaseUser>;
  scheduledDate?: Maybe<Scalars["String"]["output"]>;
  scheduledTime?: Maybe<Scalars["String"]["output"]>;
  serviceDate?: Maybe<Scalars["ISO8601Date"]["output"]>;
  serviceEmployee?: Maybe<Scalars["String"]["output"]>;
  serviceTeam?: Maybe<ServiceTeam>;
  serviceTime?: Maybe<Scalars["String"]["output"]>;
  shareableDocuments: Array<Document>;
  shares: Array<CaseShare>;
  shortName: Scalars["String"]["output"];
  startAfter?: Maybe<Scalars["String"]["output"]>;
  startDate?: Maybe<Scalars["ISO8601Date"]["output"]>;
  state: Scalars["String"]["output"];
  stateLastChangedAt?: Maybe<Scalars["ISO8601DateTime"]["output"]>;
  stateText: Scalars["String"]["output"];
  tenancy?: Maybe<Tenancy>;
  tenantMayAttend: Scalars["Boolean"]["output"];
  tenantWillAttend?: Maybe<Scalars["Boolean"]["output"]>;
  timelogAccount?: Maybe<TimelogAccount>;
  timelogs: Array<Timelog>;
  title: Scalars["String"]["output"];
  titleRaw?: Maybe<Scalars["String"]["output"]>;
  totalCommentsCount: Scalars["Int"]["output"];
  type: CaseTypeEnum;
  unreadCommentsCount: Scalars["Int"]["output"];
  updatedAt: Scalars["ISO8601DateTime"]["output"];
  whyAttention: Array<CaseAttentionCondition>;
};

export type FindTenancyAdministrationAvailableTeamsArgs = {
  forAssignment?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type FindTenancyAdministrationCommentsArgs = {
  commentTypes?: InputMaybe<Array<CaseCommentTypeEnum>>;
};

export type Follower = {
  __typename?: "Follower";
  id: Scalars["ID"]["output"];
  user: CaseUser;
};

export type Inspection = {
  __typename?: "Inspection";
  answers: Array<InspectionAnswer>;
  canProcess: Scalars["Boolean"]["output"];
  cleaning?: Maybe<Scalars["String"]["output"]>;
  createdAt: Scalars["ISO8601DateTime"]["output"];
  document?: Maybe<Document>;
  keys: Array<InspectionKey>;
  landlordSignature?: Maybe<Scalars["String"]["output"]>;
  landlordSignedBy?: Maybe<Scalars["String"]["output"]>;
  mayProcess: Scalars["Boolean"]["output"];
  meters: Array<InspectionMeter>;
  other?: Maybe<Scalars["String"]["output"]>;
  tenantSignature?: Maybe<Scalars["String"]["output"]>;
  tenantSignedBy?: Maybe<Scalars["String"]["output"]>;
  updatedAt: Scalars["ISO8601DateTime"]["output"];
};

export type InspectionAnswer = {
  __typename?: "InspectionAnswer";
  area: InspectionArea;
  note?: Maybe<Scalars["String"]["output"]>;
  position: Scalars["Int"]["output"];
  rating?: Maybe<Scalars["Int"]["output"]>;
  subject: InspectionSubject;
};

export type InspectionArea = {
  __typename?: "InspectionArea";
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
};

export type InspectionKey = {
  __typename?: "InspectionKey";
  count: Scalars["Int"]["output"];
  description: Scalars["String"]["output"];
  id?: Maybe<Scalars["ID"]["output"]>;
  keyMissing?: Maybe<Scalars["Int"]["output"]>;
  total: Scalars["Int"]["output"];
};

export type InspectionMeter = {
  __typename?: "InspectionMeter";
  description: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  value: Scalars["Float"]["output"];
};

export type InspectionSubject = {
  __typename?: "InspectionSubject";
  description?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
};

export type InterestListEntry = RecordInterface & {
  __typename?: "InterestListEntry";
  channel?: Maybe<Scalars["String"]["output"]>;
  createdAt: Scalars["ISO8601DateTime"]["output"];
  deletedAt?: Maybe<Scalars["ISO8601DateTime"]["output"]>;
  deletedBy?: Maybe<User>;
  deletedReason?: Maybe<Scalars["String"]["output"]>;
  email: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  message?: Maybe<Scalars["String"]["output"]>;
  name: Scalars["String"]["output"];
  notes: Array<InterestListNote>;
  phone: Scalars["String"]["output"];
  properties: Array<Property>;
  seenAt?: Maybe<Scalars["ISO8601DateTime"]["output"]>;
  updatedAt: Scalars["ISO8601DateTime"]["output"];
};

/** Autogenerated return type of InterestListEntryCreateMutation. */
export type InterestListEntryCreateMutationPayload = {
  __typename?: "InterestListEntryCreateMutationPayload";
  duplicatePersonName?: Maybe<Scalars["String"]["output"]>;
  errors?: Maybe<Array<Scalars["String"]["output"]>>;
  personCreated?: Maybe<Scalars["Boolean"]["output"]>;
  result?: Maybe<InterestListEntry>;
};

/** Autogenerated return type of InterestListEntryDeleteMutation. */
export type InterestListEntryDeleteMutationPayload = {
  __typename?: "InterestListEntryDeleteMutationPayload";
  errors: Array<Scalars["String"]["output"]>;
  result?: Maybe<InterestListEntry>;
};

export type InterestListEntryList = {
  __typename?: "InterestListEntryList";
  count: Scalars["Int"]["output"];
  records: Array<InterestListEntry>;
  total: Scalars["Int"]["output"];
};

export enum InterestListEntryOrderByEnum {
  CreatedAtAsc = "createdAt_ASC",
  CreatedAtDesc = "createdAt_DESC",
  EmailAsc = "email_ASC",
  EmailDesc = "email_DESC",
  NameAsc = "name_ASC",
  NameDesc = "name_DESC",
  PhoneAsc = "phone_ASC",
  PhoneDesc = "phone_DESC",
}

/** Autogenerated return type of InterestListEntryUpdateMutation. */
export type InterestListEntryUpdateMutationPayload = {
  __typename?: "InterestListEntryUpdateMutationPayload";
  errors: Array<Scalars["String"]["output"]>;
  result?: Maybe<InterestListEntry>;
};

export type InterestListEntryWhereInput = {
  byProperty?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  search?: InputMaybe<Scalars["String"]["input"]>;
};

export type InterestListNote = {
  __typename?: "InterestListNote";
  createdAt: Scalars["ISO8601DateTime"]["output"];
  id: Scalars["ID"]["output"];
  note: Scalars["String"]["output"];
  updatedAt: Scalars["ISO8601DateTime"]["output"];
  user: User;
};

/** Autogenerated return type of InterestListNoteCreateMutation. */
export type InterestListNoteCreateMutationPayload = {
  __typename?: "InterestListNoteCreateMutationPayload";
  errors: Array<Scalars["String"]["output"]>;
  result?: Maybe<InterestListNote>;
};

export type InterestListPerson = RecordInterface & {
  __typename?: "InterestListPerson";
  createdAt: Scalars["ISO8601DateTime"]["output"];
  email: Scalars["String"]["output"];
  entries: Array<InterestListEntry>;
  hasNewEntries: Scalars["Boolean"]["output"];
  id: Scalars["ID"]["output"];
  isBlacklisted: Scalars["Boolean"]["output"];
  isProcessed: Scalars["Boolean"]["output"];
  name: Scalars["String"]["output"];
  notes: Array<InterestListNote>;
  phone: Scalars["String"]["output"];
  properties: Array<Property>;
  updatedAt: Scalars["ISO8601DateTime"]["output"];
};

/** Autogenerated return type of InterestListPersonDeleteMutation. */
export type InterestListPersonDeleteMutationPayload = {
  __typename?: "InterestListPersonDeleteMutationPayload";
  errors: Array<Scalars["String"]["output"]>;
  result?: Maybe<InterestListPerson>;
};

export type InterestListPersonList = {
  __typename?: "InterestListPersonList";
  count: Scalars["Int"]["output"];
  records: Array<InterestListPerson>;
  total: Scalars["Int"]["output"];
};

export enum InterestListPersonOrderByEnum {
  CreatedAtAsc = "createdAt_ASC",
  CreatedAtDesc = "createdAt_DESC",
  EmailAsc = "email_ASC",
  EmailDesc = "email_DESC",
  NameAsc = "name_ASC",
  NameDesc = "name_DESC",
  PhoneAsc = "phone_ASC",
  PhoneDesc = "phone_DESC",
}

export enum InterestListPersonStatusEnum {
  All = "all",
  Blacklisted = "blacklisted",
  HasNew = "has_new",
  Processed = "processed",
}

/** Autogenerated return type of InterestListPersonUpdateMutation. */
export type InterestListPersonUpdateMutationPayload = {
  __typename?: "InterestListPersonUpdateMutationPayload";
  errors: Array<Scalars["String"]["output"]>;
  result?: Maybe<InterestListPerson>;
};

export type InterestListPersonWhereInput = {
  byProperty?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  byStatus?: InputMaybe<Array<InterestListPersonStatusEnum>>;
  search?: InputMaybe<Scalars["String"]["input"]>;
};

export type Message = RecordInterface & {
  __typename?: "Message";
  apartment?: Maybe<Scalars["String"]["output"]>;
  author: Scalars["String"]["output"];
  authorId: Scalars["String"]["output"];
  body: Scalars["String"]["output"];
  companies: Array<Company>;
  company?: Maybe<Company>;
  createdAt: Scalars["ISO8601DateTime"]["output"];
  emailsSentAt?: Maybe<Scalars["ISO8601DateTime"]["output"]>;
  id: Scalars["ID"]["output"];
  property: Property;
  recipients: UserList;
  smsSentAt?: Maybe<Scalars["ISO8601DateTime"]["output"]>;
  title: Scalars["String"]["output"];
  updatedAt: Scalars["ISO8601DateTime"]["output"];
};

export type MessageList = {
  __typename?: "MessageList";
  count: Scalars["Int"]["output"];
  records: Array<Message>;
  total: Scalars["Int"]["output"];
};

export enum MessageOrderByEnum {
  AuthorAsc = "author_ASC",
  AuthorDesc = "author_DESC",
  CreatedAtAsc = "createdAt_ASC",
  CreatedAtDesc = "createdAt_DESC",
  ExpireAtAsc = "expireAt_ASC",
  ExpireAtDesc = "expireAt_DESC",
  TitleAsc = "title_ASC",
  TitleDesc = "title_DESC",
  UpdatedAtAsc = "updatedAt_ASC",
  UpdatedAtDesc = "updatedAt_DESC",
}

export type MessageWhereInput = {
  byId?: InputMaybe<Scalars["ID"]["input"]>;
  byProperty?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  search?: InputMaybe<Scalars["String"]["input"]>;
};

export type MiscAdministration = CaseInterface & {
  __typename?: "MiscAdministration";
  apartment?: Maybe<Apartment>;
  archivedAt?: Maybe<Scalars["ISO8601DateTime"]["output"]>;
  archivedBy?: Maybe<CaseUser>;
  assignableServiceTeams: Array<ServiceTeam>;
  attachments: Array<CaseAttachment>;
  attention: CaseAttentionEnum;
  availableFollowers: Array<CaseUser>;
  availableResponsibleTeams: Array<AvailableResponsibleTeam>;
  availableResponsibleUsers: Array<CaseUser>;
  availableTeams: Array<Team>;
  availableTimelogAccounts: Array<TimelogAccount>;
  awaiting?: Maybe<Scalars["String"]["output"]>;
  body: Scalars["String"]["output"];
  calendarDate?: Maybe<Scalars["String"]["output"]>;
  calendarRange: DateRange;
  canAddAttachment: Scalars["Boolean"]["output"];
  canAddComment: Scalars["Boolean"]["output"];
  canAddFollower: Scalars["Boolean"]["output"];
  canAddTimelog: Scalars["Boolean"]["output"];
  canAwait: Scalars["Boolean"]["output"];
  canCancel: Scalars["Boolean"]["output"];
  canChangeResponsible: Scalars["Boolean"]["output"];
  canChangeTask: Scalars["Boolean"]["output"];
  canComplete: Scalars["Boolean"]["output"];
  canConfigureRepeat: Scalars["Boolean"]["output"];
  canRemoveAttachment: Scalars["Boolean"]["output"];
  canRemoveFollower: Scalars["Boolean"]["output"];
  canReopen: Scalars["Boolean"]["output"];
  canSendCommentAsSms: Scalars["Boolean"]["output"];
  canShare: Scalars["Boolean"]["output"];
  canShowAttention: Scalars["Boolean"]["output"];
  canShowTimelogs: Scalars["Boolean"]["output"];
  canStart: Scalars["Boolean"]["output"];
  canToggleCheck: Scalars["Boolean"]["output"];
  canUpdate: Scalars["Boolean"]["output"];
  cancelledMessage?: Maybe<Scalars["String"]["output"]>;
  checks?: Maybe<Array<CaseCheck>>;
  commentUsers: Array<CaseCommentUserOption>;
  comments: Array<CaseComment>;
  company?: Maybe<Company>;
  completeBefore?: Maybe<Scalars["String"]["output"]>;
  completed?: Maybe<Scalars["Boolean"]["output"]>;
  completedDate?: Maybe<Scalars["ISO8601DateTime"]["output"]>;
  createdAt: Scalars["ISO8601DateTime"]["output"];
  displayName: Scalars["String"]["output"];
  flaggedByCurrentUser: Scalars["Boolean"]["output"];
  followers: Array<Follower>;
  icon: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  inspected?: Maybe<Scalars["Boolean"]["output"]>;
  inspection?: Maybe<Inspection>;
  isArchived: Scalars["Boolean"]["output"];
  isAttending?: Maybe<Scalars["Boolean"]["output"]>;
  isService: Scalars["Boolean"]["output"];
  mayAddAttachment: Scalars["Boolean"]["output"];
  mayAddComment: Scalars["Boolean"]["output"];
  mayAddFollower: Scalars["Boolean"]["output"];
  mayAddTimelog: Scalars["Boolean"]["output"];
  mayAwait: Scalars["Boolean"]["output"];
  mayCancel: Scalars["Boolean"]["output"];
  mayChangeResponsible: Scalars["Boolean"]["output"];
  mayChangeTask: Scalars["Boolean"]["output"];
  mayComplete: Scalars["Boolean"]["output"];
  mayConfigureRepeat: Scalars["Boolean"]["output"];
  mayCreate: Scalars["Boolean"]["output"];
  mayRemoveAttachment: Scalars["Boolean"]["output"];
  mayRemoveFollower: Scalars["Boolean"]["output"];
  mayReopen: Scalars["Boolean"]["output"];
  mayStart: Scalars["Boolean"]["output"];
  mayToggleCheck: Scalars["Boolean"]["output"];
  name: Scalars["String"]["output"];
  parent?: Maybe<CaseInterface>;
  processing?: Maybe<Scalars["Boolean"]["output"]>;
  property?: Maybe<Property>;
  repeatPeriod?: Maybe<Scalars["String"]["output"]>;
  repeatResponsible: Scalars["Boolean"]["output"];
  repeatSteps?: Maybe<Scalars["Int"]["output"]>;
  repeating: Scalars["Boolean"]["output"];
  requester?: Maybe<User>;
  responsible?: Maybe<CaseUser>;
  scheduledDate?: Maybe<Scalars["String"]["output"]>;
  scheduledTime?: Maybe<Scalars["String"]["output"]>;
  serviceDate?: Maybe<Scalars["ISO8601Date"]["output"]>;
  serviceEmployee?: Maybe<Scalars["String"]["output"]>;
  serviceTeam?: Maybe<ServiceTeam>;
  serviceTime?: Maybe<Scalars["String"]["output"]>;
  shareableDocuments: Array<Document>;
  shares: Array<CaseShare>;
  shortName: Scalars["String"]["output"];
  startAfter?: Maybe<Scalars["String"]["output"]>;
  state: Scalars["String"]["output"];
  stateLastChangedAt?: Maybe<Scalars["ISO8601DateTime"]["output"]>;
  stateText: Scalars["String"]["output"];
  tenancy?: Maybe<Tenancy>;
  tenantMayAttend: Scalars["Boolean"]["output"];
  tenantWillAttend?: Maybe<Scalars["Boolean"]["output"]>;
  timelogAccount?: Maybe<TimelogAccount>;
  timelogs: Array<Timelog>;
  title: Scalars["String"]["output"];
  titleRaw?: Maybe<Scalars["String"]["output"]>;
  totalCommentsCount: Scalars["Int"]["output"];
  type: CaseTypeEnum;
  unreadCommentsCount: Scalars["Int"]["output"];
  updatedAt: Scalars["ISO8601DateTime"]["output"];
  whyAttention: Array<CaseAttentionCondition>;
};

export type MiscAdministrationAvailableTeamsArgs = {
  forAssignment?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type MiscAdministrationCommentsArgs = {
  commentTypes?: InputMaybe<Array<CaseCommentTypeEnum>>;
};

export type MiscService = CaseInterface & {
  __typename?: "MiscService";
  apartment?: Maybe<Apartment>;
  archivedAt?: Maybe<Scalars["ISO8601DateTime"]["output"]>;
  archivedBy?: Maybe<CaseUser>;
  assignableServiceTeams: Array<ServiceTeam>;
  attachments: Array<CaseAttachment>;
  attention: CaseAttentionEnum;
  availableFollowers: Array<CaseUser>;
  availableResponsibleTeams: Array<AvailableResponsibleTeam>;
  availableResponsibleUsers: Array<CaseUser>;
  availableTeams: Array<Team>;
  availableTimelogAccounts: Array<TimelogAccount>;
  awaiting?: Maybe<Scalars["String"]["output"]>;
  body: Scalars["String"]["output"];
  calendarDate?: Maybe<Scalars["String"]["output"]>;
  calendarRange: DateRange;
  canAddAttachment: Scalars["Boolean"]["output"];
  canAddComment: Scalars["Boolean"]["output"];
  canAddFollower: Scalars["Boolean"]["output"];
  canAddTimelog: Scalars["Boolean"]["output"];
  canAwait: Scalars["Boolean"]["output"];
  canCancel: Scalars["Boolean"]["output"];
  canCancelScheduled: Scalars["Boolean"]["output"];
  canChangeResponsible: Scalars["Boolean"]["output"];
  canChangeServiceTeam: Scalars["Boolean"]["output"];
  canChangeTask: Scalars["Boolean"]["output"];
  canComplete: Scalars["Boolean"]["output"];
  canConfigureRepeat: Scalars["Boolean"]["output"];
  canReceive: Scalars["Boolean"]["output"];
  canRemoveAttachment: Scalars["Boolean"]["output"];
  canRemoveFollower: Scalars["Boolean"]["output"];
  canReopen: Scalars["Boolean"]["output"];
  canReschedule: Scalars["Boolean"]["output"];
  canSchedule: Scalars["Boolean"]["output"];
  canSendCommentAsSms: Scalars["Boolean"]["output"];
  canShare: Scalars["Boolean"]["output"];
  canShowAttention: Scalars["Boolean"]["output"];
  canShowTimelogs: Scalars["Boolean"]["output"];
  canTenantWillAttendNo: Scalars["Boolean"]["output"];
  canTenantWillAttendYes: Scalars["Boolean"]["output"];
  canToggleCheck: Scalars["Boolean"]["output"];
  canUpdate: Scalars["Boolean"]["output"];
  cancelledMessage?: Maybe<Scalars["String"]["output"]>;
  checks?: Maybe<Array<CaseCheck>>;
  commentUsers: Array<CaseCommentUserOption>;
  comments: Array<CaseComment>;
  company?: Maybe<Company>;
  completeBefore?: Maybe<Scalars["String"]["output"]>;
  completed?: Maybe<Scalars["Boolean"]["output"]>;
  completedDate?: Maybe<Scalars["ISO8601DateTime"]["output"]>;
  createdAt: Scalars["ISO8601DateTime"]["output"];
  displayName: Scalars["String"]["output"];
  flaggedByCurrentUser: Scalars["Boolean"]["output"];
  followers: Array<Follower>;
  icon: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  inspected?: Maybe<Scalars["Boolean"]["output"]>;
  inspection?: Maybe<Inspection>;
  isArchived: Scalars["Boolean"]["output"];
  isAttending?: Maybe<Scalars["Boolean"]["output"]>;
  isService: Scalars["Boolean"]["output"];
  mayAddAttachment: Scalars["Boolean"]["output"];
  mayAddComment: Scalars["Boolean"]["output"];
  mayAddFollower: Scalars["Boolean"]["output"];
  mayAddTimelog: Scalars["Boolean"]["output"];
  mayAwait: Scalars["Boolean"]["output"];
  mayCancel: Scalars["Boolean"]["output"];
  mayCancelScheduled: Scalars["Boolean"]["output"];
  mayChangeResponsible: Scalars["Boolean"]["output"];
  mayChangeServiceTeam: Scalars["Boolean"]["output"];
  mayChangeTask: Scalars["Boolean"]["output"];
  mayComplete: Scalars["Boolean"]["output"];
  mayConfigureRepeat: Scalars["Boolean"]["output"];
  mayCreate: Scalars["Boolean"]["output"];
  mayReceive: Scalars["Boolean"]["output"];
  mayRemoveAttachment: Scalars["Boolean"]["output"];
  mayRemoveFollower: Scalars["Boolean"]["output"];
  mayReopen: Scalars["Boolean"]["output"];
  mayReschedule: Scalars["Boolean"]["output"];
  maySchedule: Scalars["Boolean"]["output"];
  mayTenantWillAttendNo: Scalars["Boolean"]["output"];
  mayTenantWillAttendYes: Scalars["Boolean"]["output"];
  mayToggleCheck: Scalars["Boolean"]["output"];
  name: Scalars["String"]["output"];
  parent?: Maybe<CaseInterface>;
  processing?: Maybe<Scalars["Boolean"]["output"]>;
  property?: Maybe<Property>;
  repeatPeriod?: Maybe<Scalars["String"]["output"]>;
  repeatResponsible: Scalars["Boolean"]["output"];
  repeatSteps?: Maybe<Scalars["Int"]["output"]>;
  repeating: Scalars["Boolean"]["output"];
  requester?: Maybe<User>;
  responsible?: Maybe<CaseUser>;
  scheduledDate?: Maybe<Scalars["String"]["output"]>;
  scheduledTime?: Maybe<Scalars["String"]["output"]>;
  serviceDate?: Maybe<Scalars["ISO8601Date"]["output"]>;
  serviceEmployee?: Maybe<Scalars["String"]["output"]>;
  serviceTeam?: Maybe<ServiceTeam>;
  serviceTime?: Maybe<Scalars["String"]["output"]>;
  shareableDocuments: Array<Document>;
  shares: Array<CaseShare>;
  shortName: Scalars["String"]["output"];
  startAfter?: Maybe<Scalars["String"]["output"]>;
  state: Scalars["String"]["output"];
  stateLastChangedAt?: Maybe<Scalars["ISO8601DateTime"]["output"]>;
  stateText: Scalars["String"]["output"];
  tenancy?: Maybe<Tenancy>;
  tenantMayAttend: Scalars["Boolean"]["output"];
  tenantWillAttend?: Maybe<Scalars["Boolean"]["output"]>;
  timelogAccount?: Maybe<TimelogAccount>;
  timelogs: Array<Timelog>;
  title: Scalars["String"]["output"];
  titleRaw?: Maybe<Scalars["String"]["output"]>;
  totalCommentsCount: Scalars["Int"]["output"];
  type: CaseTypeEnum;
  unreadCommentsCount: Scalars["Int"]["output"];
  updatedAt: Scalars["ISO8601DateTime"]["output"];
  whyAttention: Array<CaseAttentionCondition>;
};

export type MiscServiceAvailableTeamsArgs = {
  forAssignment?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type MiscServiceCommentsArgs = {
  commentTypes?: InputMaybe<Array<CaseCommentTypeEnum>>;
};

export type MovingInService = CaseInterface & {
  __typename?: "MovingInService";
  apartment?: Maybe<Apartment>;
  archivedAt?: Maybe<Scalars["ISO8601DateTime"]["output"]>;
  archivedBy?: Maybe<CaseUser>;
  assignableServiceTeams: Array<ServiceTeam>;
  attachments: Array<CaseAttachment>;
  attention: CaseAttentionEnum;
  availableFollowers: Array<CaseUser>;
  availableResponsibleTeams: Array<AvailableResponsibleTeam>;
  availableResponsibleUsers: Array<CaseUser>;
  availableTeams: Array<Team>;
  availableTimelogAccounts: Array<TimelogAccount>;
  awaiting?: Maybe<Scalars["String"]["output"]>;
  body: Scalars["String"]["output"];
  calendarDate?: Maybe<Scalars["String"]["output"]>;
  calendarRange: DateRange;
  canAddAttachment: Scalars["Boolean"]["output"];
  canAddComment: Scalars["Boolean"]["output"];
  canAddFollower: Scalars["Boolean"]["output"];
  canAddTimelog: Scalars["Boolean"]["output"];
  canAwait: Scalars["Boolean"]["output"];
  canCancel: Scalars["Boolean"]["output"];
  canCancelScheduled: Scalars["Boolean"]["output"];
  canChangeResponsible: Scalars["Boolean"]["output"];
  canChangeServiceTeam: Scalars["Boolean"]["output"];
  canChangeTask: Scalars["Boolean"]["output"];
  canComplete: Scalars["Boolean"]["output"];
  canConfigureRepeat: Scalars["Boolean"]["output"];
  canReceive: Scalars["Boolean"]["output"];
  canRemoveAttachment: Scalars["Boolean"]["output"];
  canRemoveFollower: Scalars["Boolean"]["output"];
  canReopen: Scalars["Boolean"]["output"];
  canReschedule: Scalars["Boolean"]["output"];
  canSchedule: Scalars["Boolean"]["output"];
  canSendCommentAsSms: Scalars["Boolean"]["output"];
  canShare: Scalars["Boolean"]["output"];
  canShowAttention: Scalars["Boolean"]["output"];
  canShowTimelogs: Scalars["Boolean"]["output"];
  canTenantWillAttendNo: Scalars["Boolean"]["output"];
  canTenantWillAttendYes: Scalars["Boolean"]["output"];
  canToggleCheck: Scalars["Boolean"]["output"];
  canUpdate: Scalars["Boolean"]["output"];
  cancelledMessage?: Maybe<Scalars["String"]["output"]>;
  checks?: Maybe<Array<CaseCheck>>;
  commentUsers: Array<CaseCommentUserOption>;
  comments: Array<CaseComment>;
  company?: Maybe<Company>;
  completeBefore?: Maybe<Scalars["String"]["output"]>;
  completed?: Maybe<Scalars["Boolean"]["output"]>;
  completedDate?: Maybe<Scalars["ISO8601DateTime"]["output"]>;
  createdAt: Scalars["ISO8601DateTime"]["output"];
  displayName: Scalars["String"]["output"];
  flaggedByCurrentUser: Scalars["Boolean"]["output"];
  followers: Array<Follower>;
  icon: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  inspected?: Maybe<Scalars["Boolean"]["output"]>;
  inspection?: Maybe<Inspection>;
  isArchived: Scalars["Boolean"]["output"];
  isAttending?: Maybe<Scalars["Boolean"]["output"]>;
  isService: Scalars["Boolean"]["output"];
  mayAddAttachment: Scalars["Boolean"]["output"];
  mayAddComment: Scalars["Boolean"]["output"];
  mayAddFollower: Scalars["Boolean"]["output"];
  mayAddTimelog: Scalars["Boolean"]["output"];
  mayAwait: Scalars["Boolean"]["output"];
  mayCancel: Scalars["Boolean"]["output"];
  mayCancelScheduled: Scalars["Boolean"]["output"];
  mayChangeResponsible: Scalars["Boolean"]["output"];
  mayChangeServiceTeam: Scalars["Boolean"]["output"];
  mayChangeTask: Scalars["Boolean"]["output"];
  mayComplete: Scalars["Boolean"]["output"];
  mayConfigureRepeat: Scalars["Boolean"]["output"];
  mayCreate: Scalars["Boolean"]["output"];
  mayReceive: Scalars["Boolean"]["output"];
  mayRemoveAttachment: Scalars["Boolean"]["output"];
  mayRemoveFollower: Scalars["Boolean"]["output"];
  mayReopen: Scalars["Boolean"]["output"];
  mayReschedule: Scalars["Boolean"]["output"];
  maySchedule: Scalars["Boolean"]["output"];
  mayTenantWillAttendNo: Scalars["Boolean"]["output"];
  mayTenantWillAttendYes: Scalars["Boolean"]["output"];
  mayToggleCheck: Scalars["Boolean"]["output"];
  name: Scalars["String"]["output"];
  parent?: Maybe<CaseInterface>;
  processing?: Maybe<Scalars["Boolean"]["output"]>;
  property?: Maybe<Property>;
  repeatPeriod?: Maybe<Scalars["String"]["output"]>;
  repeatResponsible: Scalars["Boolean"]["output"];
  repeatSteps?: Maybe<Scalars["Int"]["output"]>;
  repeating: Scalars["Boolean"]["output"];
  requester?: Maybe<User>;
  responsible?: Maybe<CaseUser>;
  scheduledDate?: Maybe<Scalars["String"]["output"]>;
  scheduledTime?: Maybe<Scalars["String"]["output"]>;
  serviceDate?: Maybe<Scalars["ISO8601Date"]["output"]>;
  serviceEmployee?: Maybe<Scalars["String"]["output"]>;
  serviceTeam?: Maybe<ServiceTeam>;
  serviceTime?: Maybe<Scalars["String"]["output"]>;
  shareableDocuments: Array<Document>;
  shares: Array<CaseShare>;
  shortName: Scalars["String"]["output"];
  startAfter?: Maybe<Scalars["String"]["output"]>;
  state: Scalars["String"]["output"];
  stateLastChangedAt?: Maybe<Scalars["ISO8601DateTime"]["output"]>;
  stateText: Scalars["String"]["output"];
  tenancy?: Maybe<Tenancy>;
  tenantMayAttend: Scalars["Boolean"]["output"];
  tenantWillAttend?: Maybe<Scalars["Boolean"]["output"]>;
  timelogAccount?: Maybe<TimelogAccount>;
  timelogs: Array<Timelog>;
  title: Scalars["String"]["output"];
  titleRaw?: Maybe<Scalars["String"]["output"]>;
  totalCommentsCount: Scalars["Int"]["output"];
  type: CaseTypeEnum;
  unreadCommentsCount: Scalars["Int"]["output"];
  updatedAt: Scalars["ISO8601DateTime"]["output"];
  whyAttention: Array<CaseAttentionCondition>;
};

export type MovingInServiceAvailableTeamsArgs = {
  forAssignment?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type MovingInServiceCommentsArgs = {
  commentTypes?: InputMaybe<Array<CaseCommentTypeEnum>>;
};

export type MovingInTenancy = CaseInterface & {
  __typename?: "MovingInTenancy";
  apartment?: Maybe<Apartment>;
  archivedAt?: Maybe<Scalars["ISO8601DateTime"]["output"]>;
  archivedBy?: Maybe<CaseUser>;
  assignableServiceTeams: Array<ServiceTeam>;
  attachments: Array<CaseAttachment>;
  attention: CaseAttentionEnum;
  availableFollowers: Array<CaseUser>;
  availableResponsibleTeams: Array<AvailableResponsibleTeam>;
  availableResponsibleUsers: Array<CaseUser>;
  availableTeams: Array<Team>;
  availableTimelogAccounts: Array<TimelogAccount>;
  awaiting?: Maybe<Scalars["String"]["output"]>;
  body: Scalars["String"]["output"];
  calendarDate?: Maybe<Scalars["String"]["output"]>;
  calendarRange: DateRange;
  canAddAttachment: Scalars["Boolean"]["output"];
  canAddComment: Scalars["Boolean"]["output"];
  canAddFollower: Scalars["Boolean"]["output"];
  canAddTimelog: Scalars["Boolean"]["output"];
  canAwait: Scalars["Boolean"]["output"];
  canCancel: Scalars["Boolean"]["output"];
  canChangeResponsible: Scalars["Boolean"]["output"];
  canComplete: Scalars["Boolean"]["output"];
  canConfigureRepeat: Scalars["Boolean"]["output"];
  canReceive: Scalars["Boolean"]["output"];
  canRemoveAttachment: Scalars["Boolean"]["output"];
  canRemoveFollower: Scalars["Boolean"]["output"];
  canReopen: Scalars["Boolean"]["output"];
  canSchedule: Scalars["Boolean"]["output"];
  canSendCommentAsSms: Scalars["Boolean"]["output"];
  canShare: Scalars["Boolean"]["output"];
  canShowAttention: Scalars["Boolean"]["output"];
  canShowTimelogs: Scalars["Boolean"]["output"];
  canToggleCheck: Scalars["Boolean"]["output"];
  canUpdate: Scalars["Boolean"]["output"];
  cancelledMessage?: Maybe<Scalars["String"]["output"]>;
  checks?: Maybe<Array<CaseCheck>>;
  commentUsers: Array<CaseCommentUserOption>;
  comments: Array<CaseComment>;
  company?: Maybe<Company>;
  completeBefore?: Maybe<Scalars["String"]["output"]>;
  completed?: Maybe<Scalars["Boolean"]["output"]>;
  completedDate?: Maybe<Scalars["ISO8601DateTime"]["output"]>;
  createdAt: Scalars["ISO8601DateTime"]["output"];
  displayName: Scalars["String"]["output"];
  flaggedByCurrentUser: Scalars["Boolean"]["output"];
  followers: Array<Follower>;
  icon: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  inspected?: Maybe<Scalars["Boolean"]["output"]>;
  inspection?: Maybe<Inspection>;
  isArchived: Scalars["Boolean"]["output"];
  isAttending?: Maybe<Scalars["Boolean"]["output"]>;
  isService: Scalars["Boolean"]["output"];
  mayAddAttachment: Scalars["Boolean"]["output"];
  mayAddComment: Scalars["Boolean"]["output"];
  mayAddFollower: Scalars["Boolean"]["output"];
  mayAddTimelog: Scalars["Boolean"]["output"];
  mayAwait: Scalars["Boolean"]["output"];
  mayCancel: Scalars["Boolean"]["output"];
  mayChangeResponsible: Scalars["Boolean"]["output"];
  mayComplete: Scalars["Boolean"]["output"];
  mayConfigureRepeat: Scalars["Boolean"]["output"];
  mayCreate: Scalars["Boolean"]["output"];
  mayReceive: Scalars["Boolean"]["output"];
  mayRemoveAttachment: Scalars["Boolean"]["output"];
  mayRemoveFollower: Scalars["Boolean"]["output"];
  mayReopen: Scalars["Boolean"]["output"];
  maySchedule: Scalars["Boolean"]["output"];
  mayToggleCheck: Scalars["Boolean"]["output"];
  name: Scalars["String"]["output"];
  parent?: Maybe<CaseInterface>;
  processing?: Maybe<Scalars["Boolean"]["output"]>;
  property?: Maybe<Property>;
  repeatPeriod?: Maybe<Scalars["String"]["output"]>;
  repeatResponsible: Scalars["Boolean"]["output"];
  repeatSteps?: Maybe<Scalars["Int"]["output"]>;
  repeating: Scalars["Boolean"]["output"];
  requester?: Maybe<User>;
  responsible?: Maybe<CaseUser>;
  scheduledDate?: Maybe<Scalars["String"]["output"]>;
  scheduledTime?: Maybe<Scalars["String"]["output"]>;
  serviceDate?: Maybe<Scalars["ISO8601Date"]["output"]>;
  serviceEmployee?: Maybe<Scalars["String"]["output"]>;
  serviceTeam?: Maybe<ServiceTeam>;
  serviceTime?: Maybe<Scalars["String"]["output"]>;
  shareableDocuments: Array<Document>;
  shares: Array<CaseShare>;
  shortName: Scalars["String"]["output"];
  startAfter?: Maybe<Scalars["String"]["output"]>;
  state: Scalars["String"]["output"];
  stateLastChangedAt?: Maybe<Scalars["ISO8601DateTime"]["output"]>;
  stateText: Scalars["String"]["output"];
  tenancy?: Maybe<Tenancy>;
  tenantMayAttend: Scalars["Boolean"]["output"];
  tenantWillAttend?: Maybe<Scalars["Boolean"]["output"]>;
  timelogAccount?: Maybe<TimelogAccount>;
  timelogs: Array<Timelog>;
  title: Scalars["String"]["output"];
  titleRaw?: Maybe<Scalars["String"]["output"]>;
  totalCommentsCount: Scalars["Int"]["output"];
  type: CaseTypeEnum;
  unreadCommentsCount: Scalars["Int"]["output"];
  updatedAt: Scalars["ISO8601DateTime"]["output"];
  whyAttention: Array<CaseAttentionCondition>;
};

export type MovingInTenancyAvailableTeamsArgs = {
  forAssignment?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type MovingInTenancyCommentsArgs = {
  commentTypes?: InputMaybe<Array<CaseCommentTypeEnum>>;
};

export type MovingOutService = CaseInterface & {
  __typename?: "MovingOutService";
  apartment?: Maybe<Apartment>;
  archivedAt?: Maybe<Scalars["ISO8601DateTime"]["output"]>;
  archivedBy?: Maybe<CaseUser>;
  assignableServiceTeams: Array<ServiceTeam>;
  attachments: Array<CaseAttachment>;
  attention: CaseAttentionEnum;
  availableFollowers: Array<CaseUser>;
  availableResponsibleTeams: Array<AvailableResponsibleTeam>;
  availableResponsibleUsers: Array<CaseUser>;
  availableTeams: Array<Team>;
  availableTimelogAccounts: Array<TimelogAccount>;
  awaiting?: Maybe<Scalars["String"]["output"]>;
  body: Scalars["String"]["output"];
  calendarDate?: Maybe<Scalars["String"]["output"]>;
  calendarRange: DateRange;
  canAddAttachment: Scalars["Boolean"]["output"];
  canAddComment: Scalars["Boolean"]["output"];
  canAddFollower: Scalars["Boolean"]["output"];
  canAddTimelog: Scalars["Boolean"]["output"];
  canAwait: Scalars["Boolean"]["output"];
  canCancel: Scalars["Boolean"]["output"];
  canCancelScheduled: Scalars["Boolean"]["output"];
  canChangeResponsible: Scalars["Boolean"]["output"];
  canChangeServiceTeam: Scalars["Boolean"]["output"];
  canChangeTask: Scalars["Boolean"]["output"];
  canComplete: Scalars["Boolean"]["output"];
  canConfigureRepeat: Scalars["Boolean"]["output"];
  canReceive: Scalars["Boolean"]["output"];
  canRemoveAttachment: Scalars["Boolean"]["output"];
  canRemoveFollower: Scalars["Boolean"]["output"];
  canReopen: Scalars["Boolean"]["output"];
  canReschedule: Scalars["Boolean"]["output"];
  canSchedule: Scalars["Boolean"]["output"];
  canSendCommentAsSms: Scalars["Boolean"]["output"];
  canShare: Scalars["Boolean"]["output"];
  canShowAttention: Scalars["Boolean"]["output"];
  canShowTimelogs: Scalars["Boolean"]["output"];
  canTenantWillAttendNo: Scalars["Boolean"]["output"];
  canTenantWillAttendYes: Scalars["Boolean"]["output"];
  canToggleCheck: Scalars["Boolean"]["output"];
  canUpdate: Scalars["Boolean"]["output"];
  cancelledMessage?: Maybe<Scalars["String"]["output"]>;
  checks?: Maybe<Array<CaseCheck>>;
  commentUsers: Array<CaseCommentUserOption>;
  comments: Array<CaseComment>;
  company?: Maybe<Company>;
  completeBefore?: Maybe<Scalars["String"]["output"]>;
  completed?: Maybe<Scalars["Boolean"]["output"]>;
  completedDate?: Maybe<Scalars["ISO8601DateTime"]["output"]>;
  createdAt: Scalars["ISO8601DateTime"]["output"];
  displayName: Scalars["String"]["output"];
  flaggedByCurrentUser: Scalars["Boolean"]["output"];
  followers: Array<Follower>;
  icon: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  inspected?: Maybe<Scalars["Boolean"]["output"]>;
  inspection?: Maybe<Inspection>;
  isArchived: Scalars["Boolean"]["output"];
  isAttending?: Maybe<Scalars["Boolean"]["output"]>;
  isService: Scalars["Boolean"]["output"];
  mayAddAttachment: Scalars["Boolean"]["output"];
  mayAddComment: Scalars["Boolean"]["output"];
  mayAddFollower: Scalars["Boolean"]["output"];
  mayAddTimelog: Scalars["Boolean"]["output"];
  mayAwait: Scalars["Boolean"]["output"];
  mayCancel: Scalars["Boolean"]["output"];
  mayCancelScheduled: Scalars["Boolean"]["output"];
  mayChangeResponsible: Scalars["Boolean"]["output"];
  mayChangeServiceTeam: Scalars["Boolean"]["output"];
  mayChangeTask: Scalars["Boolean"]["output"];
  mayComplete: Scalars["Boolean"]["output"];
  mayConfigureRepeat: Scalars["Boolean"]["output"];
  mayCreate: Scalars["Boolean"]["output"];
  mayReceive: Scalars["Boolean"]["output"];
  mayRemoveAttachment: Scalars["Boolean"]["output"];
  mayRemoveFollower: Scalars["Boolean"]["output"];
  mayReopen: Scalars["Boolean"]["output"];
  mayReschedule: Scalars["Boolean"]["output"];
  maySchedule: Scalars["Boolean"]["output"];
  mayTenantWillAttendNo: Scalars["Boolean"]["output"];
  mayTenantWillAttendYes: Scalars["Boolean"]["output"];
  mayToggleCheck: Scalars["Boolean"]["output"];
  name: Scalars["String"]["output"];
  parent?: Maybe<CaseInterface>;
  processing?: Maybe<Scalars["Boolean"]["output"]>;
  property?: Maybe<Property>;
  repeatPeriod?: Maybe<Scalars["String"]["output"]>;
  repeatResponsible: Scalars["Boolean"]["output"];
  repeatSteps?: Maybe<Scalars["Int"]["output"]>;
  repeating: Scalars["Boolean"]["output"];
  requester?: Maybe<User>;
  responsible?: Maybe<CaseUser>;
  scheduledDate?: Maybe<Scalars["String"]["output"]>;
  scheduledTime?: Maybe<Scalars["String"]["output"]>;
  serviceDate?: Maybe<Scalars["ISO8601Date"]["output"]>;
  serviceEmployee?: Maybe<Scalars["String"]["output"]>;
  serviceTeam?: Maybe<ServiceTeam>;
  serviceTime?: Maybe<Scalars["String"]["output"]>;
  shareableDocuments: Array<Document>;
  shares: Array<CaseShare>;
  shortName: Scalars["String"]["output"];
  startAfter?: Maybe<Scalars["String"]["output"]>;
  state: Scalars["String"]["output"];
  stateLastChangedAt?: Maybe<Scalars["ISO8601DateTime"]["output"]>;
  stateText: Scalars["String"]["output"];
  tenancy?: Maybe<Tenancy>;
  tenantMayAttend: Scalars["Boolean"]["output"];
  tenantWillAttend?: Maybe<Scalars["Boolean"]["output"]>;
  timelogAccount?: Maybe<TimelogAccount>;
  timelogs: Array<Timelog>;
  title: Scalars["String"]["output"];
  titleRaw?: Maybe<Scalars["String"]["output"]>;
  totalCommentsCount: Scalars["Int"]["output"];
  type: CaseTypeEnum;
  unreadCommentsCount: Scalars["Int"]["output"];
  updatedAt: Scalars["ISO8601DateTime"]["output"];
  whyAttention: Array<CaseAttentionCondition>;
};

export type MovingOutServiceAvailableTeamsArgs = {
  forAssignment?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type MovingOutServiceCommentsArgs = {
  commentTypes?: InputMaybe<Array<CaseCommentTypeEnum>>;
};

export type MovingOutTenancy = CaseInterface & {
  __typename?: "MovingOutTenancy";
  apartment?: Maybe<Apartment>;
  archivedAt?: Maybe<Scalars["ISO8601DateTime"]["output"]>;
  archivedBy?: Maybe<CaseUser>;
  assignableServiceTeams: Array<ServiceTeam>;
  attachments: Array<CaseAttachment>;
  attention: CaseAttentionEnum;
  availableFollowers: Array<CaseUser>;
  availableResponsibleTeams: Array<AvailableResponsibleTeam>;
  availableResponsibleUsers: Array<CaseUser>;
  availableTeams: Array<Team>;
  availableTimelogAccounts: Array<TimelogAccount>;
  awaiting?: Maybe<Scalars["String"]["output"]>;
  body: Scalars["String"]["output"];
  calendarDate?: Maybe<Scalars["String"]["output"]>;
  calendarRange: DateRange;
  canAddAttachment: Scalars["Boolean"]["output"];
  canAddComment: Scalars["Boolean"]["output"];
  canAddFollower: Scalars["Boolean"]["output"];
  canAddTimelog: Scalars["Boolean"]["output"];
  canAwait: Scalars["Boolean"]["output"];
  canCancel: Scalars["Boolean"]["output"];
  canChangeResponsible: Scalars["Boolean"]["output"];
  canComplete: Scalars["Boolean"]["output"];
  canConfigureRepeat: Scalars["Boolean"]["output"];
  canReceive: Scalars["Boolean"]["output"];
  canRemoveAttachment: Scalars["Boolean"]["output"];
  canRemoveFollower: Scalars["Boolean"]["output"];
  canReopen: Scalars["Boolean"]["output"];
  canSchedule: Scalars["Boolean"]["output"];
  canSendCommentAsSms: Scalars["Boolean"]["output"];
  canShare: Scalars["Boolean"]["output"];
  canShowAttention: Scalars["Boolean"]["output"];
  canShowTimelogs: Scalars["Boolean"]["output"];
  canToggleCheck: Scalars["Boolean"]["output"];
  canUpdate: Scalars["Boolean"]["output"];
  cancelledMessage?: Maybe<Scalars["String"]["output"]>;
  checks?: Maybe<Array<CaseCheck>>;
  commentUsers: Array<CaseCommentUserOption>;
  comments: Array<CaseComment>;
  company?: Maybe<Company>;
  completeBefore?: Maybe<Scalars["String"]["output"]>;
  completed?: Maybe<Scalars["Boolean"]["output"]>;
  completedDate?: Maybe<Scalars["ISO8601DateTime"]["output"]>;
  createdAt: Scalars["ISO8601DateTime"]["output"];
  displayName: Scalars["String"]["output"];
  flaggedByCurrentUser: Scalars["Boolean"]["output"];
  followers: Array<Follower>;
  icon: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  inspected?: Maybe<Scalars["Boolean"]["output"]>;
  inspection?: Maybe<Inspection>;
  isArchived: Scalars["Boolean"]["output"];
  isAttending?: Maybe<Scalars["Boolean"]["output"]>;
  isService: Scalars["Boolean"]["output"];
  mayAddAttachment: Scalars["Boolean"]["output"];
  mayAddComment: Scalars["Boolean"]["output"];
  mayAddFollower: Scalars["Boolean"]["output"];
  mayAddTimelog: Scalars["Boolean"]["output"];
  mayAwait: Scalars["Boolean"]["output"];
  mayCancel: Scalars["Boolean"]["output"];
  mayChangeResponsible: Scalars["Boolean"]["output"];
  mayComplete: Scalars["Boolean"]["output"];
  mayConfigureRepeat: Scalars["Boolean"]["output"];
  mayCreate: Scalars["Boolean"]["output"];
  mayReceive: Scalars["Boolean"]["output"];
  mayRemoveAttachment: Scalars["Boolean"]["output"];
  mayRemoveFollower: Scalars["Boolean"]["output"];
  mayReopen: Scalars["Boolean"]["output"];
  maySchedule: Scalars["Boolean"]["output"];
  mayToggleCheck: Scalars["Boolean"]["output"];
  name: Scalars["String"]["output"];
  parent?: Maybe<CaseInterface>;
  processing?: Maybe<Scalars["Boolean"]["output"]>;
  property?: Maybe<Property>;
  repeatPeriod?: Maybe<Scalars["String"]["output"]>;
  repeatResponsible: Scalars["Boolean"]["output"];
  repeatSteps?: Maybe<Scalars["Int"]["output"]>;
  repeating: Scalars["Boolean"]["output"];
  requester?: Maybe<User>;
  responsible?: Maybe<CaseUser>;
  scheduledDate?: Maybe<Scalars["String"]["output"]>;
  scheduledTime?: Maybe<Scalars["String"]["output"]>;
  serviceDate?: Maybe<Scalars["ISO8601Date"]["output"]>;
  serviceEmployee?: Maybe<Scalars["String"]["output"]>;
  serviceTeam?: Maybe<ServiceTeam>;
  serviceTime?: Maybe<Scalars["String"]["output"]>;
  shareableDocuments: Array<Document>;
  shares: Array<CaseShare>;
  shortName: Scalars["String"]["output"];
  startAfter?: Maybe<Scalars["String"]["output"]>;
  state: Scalars["String"]["output"];
  stateLastChangedAt?: Maybe<Scalars["ISO8601DateTime"]["output"]>;
  stateText: Scalars["String"]["output"];
  tenancy?: Maybe<Tenancy>;
  tenantMayAttend: Scalars["Boolean"]["output"];
  tenantWillAttend?: Maybe<Scalars["Boolean"]["output"]>;
  timelogAccount?: Maybe<TimelogAccount>;
  timelogs: Array<Timelog>;
  title: Scalars["String"]["output"];
  titleRaw?: Maybe<Scalars["String"]["output"]>;
  totalCommentsCount: Scalars["Int"]["output"];
  type: CaseTypeEnum;
  unreadCommentsCount: Scalars["Int"]["output"];
  updatedAt: Scalars["ISO8601DateTime"]["output"];
  whyAttention: Array<CaseAttentionCondition>;
};

export type MovingOutTenancyAvailableTeamsArgs = {
  forAssignment?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type MovingOutTenancyCommentsArgs = {
  commentTypes?: InputMaybe<Array<CaseCommentTypeEnum>>;
};

export type MovingSettlementAdministration = CaseInterface & {
  __typename?: "MovingSettlementAdministration";
  apartment?: Maybe<Apartment>;
  archivedAt?: Maybe<Scalars["ISO8601DateTime"]["output"]>;
  archivedBy?: Maybe<CaseUser>;
  assignableServiceTeams: Array<ServiceTeam>;
  attachments: Array<CaseAttachment>;
  attention: CaseAttentionEnum;
  availableFollowers: Array<CaseUser>;
  availableResponsibleTeams: Array<AvailableResponsibleTeam>;
  availableResponsibleUsers: Array<CaseUser>;
  availableTeams: Array<Team>;
  availableTimelogAccounts: Array<TimelogAccount>;
  awaiting?: Maybe<Scalars["String"]["output"]>;
  body: Scalars["String"]["output"];
  calendarDate?: Maybe<Scalars["String"]["output"]>;
  calendarRange: DateRange;
  canAddAttachment: Scalars["Boolean"]["output"];
  canAddComment: Scalars["Boolean"]["output"];
  canAddFollower: Scalars["Boolean"]["output"];
  canAddTimelog: Scalars["Boolean"]["output"];
  canAwait: Scalars["Boolean"]["output"];
  canCancel: Scalars["Boolean"]["output"];
  canChangeResponsible: Scalars["Boolean"]["output"];
  canComplete: Scalars["Boolean"]["output"];
  canConfigureRepeat: Scalars["Boolean"]["output"];
  canReceive: Scalars["Boolean"]["output"];
  canRemoveAttachment: Scalars["Boolean"]["output"];
  canRemoveFollower: Scalars["Boolean"]["output"];
  canReopen: Scalars["Boolean"]["output"];
  canRequestTenantInformation: Scalars["Boolean"]["output"];
  canSendCommentAsSms: Scalars["Boolean"]["output"];
  canSendTenantInformation: Scalars["Boolean"]["output"];
  canShare: Scalars["Boolean"]["output"];
  canShowAttention: Scalars["Boolean"]["output"];
  canShowTimelogs: Scalars["Boolean"]["output"];
  canToggleCheck: Scalars["Boolean"]["output"];
  canUpdate: Scalars["Boolean"]["output"];
  cancelledMessage?: Maybe<Scalars["String"]["output"]>;
  checks?: Maybe<Array<CaseCheck>>;
  commentUsers: Array<CaseCommentUserOption>;
  comments: Array<CaseComment>;
  company?: Maybe<Company>;
  completeBefore?: Maybe<Scalars["String"]["output"]>;
  completed?: Maybe<Scalars["Boolean"]["output"]>;
  completedDate?: Maybe<Scalars["ISO8601DateTime"]["output"]>;
  createdAt: Scalars["ISO8601DateTime"]["output"];
  displayName: Scalars["String"]["output"];
  flaggedByCurrentUser: Scalars["Boolean"]["output"];
  followers: Array<Follower>;
  icon: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  inspected?: Maybe<Scalars["Boolean"]["output"]>;
  inspection?: Maybe<Inspection>;
  isArchived: Scalars["Boolean"]["output"];
  isAttending?: Maybe<Scalars["Boolean"]["output"]>;
  isService: Scalars["Boolean"]["output"];
  mayAddAttachment: Scalars["Boolean"]["output"];
  mayAddComment: Scalars["Boolean"]["output"];
  mayAddFollower: Scalars["Boolean"]["output"];
  mayAddTimelog: Scalars["Boolean"]["output"];
  mayAwait: Scalars["Boolean"]["output"];
  mayCancel: Scalars["Boolean"]["output"];
  mayChangeResponsible: Scalars["Boolean"]["output"];
  mayComplete: Scalars["Boolean"]["output"];
  mayConfigureRepeat: Scalars["Boolean"]["output"];
  mayCreate: Scalars["Boolean"]["output"];
  mayReceive: Scalars["Boolean"]["output"];
  mayRemoveAttachment: Scalars["Boolean"]["output"];
  mayRemoveFollower: Scalars["Boolean"]["output"];
  mayReopen: Scalars["Boolean"]["output"];
  mayRequestTenantInformation: Scalars["Boolean"]["output"];
  mayToggleCheck: Scalars["Boolean"]["output"];
  name: Scalars["String"]["output"];
  nextTenancy?: Maybe<Tenancy>;
  parent?: Maybe<CaseInterface>;
  processing?: Maybe<Scalars["Boolean"]["output"]>;
  property?: Maybe<Property>;
  repeatPeriod?: Maybe<Scalars["String"]["output"]>;
  repeatResponsible: Scalars["Boolean"]["output"];
  repeatSteps?: Maybe<Scalars["Int"]["output"]>;
  repeating: Scalars["Boolean"]["output"];
  requester?: Maybe<User>;
  responsible?: Maybe<CaseUser>;
  scheduledDate?: Maybe<Scalars["String"]["output"]>;
  scheduledTime?: Maybe<Scalars["String"]["output"]>;
  serviceDate?: Maybe<Scalars["ISO8601Date"]["output"]>;
  serviceEmployee?: Maybe<Scalars["String"]["output"]>;
  serviceTeam?: Maybe<ServiceTeam>;
  serviceTime?: Maybe<Scalars["String"]["output"]>;
  shareableDocuments: Array<Document>;
  shares: Array<CaseShare>;
  shortName: Scalars["String"]["output"];
  startAfter?: Maybe<Scalars["String"]["output"]>;
  state: Scalars["String"]["output"];
  stateLastChangedAt?: Maybe<Scalars["ISO8601DateTime"]["output"]>;
  stateText: Scalars["String"]["output"];
  tenancy?: Maybe<Tenancy>;
  tenantInformation?: Maybe<MovingSettlementTenantInformation>;
  tenantMayAttend: Scalars["Boolean"]["output"];
  tenantWillAttend?: Maybe<Scalars["Boolean"]["output"]>;
  timelogAccount?: Maybe<TimelogAccount>;
  timelogs: Array<Timelog>;
  title: Scalars["String"]["output"];
  titleRaw?: Maybe<Scalars["String"]["output"]>;
  totalCommentsCount: Scalars["Int"]["output"];
  type: CaseTypeEnum;
  unreadCommentsCount: Scalars["Int"]["output"];
  updatedAt: Scalars["ISO8601DateTime"]["output"];
  whyAttention: Array<CaseAttentionCondition>;
};

export type MovingSettlementAdministrationAvailableTeamsArgs = {
  forAssignment?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type MovingSettlementAdministrationCommentsArgs = {
  commentTypes?: InputMaybe<Array<CaseCommentTypeEnum>>;
};

export type MovingSettlementTenantInformation = {
  __typename?: "MovingSettlementTenantInformation";
  address?: Maybe<Scalars["String"]["output"]>;
  bankAccount?: Maybe<BankAccount>;
  city?: Maybe<Scalars["String"]["output"]>;
  countryName?: Maybe<Scalars["String"]["output"]>;
  email?: Maybe<Scalars["String"]["output"]>;
  name: Scalars["String"]["output"];
  phone?: Maybe<Scalars["String"]["output"]>;
  postalCode?: Maybe<Scalars["String"]["output"]>;
};

export type Mutation = {
  __typename?: "Mutation";
  apartmentUpdate?: Maybe<ApartmentUpdateMutationPayload>;
  caseCommentRead?: Maybe<CaseCommentReadMutationPayload>;
  caseCreate?: Maybe<CaseCreateMutationPayload>;
  caseEndTenancyUpdateReasons?: Maybe<CaseEndTenancyUpdateReasonsMutationPayload>;
  caseInspectionProcess?: Maybe<CaseInspectionProcessMutationPayload>;
  caseInspectionSave?: Maybe<CaseInspectionSaveMutationPayload>;
  casePlanningUpdate?: Maybe<CasePlanningUpdateMutationPayload>;
  caseSchedule?: Maybe<CaseScheduleMutationPayload>;
  caseShareCreate?: Maybe<CaseShareCreateMutationPayload>;
  caseShareRevoke?: Maybe<CaseShareRevokeMutationPayload>;
  caseShareSend?: Maybe<CaseShareSendMutationPayload>;
  caseUpdate?: Maybe<CaseUpdateMutationPayload>;
  deleteInspectionAnswer?: Maybe<DeleteInspectionAnswerMutationPayload>;
  deletePayment?: Maybe<DeletePaymentMutationPayload>;
  deleteTextMacro?: Maybe<DeleteTextMacroMutationPayload>;
  economicResync?: Maybe<EconomicResyncMutationPayload>;
  interestListEntryCreate?: Maybe<InterestListEntryCreateMutationPayload>;
  interestListEntryDelete?: Maybe<InterestListEntryDeleteMutationPayload>;
  interestListEntryUpdate?: Maybe<InterestListEntryUpdateMutationPayload>;
  interestListNoteCreate?: Maybe<InterestListNoteCreateMutationPayload>;
  interestListPersonDelete?: Maybe<InterestListPersonDeleteMutationPayload>;
  interestListPersonUpdate?: Maybe<InterestListPersonUpdateMutationPayload>;
  lookupUser?: Maybe<User>;
  personalAccessTokenCreate?: Maybe<PersonalAccessTokenCreateMutationPayload>;
  personalAccessTokenDelete?: Maybe<PersonalAccessTokenDeleteMutationPayload>;
  phoneConfirm?: Maybe<PhoneConfirmMutationPayload>;
  propertyUpdate?: Maybe<PropertyUpdateMutationPayload>;
  saveInspectionAnswer?: Maybe<SaveInspectionAnswerMutationPayload>;
  savePayment?: Maybe<SavePaymentMutationPayload>;
  saveTextMacro?: Maybe<SaveTextMacroMutationPayload>;
  shortcutCreate?: Maybe<ShortcutCreateMutationPayload>;
  shortcutDelete?: Maybe<ShortcutDeleteMutationPayload>;
  shortcutUpdate?: Maybe<ShortcutUpdatePayload>;
  tenancyCreate?: Maybe<TenancyCreateMutationPayload>;
  tenancyDebtorLink?: Maybe<TenancyDebtorLinkMutationPayload>;
  tenancyDebtorUnlink?: Maybe<TenancyDebtorUnlinkMutationPayload>;
  tenancyEnd?: Maybe<EndTenancyMutationPayload>;
  tenancyNoteCreate?: Maybe<TenancyNoteCreateMutationPayload>;
  tenancyNoteDelete?: Maybe<TenancyNoteDeleteMutationPayload>;
  tenancyNoteUpdate?: Maybe<TenancyNoteUpdateMutationPayload>;
  tenancyRemove?: Maybe<TenancyRemoveMutationPayload>;
  tenancyResidentCreate?: Maybe<TenancyResidentCreateMutationPayload>;
  tenancyResidentRemove?: Maybe<TenancyResidentRemoveMutationPayload>;
  tenancyResidentUpdate?: Maybe<TenancyResidentUpdateMutationPayload>;
  tenancyRoleCreate?: Maybe<TenancyRoleCreateMutationPayload>;
  tenancyRoleRemove?: Maybe<TenancyRoleRemoveMutationPayload>;
  tenancyRoleUpdate?: Maybe<TenancyRoleUpdateMutationPayload>;
  tenancyUpdate?: Maybe<TenancyUpdateMutationPayload>;
  timelogDelete?: Maybe<TimelogDeleteMutationPayload>;
  timelogUpdate?: Maybe<TimelogUpdateMutationPayload>;
  toggleCaseFlag?: Maybe<ToggleCaseFlagMutationPayload>;
  updateExternalUser?: Maybe<UpdateExternalUserMutationPayload>;
};

export type MutationApartmentUpdateArgs = {
  apartmentId: Scalars["ID"]["input"];
  fields?: InputMaybe<Array<FieldValueInput>>;
};

export type MutationCaseCommentReadArgs = {
  caseId: Scalars["ID"]["input"];
  senderId: Scalars["ID"]["input"];
};

export type MutationCaseCreateArgs = {
  apartmentId?: InputMaybe<Scalars["ID"]["input"]>;
  input?: InputMaybe<CaseEventInput>;
  parentId?: InputMaybe<Scalars["ID"]["input"]>;
  propertyId?: InputMaybe<Scalars["ID"]["input"]>;
  requester?: InputMaybe<Scalars["String"]["input"]>;
  tenancyId?: InputMaybe<Scalars["ID"]["input"]>;
  type: CaseTypeEnum;
};

export type MutationCaseEndTenancyUpdateReasonsArgs = {
  caseId: Scalars["ID"]["input"];
  reasons: Array<EndTenancyReasonSelectionInput>;
};

export type MutationCaseInspectionProcessArgs = {
  input: BaseInspectionInput;
};

export type MutationCaseInspectionSaveArgs = {
  input: BaseInspectionInput;
};

export type MutationCasePlanningUpdateArgs = {
  caseId: Scalars["ID"]["input"];
  completeBefore?: InputMaybe<Scalars["ISO8601Date"]["input"]>;
  responsibleId?: InputMaybe<Scalars["ID"]["input"]>;
  scheduledDate?: InputMaybe<Scalars["ISO8601Date"]["input"]>;
  scheduledTime?: InputMaybe<Scalars["String"]["input"]>;
  startAfter?: InputMaybe<Scalars["ISO8601Date"]["input"]>;
};

export type MutationCaseScheduleArgs = {
  caseId: Scalars["ID"]["input"];
  scheduledDate: Scalars["ISO8601Date"]["input"];
  scheduledTime: Scalars["String"]["input"];
};

export type MutationCaseShareCreateArgs = {
  caseId: Scalars["ID"]["input"];
  description: Scalars["String"]["input"];
  expiresAt?: InputMaybe<Scalars["ISO8601DateTime"]["input"]>;
  note: Scalars["String"]["input"];
  selection: CaseShareSelectionInput;
};

export type MutationCaseShareRevokeArgs = {
  shareId: Scalars["ID"]["input"];
};

export type MutationCaseShareSendArgs = {
  emails?: InputMaybe<Array<Scalars["String"]["input"]>>;
  phones?: InputMaybe<Array<Scalars["String"]["input"]>>;
  shareId: Scalars["ID"]["input"];
};

export type MutationCaseUpdateArgs = {
  caseId: Scalars["ID"]["input"];
  event: CaseEventEnum;
  input?: InputMaybe<CaseEventInput>;
};

export type MutationDeleteInspectionAnswerArgs = {
  areaId: Scalars["ID"]["input"];
  caseId: Scalars["ID"]["input"];
  subjectId: Scalars["ID"]["input"];
};

export type MutationDeletePaymentArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationDeleteTextMacroArgs = {
  id: Scalars["Int"]["input"];
};

export type MutationEconomicResyncArgs = {
  byTenancy?: InputMaybe<Scalars["ID"]["input"]>;
};

export type MutationInterestListEntryCreateArgs = {
  channel?: InputMaybe<Scalars["String"]["input"]>;
  email: Scalars["String"]["input"];
  failOnDuplicate?: InputMaybe<Scalars["Boolean"]["input"]>;
  message?: InputMaybe<Scalars["String"]["input"]>;
  name: Scalars["String"]["input"];
  phone: Scalars["String"]["input"];
  propertyIds: Array<Scalars["ID"]["input"]>;
};

export type MutationInterestListEntryDeleteArgs = {
  id: Scalars["ID"]["input"];
  note: Scalars["String"]["input"];
};

export type MutationInterestListEntryUpdateArgs = {
  channel?: InputMaybe<Scalars["String"]["input"]>;
  email?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["ID"]["input"];
  message?: InputMaybe<Scalars["String"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  phone?: InputMaybe<Scalars["String"]["input"]>;
  propertyIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  seenAt?: InputMaybe<Scalars["ISO8601DateTime"]["input"]>;
};

export type MutationInterestListNoteCreateArgs = {
  entryId: Scalars["ID"]["input"];
  note: Scalars["String"]["input"];
};

export type MutationInterestListPersonDeleteArgs = {
  id: Scalars["ID"]["input"];
  isBlacklisted?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type MutationInterestListPersonUpdateArgs = {
  email?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["ID"]["input"];
  isBlacklisted?: InputMaybe<Scalars["Boolean"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  phone?: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationLookupUserArgs = {
  email: Scalars["String"]["input"];
};

export type MutationPersonalAccessTokenCreateArgs = {
  name: Scalars["String"]["input"];
};

export type MutationPersonalAccessTokenDeleteArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationPhoneConfirmArgs = {
  userId: Scalars["ID"]["input"];
};

export type MutationPropertyUpdateArgs = {
  fields?: InputMaybe<Array<FieldValueInput>>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  propertyId: Scalars["ID"]["input"];
};

export type MutationSaveInspectionAnswerArgs = {
  areaId: Scalars["ID"]["input"];
  caseId: Scalars["ID"]["input"];
  note?: InputMaybe<Scalars["String"]["input"]>;
  position: Scalars["Int"]["input"];
  rating: Scalars["Int"]["input"];
  subjectId: Scalars["ID"]["input"];
};

export type MutationSavePaymentArgs = {
  amount: Scalars["Float"]["input"];
  endDate: Scalars["String"]["input"];
  id?: InputMaybe<Scalars["ID"]["input"]>;
  reference?: InputMaybe<Scalars["String"]["input"]>;
  startDate: Scalars["String"]["input"];
  tenancyId: Scalars["ID"]["input"];
};

export type MutationSaveTextMacroArgs = {
  available: Scalars["String"]["input"];
  content: Scalars["String"]["input"];
  id?: InputMaybe<Scalars["Int"]["input"]>;
  name: Scalars["String"]["input"];
};

export type MutationShortcutCreateArgs = {
  attributes: ShortcutAttributesInput;
};

export type MutationShortcutDeleteArgs = {
  shortcutId: Scalars["ID"]["input"];
};

export type MutationShortcutUpdateArgs = {
  attributes: ShortcutAttributesInput;
  shortcutId: Scalars["ID"]["input"];
};

export type MutationTenancyCreateArgs = {
  apartment: Scalars["String"]["input"];
  depositAmount?: InputMaybe<Scalars["Float"]["input"]>;
  endDate?: InputMaybe<Scalars["ISO8601Date"]["input"]>;
  endTenancyTerms?: InputMaybe<Scalars["String"]["input"]>;
  startDate?: InputMaybe<Scalars["ISO8601Date"]["input"]>;
  user: TenancyUserInput;
};

export type MutationTenancyDebtorLinkArgs = {
  debtorId: Scalars["ID"]["input"];
  tenancyId: Scalars["ID"]["input"];
};

export type MutationTenancyDebtorUnlinkArgs = {
  tenancyId: Scalars["ID"]["input"];
};

export type MutationTenancyEndArgs = {
  comment?: InputMaybe<Scalars["String"]["input"]>;
  endDate: Scalars["ISO8601Date"]["input"];
  endTenancyReasons?: InputMaybe<Array<Scalars["String"]["input"]>>;
  otherReasonNote?: InputMaybe<Scalars["String"]["input"]>;
  tenancyId: Scalars["ID"]["input"];
};

export type MutationTenancyNoteCreateArgs = {
  attachments?: InputMaybe<Array<Scalars["String"]["input"]>>;
  content: Scalars["String"]["input"];
  tenancyId: Scalars["ID"]["input"];
};

export type MutationTenancyNoteDeleteArgs = {
  noteId: Scalars["ID"]["input"];
  tenancyId: Scalars["ID"]["input"];
};

export type MutationTenancyNoteUpdateArgs = {
  attachments?: InputMaybe<Array<Scalars["String"]["input"]>>;
  attachmentsToRemove?: InputMaybe<Array<Scalars["String"]["input"]>>;
  content?: InputMaybe<Scalars["String"]["input"]>;
  noteId: Scalars["ID"]["input"];
  tenancyId: Scalars["ID"]["input"];
};

export type MutationTenancyRemoveArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationTenancyResidentCreateArgs = {
  email?: InputMaybe<Scalars["String"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  phone?: InputMaybe<Scalars["String"]["input"]>;
  tenancyId: Scalars["ID"]["input"];
};

export type MutationTenancyResidentRemoveArgs = {
  residentId: Scalars["ID"]["input"];
};

export type MutationTenancyResidentUpdateArgs = {
  email?: InputMaybe<Scalars["String"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  phone?: InputMaybe<Scalars["String"]["input"]>;
  residentId: Scalars["ID"]["input"];
};

export type MutationTenancyRoleCreateArgs = {
  email?: InputMaybe<Scalars["String"]["input"]>;
  isPrimary?: InputMaybe<Scalars["Boolean"]["input"]>;
  isResident?: InputMaybe<Scalars["Boolean"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  phone?: InputMaybe<Scalars["String"]["input"]>;
  tenancyId: Scalars["ID"]["input"];
  userId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type MutationTenancyRoleRemoveArgs = {
  tenancyRoleId: Scalars["ID"]["input"];
};

export type MutationTenancyRoleUpdateArgs = {
  isPrimary?: InputMaybe<Scalars["Boolean"]["input"]>;
  isResident?: InputMaybe<Scalars["Boolean"]["input"]>;
  tenancyRoleId: Scalars["ID"]["input"];
};

export type MutationTenancyUpdateArgs = {
  depositAmount?: InputMaybe<Scalars["Float"]["input"]>;
  endDate?: InputMaybe<Scalars["ISO8601Date"]["input"]>;
  endTenancyTerms?: InputMaybe<Scalars["String"]["input"]>;
  fields?: InputMaybe<Array<FieldValueInput>>;
  intervalAmount?: InputMaybe<Scalars["Float"]["input"]>;
  startDate?: InputMaybe<Scalars["ISO8601Date"]["input"]>;
  tenancyId: Scalars["ID"]["input"];
};

export type MutationTimelogDeleteArgs = {
  timelogId: Scalars["ID"]["input"];
};

export type MutationTimelogUpdateArgs = {
  accountId: Scalars["ID"]["input"];
  categoryId: Scalars["ID"]["input"];
  date: Scalars["ISO8601Date"]["input"];
  hoursWithoutMinutes: Scalars["Int"]["input"];
  minutesWithoutHours: Scalars["Int"]["input"];
  note?: InputMaybe<Scalars["String"]["input"]>;
  timelogId: Scalars["ID"]["input"];
};

export type MutationToggleCaseFlagArgs = {
  caseId: Scalars["ID"]["input"];
  flagged?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type MutationUpdateExternalUserArgs = {
  email?: InputMaybe<Scalars["String"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  phone?: InputMaybe<Scalars["String"]["input"]>;
  userId: Scalars["ID"]["input"];
};

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: "PageInfo";
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars["String"]["output"]>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars["Boolean"]["output"];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars["Boolean"]["output"];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars["String"]["output"]>;
};

export type PartnerProduct = {
  __typename?: "PartnerProduct";
  name: Scalars["String"]["output"];
  partner: Scalars["String"]["output"];
};

export type Payment = {
  __typename?: "Payment";
  amount: Scalars["Float"]["output"];
  endDate: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  reference?: Maybe<Scalars["String"]["output"]>;
  startDate: Scalars["String"]["output"];
};

export type PersonalAccessToken = {
  __typename?: "PersonalAccessToken";
  createdAt: Scalars["ISO8601DateTime"]["output"];
  expiresAt?: Maybe<Scalars["ISO8601DateTime"]["output"]>;
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
  token?: Maybe<Scalars["String"]["output"]>;
};

/** The connection type for PersonalAccessToken. */
export type PersonalAccessTokenConnection = {
  __typename?: "PersonalAccessTokenConnection";
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PersonalAccessTokenEdge>>>;
  /** A list of nodes. */
  nodes: Array<PersonalAccessToken>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars["Int"]["output"]>;
};

/** Autogenerated return type of PersonalAccessTokenCreateMutation. */
export type PersonalAccessTokenCreateMutationPayload = {
  __typename?: "PersonalAccessTokenCreateMutationPayload";
  errors?: Maybe<Array<Scalars["String"]["output"]>>;
  personalAccessToken?: Maybe<PersonalAccessToken>;
};

/** Autogenerated return type of PersonalAccessTokenDeleteMutation. */
export type PersonalAccessTokenDeleteMutationPayload = {
  __typename?: "PersonalAccessTokenDeleteMutationPayload";
  errors: Array<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
};

/** An edge in a connection. */
export type PersonalAccessTokenEdge = {
  __typename?: "PersonalAccessTokenEdge";
  /** A cursor for use in pagination. */
  cursor: Scalars["String"]["output"];
  /** The item at the end of the edge. */
  node?: Maybe<PersonalAccessToken>;
};

/** Autogenerated return type of PhoneConfirmMutation. */
export type PhoneConfirmMutationPayload = {
  __typename?: "PhoneConfirmMutationPayload";
  errors: Array<Scalars["String"]["output"]>;
  user?: Maybe<User>;
};

export type PreparationService = CaseInterface & {
  __typename?: "PreparationService";
  apartment?: Maybe<Apartment>;
  archivedAt?: Maybe<Scalars["ISO8601DateTime"]["output"]>;
  archivedBy?: Maybe<CaseUser>;
  assignableServiceTeams: Array<ServiceTeam>;
  attachments: Array<CaseAttachment>;
  attention: CaseAttentionEnum;
  availableFollowers: Array<CaseUser>;
  availableResponsibleTeams: Array<AvailableResponsibleTeam>;
  availableResponsibleUsers: Array<CaseUser>;
  availableTeams: Array<Team>;
  availableTimelogAccounts: Array<TimelogAccount>;
  awaiting?: Maybe<Scalars["String"]["output"]>;
  body: Scalars["String"]["output"];
  calendarDate?: Maybe<Scalars["String"]["output"]>;
  calendarRange: DateRange;
  canAddAttachment: Scalars["Boolean"]["output"];
  canAddComment: Scalars["Boolean"]["output"];
  canAddFollower: Scalars["Boolean"]["output"];
  canAddTimelog: Scalars["Boolean"]["output"];
  canAwait: Scalars["Boolean"]["output"];
  canCancel: Scalars["Boolean"]["output"];
  canCancelScheduled: Scalars["Boolean"]["output"];
  canChangeResponsible: Scalars["Boolean"]["output"];
  canChangeServiceTeam: Scalars["Boolean"]["output"];
  canChangeTask: Scalars["Boolean"]["output"];
  canComplete: Scalars["Boolean"]["output"];
  canConfigureRepeat: Scalars["Boolean"]["output"];
  canReceive: Scalars["Boolean"]["output"];
  canRemoveAttachment: Scalars["Boolean"]["output"];
  canRemoveFollower: Scalars["Boolean"]["output"];
  canReopen: Scalars["Boolean"]["output"];
  canReschedule: Scalars["Boolean"]["output"];
  canSchedule: Scalars["Boolean"]["output"];
  canSendCommentAsSms: Scalars["Boolean"]["output"];
  canShare: Scalars["Boolean"]["output"];
  canShowAttention: Scalars["Boolean"]["output"];
  canShowTimelogs: Scalars["Boolean"]["output"];
  canTenantWillAttendNo: Scalars["Boolean"]["output"];
  canTenantWillAttendYes: Scalars["Boolean"]["output"];
  canToggleCheck: Scalars["Boolean"]["output"];
  canUpdate: Scalars["Boolean"]["output"];
  cancelledMessage?: Maybe<Scalars["String"]["output"]>;
  checks?: Maybe<Array<CaseCheck>>;
  commentUsers: Array<CaseCommentUserOption>;
  comments: Array<CaseComment>;
  company?: Maybe<Company>;
  completeBefore?: Maybe<Scalars["String"]["output"]>;
  completed?: Maybe<Scalars["Boolean"]["output"]>;
  completedDate?: Maybe<Scalars["ISO8601DateTime"]["output"]>;
  createdAt: Scalars["ISO8601DateTime"]["output"];
  displayName: Scalars["String"]["output"];
  flaggedByCurrentUser: Scalars["Boolean"]["output"];
  followers: Array<Follower>;
  icon: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  inspected?: Maybe<Scalars["Boolean"]["output"]>;
  inspection?: Maybe<Inspection>;
  isArchived: Scalars["Boolean"]["output"];
  isAttending?: Maybe<Scalars["Boolean"]["output"]>;
  isService: Scalars["Boolean"]["output"];
  mayAddAttachment: Scalars["Boolean"]["output"];
  mayAddComment: Scalars["Boolean"]["output"];
  mayAddFollower: Scalars["Boolean"]["output"];
  mayAddTimelog: Scalars["Boolean"]["output"];
  mayAwait: Scalars["Boolean"]["output"];
  mayCancel: Scalars["Boolean"]["output"];
  mayCancelScheduled: Scalars["Boolean"]["output"];
  mayChangeResponsible: Scalars["Boolean"]["output"];
  mayChangeServiceTeam: Scalars["Boolean"]["output"];
  mayChangeTask: Scalars["Boolean"]["output"];
  mayComplete: Scalars["Boolean"]["output"];
  mayConfigureRepeat: Scalars["Boolean"]["output"];
  mayCreate: Scalars["Boolean"]["output"];
  mayReceive: Scalars["Boolean"]["output"];
  mayRemoveAttachment: Scalars["Boolean"]["output"];
  mayRemoveFollower: Scalars["Boolean"]["output"];
  mayReopen: Scalars["Boolean"]["output"];
  mayReschedule: Scalars["Boolean"]["output"];
  maySchedule: Scalars["Boolean"]["output"];
  mayTenantWillAttendNo: Scalars["Boolean"]["output"];
  mayTenantWillAttendYes: Scalars["Boolean"]["output"];
  mayToggleCheck: Scalars["Boolean"]["output"];
  name: Scalars["String"]["output"];
  parent?: Maybe<CaseInterface>;
  processing?: Maybe<Scalars["Boolean"]["output"]>;
  property?: Maybe<Property>;
  repeatPeriod?: Maybe<Scalars["String"]["output"]>;
  repeatResponsible: Scalars["Boolean"]["output"];
  repeatSteps?: Maybe<Scalars["Int"]["output"]>;
  repeating: Scalars["Boolean"]["output"];
  requester?: Maybe<User>;
  responsible?: Maybe<CaseUser>;
  scheduledDate?: Maybe<Scalars["String"]["output"]>;
  scheduledTime?: Maybe<Scalars["String"]["output"]>;
  serviceDate?: Maybe<Scalars["ISO8601Date"]["output"]>;
  serviceEmployee?: Maybe<Scalars["String"]["output"]>;
  serviceTeam?: Maybe<ServiceTeam>;
  serviceTime?: Maybe<Scalars["String"]["output"]>;
  shareableDocuments: Array<Document>;
  shares: Array<CaseShare>;
  shortName: Scalars["String"]["output"];
  startAfter?: Maybe<Scalars["String"]["output"]>;
  state: Scalars["String"]["output"];
  stateLastChangedAt?: Maybe<Scalars["ISO8601DateTime"]["output"]>;
  stateText: Scalars["String"]["output"];
  tenancy?: Maybe<Tenancy>;
  tenantMayAttend: Scalars["Boolean"]["output"];
  tenantWillAttend?: Maybe<Scalars["Boolean"]["output"]>;
  timelogAccount?: Maybe<TimelogAccount>;
  timelogs: Array<Timelog>;
  title: Scalars["String"]["output"];
  titleRaw?: Maybe<Scalars["String"]["output"]>;
  totalCommentsCount: Scalars["Int"]["output"];
  type: CaseTypeEnum;
  unreadCommentsCount: Scalars["Int"]["output"];
  updatedAt: Scalars["ISO8601DateTime"]["output"];
  whyAttention: Array<CaseAttentionCondition>;
};

export type PreparationServiceAvailableTeamsArgs = {
  forAssignment?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type PreparationServiceCommentsArgs = {
  commentTypes?: InputMaybe<Array<CaseCommentTypeEnum>>;
};

export type Property = RecordInterface & {
  __typename?: "Property";
  activeServiceCasesCount: Scalars["Int"]["output"];
  administrator: Company;
  availableFieldGroups: Array<FieldGroup>;
  canUpdate: Scalars["Boolean"]["output"];
  createdAt: Scalars["ISO8601DateTime"]["output"];
  fieldGroups: Array<PropertyFieldGroup>;
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
  owner: Company;
  updatedAt: Scalars["ISO8601DateTime"]["output"];
};

export type PropertyFieldGroup = {
  __typename?: "PropertyFieldGroup";
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
  position: Scalars["Int"]["output"];
  values: Array<FieldValue>;
};

export type PropertyList = {
  __typename?: "PropertyList";
  count: Scalars["Int"]["output"];
  records: Array<Property>;
  total: Scalars["Int"]["output"];
};

export enum PropertyOrderByEnum {
  AdministratorAsc = "administrator_ASC",
  AdministratorDesc = "administrator_DESC",
  CreatedAtAsc = "createdAt_ASC",
  CreatedAtDesc = "createdAt_DESC",
  NameAsc = "name_ASC",
  NameDesc = "name_DESC",
  OwnerAsc = "owner_ASC",
  OwnerDesc = "owner_DESC",
  UpdatedAtAsc = "updatedAt_ASC",
  UpdatedAtDesc = "updatedAt_DESC",
}

/** Autogenerated return type of PropertyUpdateMutation. */
export type PropertyUpdateMutationPayload = {
  __typename?: "PropertyUpdateMutationPayload";
  errors: Array<Scalars["String"]["output"]>;
  property?: Maybe<Property>;
};

export type PropertyWhereInput = {
  archived?: InputMaybe<Scalars["Boolean"]["input"]>;
  byAdministrator?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  byId?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  byOwner?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  byServiceTeam?: InputMaybe<Scalars["ID"]["input"]>;
  forCurrentUser?: InputMaybe<Scalars["Boolean"]["input"]>;
  interestListEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  search?: InputMaybe<Scalars["String"]["input"]>;
};

export type Query = {
  __typename?: "Query";
  apartment?: Maybe<Apartment>;
  apartments: ApartmentList;
  attachmentCategories: Array<AttachmentCategory>;
  case?: Maybe<CaseInterface>;
  caseDefinitions: Array<CaseDefinition>;
  cases: CaseList;
  companies: CompanyList;
  contractOptions: ContractOptions;
  currentUser?: Maybe<User>;
  economicDebtors: EconomicDebtorList;
  economicSubscribers: EconomicSubscriberList;
  economicSubscription?: Maybe<EconomicSubscription>;
  economicSubscriptions: EconomicSubscriptionList;
  endTenancyReasons: Array<EndTenancyReason>;
  fieldGroups: FieldGroupList;
  fields?: Maybe<FieldList>;
  interestListEntries: InterestListEntryList;
  interestListEntry?: Maybe<InterestListEntry>;
  interestListPeople: InterestListPersonList;
  interestListPerson?: Maybe<InterestListPerson>;
  properties: PropertyList;
  property?: Maybe<Property>;
  questions: Array<Question>;
  team?: Maybe<Team>;
  teamMembers: UserList;
  teams: TeamList;
  tenancies: TenancyList;
  tenancy?: Maybe<Tenancy>;
  textMacros: Array<TextMacro>;
  timelogAccounts: Array<TimelogAccount>;
};

export type QueryApartmentArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryApartmentsArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<ApartmentOrderByEnum>;
  where?: InputMaybe<ApartmentWhereInput>;
};

export type QueryAttachmentCategoriesArgs = {
  lang: Scalars["String"]["input"];
};

export type QueryCaseArgs = {
  byType?: InputMaybe<Array<Scalars["String"]["input"]>>;
  caseId: Scalars["ID"]["input"];
};

export type QueryCasesArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<CaseOrderByEnum>;
  where?: InputMaybe<CaseWhereInput>;
};

export type QueryCompaniesArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<CompanyOrderByEnum>;
  where?: InputMaybe<CompanyWhereInput>;
};

export type QueryEconomicDebtorsArgs = {
  where?: InputMaybe<EconomicDebtorWhereInput>;
};

export type QueryEconomicSubscribersArgs = {
  where?: InputMaybe<EconomicSubscriberWhereInput>;
};

export type QueryEconomicSubscriptionArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryEconomicSubscriptionsArgs = {
  where?: InputMaybe<EconomicSubscriptionWhereInput>;
};

export type QueryInterestListEntriesArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<InterestListEntryOrderByEnum>;
  where?: InputMaybe<InterestListEntryWhereInput>;
};

export type QueryInterestListEntryArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryInterestListPeopleArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<InterestListPersonOrderByEnum>;
  where?: InputMaybe<InterestListPersonWhereInput>;
};

export type QueryInterestListPersonArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryPropertiesArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<PropertyOrderByEnum>;
  where?: InputMaybe<PropertyWhereInput>;
};

export type QueryPropertyArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryQuestionsArgs = {
  where?: InputMaybe<QuestionWhereInput>;
};

export type QueryTeamArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryTeamMembersArgs = {
  where?: InputMaybe<TeamMemberWhereInput>;
};

export type QueryTeamsArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<TeamOrderByEnum>;
  scope?: InputMaybe<TeamScopeEnum>;
};

export type QueryTenanciesArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<TenancyOrderByEnum>;
  where?: InputMaybe<TenancyWhereInput>;
};

export type QueryTenancyArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryTextMacrosArgs = {
  available: Array<Scalars["String"]["input"]>;
};

export type Question = {
  __typename?: "Question";
  answerDa: Scalars["String"]["output"];
  answerEn: Scalars["String"]["output"];
  createdAt: Scalars["ISO8601DateTime"]["output"];
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
  properties?: Maybe<Array<QuestionProperty>>;
  questionDa: Scalars["String"]["output"];
  questionEn: Scalars["String"]["output"];
  updatedAt: Scalars["ISO8601DateTime"]["output"];
};

export type QuestionProperty = {
  __typename?: "QuestionProperty";
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
};

export type QuestionWhereInput = {
  byProperty?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  search?: InputMaybe<Scalars["String"]["input"]>;
};

export type RecordInterface = {
  createdAt: Scalars["ISO8601DateTime"]["output"];
  id: Scalars["ID"]["output"];
  updatedAt: Scalars["ISO8601DateTime"]["output"];
};

export type RequestTenancy = CaseInterface & {
  __typename?: "RequestTenancy";
  apartment?: Maybe<Apartment>;
  archivedAt?: Maybe<Scalars["ISO8601DateTime"]["output"]>;
  archivedBy?: Maybe<CaseUser>;
  assignableServiceTeams: Array<ServiceTeam>;
  attachments: Array<CaseAttachment>;
  attention: CaseAttentionEnum;
  availableFollowers: Array<CaseUser>;
  availableResponsibleTeams: Array<AvailableResponsibleTeam>;
  availableResponsibleUsers: Array<CaseUser>;
  availableTeams: Array<Team>;
  availableTimelogAccounts: Array<TimelogAccount>;
  awaiting?: Maybe<Scalars["String"]["output"]>;
  body: Scalars["String"]["output"];
  calendarDate?: Maybe<Scalars["String"]["output"]>;
  calendarRange: DateRange;
  canAddAttachment: Scalars["Boolean"]["output"];
  canAddComment: Scalars["Boolean"]["output"];
  canAddFollower: Scalars["Boolean"]["output"];
  canAddTimelog: Scalars["Boolean"]["output"];
  canAwait: Scalars["Boolean"]["output"];
  canCancel: Scalars["Boolean"]["output"];
  canChangeResponsible: Scalars["Boolean"]["output"];
  canComplete: Scalars["Boolean"]["output"];
  canConfigureRepeat: Scalars["Boolean"]["output"];
  canCreateTenancy: Scalars["Boolean"]["output"];
  canReceive: Scalars["Boolean"]["output"];
  canRemoveAttachment: Scalars["Boolean"]["output"];
  canRemoveFollower: Scalars["Boolean"]["output"];
  canReopen: Scalars["Boolean"]["output"];
  canSendCommentAsSms: Scalars["Boolean"]["output"];
  canShare: Scalars["Boolean"]["output"];
  canShowAttention: Scalars["Boolean"]["output"];
  canShowTimelogs: Scalars["Boolean"]["output"];
  canToggleCheck: Scalars["Boolean"]["output"];
  canUpdate: Scalars["Boolean"]["output"];
  cancelledMessage?: Maybe<Scalars["String"]["output"]>;
  checks?: Maybe<Array<CaseCheck>>;
  comment?: Maybe<Scalars["String"]["output"]>;
  commentUsers: Array<CaseCommentUserOption>;
  comments: Array<CaseComment>;
  company?: Maybe<Company>;
  completeBefore?: Maybe<Scalars["String"]["output"]>;
  completed?: Maybe<Scalars["Boolean"]["output"]>;
  completedDate?: Maybe<Scalars["ISO8601DateTime"]["output"]>;
  createTenancyCases: Array<CreateTenancy>;
  createdAt: Scalars["ISO8601DateTime"]["output"];
  daysBetween?: Maybe<Scalars["String"]["output"]>;
  displayName: Scalars["String"]["output"];
  endDate?: Maybe<Scalars["ISO8601Date"]["output"]>;
  flaggedByCurrentUser: Scalars["Boolean"]["output"];
  followers: Array<Follower>;
  icon: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  inspected?: Maybe<Scalars["Boolean"]["output"]>;
  inspection?: Maybe<Inspection>;
  isArchived: Scalars["Boolean"]["output"];
  isAttending?: Maybe<Scalars["Boolean"]["output"]>;
  isService: Scalars["Boolean"]["output"];
  mayAddAttachment: Scalars["Boolean"]["output"];
  mayAddComment: Scalars["Boolean"]["output"];
  mayAddFollower: Scalars["Boolean"]["output"];
  mayAddTimelog: Scalars["Boolean"]["output"];
  mayAwait: Scalars["Boolean"]["output"];
  mayCancel: Scalars["Boolean"]["output"];
  mayChangeResponsible: Scalars["Boolean"]["output"];
  mayComplete: Scalars["Boolean"]["output"];
  mayConfigureRepeat: Scalars["Boolean"]["output"];
  mayCreate: Scalars["Boolean"]["output"];
  mayReceive: Scalars["Boolean"]["output"];
  mayRemoveAttachment: Scalars["Boolean"]["output"];
  mayRemoveFollower: Scalars["Boolean"]["output"];
  mayReopen: Scalars["Boolean"]["output"];
  mayToggleCheck: Scalars["Boolean"]["output"];
  name: Scalars["String"]["output"];
  numberOfResidents: Scalars["Int"]["output"];
  parent?: Maybe<CaseInterface>;
  partnerProduct?: Maybe<PartnerProduct>;
  processing?: Maybe<Scalars["Boolean"]["output"]>;
  property?: Maybe<Property>;
  repeatPeriod?: Maybe<Scalars["String"]["output"]>;
  repeatResponsible: Scalars["Boolean"]["output"];
  repeatSteps?: Maybe<Scalars["Int"]["output"]>;
  repeating: Scalars["Boolean"]["output"];
  requester?: Maybe<User>;
  residents: Array<Resident>;
  responsible?: Maybe<CaseUser>;
  scheduledDate?: Maybe<Scalars["String"]["output"]>;
  scheduledTime?: Maybe<Scalars["String"]["output"]>;
  serviceDate?: Maybe<Scalars["ISO8601Date"]["output"]>;
  serviceEmployee?: Maybe<Scalars["String"]["output"]>;
  serviceTeam?: Maybe<ServiceTeam>;
  serviceTime?: Maybe<Scalars["String"]["output"]>;
  shareableDocuments: Array<Document>;
  shares: Array<CaseShare>;
  shortName: Scalars["String"]["output"];
  startAfter?: Maybe<Scalars["String"]["output"]>;
  startDate: Scalars["ISO8601Date"]["output"];
  state: Scalars["String"]["output"];
  stateLastChangedAt?: Maybe<Scalars["ISO8601DateTime"]["output"]>;
  stateText: Scalars["String"]["output"];
  tenancy?: Maybe<Tenancy>;
  tenantMayAttend: Scalars["Boolean"]["output"];
  tenantWillAttend?: Maybe<Scalars["Boolean"]["output"]>;
  timelogAccount?: Maybe<TimelogAccount>;
  timelogs: Array<Timelog>;
  title: Scalars["String"]["output"];
  titleRaw?: Maybe<Scalars["String"]["output"]>;
  totalCommentsCount: Scalars["Int"]["output"];
  type: CaseTypeEnum;
  unreadCommentsCount: Scalars["Int"]["output"];
  updatedAt: Scalars["ISO8601DateTime"]["output"];
  whyAttention: Array<CaseAttentionCondition>;
};

export type RequestTenancyAvailableTeamsArgs = {
  forAssignment?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type RequestTenancyCommentsArgs = {
  commentTypes?: InputMaybe<Array<CaseCommentTypeEnum>>;
};

export type Resident = {
  __typename?: "Resident";
  email?: Maybe<Scalars["String"]["output"]>;
  id?: Maybe<Scalars["ID"]["output"]>;
  name: Scalars["String"]["output"];
  phone?: Maybe<Scalars["String"]["output"]>;
};

/** Autogenerated return type of SaveInspectionAnswerMutation. */
export type SaveInspectionAnswerMutationPayload = {
  __typename?: "SaveInspectionAnswerMutationPayload";
  errors: Array<Scalars["String"]["output"]>;
  result?: Maybe<InspectionAnswer>;
};

/** Autogenerated return type of SavePaymentMutation. */
export type SavePaymentMutationPayload = {
  __typename?: "SavePaymentMutationPayload";
  errors: Array<Scalars["String"]["output"]>;
  payment?: Maybe<Payment>;
};

/** Autogenerated return type of SaveTextMacroMutation. */
export type SaveTextMacroMutationPayload = {
  __typename?: "SaveTextMacroMutationPayload";
  errors: Array<Scalars["String"]["output"]>;
  textMacro?: Maybe<TextMacro>;
};

export type ServiceTeam = Team & {
  __typename?: "ServiceTeam";
  id: Scalars["ID"]["output"];
  members: Array<User>;
  name: Scalars["String"]["output"];
  properties: ServiceTeamPropertyConnection;
};

export type ServiceTeamPropertiesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<PropertyOrderByEnum>;
};

export type ServiceTeamProperty = {
  __typename?: "ServiceTeamProperty";
  id: Scalars["ID"]["output"];
  isServiceResponsible: Scalars["Boolean"]["output"];
  name: Scalars["String"]["output"];
};

/** The connection type for ServiceTeamProperty. */
export type ServiceTeamPropertyConnection = {
  __typename?: "ServiceTeamPropertyConnection";
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ServiceTeamPropertyEdge>>>;
  /** A list of nodes. */
  nodes: Array<ServiceTeamProperty>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars["Int"]["output"]>;
};

/** An edge in a connection. */
export type ServiceTeamPropertyEdge = {
  __typename?: "ServiceTeamPropertyEdge";
  /** A cursor for use in pagination. */
  cursor: Scalars["String"]["output"];
  /** The item at the end of the edge. */
  node?: Maybe<ServiceTeamProperty>;
};

export type Shortcut = {
  __typename?: "Shortcut";
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
  state: Scalars["JSON"]["output"];
  type: Scalars["String"]["output"];
};

export type ShortcutAttributesInput = {
  name: Scalars["String"]["input"];
  state: Scalars["JSON"]["input"];
  type: Scalars["String"]["input"];
};

/** The connection type for Shortcut. */
export type ShortcutConnection = {
  __typename?: "ShortcutConnection";
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ShortcutEdge>>>;
  /** A list of nodes. */
  nodes: Array<Shortcut>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars["Int"]["output"]>;
};

/** Autogenerated return type of ShortcutCreateMutation. */
export type ShortcutCreateMutationPayload = {
  __typename?: "ShortcutCreateMutationPayload";
  errors?: Maybe<Array<Scalars["String"]["output"]>>;
  shortcut?: Maybe<Shortcut>;
};

/** Autogenerated return type of ShortcutDeleteMutation. */
export type ShortcutDeleteMutationPayload = {
  __typename?: "ShortcutDeleteMutationPayload";
  errors?: Maybe<Array<Scalars["String"]["output"]>>;
  shortcutId?: Maybe<Scalars["ID"]["output"]>;
};

/** An edge in a connection. */
export type ShortcutEdge = {
  __typename?: "ShortcutEdge";
  /** A cursor for use in pagination. */
  cursor: Scalars["String"]["output"];
  /** The item at the end of the edge. */
  node?: Maybe<Shortcut>;
};

/** Autogenerated return type of ShortcutUpdate. */
export type ShortcutUpdatePayload = {
  __typename?: "ShortcutUpdatePayload";
  errors?: Maybe<Array<Scalars["String"]["output"]>>;
  shortcut?: Maybe<Shortcut>;
};

export type ShortcutWhereInput = {
  query?: InputMaybe<Scalars["String"]["input"]>;
  type?: InputMaybe<Scalars["String"]["input"]>;
};

export type Team = {
  id: Scalars["ID"]["output"];
  members: Array<User>;
  name: Scalars["String"]["output"];
};

export type TeamList = {
  __typename?: "TeamList";
  count: Scalars["Int"]["output"];
  records: Array<Team>;
  total: Scalars["Int"]["output"];
};

export type TeamMemberWhereInput = {
  caseWorkers?: InputMaybe<Scalars["Boolean"]["input"]>;
  search?: InputMaybe<Scalars["String"]["input"]>;
};

export enum TeamOrderByEnum {
  NameAsc = "name_ASC",
  NameDesc = "name_DESC",
}

export enum TeamScopeEnum {
  /** Administration teams */
  Administration = "ADMINISTRATION",
  /** Service teams */
  Service = "SERVICE",
}

export type Tenancy = RecordInterface & {
  __typename?: "Tenancy";
  apartment: Apartment;
  availableFieldGroups: Array<FieldGroup>;
  canUpdate: Scalars["Boolean"]["output"];
  cases: CaseList;
  contractCase?: Maybe<CreateTenancy>;
  createdAt: Scalars["ISO8601DateTime"]["output"];
  depositAmount?: Maybe<Scalars["Int"]["output"]>;
  depositDueDate?: Maybe<Scalars["String"]["output"]>;
  description: Scalars["String"]["output"];
  documents?: Maybe<Array<Document>>;
  economic: TenancyEconomic;
  electricityAmount?: Maybe<Scalars["Int"]["output"]>;
  endDate?: Maybe<Scalars["String"]["output"]>;
  endTenancyTerms?: Maybe<TenancyTerms>;
  endTenancyTermsCondition?: Maybe<Scalars["String"]["output"]>;
  expectedMovingInCases: Array<CaseDefinition>;
  expectedMovingOutCases: Array<CaseDefinition>;
  fieldGroups: Array<TenancyFieldGroup>;
  hasEndTenancyCase: Scalars["Boolean"]["output"];
  heatingAmount?: Maybe<Scalars["Int"]["output"]>;
  id: Scalars["ID"]["output"];
  intervalAmount?: Maybe<Scalars["Int"]["output"]>;
  intervalAmountType: TenancyIntervalAmountTypeEnum;
  keys: Array<TenancyKey>;
  lastPaymentDate?: Maybe<Scalars["String"]["output"]>;
  movingInCase?: Maybe<Case>;
  movingOutCase?: Maybe<Case>;
  notes: TenancyNoteList;
  paymentAttention: TenancyPaymentAttentionEnum;
  payments: Array<Payment>;
  removable: Scalars["Boolean"]["output"];
  requestedEndDate?: Maybe<Scalars["String"]["output"]>;
  residents: Array<Resident>;
  roles: Array<TenancyRole>;
  startDate: Scalars["String"]["output"];
  updatedAt: Scalars["ISO8601DateTime"]["output"];
  user: User;
  waterAmount?: Maybe<Scalars["Int"]["output"]>;
};

export type TenancyCasesArgs = {
  orderBy?: InputMaybe<CaseOrderByEnum>;
  where?: InputMaybe<CaseWhereInput>;
};

export type TenancyEndTenancyTermsArgs = {
  endDate?: InputMaybe<Scalars["ISO8601Date"]["input"]>;
};

/** Autogenerated return type of TenancyCreateMutation. */
export type TenancyCreateMutationPayload = {
  __typename?: "TenancyCreateMutationPayload";
  errors?: Maybe<Array<Scalars["String"]["output"]>>;
  tenancy?: Maybe<Tenancy>;
};

/** Autogenerated return type of TenancyDebtorLinkMutation. */
export type TenancyDebtorLinkMutationPayload = {
  __typename?: "TenancyDebtorLinkMutationPayload";
  errors?: Maybe<Array<Scalars["String"]["output"]>>;
  isLinked?: Maybe<Scalars["Boolean"]["output"]>;
};

/** Autogenerated return type of TenancyDebtorUnlinkMutation. */
export type TenancyDebtorUnlinkMutationPayload = {
  __typename?: "TenancyDebtorUnlinkMutationPayload";
  errors: Array<Scalars["String"]["output"]>;
  isUnlinked: Scalars["Boolean"]["output"];
};

export type TenancyEconomic = {
  __typename?: "TenancyEconomic";
  advanceElectricityAmount?: Maybe<Scalars["Float"]["output"]>;
  advanceElectricityIntervalEndAt?: Maybe<Scalars["ISO8601Date"]["output"]>;
  advanceElectricityIntervalStartAt?: Maybe<Scalars["ISO8601Date"]["output"]>;
  advanceElectricitySignedUpAt?: Maybe<Scalars["ISO8601Date"]["output"]>;
  advanceHeatingAmount?: Maybe<Scalars["Float"]["output"]>;
  advanceHeatingIntervalEndAt?: Maybe<Scalars["ISO8601Date"]["output"]>;
  advanceHeatingIntervalStartAt?: Maybe<Scalars["ISO8601Date"]["output"]>;
  advanceHeatingSignedUpAt?: Maybe<Scalars["ISO8601Date"]["output"]>;
  advanceWasteWaterAmount?: Maybe<Scalars["Float"]["output"]>;
  advanceWasteWaterIntervalEndAt?: Maybe<Scalars["ISO8601Date"]["output"]>;
  advanceWasteWaterIntervalStartAt?: Maybe<Scalars["ISO8601Date"]["output"]>;
  advanceWasteWaterSignedUpAt?: Maybe<Scalars["ISO8601Date"]["output"]>;
  advanceWaterAmount?: Maybe<Scalars["Float"]["output"]>;
  advanceWaterIntervalEndAt?: Maybe<Scalars["ISO8601Date"]["output"]>;
  advanceWaterIntervalStartAt?: Maybe<Scalars["ISO8601Date"]["output"]>;
  advanceWaterSignedUpAt?: Maybe<Scalars["ISO8601Date"]["output"]>;
  commercialRentAmount?: Maybe<Scalars["Float"]["output"]>;
  commercialRentIntervalEndAt?: Maybe<Scalars["ISO8601Date"]["output"]>;
  commercialRentIntervalStartAt?: Maybe<Scalars["ISO8601Date"]["output"]>;
  commercialRentSignedUpAt?: Maybe<Scalars["ISO8601Date"]["output"]>;
  companySyncedAt?: Maybe<Scalars["ISO8601DateTime"]["output"]>;
  debtor?: Maybe<EconomicDebtor>;
  deposit?: Maybe<Scalars["Float"]["output"]>;
  otherAmount?: Maybe<Scalars["Float"]["output"]>;
  otherIntervalEndAt?: Maybe<Scalars["ISO8601Date"]["output"]>;
  otherIntervalStartAt?: Maybe<Scalars["ISO8601Date"]["output"]>;
  otherSignedUpAt?: Maybe<Scalars["ISO8601Date"]["output"]>;
  parkingAmount?: Maybe<Scalars["Float"]["output"]>;
  parkingIntervalEndAt?: Maybe<Scalars["ISO8601Date"]["output"]>;
  parkingIntervalStartAt?: Maybe<Scalars["ISO8601Date"]["output"]>;
  parkingSignedUpAt?: Maybe<Scalars["ISO8601Date"]["output"]>;
  prepaidRent?: Maybe<Scalars["Float"]["output"]>;
  regulationDepositAmount?: Maybe<Scalars["Float"]["output"]>;
  regulationDepositIntervalEndAt?: Maybe<Scalars["ISO8601Date"]["output"]>;
  regulationDepositIntervalStartAt?: Maybe<Scalars["ISO8601Date"]["output"]>;
  regulationDepositSignedUpAt?: Maybe<Scalars["ISO8601Date"]["output"]>;
  regulationPrepaidRentAmount?: Maybe<Scalars["Float"]["output"]>;
  regulationPrepaidRentIntervalEndAt?: Maybe<Scalars["ISO8601Date"]["output"]>;
  regulationPrepaidRentIntervalStartAt?: Maybe<
    Scalars["ISO8601Date"]["output"]
  >;
  regulationPrepaidRentSignedUpAt?: Maybe<Scalars["ISO8601Date"]["output"]>;
  rentAmount?: Maybe<Scalars["Float"]["output"]>;
  rentIntervalEndAt?: Maybe<Scalars["ISO8601Date"]["output"]>;
  rentIntervalStartAt?: Maybe<Scalars["ISO8601Date"]["output"]>;
  rentReductionAmount?: Maybe<Scalars["Float"]["output"]>;
  rentReductionIntervalEndAt?: Maybe<Scalars["ISO8601Date"]["output"]>;
  rentReductionIntervalStartAt?: Maybe<Scalars["ISO8601Date"]["output"]>;
  rentReductionSignedUpAt?: Maybe<Scalars["ISO8601Date"]["output"]>;
  rentSignedUpAt?: Maybe<Scalars["ISO8601Date"]["output"]>;
  settlementElectricityAmount?: Maybe<Scalars["Float"]["output"]>;
  settlementElectricityIntervalEndAt?: Maybe<Scalars["ISO8601Date"]["output"]>;
  settlementElectricityIntervalStartAt?: Maybe<
    Scalars["ISO8601Date"]["output"]
  >;
  settlementElectricitySignedUpAt?: Maybe<Scalars["ISO8601Date"]["output"]>;
  settlementHeatingAmount?: Maybe<Scalars["Float"]["output"]>;
  settlementHeatingIntervalEndAt?: Maybe<Scalars["ISO8601Date"]["output"]>;
  settlementHeatingIntervalStartAt?: Maybe<Scalars["ISO8601Date"]["output"]>;
  settlementHeatingSignedUpAt?: Maybe<Scalars["ISO8601Date"]["output"]>;
  settlementWasteWaterAmount?: Maybe<Scalars["Float"]["output"]>;
  settlementWasteWaterIntervalEndAt?: Maybe<Scalars["ISO8601Date"]["output"]>;
  settlementWasteWaterIntervalStartAt?: Maybe<Scalars["ISO8601Date"]["output"]>;
  settlementWasteWaterSignedUpAt?: Maybe<Scalars["ISO8601Date"]["output"]>;
  settlementWaterAmount?: Maybe<Scalars["Float"]["output"]>;
  settlementWaterIntervalEndAt?: Maybe<Scalars["ISO8601Date"]["output"]>;
  settlementWaterIntervalStartAt?: Maybe<Scalars["ISO8601Date"]["output"]>;
  settlementWaterSignedUpAt?: Maybe<Scalars["ISO8601Date"]["output"]>;
  subscription?: Maybe<TenancyEconomicSubscription>;
  subscriptions?: Maybe<Array<TenancyEconomicSubscription>>;
};

export type TenancyEconomicSubscriptionArgs = {
  id: Scalars["ID"]["input"];
};

export type TenancyEconomicSubscription = {
  __typename?: "TenancyEconomicSubscription";
  currentAmount?: Maybe<Scalars["Float"]["output"]>;
  history?: Maybe<Array<EconomicSubscriber>>;
  id: Scalars["ID"]["output"];
  interval?: Maybe<EconomicSubscriptionIntervalEnum>;
  name: Scalars["String"]["output"];
};

export type TenancyFieldGroup = {
  __typename?: "TenancyFieldGroup";
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
  position: Scalars["Int"]["output"];
  values: Array<FieldValue>;
};

export enum TenancyIntervalAmountTypeEnum {
  Contract = "contract",
  Economic = "economic",
  Unknown = "unknown",
}

export type TenancyKey = {
  __typename?: "TenancyKey";
  description: Scalars["String"]["output"];
  handedIn?: Maybe<Scalars["Int"]["output"]>;
  handedOut: Scalars["Int"]["output"];
  id: Scalars["ID"]["output"];
  missing: Scalars["Int"]["output"];
};

export type TenancyList = {
  __typename?: "TenancyList";
  count: Scalars["Int"]["output"];
  records: Array<Tenancy>;
  total: Scalars["Int"]["output"];
};

export type TenancyNote = {
  __typename?: "TenancyNote";
  attachments: Array<File>;
  content: Scalars["String"]["output"];
  createdAt: Scalars["ISO8601DateTime"]["output"];
  id: Scalars["ID"]["output"];
  updatedAt: Scalars["ISO8601DateTime"]["output"];
  user: User;
};

/** Autogenerated return type of TenancyNoteCreateMutation. */
export type TenancyNoteCreateMutationPayload = {
  __typename?: "TenancyNoteCreateMutationPayload";
  errors: Array<Scalars["String"]["output"]>;
  tenancyNote?: Maybe<TenancyNote>;
};

/** Autogenerated return type of TenancyNoteDeleteMutation. */
export type TenancyNoteDeleteMutationPayload = {
  __typename?: "TenancyNoteDeleteMutationPayload";
  errors: Array<Scalars["String"]["output"]>;
  tenancyNote?: Maybe<TenancyNote>;
};

export type TenancyNoteList = {
  __typename?: "TenancyNoteList";
  count: Scalars["Int"]["output"];
  records: Array<TenancyNote>;
  total: Scalars["Int"]["output"];
};

/** Autogenerated return type of TenancyNoteUpdateMutation. */
export type TenancyNoteUpdateMutationPayload = {
  __typename?: "TenancyNoteUpdateMutationPayload";
  errors: Array<Scalars["String"]["output"]>;
  tenancyNote?: Maybe<TenancyNote>;
};

export enum TenancyOrderByEnum {
  ApartmentPublicIdAsc = "apartmentPublicId_ASC",
  ApartmentPublicIdDesc = "apartmentPublicId_DESC",
  ApartmentAsc = "apartment_ASC",
  ApartmentDesc = "apartment_DESC",
  CprAsc = "cpr_ASC",
  CprDesc = "cpr_DESC",
  DepositAmountAsc = "depositAmount_ASC",
  DepositAmountDesc = "depositAmount_DESC",
  DepositDueDateAsc = "depositDueDate_ASC",
  DepositDueDateDesc = "depositDueDate_DESC",
  DepositAsc = "deposit_ASC",
  DepositDesc = "deposit_DESC",
  EconomicAdvanceElectricityAmountAsc = "economicAdvanceElectricityAmount_ASC",
  EconomicAdvanceElectricityAmountDesc = "economicAdvanceElectricityAmount_DESC",
  EconomicAdvanceElectricityIntervalEndAtAsc = "economicAdvanceElectricityIntervalEndAt_ASC",
  EconomicAdvanceElectricityIntervalEndAtDesc = "economicAdvanceElectricityIntervalEndAt_DESC",
  EconomicAdvanceElectricityIntervalStartAtAsc = "economicAdvanceElectricityIntervalStartAt_ASC",
  EconomicAdvanceElectricityIntervalStartAtDesc = "economicAdvanceElectricityIntervalStartAt_DESC",
  EconomicAdvanceHeatingAmountAsc = "economicAdvanceHeatingAmount_ASC",
  EconomicAdvanceHeatingAmountDesc = "economicAdvanceHeatingAmount_DESC",
  EconomicAdvanceHeatingIntervalEndAtAsc = "economicAdvanceHeatingIntervalEndAt_ASC",
  EconomicAdvanceHeatingIntervalEndAtDesc = "economicAdvanceHeatingIntervalEndAt_DESC",
  EconomicAdvanceHeatingIntervalStartAtAsc = "economicAdvanceHeatingIntervalStartAt_ASC",
  EconomicAdvanceHeatingIntervalStartAtDesc = "economicAdvanceHeatingIntervalStartAt_DESC",
  EconomicAdvanceWasteWaterAmountAsc = "economicAdvanceWasteWaterAmount_ASC",
  EconomicAdvanceWasteWaterAmountDesc = "economicAdvanceWasteWaterAmount_DESC",
  EconomicAdvanceWasteWaterIntervalEndAtAsc = "economicAdvanceWasteWaterIntervalEndAt_ASC",
  EconomicAdvanceWasteWaterIntervalEndAtDesc = "economicAdvanceWasteWaterIntervalEndAt_DESC",
  EconomicAdvanceWasteWaterIntervalStartAtAsc = "economicAdvanceWasteWaterIntervalStartAt_ASC",
  EconomicAdvanceWasteWaterIntervalStartAtDesc = "economicAdvanceWasteWaterIntervalStartAt_DESC",
  EconomicAdvanceWaterAmountAsc = "economicAdvanceWaterAmount_ASC",
  EconomicAdvanceWaterAmountDesc = "economicAdvanceWaterAmount_DESC",
  EconomicAdvanceWaterIntervalEndAtAsc = "economicAdvanceWaterIntervalEndAt_ASC",
  EconomicAdvanceWaterIntervalEndAtDesc = "economicAdvanceWaterIntervalEndAt_DESC",
  EconomicAdvanceWaterIntervalStartAtAsc = "economicAdvanceWaterIntervalStartAt_ASC",
  EconomicAdvanceWaterIntervalStartAtDesc = "economicAdvanceWaterIntervalStartAt_DESC",
  EconomicCommercialRentAmountAsc = "economicCommercialRentAmount_ASC",
  EconomicCommercialRentAmountDesc = "economicCommercialRentAmount_DESC",
  EconomicCommercialRentIntervalEndAtAsc = "economicCommercialRentIntervalEndAt_ASC",
  EconomicCommercialRentIntervalEndAtDesc = "economicCommercialRentIntervalEndAt_DESC",
  EconomicCommercialRentIntervalStartAtAsc = "economicCommercialRentIntervalStartAt_ASC",
  EconomicCommercialRentIntervalStartAtDesc = "economicCommercialRentIntervalStartAt_DESC",
  EconomicOtherAmountAsc = "economicOtherAmount_ASC",
  EconomicOtherAmountDesc = "economicOtherAmount_DESC",
  EconomicOtherIntervalEndAtAsc = "economicOtherIntervalEndAt_ASC",
  EconomicOtherIntervalEndAtDesc = "economicOtherIntervalEndAt_DESC",
  EconomicOtherIntervalStartAtAsc = "economicOtherIntervalStartAt_ASC",
  EconomicOtherIntervalStartAtDesc = "economicOtherIntervalStartAt_DESC",
  EconomicParkingAmountAsc = "economicParkingAmount_ASC",
  EconomicParkingAmountDesc = "economicParkingAmount_DESC",
  EconomicParkingIntervalEndAtAsc = "economicParkingIntervalEndAt_ASC",
  EconomicParkingIntervalEndAtDesc = "economicParkingIntervalEndAt_DESC",
  EconomicParkingIntervalStartAtAsc = "economicParkingIntervalStartAt_ASC",
  EconomicParkingIntervalStartAtDesc = "economicParkingIntervalStartAt_DESC",
  EconomicRegulationDepositAmountAsc = "economicRegulationDepositAmount_ASC",
  EconomicRegulationDepositAmountDesc = "economicRegulationDepositAmount_DESC",
  EconomicRegulationDepositIntervalEndAtAsc = "economicRegulationDepositIntervalEndAt_ASC",
  EconomicRegulationDepositIntervalEndAtDesc = "economicRegulationDepositIntervalEndAt_DESC",
  EconomicRegulationDepositIntervalStartAtAsc = "economicRegulationDepositIntervalStartAt_ASC",
  EconomicRegulationDepositIntervalStartAtDesc = "economicRegulationDepositIntervalStartAt_DESC",
  EconomicRegulationPrepaidRentAmountAsc = "economicRegulationPrepaidRentAmount_ASC",
  EconomicRegulationPrepaidRentAmountDesc = "economicRegulationPrepaidRentAmount_DESC",
  EconomicRegulationPrepaidRentIntervalEndAtAsc = "economicRegulationPrepaidRentIntervalEndAt_ASC",
  EconomicRegulationPrepaidRentIntervalEndAtDesc = "economicRegulationPrepaidRentIntervalEndAt_DESC",
  EconomicRegulationPrepaidRentIntervalStartAtAsc = "economicRegulationPrepaidRentIntervalStartAt_ASC",
  EconomicRegulationPrepaidRentIntervalStartAtDesc = "economicRegulationPrepaidRentIntervalStartAt_DESC",
  EconomicRentAmountAsc = "economicRentAmount_ASC",
  EconomicRentAmountDesc = "economicRentAmount_DESC",
  EconomicRentIntervalEndAtAsc = "economicRentIntervalEndAt_ASC",
  EconomicRentIntervalEndAtDesc = "economicRentIntervalEndAt_DESC",
  EconomicRentIntervalStartAtAsc = "economicRentIntervalStartAt_ASC",
  EconomicRentIntervalStartAtDesc = "economicRentIntervalStartAt_DESC",
  EconomicRentReductionAmountAsc = "economicRentReductionAmount_ASC",
  EconomicRentReductionAmountDesc = "economicRentReductionAmount_DESC",
  EconomicRentReductionIntervalEndAtAsc = "economicRentReductionIntervalEndAt_ASC",
  EconomicRentReductionIntervalEndAtDesc = "economicRentReductionIntervalEndAt_DESC",
  EconomicRentReductionIntervalStartAtAsc = "economicRentReductionIntervalStartAt_ASC",
  EconomicRentReductionIntervalStartAtDesc = "economicRentReductionIntervalStartAt_DESC",
  EconomicSettlementElectricityAmountAsc = "economicSettlementElectricityAmount_ASC",
  EconomicSettlementElectricityAmountDesc = "economicSettlementElectricityAmount_DESC",
  EconomicSettlementElectricityIntervalEndAtAsc = "economicSettlementElectricityIntervalEndAt_ASC",
  EconomicSettlementElectricityIntervalEndAtDesc = "economicSettlementElectricityIntervalEndAt_DESC",
  EconomicSettlementElectricityIntervalStartAtAsc = "economicSettlementElectricityIntervalStartAt_ASC",
  EconomicSettlementElectricityIntervalStartAtDesc = "economicSettlementElectricityIntervalStartAt_DESC",
  EconomicSettlementHeatingAmountAsc = "economicSettlementHeatingAmount_ASC",
  EconomicSettlementHeatingAmountDesc = "economicSettlementHeatingAmount_DESC",
  EconomicSettlementHeatingIntervalEndAtAsc = "economicSettlementHeatingIntervalEndAt_ASC",
  EconomicSettlementHeatingIntervalEndAtDesc = "economicSettlementHeatingIntervalEndAt_DESC",
  EconomicSettlementHeatingIntervalStartAtAsc = "economicSettlementHeatingIntervalStartAt_ASC",
  EconomicSettlementHeatingIntervalStartAtDesc = "economicSettlementHeatingIntervalStartAt_DESC",
  EconomicSettlementWasteWaterAmountAsc = "economicSettlementWasteWaterAmount_ASC",
  EconomicSettlementWasteWaterAmountDesc = "economicSettlementWasteWaterAmount_DESC",
  EconomicSettlementWasteWaterIntervalEndAtAsc = "economicSettlementWasteWaterIntervalEndAt_ASC",
  EconomicSettlementWasteWaterIntervalEndAtDesc = "economicSettlementWasteWaterIntervalEndAt_DESC",
  EconomicSettlementWasteWaterIntervalStartAtAsc = "economicSettlementWasteWaterIntervalStartAt_ASC",
  EconomicSettlementWasteWaterIntervalStartAtDesc = "economicSettlementWasteWaterIntervalStartAt_DESC",
  EconomicSettlementWaterAmountAsc = "economicSettlementWaterAmount_ASC",
  EconomicSettlementWaterAmountDesc = "economicSettlementWaterAmount_DESC",
  EconomicSettlementWaterIntervalEndAtAsc = "economicSettlementWaterIntervalEndAt_ASC",
  EconomicSettlementWaterIntervalEndAtDesc = "economicSettlementWaterIntervalEndAt_DESC",
  EconomicSettlementWaterIntervalStartAtAsc = "economicSettlementWaterIntervalStartAt_ASC",
  EconomicSettlementWaterIntervalStartAtDesc = "economicSettlementWaterIntervalStartAt_DESC",
  EmailAsc = "email_ASC",
  EmailDesc = "email_DESC",
  EndDateAsc = "endDate_ASC",
  EndDateDesc = "endDate_DESC",
  IntervalAmountAsc = "intervalAmount_ASC",
  IntervalAmountDesc = "intervalAmount_DESC",
  LastPaymentDateAsc = "lastPaymentDate_ASC",
  LastPaymentDateDesc = "lastPaymentDate_DESC",
  NameAsc = "name_ASC",
  NameDesc = "name_DESC",
  PhoneAsc = "phone_ASC",
  PhoneDesc = "phone_DESC",
  PrepaidRentAsc = "prepaidRent_ASC",
  PrepaidRentDesc = "prepaidRent_DESC",
  RequestedEndDateAsc = "requestedEndDate_ASC",
  RequestedEndDateDesc = "requestedEndDate_DESC",
  StartDateAsc = "startDate_ASC",
  StartDateDesc = "startDate_DESC",
}

export enum TenancyPaymentAttentionEnum {
  Critical = "critical",
  Normal = "normal",
  Success = "success",
}

/** Autogenerated return type of TenancyRemoveMutation. */
export type TenancyRemoveMutationPayload = {
  __typename?: "TenancyRemoveMutationPayload";
  errors: Array<Scalars["String"]["output"]>;
  tenancy?: Maybe<Tenancy>;
};

/** Autogenerated return type of TenancyResidentCreateMutation. */
export type TenancyResidentCreateMutationPayload = {
  __typename?: "TenancyResidentCreateMutationPayload";
  errors?: Maybe<Array<Scalars["String"]["output"]>>;
  resident?: Maybe<Resident>;
};

/** Autogenerated return type of TenancyResidentRemoveMutation. */
export type TenancyResidentRemoveMutationPayload = {
  __typename?: "TenancyResidentRemoveMutationPayload";
  errors?: Maybe<Array<Scalars["String"]["output"]>>;
  resident?: Maybe<Resident>;
};

/** Autogenerated return type of TenancyResidentUpdateMutation. */
export type TenancyResidentUpdateMutationPayload = {
  __typename?: "TenancyResidentUpdateMutationPayload";
  errors?: Maybe<Array<Scalars["String"]["output"]>>;
  resident?: Maybe<Resident>;
};

export type TenancyRole = {
  __typename?: "TenancyRole";
  id: Scalars["ID"]["output"];
  isPrimary: Scalars["Boolean"]["output"];
  isResident: Scalars["Boolean"]["output"];
  user: User;
};

/** Autogenerated return type of TenancyRoleCreateMutation. */
export type TenancyRoleCreateMutationPayload = {
  __typename?: "TenancyRoleCreateMutationPayload";
  errors?: Maybe<Array<Scalars["String"]["output"]>>;
  tenancyRole?: Maybe<TenancyRole>;
};

/** Autogenerated return type of TenancyRoleRemoveMutation. */
export type TenancyRoleRemoveMutationPayload = {
  __typename?: "TenancyRoleRemoveMutationPayload";
  errors?: Maybe<Array<Scalars["String"]["output"]>>;
  tenancyRole?: Maybe<TenancyRole>;
};

/** Autogenerated return type of TenancyRoleUpdateMutation. */
export type TenancyRoleUpdateMutationPayload = {
  __typename?: "TenancyRoleUpdateMutationPayload";
  errors?: Maybe<Array<Scalars["String"]["output"]>>;
  tenancyRole?: Maybe<TenancyRole>;
};

export type TenancyTerms = {
  __typename?: "TenancyTerms";
  earlyEndDate?: Maybe<Scalars["Boolean"]["output"]>;
  endDate?: Maybe<Scalars["String"]["output"]>;
  endDateLongFormat?: Maybe<Scalars["String"]["output"]>;
  lastRentDate?: Maybe<Scalars["String"]["output"]>;
  lastRentDateLongFormat?: Maybe<Scalars["String"]["output"]>;
  leaveDate?: Maybe<Scalars["String"]["output"]>;
  leaveDateLongFormat?: Maybe<Scalars["String"]["output"]>;
};

/** Autogenerated return type of TenancyUpdateMutation. */
export type TenancyUpdateMutationPayload = {
  __typename?: "TenancyUpdateMutationPayload";
  errors?: Maybe<Array<Scalars["String"]["output"]>>;
  tenancy?: Maybe<Tenancy>;
};

export type TenancyUserInput = {
  email?: InputMaybe<Scalars["String"]["input"]>;
  external: Scalars["Boolean"]["input"];
  locale?: InputMaybe<Scalars["String"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  note?: InputMaybe<Scalars["String"]["input"]>;
};

export type TenancyWhereInput = {
  approved?: InputMaybe<Scalars["Boolean"]["input"]>;
  archived?: InputMaybe<Scalars["Boolean"]["input"]>;
  byAdministrator?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  byApartment?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  byPaymentAttention?: InputMaybe<Array<TenancyPaymentAttentionEnum>>;
  byProperty?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  conflictingWithDateRange?: InputMaybe<DateRangeInput>;
  search?: InputMaybe<Scalars["String"]["input"]>;
};

export type TextMacro = {
  __typename?: "TextMacro";
  available: Scalars["String"]["output"];
  content: Scalars["String"]["output"];
  createdAt: Scalars["ISO8601DateTime"]["output"];
  id: Scalars["Int"]["output"];
  name: Scalars["String"]["output"];
  updatedAt: Scalars["ISO8601DateTime"]["output"];
};

export type Timelog = {
  __typename?: "Timelog";
  account: TimelogAccount;
  canDestroy: Scalars["Boolean"]["output"];
  canUpdate: Scalars["Boolean"]["output"];
  category: TimelogCategory;
  date: Scalars["ISO8601Date"]["output"];
  hoursWithoutMinutes: Scalars["Int"]["output"];
  id: Scalars["ID"]["output"];
  minutesWithoutHours: Scalars["Int"]["output"];
  note?: Maybe<Scalars["String"]["output"]>;
  user: User;
};

export type TimelogAccount = {
  __typename?: "TimelogAccount";
  categories: Array<TimelogCategory>;
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
};

export type TimelogCategory = {
  __typename?: "TimelogCategory";
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
};

/** Autogenerated return type of TimelogDeleteMutation. */
export type TimelogDeleteMutationPayload = {
  __typename?: "TimelogDeleteMutationPayload";
  errors: Array<Scalars["String"]["output"]>;
  result?: Maybe<Timelog>;
};

/** Autogenerated return type of TimelogUpdateMutation. */
export type TimelogUpdateMutationPayload = {
  __typename?: "TimelogUpdateMutationPayload";
  errors: Array<Scalars["String"]["output"]>;
  result?: Maybe<CaseInterface>;
};

/** Autogenerated return type of ToggleCaseFlagMutation. */
export type ToggleCaseFlagMutationPayload = {
  __typename?: "ToggleCaseFlagMutationPayload";
  errors: Array<Scalars["String"]["output"]>;
};

/** Autogenerated return type of UpdateExternalUserMutation. */
export type UpdateExternalUserMutationPayload = {
  __typename?: "UpdateExternalUserMutationPayload";
  errors?: Maybe<Array<Scalars["String"]["output"]>>;
  user?: Maybe<User>;
};

export type User = RecordInterface & {
  __typename?: "User";
  address?: Maybe<Scalars["String"]["output"]>;
  bankAccount?: Maybe<BankAccount>;
  business: Scalars["Boolean"]["output"];
  city?: Maybe<Scalars["String"]["output"]>;
  company?: Maybe<Scalars["String"]["output"]>;
  countryName?: Maybe<Scalars["String"]["output"]>;
  cpr?: Maybe<Scalars["String"]["output"]>;
  createdAt: Scalars["ISO8601DateTime"]["output"];
  email: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  isAdministrator: Scalars["Boolean"]["output"];
  isExternal: Scalars["Boolean"]["output"];
  isPhoneConfirmed: Scalars["Boolean"]["output"];
  isServiceAdministrator: Scalars["Boolean"]["output"];
  isServiceCaseWorker: Scalars["Boolean"]["output"];
  isSystemAdministrator: Scalars["Boolean"]["output"];
  locale: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
  personalAccessTokens: PersonalAccessTokenConnection;
  phone?: Maybe<Scalars["String"]["output"]>;
  postalCode?: Maybe<Scalars["String"]["output"]>;
  protected: Scalars["Boolean"]["output"];
  serviceTeams: Array<ServiceTeam>;
  shortcut?: Maybe<Shortcut>;
  shortcuts: ShortcutConnection;
  showSensitiveInfo: Scalars["Boolean"]["output"];
  teams: Array<AdministrationTeam>;
  updatedAt: Scalars["ISO8601DateTime"]["output"];
  vat?: Maybe<Scalars["String"]["output"]>;
};

export type UserPersonalAccessTokensArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type UserServiceTeamsArgs = {
  orderBy?: InputMaybe<TeamOrderByEnum>;
};

export type UserShortcutArgs = {
  shortcutId: Scalars["ID"]["input"];
};

export type UserShortcutsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  where?: InputMaybe<ShortcutWhereInput>;
};

export type UserList = {
  __typename?: "UserList";
  count: Scalars["Int"]["output"];
  records: Array<User>;
  total: Scalars["Int"]["output"];
};

export type UtilityAdministration = CaseInterface & {
  __typename?: "UtilityAdministration";
  apartment?: Maybe<Apartment>;
  archivedAt?: Maybe<Scalars["ISO8601DateTime"]["output"]>;
  archivedBy?: Maybe<CaseUser>;
  assignableServiceTeams: Array<ServiceTeam>;
  attachments: Array<CaseAttachment>;
  attention: CaseAttentionEnum;
  availableFollowers: Array<CaseUser>;
  availableResponsibleTeams: Array<AvailableResponsibleTeam>;
  availableResponsibleUsers: Array<CaseUser>;
  availableTeams: Array<Team>;
  availableTimelogAccounts: Array<TimelogAccount>;
  awaiting?: Maybe<Scalars["String"]["output"]>;
  body: Scalars["String"]["output"];
  calendarDate?: Maybe<Scalars["String"]["output"]>;
  calendarRange: DateRange;
  canAddAttachment: Scalars["Boolean"]["output"];
  canAddComment: Scalars["Boolean"]["output"];
  canAddFollower: Scalars["Boolean"]["output"];
  canAddTimelog: Scalars["Boolean"]["output"];
  canAwait: Scalars["Boolean"]["output"];
  canCancel: Scalars["Boolean"]["output"];
  canChangeResponsible: Scalars["Boolean"]["output"];
  canChangeTask: Scalars["Boolean"]["output"];
  canComplete: Scalars["Boolean"]["output"];
  canConfigureRepeat: Scalars["Boolean"]["output"];
  canReceive: Scalars["Boolean"]["output"];
  canRemoveAttachment: Scalars["Boolean"]["output"];
  canRemoveFollower: Scalars["Boolean"]["output"];
  canReopen: Scalars["Boolean"]["output"];
  canSendCommentAsSms: Scalars["Boolean"]["output"];
  canShare: Scalars["Boolean"]["output"];
  canShowAttention: Scalars["Boolean"]["output"];
  canShowTimelogs: Scalars["Boolean"]["output"];
  canToggleCheck: Scalars["Boolean"]["output"];
  canUpdate: Scalars["Boolean"]["output"];
  cancelledMessage?: Maybe<Scalars["String"]["output"]>;
  checks?: Maybe<Array<CaseCheck>>;
  commentUsers: Array<CaseCommentUserOption>;
  comments: Array<CaseComment>;
  company?: Maybe<Company>;
  completeBefore?: Maybe<Scalars["String"]["output"]>;
  completed?: Maybe<Scalars["Boolean"]["output"]>;
  completedDate?: Maybe<Scalars["ISO8601DateTime"]["output"]>;
  createdAt: Scalars["ISO8601DateTime"]["output"];
  displayName: Scalars["String"]["output"];
  flaggedByCurrentUser: Scalars["Boolean"]["output"];
  followers: Array<Follower>;
  icon: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  inspected?: Maybe<Scalars["Boolean"]["output"]>;
  inspection?: Maybe<Inspection>;
  isArchived: Scalars["Boolean"]["output"];
  isAttending?: Maybe<Scalars["Boolean"]["output"]>;
  isService: Scalars["Boolean"]["output"];
  mayAddAttachment: Scalars["Boolean"]["output"];
  mayAddComment: Scalars["Boolean"]["output"];
  mayAddFollower: Scalars["Boolean"]["output"];
  mayAddTimelog: Scalars["Boolean"]["output"];
  mayAwait: Scalars["Boolean"]["output"];
  mayCancel: Scalars["Boolean"]["output"];
  mayChangeResponsible: Scalars["Boolean"]["output"];
  mayChangeTask: Scalars["Boolean"]["output"];
  mayComplete: Scalars["Boolean"]["output"];
  mayConfigureRepeat: Scalars["Boolean"]["output"];
  mayCreate: Scalars["Boolean"]["output"];
  mayReceive: Scalars["Boolean"]["output"];
  mayRemoveAttachment: Scalars["Boolean"]["output"];
  mayRemoveFollower: Scalars["Boolean"]["output"];
  mayReopen: Scalars["Boolean"]["output"];
  mayToggleCheck: Scalars["Boolean"]["output"];
  name: Scalars["String"]["output"];
  parent?: Maybe<CaseInterface>;
  processing?: Maybe<Scalars["Boolean"]["output"]>;
  property?: Maybe<Property>;
  repeatPeriod?: Maybe<Scalars["String"]["output"]>;
  repeatResponsible: Scalars["Boolean"]["output"];
  repeatSteps?: Maybe<Scalars["Int"]["output"]>;
  repeating: Scalars["Boolean"]["output"];
  requester?: Maybe<User>;
  responsible?: Maybe<CaseUser>;
  scheduledDate?: Maybe<Scalars["String"]["output"]>;
  scheduledTime?: Maybe<Scalars["String"]["output"]>;
  serviceDate?: Maybe<Scalars["ISO8601Date"]["output"]>;
  serviceEmployee?: Maybe<Scalars["String"]["output"]>;
  serviceTeam?: Maybe<ServiceTeam>;
  serviceTime?: Maybe<Scalars["String"]["output"]>;
  shareableDocuments: Array<Document>;
  shares: Array<CaseShare>;
  shortName: Scalars["String"]["output"];
  startAfter?: Maybe<Scalars["String"]["output"]>;
  state: Scalars["String"]["output"];
  stateLastChangedAt?: Maybe<Scalars["ISO8601DateTime"]["output"]>;
  stateText: Scalars["String"]["output"];
  tenancy?: Maybe<Tenancy>;
  tenantMayAttend: Scalars["Boolean"]["output"];
  tenantWillAttend?: Maybe<Scalars["Boolean"]["output"]>;
  timelogAccount?: Maybe<TimelogAccount>;
  timelogs: Array<Timelog>;
  title: Scalars["String"]["output"];
  titleRaw?: Maybe<Scalars["String"]["output"]>;
  totalCommentsCount: Scalars["Int"]["output"];
  type: CaseTypeEnum;
  unreadCommentsCount: Scalars["Int"]["output"];
  updatedAt: Scalars["ISO8601DateTime"]["output"];
  whyAttention: Array<CaseAttentionCondition>;
};

export type UtilityAdministrationAvailableTeamsArgs = {
  forAssignment?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type UtilityAdministrationCommentsArgs = {
  commentTypes?: InputMaybe<Array<CaseCommentTypeEnum>>;
};

export type PersonalAccessTokenTokenFragmentFragment = {
  __typename?: "PersonalAccessToken";
  id: string;
  name: string;
  token?: string | null;
  createdAt: any;
} & { " $fragmentName"?: "PersonalAccessTokenTokenFragmentFragment" };

export type PersonalAccessTokensQueryQueryVariables = Exact<{
  [key: string]: never;
}>;

export type PersonalAccessTokensQueryQuery = {
  __typename?: "Query";
  currentUser?: {
    __typename?: "User";
    personalAccessTokens: {
      __typename?: "PersonalAccessTokenConnection";
      nodes: Array<
        { __typename?: "PersonalAccessToken" } & {
          " $fragmentRefs"?: {
            PersonalAccessTokenTokenFragmentFragment: PersonalAccessTokenTokenFragmentFragment;
          };
        }
      >;
    };
  } | null;
};

export type CreatePersonalAccessTokenMutationVariables = Exact<{
  name: Scalars["String"]["input"];
}>;

export type CreatePersonalAccessTokenMutation = {
  __typename?: "Mutation";
  result?: {
    __typename?: "PersonalAccessTokenCreateMutationPayload";
    errors?: Array<string> | null;
    personalAccessToken?: {
      __typename?: "PersonalAccessToken";
      id: string;
      name: string;
      token?: string | null;
    } | null;
  } | null;
};

export type PersonalAccessTokenDeleteMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type PersonalAccessTokenDeleteMutation = {
  __typename?: "Mutation";
  personalAccessTokenDelete?: {
    __typename?: "PersonalAccessTokenDeleteMutationPayload";
    errors: Array<string>;
    id: string;
  } | null;
};

export type DataTableApartmentsFragment = {
  __typename: "Apartment";
  id: string;
  publicId: string;
  address: string;
  city: string;
  key?: string | null;
  inactive?: boolean | null;
  inactiveStartDate?: string | null;
  inactiveEndDate?: string | null;
  inactiveDescription?: string | null;
  service: number;
  property: { __typename?: "Property"; name: string };
  previousTenancy?: {
    __typename?: "Tenancy";
    id: string;
    startDate: string;
    endDate?: string | null;
    requestedEndDate?: string | null;
    intervalAmount?: number | null;
    intervalAmountType: TenancyIntervalAmountTypeEnum;
    depositAmount?: number | null;
    depositDueDate?: string | null;
    heatingAmount?: number | null;
    waterAmount?: number | null;
    electricityAmount?: number | null;
    user: {
      __typename?: "User";
      name: string;
      email: string;
      phone?: string | null;
      protected: boolean;
    };
    expectedMovingInCases: Array<{
      __typename?: "CaseDefinition";
      type: CaseTypeEnum;
      name: string;
      icon: string;
    }>;
    expectedMovingOutCases: Array<{
      __typename?: "CaseDefinition";
      type: CaseTypeEnum;
      name: string;
      icon: string;
    }>;
    movingInCase?: {
      __typename?: "Case";
      id: string;
      icon: string;
      attention: CaseAttentionEnum;
      children: Array<{
        __typename?: "Case";
        id: string;
        type: CaseTypeEnum;
        shortName: string;
        icon: string;
        attention: CaseAttentionEnum;
      }>;
    } | null;
    movingOutCase?: {
      __typename?: "Case";
      id: string;
      icon: string;
      attention: CaseAttentionEnum;
      children: Array<{
        __typename?: "Case";
        id: string;
        type: CaseTypeEnum;
        shortName: string;
        icon: string;
        attention: CaseAttentionEnum;
      }>;
    } | null;
    contractCase?: {
      __typename?: "CreateTenancy";
      id: string;
      type: CaseTypeEnum;
      attention: CaseAttentionEnum;
      awaiting?: string | null;
      stateText: string;
    } | null;
    economic: {
      __typename?: "TenancyEconomic";
      rentAmount?: number | null;
      parkingAmount?: number | null;
      rentReductionAmount?: number | null;
      regulationDepositAmount?: number | null;
      regulationPrepaidRentAmount?: number | null;
      advanceWasteWaterAmount?: number | null;
      advanceWaterAmount?: number | null;
      advanceHeatingAmount?: number | null;
      advanceElectricityAmount?: number | null;
      settlementWasteWaterAmount?: number | null;
      settlementWaterAmount?: number | null;
      settlementHeatingAmount?: number | null;
      settlementElectricityAmount?: number | null;
      otherAmount?: number | null;
      companySyncedAt?: any | null;
      deposit?: number | null;
      prepaidRent?: number | null;
      debtor?: { __typename?: "EconomicDebtor"; externalId: number } | null;
    };
  } | null;
  currentTenancy?: {
    __typename?: "Tenancy";
    id: string;
    startDate: string;
    endDate?: string | null;
    requestedEndDate?: string | null;
    depositAmount?: number | null;
    intervalAmount?: number | null;
    intervalAmountType: TenancyIntervalAmountTypeEnum;
    depositDueDate?: string | null;
    heatingAmount?: number | null;
    waterAmount?: number | null;
    electricityAmount?: number | null;
    user: {
      __typename?: "User";
      name: string;
      email: string;
      phone?: string | null;
      protected: boolean;
    };
    expectedMovingInCases: Array<{
      __typename?: "CaseDefinition";
      type: CaseTypeEnum;
      name: string;
      icon: string;
    }>;
    expectedMovingOutCases: Array<{
      __typename?: "CaseDefinition";
      type: CaseTypeEnum;
      name: string;
      icon: string;
    }>;
    movingInCase?: {
      __typename?: "Case";
      id: string;
      icon: string;
      attention: CaseAttentionEnum;
      children: Array<{
        __typename?: "Case";
        id: string;
        type: CaseTypeEnum;
        shortName: string;
        icon: string;
        attention: CaseAttentionEnum;
      }>;
    } | null;
    movingOutCase?: {
      __typename?: "Case";
      id: string;
      icon: string;
      attention: CaseAttentionEnum;
      children: Array<{
        __typename?: "Case";
        id: string;
        type: CaseTypeEnum;
        shortName: string;
        icon: string;
        attention: CaseAttentionEnum;
      }>;
    } | null;
    contractCase?: {
      __typename?: "CreateTenancy";
      id: string;
      type: CaseTypeEnum;
      attention: CaseAttentionEnum;
      awaiting?: string | null;
      stateText: string;
    } | null;
    economic: {
      __typename?: "TenancyEconomic";
      rentAmount?: number | null;
      parkingAmount?: number | null;
      rentReductionAmount?: number | null;
      regulationDepositAmount?: number | null;
      regulationPrepaidRentAmount?: number | null;
      advanceWasteWaterAmount?: number | null;
      advanceWaterAmount?: number | null;
      advanceHeatingAmount?: number | null;
      advanceElectricityAmount?: number | null;
      settlementWasteWaterAmount?: number | null;
      settlementWaterAmount?: number | null;
      settlementHeatingAmount?: number | null;
      settlementElectricityAmount?: number | null;
      otherAmount?: number | null;
      companySyncedAt?: any | null;
      deposit?: number | null;
      prepaidRent?: number | null;
      debtor?: { __typename?: "EconomicDebtor"; externalId: number } | null;
    };
  } | null;
  nextTenancy?: {
    __typename?: "Tenancy";
    id: string;
    startDate: string;
    endDate?: string | null;
    requestedEndDate?: string | null;
    intervalAmount?: number | null;
    intervalAmountType: TenancyIntervalAmountTypeEnum;
    depositAmount?: number | null;
    depositDueDate?: string | null;
    heatingAmount?: number | null;
    waterAmount?: number | null;
    electricityAmount?: number | null;
    user: {
      __typename?: "User";
      name: string;
      email: string;
      phone?: string | null;
      protected: boolean;
    };
    expectedMovingInCases: Array<{
      __typename?: "CaseDefinition";
      type: CaseTypeEnum;
      name: string;
      icon: string;
    }>;
    expectedMovingOutCases: Array<{
      __typename?: "CaseDefinition";
      type: CaseTypeEnum;
      name: string;
      icon: string;
    }>;
    movingInCase?: {
      __typename?: "Case";
      id: string;
      icon: string;
      attention: CaseAttentionEnum;
      children: Array<{
        __typename?: "Case";
        id: string;
        type: CaseTypeEnum;
        shortName: string;
        icon: string;
        attention: CaseAttentionEnum;
      }>;
    } | null;
    movingOutCase?: {
      __typename?: "Case";
      id: string;
      icon: string;
      attention: CaseAttentionEnum;
      children: Array<{
        __typename?: "Case";
        id: string;
        type: CaseTypeEnum;
        shortName: string;
        icon: string;
        attention: CaseAttentionEnum;
      }>;
    } | null;
    contractCase?: {
      __typename?: "CreateTenancy";
      id: string;
      type: CaseTypeEnum;
      attention: CaseAttentionEnum;
      awaiting?: string | null;
      stateText: string;
    } | null;
    economic: {
      __typename?: "TenancyEconomic";
      rentAmount?: number | null;
      parkingAmount?: number | null;
      rentReductionAmount?: number | null;
      regulationDepositAmount?: number | null;
      regulationPrepaidRentAmount?: number | null;
      advanceWasteWaterAmount?: number | null;
      advanceWaterAmount?: number | null;
      advanceHeatingAmount?: number | null;
      advanceElectricityAmount?: number | null;
      settlementWasteWaterAmount?: number | null;
      settlementWaterAmount?: number | null;
      settlementHeatingAmount?: number | null;
      settlementElectricityAmount?: number | null;
      otherAmount?: number | null;
      companySyncedAt?: any | null;
      deposit?: number | null;
      prepaidRent?: number | null;
      debtor?: { __typename?: "EconomicDebtor"; externalId: number } | null;
    };
  } | null;
} & { " $fragmentName"?: "DataTableApartmentsFragment" };

export type ApartmentsCalendarQueryVariables = Exact<{
  tenancyWhere?: InputMaybe<TenancyWhereInput>;
  caseWhere?: InputMaybe<CaseWhereInput>;
}>;

export type ApartmentsCalendarQuery = {
  __typename?: "Query";
  tenancies: {
    __typename?: "TenancyList";
    records: Array<{
      __typename?: "Tenancy";
      id: string;
      startDate: string;
      endDate?: string | null;
      movingInCase?: {
        __typename?: "Case";
        id: string;
        attention: CaseAttentionEnum;
      } | null;
      movingOutCase?: {
        __typename?: "Case";
        id: string;
        attention: CaseAttentionEnum;
      } | null;
      user: { __typename?: "User"; name: string };
      apartment: { __typename?: "Apartment"; id: string };
    }>;
  };
  cases: {
    __typename?: "CaseList";
    records: Array<
      | {
          __typename?: "CleaningService";
          id: string;
          type: CaseTypeEnum;
          state: string;
          attention: CaseAttentionEnum;
          icon: string;
          name: string;
          calendarDate?: string | null;
          awaiting?: string | null;
          apartment?: { __typename?: "Apartment"; id: string } | null;
        }
      | {
          __typename?: "CreateTenancy";
          id: string;
          type: CaseTypeEnum;
          state: string;
          attention: CaseAttentionEnum;
          icon: string;
          name: string;
          calendarDate?: string | null;
          awaiting?: string | null;
          apartment?: { __typename?: "Apartment"; id: string } | null;
        }
      | {
          __typename?: "EndTenancy";
          id: string;
          type: CaseTypeEnum;
          state: string;
          attention: CaseAttentionEnum;
          icon: string;
          name: string;
          calendarDate?: string | null;
          awaiting?: string | null;
          apartment?: { __typename?: "Apartment"; id: string } | null;
        }
      | {
          __typename?: "FindTenancyAdministration";
          id: string;
          type: CaseTypeEnum;
          state: string;
          attention: CaseAttentionEnum;
          icon: string;
          name: string;
          calendarDate?: string | null;
          awaiting?: string | null;
          apartment?: { __typename?: "Apartment"; id: string } | null;
        }
      | {
          __typename?: "MiscAdministration";
          id: string;
          type: CaseTypeEnum;
          state: string;
          attention: CaseAttentionEnum;
          icon: string;
          name: string;
          calendarDate?: string | null;
          awaiting?: string | null;
          apartment?: { __typename?: "Apartment"; id: string } | null;
        }
      | {
          __typename?: "MiscService";
          id: string;
          type: CaseTypeEnum;
          state: string;
          attention: CaseAttentionEnum;
          icon: string;
          name: string;
          calendarDate?: string | null;
          awaiting?: string | null;
          apartment?: { __typename?: "Apartment"; id: string } | null;
        }
      | {
          __typename?: "MovingInService";
          id: string;
          type: CaseTypeEnum;
          state: string;
          attention: CaseAttentionEnum;
          icon: string;
          name: string;
          calendarDate?: string | null;
          awaiting?: string | null;
          apartment?: { __typename?: "Apartment"; id: string } | null;
        }
      | {
          __typename?: "MovingInTenancy";
          id: string;
          type: CaseTypeEnum;
          state: string;
          attention: CaseAttentionEnum;
          icon: string;
          name: string;
          calendarDate?: string | null;
          awaiting?: string | null;
          apartment?: { __typename?: "Apartment"; id: string } | null;
        }
      | {
          __typename?: "MovingOutService";
          id: string;
          type: CaseTypeEnum;
          state: string;
          attention: CaseAttentionEnum;
          icon: string;
          name: string;
          calendarDate?: string | null;
          awaiting?: string | null;
          apartment?: { __typename?: "Apartment"; id: string } | null;
        }
      | {
          __typename?: "MovingOutTenancy";
          id: string;
          type: CaseTypeEnum;
          state: string;
          attention: CaseAttentionEnum;
          icon: string;
          name: string;
          calendarDate?: string | null;
          awaiting?: string | null;
          apartment?: { __typename?: "Apartment"; id: string } | null;
        }
      | {
          __typename?: "MovingSettlementAdministration";
          id: string;
          type: CaseTypeEnum;
          state: string;
          attention: CaseAttentionEnum;
          icon: string;
          name: string;
          calendarDate?: string | null;
          awaiting?: string | null;
          apartment?: { __typename?: "Apartment"; id: string } | null;
        }
      | {
          __typename?: "PreparationService";
          id: string;
          type: CaseTypeEnum;
          state: string;
          attention: CaseAttentionEnum;
          icon: string;
          name: string;
          calendarDate?: string | null;
          awaiting?: string | null;
          apartment?: { __typename?: "Apartment"; id: string } | null;
        }
      | {
          __typename?: "RequestTenancy";
          id: string;
          type: CaseTypeEnum;
          state: string;
          attention: CaseAttentionEnum;
          icon: string;
          name: string;
          calendarDate?: string | null;
          awaiting?: string | null;
          apartment?: { __typename?: "Apartment"; id: string } | null;
        }
      | {
          __typename?: "UtilityAdministration";
          id: string;
          type: CaseTypeEnum;
          state: string;
          attention: CaseAttentionEnum;
          icon: string;
          name: string;
          calendarDate?: string | null;
          awaiting?: string | null;
          apartment?: { __typename?: "Apartment"; id: string } | null;
        }
    >;
  };
};

type DataTableCases_CleaningService_Fragment = {
  __typename: "CleaningService";
  id: string;
  type: CaseTypeEnum;
  icon: string;
  createdAt: any;
  updatedAt: any;
  name: string;
  shortName: string;
  state: string;
  stateText: string;
  stateLastChangedAt?: any | null;
  attention: CaseAttentionEnum;
  awaiting?: string | null;
  startAfter?: string | null;
  completeBefore?: string | null;
  scheduledDate?: string | null;
  scheduledTime?: string | null;
  isAttending?: boolean | null;
  serviceTeam?: { __typename?: "ServiceTeam"; id: string; name: string } | null;
  requester?: {
    __typename?: "User";
    id: string;
    name: string;
    email: string;
    phone?: string | null;
    protected: boolean;
  } | null;
  responsible?: {
    __typename?: "CaseUser";
    id: string;
    name: string;
    email: string;
    phone?: string | null;
    protected: boolean;
  } | null;
  property?: { __typename?: "Property"; id: string; name: string } | null;
  apartment?: {
    __typename?: "Apartment";
    id: string;
    publicId: string;
    address: string;
    postalCode: string;
    city: string;
  } | null;
  tenancy?: {
    __typename?: "Tenancy";
    id: string;
    startDate: string;
    requestedEndDate?: string | null;
    endDate?: string | null;
    user: {
      __typename?: "User";
      id: string;
      name: string;
      email: string;
      phone?: string | null;
      protected: boolean;
    };
  } | null;
} & { " $fragmentName"?: "DataTableCases_CleaningService_Fragment" };

type DataTableCases_CreateTenancy_Fragment = {
  __typename: "CreateTenancy";
  id: string;
  type: CaseTypeEnum;
  icon: string;
  createdAt: any;
  updatedAt: any;
  name: string;
  shortName: string;
  state: string;
  stateText: string;
  stateLastChangedAt?: any | null;
  attention: CaseAttentionEnum;
  awaiting?: string | null;
  startAfter?: string | null;
  completeBefore?: string | null;
  scheduledDate?: string | null;
  scheduledTime?: string | null;
  isAttending?: boolean | null;
  serviceTeam?: { __typename?: "ServiceTeam"; id: string; name: string } | null;
  requester?: {
    __typename?: "User";
    id: string;
    name: string;
    email: string;
    phone?: string | null;
    protected: boolean;
  } | null;
  responsible?: {
    __typename?: "CaseUser";
    id: string;
    name: string;
    email: string;
    phone?: string | null;
    protected: boolean;
  } | null;
  property?: { __typename?: "Property"; id: string; name: string } | null;
  apartment?: {
    __typename?: "Apartment";
    id: string;
    publicId: string;
    address: string;
    postalCode: string;
    city: string;
  } | null;
  tenancy?: {
    __typename?: "Tenancy";
    id: string;
    startDate: string;
    requestedEndDate?: string | null;
    endDate?: string | null;
    user: {
      __typename?: "User";
      id: string;
      name: string;
      email: string;
      phone?: string | null;
      protected: boolean;
    };
  } | null;
} & { " $fragmentName"?: "DataTableCases_CreateTenancy_Fragment" };

type DataTableCases_EndTenancy_Fragment = {
  __typename: "EndTenancy";
  id: string;
  type: CaseTypeEnum;
  icon: string;
  createdAt: any;
  updatedAt: any;
  name: string;
  shortName: string;
  state: string;
  stateText: string;
  stateLastChangedAt?: any | null;
  attention: CaseAttentionEnum;
  awaiting?: string | null;
  startAfter?: string | null;
  completeBefore?: string | null;
  scheduledDate?: string | null;
  scheduledTime?: string | null;
  isAttending?: boolean | null;
  serviceTeam?: { __typename?: "ServiceTeam"; id: string; name: string } | null;
  requester?: {
    __typename?: "User";
    id: string;
    name: string;
    email: string;
    phone?: string | null;
    protected: boolean;
  } | null;
  responsible?: {
    __typename?: "CaseUser";
    id: string;
    name: string;
    email: string;
    phone?: string | null;
    protected: boolean;
  } | null;
  property?: { __typename?: "Property"; id: string; name: string } | null;
  apartment?: {
    __typename?: "Apartment";
    id: string;
    publicId: string;
    address: string;
    postalCode: string;
    city: string;
  } | null;
  tenancy?: {
    __typename?: "Tenancy";
    id: string;
    startDate: string;
    requestedEndDate?: string | null;
    endDate?: string | null;
    user: {
      __typename?: "User";
      id: string;
      name: string;
      email: string;
      phone?: string | null;
      protected: boolean;
    };
  } | null;
} & { " $fragmentName"?: "DataTableCases_EndTenancy_Fragment" };

type DataTableCases_FindTenancyAdministration_Fragment = {
  __typename: "FindTenancyAdministration";
  id: string;
  type: CaseTypeEnum;
  icon: string;
  createdAt: any;
  updatedAt: any;
  name: string;
  shortName: string;
  state: string;
  stateText: string;
  stateLastChangedAt?: any | null;
  attention: CaseAttentionEnum;
  awaiting?: string | null;
  startAfter?: string | null;
  completeBefore?: string | null;
  scheduledDate?: string | null;
  scheduledTime?: string | null;
  isAttending?: boolean | null;
  serviceTeam?: { __typename?: "ServiceTeam"; id: string; name: string } | null;
  requester?: {
    __typename?: "User";
    id: string;
    name: string;
    email: string;
    phone?: string | null;
    protected: boolean;
  } | null;
  responsible?: {
    __typename?: "CaseUser";
    id: string;
    name: string;
    email: string;
    phone?: string | null;
    protected: boolean;
  } | null;
  property?: { __typename?: "Property"; id: string; name: string } | null;
  apartment?: {
    __typename?: "Apartment";
    id: string;
    publicId: string;
    address: string;
    postalCode: string;
    city: string;
  } | null;
  tenancy?: {
    __typename?: "Tenancy";
    id: string;
    startDate: string;
    requestedEndDate?: string | null;
    endDate?: string | null;
    user: {
      __typename?: "User";
      id: string;
      name: string;
      email: string;
      phone?: string | null;
      protected: boolean;
    };
  } | null;
} & { " $fragmentName"?: "DataTableCases_FindTenancyAdministration_Fragment" };

type DataTableCases_MiscAdministration_Fragment = {
  __typename: "MiscAdministration";
  id: string;
  type: CaseTypeEnum;
  icon: string;
  createdAt: any;
  updatedAt: any;
  name: string;
  shortName: string;
  state: string;
  stateText: string;
  stateLastChangedAt?: any | null;
  attention: CaseAttentionEnum;
  awaiting?: string | null;
  startAfter?: string | null;
  completeBefore?: string | null;
  scheduledDate?: string | null;
  scheduledTime?: string | null;
  isAttending?: boolean | null;
  serviceTeam?: { __typename?: "ServiceTeam"; id: string; name: string } | null;
  requester?: {
    __typename?: "User";
    id: string;
    name: string;
    email: string;
    phone?: string | null;
    protected: boolean;
  } | null;
  responsible?: {
    __typename?: "CaseUser";
    id: string;
    name: string;
    email: string;
    phone?: string | null;
    protected: boolean;
  } | null;
  property?: { __typename?: "Property"; id: string; name: string } | null;
  apartment?: {
    __typename?: "Apartment";
    id: string;
    publicId: string;
    address: string;
    postalCode: string;
    city: string;
  } | null;
  tenancy?: {
    __typename?: "Tenancy";
    id: string;
    startDate: string;
    requestedEndDate?: string | null;
    endDate?: string | null;
    user: {
      __typename?: "User";
      id: string;
      name: string;
      email: string;
      phone?: string | null;
      protected: boolean;
    };
  } | null;
} & { " $fragmentName"?: "DataTableCases_MiscAdministration_Fragment" };

type DataTableCases_MiscService_Fragment = {
  __typename: "MiscService";
  id: string;
  type: CaseTypeEnum;
  icon: string;
  createdAt: any;
  updatedAt: any;
  name: string;
  shortName: string;
  state: string;
  stateText: string;
  stateLastChangedAt?: any | null;
  attention: CaseAttentionEnum;
  awaiting?: string | null;
  startAfter?: string | null;
  completeBefore?: string | null;
  scheduledDate?: string | null;
  scheduledTime?: string | null;
  isAttending?: boolean | null;
  serviceTeam?: { __typename?: "ServiceTeam"; id: string; name: string } | null;
  requester?: {
    __typename?: "User";
    id: string;
    name: string;
    email: string;
    phone?: string | null;
    protected: boolean;
  } | null;
  responsible?: {
    __typename?: "CaseUser";
    id: string;
    name: string;
    email: string;
    phone?: string | null;
    protected: boolean;
  } | null;
  property?: { __typename?: "Property"; id: string; name: string } | null;
  apartment?: {
    __typename?: "Apartment";
    id: string;
    publicId: string;
    address: string;
    postalCode: string;
    city: string;
  } | null;
  tenancy?: {
    __typename?: "Tenancy";
    id: string;
    startDate: string;
    requestedEndDate?: string | null;
    endDate?: string | null;
    user: {
      __typename?: "User";
      id: string;
      name: string;
      email: string;
      phone?: string | null;
      protected: boolean;
    };
  } | null;
} & { " $fragmentName"?: "DataTableCases_MiscService_Fragment" };

type DataTableCases_MovingInService_Fragment = {
  __typename: "MovingInService";
  id: string;
  type: CaseTypeEnum;
  icon: string;
  createdAt: any;
  updatedAt: any;
  name: string;
  shortName: string;
  state: string;
  stateText: string;
  stateLastChangedAt?: any | null;
  attention: CaseAttentionEnum;
  awaiting?: string | null;
  startAfter?: string | null;
  completeBefore?: string | null;
  scheduledDate?: string | null;
  scheduledTime?: string | null;
  isAttending?: boolean | null;
  serviceTeam?: { __typename?: "ServiceTeam"; id: string; name: string } | null;
  requester?: {
    __typename?: "User";
    id: string;
    name: string;
    email: string;
    phone?: string | null;
    protected: boolean;
  } | null;
  responsible?: {
    __typename?: "CaseUser";
    id: string;
    name: string;
    email: string;
    phone?: string | null;
    protected: boolean;
  } | null;
  property?: { __typename?: "Property"; id: string; name: string } | null;
  apartment?: {
    __typename?: "Apartment";
    id: string;
    publicId: string;
    address: string;
    postalCode: string;
    city: string;
  } | null;
  tenancy?: {
    __typename?: "Tenancy";
    id: string;
    startDate: string;
    requestedEndDate?: string | null;
    endDate?: string | null;
    user: {
      __typename?: "User";
      id: string;
      name: string;
      email: string;
      phone?: string | null;
      protected: boolean;
    };
  } | null;
} & { " $fragmentName"?: "DataTableCases_MovingInService_Fragment" };

type DataTableCases_MovingInTenancy_Fragment = {
  __typename: "MovingInTenancy";
  id: string;
  type: CaseTypeEnum;
  icon: string;
  createdAt: any;
  updatedAt: any;
  name: string;
  shortName: string;
  state: string;
  stateText: string;
  stateLastChangedAt?: any | null;
  attention: CaseAttentionEnum;
  awaiting?: string | null;
  startAfter?: string | null;
  completeBefore?: string | null;
  scheduledDate?: string | null;
  scheduledTime?: string | null;
  isAttending?: boolean | null;
  serviceTeam?: { __typename?: "ServiceTeam"; id: string; name: string } | null;
  requester?: {
    __typename?: "User";
    id: string;
    name: string;
    email: string;
    phone?: string | null;
    protected: boolean;
  } | null;
  responsible?: {
    __typename?: "CaseUser";
    id: string;
    name: string;
    email: string;
    phone?: string | null;
    protected: boolean;
  } | null;
  property?: { __typename?: "Property"; id: string; name: string } | null;
  apartment?: {
    __typename?: "Apartment";
    id: string;
    publicId: string;
    address: string;
    postalCode: string;
    city: string;
  } | null;
  tenancy?: {
    __typename?: "Tenancy";
    id: string;
    startDate: string;
    requestedEndDate?: string | null;
    endDate?: string | null;
    user: {
      __typename?: "User";
      id: string;
      name: string;
      email: string;
      phone?: string | null;
      protected: boolean;
    };
  } | null;
} & { " $fragmentName"?: "DataTableCases_MovingInTenancy_Fragment" };

type DataTableCases_MovingOutService_Fragment = {
  __typename: "MovingOutService";
  id: string;
  type: CaseTypeEnum;
  icon: string;
  createdAt: any;
  updatedAt: any;
  name: string;
  shortName: string;
  state: string;
  stateText: string;
  stateLastChangedAt?: any | null;
  attention: CaseAttentionEnum;
  awaiting?: string | null;
  startAfter?: string | null;
  completeBefore?: string | null;
  scheduledDate?: string | null;
  scheduledTime?: string | null;
  isAttending?: boolean | null;
  serviceTeam?: { __typename?: "ServiceTeam"; id: string; name: string } | null;
  requester?: {
    __typename?: "User";
    id: string;
    name: string;
    email: string;
    phone?: string | null;
    protected: boolean;
  } | null;
  responsible?: {
    __typename?: "CaseUser";
    id: string;
    name: string;
    email: string;
    phone?: string | null;
    protected: boolean;
  } | null;
  property?: { __typename?: "Property"; id: string; name: string } | null;
  apartment?: {
    __typename?: "Apartment";
    id: string;
    publicId: string;
    address: string;
    postalCode: string;
    city: string;
  } | null;
  tenancy?: {
    __typename?: "Tenancy";
    id: string;
    startDate: string;
    requestedEndDate?: string | null;
    endDate?: string | null;
    user: {
      __typename?: "User";
      id: string;
      name: string;
      email: string;
      phone?: string | null;
      protected: boolean;
    };
  } | null;
} & { " $fragmentName"?: "DataTableCases_MovingOutService_Fragment" };

type DataTableCases_MovingOutTenancy_Fragment = {
  __typename: "MovingOutTenancy";
  id: string;
  type: CaseTypeEnum;
  icon: string;
  createdAt: any;
  updatedAt: any;
  name: string;
  shortName: string;
  state: string;
  stateText: string;
  stateLastChangedAt?: any | null;
  attention: CaseAttentionEnum;
  awaiting?: string | null;
  startAfter?: string | null;
  completeBefore?: string | null;
  scheduledDate?: string | null;
  scheduledTime?: string | null;
  isAttending?: boolean | null;
  serviceTeam?: { __typename?: "ServiceTeam"; id: string; name: string } | null;
  requester?: {
    __typename?: "User";
    id: string;
    name: string;
    email: string;
    phone?: string | null;
    protected: boolean;
  } | null;
  responsible?: {
    __typename?: "CaseUser";
    id: string;
    name: string;
    email: string;
    phone?: string | null;
    protected: boolean;
  } | null;
  property?: { __typename?: "Property"; id: string; name: string } | null;
  apartment?: {
    __typename?: "Apartment";
    id: string;
    publicId: string;
    address: string;
    postalCode: string;
    city: string;
  } | null;
  tenancy?: {
    __typename?: "Tenancy";
    id: string;
    startDate: string;
    requestedEndDate?: string | null;
    endDate?: string | null;
    user: {
      __typename?: "User";
      id: string;
      name: string;
      email: string;
      phone?: string | null;
      protected: boolean;
    };
  } | null;
} & { " $fragmentName"?: "DataTableCases_MovingOutTenancy_Fragment" };

type DataTableCases_MovingSettlementAdministration_Fragment = {
  __typename: "MovingSettlementAdministration";
  id: string;
  type: CaseTypeEnum;
  icon: string;
  createdAt: any;
  updatedAt: any;
  name: string;
  shortName: string;
  state: string;
  stateText: string;
  stateLastChangedAt?: any | null;
  attention: CaseAttentionEnum;
  awaiting?: string | null;
  startAfter?: string | null;
  completeBefore?: string | null;
  scheduledDate?: string | null;
  scheduledTime?: string | null;
  isAttending?: boolean | null;
  serviceTeam?: { __typename?: "ServiceTeam"; id: string; name: string } | null;
  requester?: {
    __typename?: "User";
    id: string;
    name: string;
    email: string;
    phone?: string | null;
    protected: boolean;
  } | null;
  responsible?: {
    __typename?: "CaseUser";
    id: string;
    name: string;
    email: string;
    phone?: string | null;
    protected: boolean;
  } | null;
  property?: { __typename?: "Property"; id: string; name: string } | null;
  apartment?: {
    __typename?: "Apartment";
    id: string;
    publicId: string;
    address: string;
    postalCode: string;
    city: string;
  } | null;
  tenancy?: {
    __typename?: "Tenancy";
    id: string;
    startDate: string;
    requestedEndDate?: string | null;
    endDate?: string | null;
    user: {
      __typename?: "User";
      id: string;
      name: string;
      email: string;
      phone?: string | null;
      protected: boolean;
    };
  } | null;
} & {
  " $fragmentName"?: "DataTableCases_MovingSettlementAdministration_Fragment";
};

type DataTableCases_PreparationService_Fragment = {
  __typename: "PreparationService";
  id: string;
  type: CaseTypeEnum;
  icon: string;
  createdAt: any;
  updatedAt: any;
  name: string;
  shortName: string;
  state: string;
  stateText: string;
  stateLastChangedAt?: any | null;
  attention: CaseAttentionEnum;
  awaiting?: string | null;
  startAfter?: string | null;
  completeBefore?: string | null;
  scheduledDate?: string | null;
  scheduledTime?: string | null;
  isAttending?: boolean | null;
  serviceTeam?: { __typename?: "ServiceTeam"; id: string; name: string } | null;
  requester?: {
    __typename?: "User";
    id: string;
    name: string;
    email: string;
    phone?: string | null;
    protected: boolean;
  } | null;
  responsible?: {
    __typename?: "CaseUser";
    id: string;
    name: string;
    email: string;
    phone?: string | null;
    protected: boolean;
  } | null;
  property?: { __typename?: "Property"; id: string; name: string } | null;
  apartment?: {
    __typename?: "Apartment";
    id: string;
    publicId: string;
    address: string;
    postalCode: string;
    city: string;
  } | null;
  tenancy?: {
    __typename?: "Tenancy";
    id: string;
    startDate: string;
    requestedEndDate?: string | null;
    endDate?: string | null;
    user: {
      __typename?: "User";
      id: string;
      name: string;
      email: string;
      phone?: string | null;
      protected: boolean;
    };
  } | null;
} & { " $fragmentName"?: "DataTableCases_PreparationService_Fragment" };

type DataTableCases_RequestTenancy_Fragment = {
  __typename: "RequestTenancy";
  id: string;
  type: CaseTypeEnum;
  icon: string;
  createdAt: any;
  updatedAt: any;
  name: string;
  shortName: string;
  state: string;
  stateText: string;
  stateLastChangedAt?: any | null;
  attention: CaseAttentionEnum;
  awaiting?: string | null;
  startAfter?: string | null;
  completeBefore?: string | null;
  scheduledDate?: string | null;
  scheduledTime?: string | null;
  isAttending?: boolean | null;
  serviceTeam?: { __typename?: "ServiceTeam"; id: string; name: string } | null;
  requester?: {
    __typename?: "User";
    id: string;
    name: string;
    email: string;
    phone?: string | null;
    protected: boolean;
  } | null;
  responsible?: {
    __typename?: "CaseUser";
    id: string;
    name: string;
    email: string;
    phone?: string | null;
    protected: boolean;
  } | null;
  property?: { __typename?: "Property"; id: string; name: string } | null;
  apartment?: {
    __typename?: "Apartment";
    id: string;
    publicId: string;
    address: string;
    postalCode: string;
    city: string;
  } | null;
  tenancy?: {
    __typename?: "Tenancy";
    id: string;
    startDate: string;
    requestedEndDate?: string | null;
    endDate?: string | null;
    user: {
      __typename?: "User";
      id: string;
      name: string;
      email: string;
      phone?: string | null;
      protected: boolean;
    };
  } | null;
} & { " $fragmentName"?: "DataTableCases_RequestTenancy_Fragment" };

type DataTableCases_UtilityAdministration_Fragment = {
  __typename: "UtilityAdministration";
  id: string;
  type: CaseTypeEnum;
  icon: string;
  createdAt: any;
  updatedAt: any;
  name: string;
  shortName: string;
  state: string;
  stateText: string;
  stateLastChangedAt?: any | null;
  attention: CaseAttentionEnum;
  awaiting?: string | null;
  startAfter?: string | null;
  completeBefore?: string | null;
  scheduledDate?: string | null;
  scheduledTime?: string | null;
  isAttending?: boolean | null;
  serviceTeam?: { __typename?: "ServiceTeam"; id: string; name: string } | null;
  requester?: {
    __typename?: "User";
    id: string;
    name: string;
    email: string;
    phone?: string | null;
    protected: boolean;
  } | null;
  responsible?: {
    __typename?: "CaseUser";
    id: string;
    name: string;
    email: string;
    phone?: string | null;
    protected: boolean;
  } | null;
  property?: { __typename?: "Property"; id: string; name: string } | null;
  apartment?: {
    __typename?: "Apartment";
    id: string;
    publicId: string;
    address: string;
    postalCode: string;
    city: string;
  } | null;
  tenancy?: {
    __typename?: "Tenancy";
    id: string;
    startDate: string;
    requestedEndDate?: string | null;
    endDate?: string | null;
    user: {
      __typename?: "User";
      id: string;
      name: string;
      email: string;
      phone?: string | null;
      protected: boolean;
    };
  } | null;
} & { " $fragmentName"?: "DataTableCases_UtilityAdministration_Fragment" };

export type DataTableCasesFragment =
  | DataTableCases_CleaningService_Fragment
  | DataTableCases_CreateTenancy_Fragment
  | DataTableCases_EndTenancy_Fragment
  | DataTableCases_FindTenancyAdministration_Fragment
  | DataTableCases_MiscAdministration_Fragment
  | DataTableCases_MiscService_Fragment
  | DataTableCases_MovingInService_Fragment
  | DataTableCases_MovingInTenancy_Fragment
  | DataTableCases_MovingOutService_Fragment
  | DataTableCases_MovingOutTenancy_Fragment
  | DataTableCases_MovingSettlementAdministration_Fragment
  | DataTableCases_PreparationService_Fragment
  | DataTableCases_RequestTenancy_Fragment
  | DataTableCases_UtilityAdministration_Fragment;

export type EconomicSubscriberFragment = {
  __typename: "EconomicSubscriber";
  id: string;
  price: number;
  canceledAt?: any | null;
  intervalStartAt?: any | null;
  intervalEndAt?: any | null;
  signedUpAt?: any | null;
  debtor: {
    __typename: "EconomicDebtor";
    id: string;
    name: string;
    addressText?: string | null;
  };
  subscription: {
    __typename: "EconomicSubscription";
    id: string;
    intervalType?: EconomicSubscriptionIntervalEnum | null;
    name: string;
  };
} & { " $fragmentName"?: "EconomicSubscriberFragment" };

export type DataTablePropertiesFragment = {
  __typename: "Property";
  id: string;
  name: string;
  activeServiceCasesCount: number;
  createdAt: any;
  administrator: { __typename?: "Company"; name: string };
  owner: { __typename?: "Company"; name: string };
} & { " $fragmentName"?: "DataTablePropertiesFragment" };

export type DataTableTenanciesFragment = {
  __typename?: "Tenancy";
  id: string;
  startDate: string;
  endDate?: string | null;
  requestedEndDate?: string | null;
  depositAmount?: number | null;
  depositDueDate?: string | null;
  intervalAmount?: number | null;
  heatingAmount?: number | null;
  waterAmount?: number | null;
  electricityAmount?: number | null;
  expectedMovingInCases: Array<{
    __typename?: "CaseDefinition";
    type: CaseTypeEnum;
    name: string;
    icon: string;
  }>;
  expectedMovingOutCases: Array<{
    __typename?: "CaseDefinition";
    type: CaseTypeEnum;
    name: string;
    icon: string;
  }>;
  movingInCase?: {
    __typename?: "Case";
    id: string;
    icon: string;
    attention: CaseAttentionEnum;
    children: Array<{
      __typename?: "Case";
      id: string;
      type: CaseTypeEnum;
      shortName: string;
      icon: string;
      attention: CaseAttentionEnum;
    }>;
  } | null;
  movingOutCase?: {
    __typename?: "Case";
    id: string;
    icon: string;
    attention: CaseAttentionEnum;
    children: Array<{
      __typename?: "Case";
      id: string;
      type: CaseTypeEnum;
      shortName: string;
      icon: string;
      attention: CaseAttentionEnum;
    }>;
  } | null;
  contractCase?: {
    __typename?: "CreateTenancy";
    id: string;
    icon: string;
    attention: CaseAttentionEnum;
    stateText: string;
  } | null;
  user: {
    __typename?: "User";
    name: string;
    phone?: string | null;
    email: string;
    protected: boolean;
  };
  apartment: {
    __typename?: "Apartment";
    id: string;
    publicId: string;
    address: string;
    city: string;
  };
  economic: {
    __typename?: "TenancyEconomic";
    deposit?: number | null;
    prepaidRent?: number | null;
    rentAmount?: number | null;
    parkingAmount?: number | null;
    rentReductionAmount?: number | null;
    regulationDepositAmount?: number | null;
    regulationPrepaidRentAmount?: number | null;
    advanceWasteWaterAmount?: number | null;
    advanceWaterAmount?: number | null;
    advanceHeatingAmount?: number | null;
    advanceElectricityAmount?: number | null;
    settlementWasteWaterAmount?: number | null;
    settlementWaterAmount?: number | null;
    settlementHeatingAmount?: number | null;
    settlementElectricityAmount?: number | null;
    otherAmount?: number | null;
    companySyncedAt?: any | null;
    debtor?: {
      __typename?: "EconomicDebtor";
      id: string;
      name: string;
      externalId: number;
    } | null;
  };
} & { " $fragmentName"?: "DataTableTenanciesFragment" };

export type FilterCaseTypeQueryVariables = Exact<{ [key: string]: never }>;

export type FilterCaseTypeQuery = {
  __typename?: "Query";
  caseDefinitions: Array<{
    __typename: "CaseDefinition";
    states: Array<string>;
    type: CaseTypeEnum;
    icon: string;
  }>;
};

export type FilterCaseWorkerQueryVariables = Exact<{ [key: string]: never }>;

export type FilterCaseWorkerQuery = {
  __typename?: "Query";
  teamMembers: {
    __typename?: "UserList";
    records: Array<{ __typename?: "User"; id: string; name: string }>;
  };
};

export type FilterPropertyQueryVariables = Exact<{ [key: string]: never }>;

export type FilterPropertyQuery = {
  __typename?: "Query";
  properties: {
    __typename?: "PropertyList";
    records: Array<{ __typename?: "Property"; id: string; name: string }>;
  };
};

export type FilterTeamQueryVariables = Exact<{ [key: string]: never }>;

export type FilterTeamQuery = {
  __typename?: "Query";
  teams: {
    __typename?: "TeamList";
    records: Array<
      | { __typename?: "AdministrationTeam"; id: string; name: string }
      | { __typename?: "ServiceTeam"; id: string; name: string }
    >;
  };
};

type CaseDefinitionCaseFragment_CleaningService_Fragment = {
  __typename: "CleaningService";
  id: string;
  name: string;
  shortName: string;
  type: CaseTypeEnum;
  icon: string;
  attention: CaseAttentionEnum;
  awaiting?: string | null;
  state: string;
  stateText: string;
} & {
  " $fragmentName"?: "CaseDefinitionCaseFragment_CleaningService_Fragment";
};

type CaseDefinitionCaseFragment_CreateTenancy_Fragment = {
  __typename: "CreateTenancy";
  id: string;
  name: string;
  shortName: string;
  type: CaseTypeEnum;
  icon: string;
  attention: CaseAttentionEnum;
  awaiting?: string | null;
  state: string;
  stateText: string;
} & { " $fragmentName"?: "CaseDefinitionCaseFragment_CreateTenancy_Fragment" };

type CaseDefinitionCaseFragment_EndTenancy_Fragment = {
  __typename: "EndTenancy";
  id: string;
  name: string;
  shortName: string;
  type: CaseTypeEnum;
  icon: string;
  attention: CaseAttentionEnum;
  awaiting?: string | null;
  state: string;
  stateText: string;
} & { " $fragmentName"?: "CaseDefinitionCaseFragment_EndTenancy_Fragment" };

type CaseDefinitionCaseFragment_FindTenancyAdministration_Fragment = {
  __typename: "FindTenancyAdministration";
  id: string;
  name: string;
  shortName: string;
  type: CaseTypeEnum;
  icon: string;
  attention: CaseAttentionEnum;
  awaiting?: string | null;
  state: string;
  stateText: string;
} & {
  " $fragmentName"?: "CaseDefinitionCaseFragment_FindTenancyAdministration_Fragment";
};

type CaseDefinitionCaseFragment_MiscAdministration_Fragment = {
  __typename: "MiscAdministration";
  id: string;
  name: string;
  shortName: string;
  type: CaseTypeEnum;
  icon: string;
  attention: CaseAttentionEnum;
  awaiting?: string | null;
  state: string;
  stateText: string;
} & {
  " $fragmentName"?: "CaseDefinitionCaseFragment_MiscAdministration_Fragment";
};

type CaseDefinitionCaseFragment_MiscService_Fragment = {
  __typename: "MiscService";
  id: string;
  name: string;
  shortName: string;
  type: CaseTypeEnum;
  icon: string;
  attention: CaseAttentionEnum;
  awaiting?: string | null;
  state: string;
  stateText: string;
} & { " $fragmentName"?: "CaseDefinitionCaseFragment_MiscService_Fragment" };

type CaseDefinitionCaseFragment_MovingInService_Fragment = {
  __typename: "MovingInService";
  id: string;
  name: string;
  shortName: string;
  type: CaseTypeEnum;
  icon: string;
  attention: CaseAttentionEnum;
  awaiting?: string | null;
  state: string;
  stateText: string;
} & {
  " $fragmentName"?: "CaseDefinitionCaseFragment_MovingInService_Fragment";
};

type CaseDefinitionCaseFragment_MovingInTenancy_Fragment = {
  __typename: "MovingInTenancy";
  id: string;
  name: string;
  shortName: string;
  type: CaseTypeEnum;
  icon: string;
  attention: CaseAttentionEnum;
  awaiting?: string | null;
  state: string;
  stateText: string;
} & {
  " $fragmentName"?: "CaseDefinitionCaseFragment_MovingInTenancy_Fragment";
};

type CaseDefinitionCaseFragment_MovingOutService_Fragment = {
  __typename: "MovingOutService";
  id: string;
  name: string;
  shortName: string;
  type: CaseTypeEnum;
  icon: string;
  attention: CaseAttentionEnum;
  awaiting?: string | null;
  state: string;
  stateText: string;
} & {
  " $fragmentName"?: "CaseDefinitionCaseFragment_MovingOutService_Fragment";
};

type CaseDefinitionCaseFragment_MovingOutTenancy_Fragment = {
  __typename: "MovingOutTenancy";
  id: string;
  name: string;
  shortName: string;
  type: CaseTypeEnum;
  icon: string;
  attention: CaseAttentionEnum;
  awaiting?: string | null;
  state: string;
  stateText: string;
} & {
  " $fragmentName"?: "CaseDefinitionCaseFragment_MovingOutTenancy_Fragment";
};

type CaseDefinitionCaseFragment_MovingSettlementAdministration_Fragment = {
  __typename: "MovingSettlementAdministration";
  id: string;
  name: string;
  shortName: string;
  type: CaseTypeEnum;
  icon: string;
  attention: CaseAttentionEnum;
  awaiting?: string | null;
  state: string;
  stateText: string;
} & {
  " $fragmentName"?: "CaseDefinitionCaseFragment_MovingSettlementAdministration_Fragment";
};

type CaseDefinitionCaseFragment_PreparationService_Fragment = {
  __typename: "PreparationService";
  id: string;
  name: string;
  shortName: string;
  type: CaseTypeEnum;
  icon: string;
  attention: CaseAttentionEnum;
  awaiting?: string | null;
  state: string;
  stateText: string;
} & {
  " $fragmentName"?: "CaseDefinitionCaseFragment_PreparationService_Fragment";
};

type CaseDefinitionCaseFragment_RequestTenancy_Fragment = {
  __typename: "RequestTenancy";
  id: string;
  name: string;
  shortName: string;
  type: CaseTypeEnum;
  icon: string;
  attention: CaseAttentionEnum;
  awaiting?: string | null;
  state: string;
  stateText: string;
} & { " $fragmentName"?: "CaseDefinitionCaseFragment_RequestTenancy_Fragment" };

type CaseDefinitionCaseFragment_UtilityAdministration_Fragment = {
  __typename: "UtilityAdministration";
  id: string;
  name: string;
  shortName: string;
  type: CaseTypeEnum;
  icon: string;
  attention: CaseAttentionEnum;
  awaiting?: string | null;
  state: string;
  stateText: string;
} & {
  " $fragmentName"?: "CaseDefinitionCaseFragment_UtilityAdministration_Fragment";
};

export type CaseDefinitionCaseFragmentFragment =
  | CaseDefinitionCaseFragment_CleaningService_Fragment
  | CaseDefinitionCaseFragment_CreateTenancy_Fragment
  | CaseDefinitionCaseFragment_EndTenancy_Fragment
  | CaseDefinitionCaseFragment_FindTenancyAdministration_Fragment
  | CaseDefinitionCaseFragment_MiscAdministration_Fragment
  | CaseDefinitionCaseFragment_MiscService_Fragment
  | CaseDefinitionCaseFragment_MovingInService_Fragment
  | CaseDefinitionCaseFragment_MovingInTenancy_Fragment
  | CaseDefinitionCaseFragment_MovingOutService_Fragment
  | CaseDefinitionCaseFragment_MovingOutTenancy_Fragment
  | CaseDefinitionCaseFragment_MovingSettlementAdministration_Fragment
  | CaseDefinitionCaseFragment_PreparationService_Fragment
  | CaseDefinitionCaseFragment_RequestTenancy_Fragment
  | CaseDefinitionCaseFragment_UtilityAdministration_Fragment;

export type CaseDefinitionInfoFragmentFragment = {
  __typename: "CaseDefinition";
  name: string;
  icon: string;
  type: CaseTypeEnum;
} & { " $fragmentName"?: "CaseDefinitionInfoFragmentFragment" };

export type HeaderActionsDataQueryVariables = Exact<{ [key: string]: never }>;

export type HeaderActionsDataQuery = {
  __typename?: "Query";
  inbox: Array<
    {
      __typename?: "CaseDefinition";
      cases: {
        __typename?: "CaseList";
        count: number;
        records: Array<
          | ({ __typename?: "CleaningService" } & {
              " $fragmentRefs"?: {
                CaseDefinitionCaseFragment_CleaningService_Fragment: CaseDefinitionCaseFragment_CleaningService_Fragment;
              };
            })
          | ({ __typename?: "CreateTenancy" } & {
              " $fragmentRefs"?: {
                CaseDefinitionCaseFragment_CreateTenancy_Fragment: CaseDefinitionCaseFragment_CreateTenancy_Fragment;
              };
            })
          | ({ __typename?: "EndTenancy" } & {
              " $fragmentRefs"?: {
                CaseDefinitionCaseFragment_EndTenancy_Fragment: CaseDefinitionCaseFragment_EndTenancy_Fragment;
              };
            })
          | ({ __typename?: "FindTenancyAdministration" } & {
              " $fragmentRefs"?: {
                CaseDefinitionCaseFragment_FindTenancyAdministration_Fragment: CaseDefinitionCaseFragment_FindTenancyAdministration_Fragment;
              };
            })
          | ({ __typename?: "MiscAdministration" } & {
              " $fragmentRefs"?: {
                CaseDefinitionCaseFragment_MiscAdministration_Fragment: CaseDefinitionCaseFragment_MiscAdministration_Fragment;
              };
            })
          | ({ __typename?: "MiscService" } & {
              " $fragmentRefs"?: {
                CaseDefinitionCaseFragment_MiscService_Fragment: CaseDefinitionCaseFragment_MiscService_Fragment;
              };
            })
          | ({ __typename?: "MovingInService" } & {
              " $fragmentRefs"?: {
                CaseDefinitionCaseFragment_MovingInService_Fragment: CaseDefinitionCaseFragment_MovingInService_Fragment;
              };
            })
          | ({ __typename?: "MovingInTenancy" } & {
              " $fragmentRefs"?: {
                CaseDefinitionCaseFragment_MovingInTenancy_Fragment: CaseDefinitionCaseFragment_MovingInTenancy_Fragment;
              };
            })
          | ({ __typename?: "MovingOutService" } & {
              " $fragmentRefs"?: {
                CaseDefinitionCaseFragment_MovingOutService_Fragment: CaseDefinitionCaseFragment_MovingOutService_Fragment;
              };
            })
          | ({ __typename?: "MovingOutTenancy" } & {
              " $fragmentRefs"?: {
                CaseDefinitionCaseFragment_MovingOutTenancy_Fragment: CaseDefinitionCaseFragment_MovingOutTenancy_Fragment;
              };
            })
          | ({ __typename?: "MovingSettlementAdministration" } & {
              " $fragmentRefs"?: {
                CaseDefinitionCaseFragment_MovingSettlementAdministration_Fragment: CaseDefinitionCaseFragment_MovingSettlementAdministration_Fragment;
              };
            })
          | ({ __typename?: "PreparationService" } & {
              " $fragmentRefs"?: {
                CaseDefinitionCaseFragment_PreparationService_Fragment: CaseDefinitionCaseFragment_PreparationService_Fragment;
              };
            })
          | ({ __typename?: "RequestTenancy" } & {
              " $fragmentRefs"?: {
                CaseDefinitionCaseFragment_RequestTenancy_Fragment: CaseDefinitionCaseFragment_RequestTenancy_Fragment;
              };
            })
          | ({ __typename?: "UtilityAdministration" } & {
              " $fragmentRefs"?: {
                CaseDefinitionCaseFragment_UtilityAdministration_Fragment: CaseDefinitionCaseFragment_UtilityAdministration_Fragment;
              };
            })
        >;
      };
    } & {
      " $fragmentRefs"?: {
        CaseDefinitionInfoFragmentFragment: CaseDefinitionInfoFragmentFragment;
      };
    }
  >;
  flagged: Array<
    {
      __typename?: "CaseDefinition";
      cases: {
        __typename?: "CaseList";
        count: number;
        records: Array<
          | ({ __typename?: "CleaningService" } & {
              " $fragmentRefs"?: {
                CaseDefinitionCaseFragment_CleaningService_Fragment: CaseDefinitionCaseFragment_CleaningService_Fragment;
              };
            })
          | ({ __typename?: "CreateTenancy" } & {
              " $fragmentRefs"?: {
                CaseDefinitionCaseFragment_CreateTenancy_Fragment: CaseDefinitionCaseFragment_CreateTenancy_Fragment;
              };
            })
          | ({ __typename?: "EndTenancy" } & {
              " $fragmentRefs"?: {
                CaseDefinitionCaseFragment_EndTenancy_Fragment: CaseDefinitionCaseFragment_EndTenancy_Fragment;
              };
            })
          | ({ __typename?: "FindTenancyAdministration" } & {
              " $fragmentRefs"?: {
                CaseDefinitionCaseFragment_FindTenancyAdministration_Fragment: CaseDefinitionCaseFragment_FindTenancyAdministration_Fragment;
              };
            })
          | ({ __typename?: "MiscAdministration" } & {
              " $fragmentRefs"?: {
                CaseDefinitionCaseFragment_MiscAdministration_Fragment: CaseDefinitionCaseFragment_MiscAdministration_Fragment;
              };
            })
          | ({ __typename?: "MiscService" } & {
              " $fragmentRefs"?: {
                CaseDefinitionCaseFragment_MiscService_Fragment: CaseDefinitionCaseFragment_MiscService_Fragment;
              };
            })
          | ({ __typename?: "MovingInService" } & {
              " $fragmentRefs"?: {
                CaseDefinitionCaseFragment_MovingInService_Fragment: CaseDefinitionCaseFragment_MovingInService_Fragment;
              };
            })
          | ({ __typename?: "MovingInTenancy" } & {
              " $fragmentRefs"?: {
                CaseDefinitionCaseFragment_MovingInTenancy_Fragment: CaseDefinitionCaseFragment_MovingInTenancy_Fragment;
              };
            })
          | ({ __typename?: "MovingOutService" } & {
              " $fragmentRefs"?: {
                CaseDefinitionCaseFragment_MovingOutService_Fragment: CaseDefinitionCaseFragment_MovingOutService_Fragment;
              };
            })
          | ({ __typename?: "MovingOutTenancy" } & {
              " $fragmentRefs"?: {
                CaseDefinitionCaseFragment_MovingOutTenancy_Fragment: CaseDefinitionCaseFragment_MovingOutTenancy_Fragment;
              };
            })
          | ({ __typename?: "MovingSettlementAdministration" } & {
              " $fragmentRefs"?: {
                CaseDefinitionCaseFragment_MovingSettlementAdministration_Fragment: CaseDefinitionCaseFragment_MovingSettlementAdministration_Fragment;
              };
            })
          | ({ __typename?: "PreparationService" } & {
              " $fragmentRefs"?: {
                CaseDefinitionCaseFragment_PreparationService_Fragment: CaseDefinitionCaseFragment_PreparationService_Fragment;
              };
            })
          | ({ __typename?: "RequestTenancy" } & {
              " $fragmentRefs"?: {
                CaseDefinitionCaseFragment_RequestTenancy_Fragment: CaseDefinitionCaseFragment_RequestTenancy_Fragment;
              };
            })
          | ({ __typename?: "UtilityAdministration" } & {
              " $fragmentRefs"?: {
                CaseDefinitionCaseFragment_UtilityAdministration_Fragment: CaseDefinitionCaseFragment_UtilityAdministration_Fragment;
              };
            })
        >;
      };
    } & {
      " $fragmentRefs"?: {
        CaseDefinitionInfoFragmentFragment: CaseDefinitionInfoFragmentFragment;
      };
    }
  >;
  messages: Array<
    {
      __typename?: "CaseDefinition";
      cases: {
        __typename?: "CaseList";
        count: number;
        records: Array<
          | ({ __typename?: "CleaningService" } & {
              " $fragmentRefs"?: {
                CaseDefinitionCaseFragment_CleaningService_Fragment: CaseDefinitionCaseFragment_CleaningService_Fragment;
              };
            })
          | ({ __typename?: "CreateTenancy" } & {
              " $fragmentRefs"?: {
                CaseDefinitionCaseFragment_CreateTenancy_Fragment: CaseDefinitionCaseFragment_CreateTenancy_Fragment;
              };
            })
          | ({ __typename?: "EndTenancy" } & {
              " $fragmentRefs"?: {
                CaseDefinitionCaseFragment_EndTenancy_Fragment: CaseDefinitionCaseFragment_EndTenancy_Fragment;
              };
            })
          | ({ __typename?: "FindTenancyAdministration" } & {
              " $fragmentRefs"?: {
                CaseDefinitionCaseFragment_FindTenancyAdministration_Fragment: CaseDefinitionCaseFragment_FindTenancyAdministration_Fragment;
              };
            })
          | ({ __typename?: "MiscAdministration" } & {
              " $fragmentRefs"?: {
                CaseDefinitionCaseFragment_MiscAdministration_Fragment: CaseDefinitionCaseFragment_MiscAdministration_Fragment;
              };
            })
          | ({ __typename?: "MiscService" } & {
              " $fragmentRefs"?: {
                CaseDefinitionCaseFragment_MiscService_Fragment: CaseDefinitionCaseFragment_MiscService_Fragment;
              };
            })
          | ({ __typename?: "MovingInService" } & {
              " $fragmentRefs"?: {
                CaseDefinitionCaseFragment_MovingInService_Fragment: CaseDefinitionCaseFragment_MovingInService_Fragment;
              };
            })
          | ({ __typename?: "MovingInTenancy" } & {
              " $fragmentRefs"?: {
                CaseDefinitionCaseFragment_MovingInTenancy_Fragment: CaseDefinitionCaseFragment_MovingInTenancy_Fragment;
              };
            })
          | ({ __typename?: "MovingOutService" } & {
              " $fragmentRefs"?: {
                CaseDefinitionCaseFragment_MovingOutService_Fragment: CaseDefinitionCaseFragment_MovingOutService_Fragment;
              };
            })
          | ({ __typename?: "MovingOutTenancy" } & {
              " $fragmentRefs"?: {
                CaseDefinitionCaseFragment_MovingOutTenancy_Fragment: CaseDefinitionCaseFragment_MovingOutTenancy_Fragment;
              };
            })
          | ({ __typename?: "MovingSettlementAdministration" } & {
              " $fragmentRefs"?: {
                CaseDefinitionCaseFragment_MovingSettlementAdministration_Fragment: CaseDefinitionCaseFragment_MovingSettlementAdministration_Fragment;
              };
            })
          | ({ __typename?: "PreparationService" } & {
              " $fragmentRefs"?: {
                CaseDefinitionCaseFragment_PreparationService_Fragment: CaseDefinitionCaseFragment_PreparationService_Fragment;
              };
            })
          | ({ __typename?: "RequestTenancy" } & {
              " $fragmentRefs"?: {
                CaseDefinitionCaseFragment_RequestTenancy_Fragment: CaseDefinitionCaseFragment_RequestTenancy_Fragment;
              };
            })
          | ({ __typename?: "UtilityAdministration" } & {
              " $fragmentRefs"?: {
                CaseDefinitionCaseFragment_UtilityAdministration_Fragment: CaseDefinitionCaseFragment_UtilityAdministration_Fragment;
              };
            })
        >;
      };
    } & {
      " $fragmentRefs"?: {
        CaseDefinitionInfoFragmentFragment: CaseDefinitionInfoFragmentFragment;
      };
    }
  >;
};

export type GlobalSearchQueryQueryVariables = Exact<{
  searchValue: Scalars["String"]["input"];
}>;

export type GlobalSearchQueryQuery = {
  __typename?: "Query";
  tenancies: {
    __typename: "TenancyList";
    records: Array<{
      __typename: "Tenancy";
      id: string;
      user: { __typename: "User"; id: string; name: string };
      apartment: { __typename: "Apartment"; id: string; address: string };
    }>;
  };
  cases: {
    __typename: "CaseList";
    records: Array<
      | {
          __typename: "CleaningService";
          id: string;
          name: string;
          shortName: string;
          stateText: string;
          apartment?: {
            __typename: "Apartment";
            id: string;
            address: string;
          } | null;
        }
      | {
          __typename: "CreateTenancy";
          id: string;
          name: string;
          shortName: string;
          stateText: string;
          apartment?: {
            __typename: "Apartment";
            id: string;
            address: string;
          } | null;
        }
      | {
          __typename: "EndTenancy";
          id: string;
          name: string;
          shortName: string;
          stateText: string;
          apartment?: {
            __typename: "Apartment";
            id: string;
            address: string;
          } | null;
        }
      | {
          __typename: "FindTenancyAdministration";
          id: string;
          name: string;
          shortName: string;
          stateText: string;
          apartment?: {
            __typename: "Apartment";
            id: string;
            address: string;
          } | null;
        }
      | {
          __typename: "MiscAdministration";
          id: string;
          name: string;
          shortName: string;
          stateText: string;
          apartment?: {
            __typename: "Apartment";
            id: string;
            address: string;
          } | null;
        }
      | {
          __typename: "MiscService";
          id: string;
          name: string;
          shortName: string;
          stateText: string;
          apartment?: {
            __typename: "Apartment";
            id: string;
            address: string;
          } | null;
        }
      | {
          __typename: "MovingInService";
          id: string;
          name: string;
          shortName: string;
          stateText: string;
          apartment?: {
            __typename: "Apartment";
            id: string;
            address: string;
          } | null;
        }
      | {
          __typename: "MovingInTenancy";
          id: string;
          name: string;
          shortName: string;
          stateText: string;
          apartment?: {
            __typename: "Apartment";
            id: string;
            address: string;
          } | null;
        }
      | {
          __typename: "MovingOutService";
          id: string;
          name: string;
          shortName: string;
          stateText: string;
          apartment?: {
            __typename: "Apartment";
            id: string;
            address: string;
          } | null;
        }
      | {
          __typename: "MovingOutTenancy";
          id: string;
          name: string;
          shortName: string;
          stateText: string;
          apartment?: {
            __typename: "Apartment";
            id: string;
            address: string;
          } | null;
        }
      | {
          __typename: "MovingSettlementAdministration";
          id: string;
          name: string;
          shortName: string;
          stateText: string;
          apartment?: {
            __typename: "Apartment";
            id: string;
            address: string;
          } | null;
        }
      | {
          __typename: "PreparationService";
          id: string;
          name: string;
          shortName: string;
          stateText: string;
          apartment?: {
            __typename: "Apartment";
            id: string;
            address: string;
          } | null;
        }
      | {
          __typename: "RequestTenancy";
          id: string;
          name: string;
          shortName: string;
          stateText: string;
          apartment?: {
            __typename: "Apartment";
            id: string;
            address: string;
          } | null;
        }
      | {
          __typename: "UtilityAdministration";
          id: string;
          name: string;
          shortName: string;
          stateText: string;
          apartment?: {
            __typename: "Apartment";
            id: string;
            address: string;
          } | null;
        }
    >;
  };
};

export type ShortcutControlQueryVariables = Exact<{
  shortcutId: Scalars["ID"]["input"];
}>;

export type ShortcutControlQuery = {
  __typename?: "Query";
  currentUser?: {
    __typename?: "User";
    shortcut?: {
      __typename?: "Shortcut";
      id: string;
      type: string;
      name: string;
    } | null;
  } | null;
};

export type ShortcutUpdateMutationVariables = Exact<{
  shortcutId: Scalars["ID"]["input"];
  attributes: ShortcutAttributesInput;
}>;

export type ShortcutUpdateMutation = {
  __typename?: "Mutation";
  shortcutUpdate?: {
    __typename?: "ShortcutUpdatePayload";
    errors?: Array<string> | null;
  } | null;
};

export type ShortcutCreateMutationMutationVariables = Exact<{
  attributes: ShortcutAttributesInput;
}>;

export type ShortcutCreateMutationMutation = {
  __typename?: "Mutation";
  shortcutCreate?: {
    __typename?: "ShortcutCreateMutationPayload";
    errors?: Array<string> | null;
    shortcut?: { __typename?: "Shortcut"; id: string } | null;
  } | null;
};

export type ShortcutRemoveMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type ShortcutRemoveMutation = {
  __typename?: "Mutation";
  shortcutDelete?: {
    __typename?: "ShortcutDeleteMutationPayload";
    shortcutId?: string | null;
    errors?: Array<string> | null;
  } | null;
};

export type ShortcutsListShortcutFragment = {
  __typename?: "Shortcut";
  id: string;
  name: string;
  type: string;
} & { " $fragmentName"?: "ShortcutsListShortcutFragment" };

export type ShortcutsListQueryVariables = Exact<{
  where?: InputMaybe<ShortcutWhereInput>;
}>;

export type ShortcutsListQuery = {
  __typename?: "Query";
  currentUser?: {
    __typename?: "User";
    shortcuts: {
      __typename?: "ShortcutConnection";
      nodes: Array<
        { __typename?: "Shortcut" } & {
          " $fragmentRefs"?: {
            ShortcutsListShortcutFragment: ShortcutsListShortcutFragment;
          };
        }
      >;
    };
    shortcutsTotal: {
      __typename?: "ShortcutConnection";
      totalCount?: number | null;
    };
  } | null;
};

export type AvailableApartmentsQueryVariables = Exact<{
  properties: Array<Scalars["ID"]["input"]> | Scalars["ID"]["input"];
  filter?: InputMaybe<AvailableWithinInput>;
  search: AvailableWithinInput;
  view: AvailableWithinInput;
}>;

export type AvailableApartmentsQuery = {
  __typename?: "Query";
  apartments: {
    __typename?: "ApartmentList";
    qualifying: Array<{
      __typename?: "Availability";
      apartmentId: string;
      from?: any | null;
      to?: any | null;
    }>;
    records: Array<{
      __typename?: "Apartment";
      id: string;
      publicId: string;
      address: string;
      inactive?: boolean | null;
      inactiveStartDate?: string | null;
      inactiveEndDate?: string | null;
      inactiveDescription?: string | null;
      occupancy: Array<{
        __typename?: "Tenancy";
        id: string;
        startDate: string;
        endDate?: string | null;
        intervalAmount?: number | null;
        depositAmount?: number | null;
        user: { __typename?: "User"; name: string };
      }>;
    }>;
  };
};

export type ScreenApartment_ApartmentJournalFragment = {
  __typename?: "TenancyNoteList";
  records: Array<{
    __typename: "TenancyNote";
    id: string;
    content: string;
    createdAt: any;
    updatedAt: any;
    user: { __typename?: "User"; id: string; name: string };
    attachments: Array<{
      __typename?: "File";
      id: string;
      fileName: string;
      url: string;
    }>;
  }>;
} & { " $fragmentName"?: "ScreenApartment_ApartmentJournalFragment" };

export type TenancyNoteDeleteMutationVariables = Exact<{
  tenancyId: Scalars["ID"]["input"];
  noteId: Scalars["ID"]["input"];
}>;

export type TenancyNoteDeleteMutation = {
  __typename?: "Mutation";
  tenancyNoteDelete?: {
    __typename?: "TenancyNoteDeleteMutationPayload";
    errors: Array<string>;
  } | null;
};

export type TenancyNoteCreateMutationVariables = Exact<{
  tenancyId: Scalars["ID"]["input"];
  content: Scalars["String"]["input"];
  attachments?: InputMaybe<
    Array<Scalars["String"]["input"]> | Scalars["String"]["input"]
  >;
}>;

export type TenancyNoteCreateMutation = {
  __typename?: "Mutation";
  tenancyNoteCreate?: {
    __typename?: "TenancyNoteCreateMutationPayload";
    errors: Array<string>;
    tenancyNote?: {
      __typename?: "TenancyNote";
      content: string;
      createdAt: any;
      user: { __typename?: "User"; name: string };
      attachments: Array<{
        __typename?: "File";
        fileName: string;
        url: string;
      }>;
    } | null;
  } | null;
};

export type TenancyNoteUpdateMutationVariables = Exact<{
  tenancyId: Scalars["ID"]["input"];
  noteId: Scalars["ID"]["input"];
  content?: InputMaybe<Scalars["String"]["input"]>;
  attachments?: InputMaybe<
    Array<Scalars["String"]["input"]> | Scalars["String"]["input"]
  >;
  attachmentsToRemove?: InputMaybe<
    Array<Scalars["String"]["input"]> | Scalars["String"]["input"]
  >;
}>;

export type TenancyNoteUpdateMutation = {
  __typename?: "Mutation";
  tenancyNoteUpdate?: {
    __typename?: "TenancyNoteUpdateMutationPayload";
    errors: Array<string>;
    tenancyNote?: {
      __typename?: "TenancyNote";
      content: string;
      createdAt: any;
      user: { __typename?: "User"; name: string };
      attachments: Array<{
        __typename?: "File";
        id: string;
        fileName: string;
        url: string;
      }>;
    } | null;
  } | null;
};

export type ScreenApartment_BodyApartmentQueryVariables = Exact<{
  apartmentId: Scalars["ID"]["input"];
  archived: Scalars["Boolean"]["input"];
}>;

export type ScreenApartment_BodyApartmentQuery = {
  __typename?: "Query";
  apartment?: {
    __typename?: "Apartment";
    id: string;
    address: string;
    canUpdate: boolean;
    property: { __typename?: "Property" } & {
      " $fragmentRefs"?: {
        ScreenApartment_LandlordFragment: ScreenApartment_LandlordFragment;
      };
    };
    messages: {
      __typename?: "MessageList";
      records: Array<
        { __typename?: "Message" } & {
          " $fragmentRefs"?: {
            ScreenApartment_MessageFragment: ScreenApartment_MessageFragment;
          };
        }
      >;
    };
    cases: {
      __typename?: "CaseList";
      records: Array<
        | ({ __typename?: "CleaningService" } & {
            " $fragmentRefs"?: {
              ScreenApartment_Case_CleaningService_Fragment: ScreenApartment_Case_CleaningService_Fragment;
            };
          })
        | ({ __typename?: "CreateTenancy" } & {
            " $fragmentRefs"?: {
              ScreenApartment_Case_CreateTenancy_Fragment: ScreenApartment_Case_CreateTenancy_Fragment;
            };
          })
        | ({ __typename?: "EndTenancy" } & {
            " $fragmentRefs"?: {
              ScreenApartment_Case_EndTenancy_Fragment: ScreenApartment_Case_EndTenancy_Fragment;
            };
          })
        | ({ __typename?: "FindTenancyAdministration" } & {
            " $fragmentRefs"?: {
              ScreenApartment_Case_FindTenancyAdministration_Fragment: ScreenApartment_Case_FindTenancyAdministration_Fragment;
            };
          })
        | ({ __typename?: "MiscAdministration" } & {
            " $fragmentRefs"?: {
              ScreenApartment_Case_MiscAdministration_Fragment: ScreenApartment_Case_MiscAdministration_Fragment;
            };
          })
        | ({ __typename?: "MiscService" } & {
            " $fragmentRefs"?: {
              ScreenApartment_Case_MiscService_Fragment: ScreenApartment_Case_MiscService_Fragment;
            };
          })
        | ({ __typename?: "MovingInService" } & {
            " $fragmentRefs"?: {
              ScreenApartment_Case_MovingInService_Fragment: ScreenApartment_Case_MovingInService_Fragment;
            };
          })
        | ({ __typename?: "MovingInTenancy" } & {
            " $fragmentRefs"?: {
              ScreenApartment_Case_MovingInTenancy_Fragment: ScreenApartment_Case_MovingInTenancy_Fragment;
            };
          })
        | ({ __typename?: "MovingOutService" } & {
            " $fragmentRefs"?: {
              ScreenApartment_Case_MovingOutService_Fragment: ScreenApartment_Case_MovingOutService_Fragment;
            };
          })
        | ({ __typename?: "MovingOutTenancy" } & {
            " $fragmentRefs"?: {
              ScreenApartment_Case_MovingOutTenancy_Fragment: ScreenApartment_Case_MovingOutTenancy_Fragment;
            };
          })
        | ({ __typename?: "MovingSettlementAdministration" } & {
            " $fragmentRefs"?: {
              ScreenApartment_Case_MovingSettlementAdministration_Fragment: ScreenApartment_Case_MovingSettlementAdministration_Fragment;
            };
          })
        | ({ __typename?: "PreparationService" } & {
            " $fragmentRefs"?: {
              ScreenApartment_Case_PreparationService_Fragment: ScreenApartment_Case_PreparationService_Fragment;
            };
          })
        | ({ __typename?: "RequestTenancy" } & {
            " $fragmentRefs"?: {
              ScreenApartment_Case_RequestTenancy_Fragment: ScreenApartment_Case_RequestTenancy_Fragment;
            };
          })
        | ({ __typename?: "UtilityAdministration" } & {
            " $fragmentRefs"?: {
              ScreenApartment_Case_UtilityAdministration_Fragment: ScreenApartment_Case_UtilityAdministration_Fragment;
            };
          })
      >;
    };
    documents?: Array<
      { __typename?: "Document" } & {
        " $fragmentRefs"?: {
          ScreenApartment_DocumentFragment: ScreenApartment_DocumentFragment;
        };
      }
    > | null;
    fieldGroups: Array<{
      __typename?: "ApartmentFieldGroup";
      id: string;
      name: string;
      position: number;
      values: Array<
        | {
            __typename?: "FieldValueBoolean";
            booleanValue?: boolean | null;
            field: {
              __typename?: "Field";
              id: string;
              name: string;
              position: number;
              valueType: FieldValueTypeEnum;
              enumOptions: Array<{
                __typename?: "FieldEnumOption";
                id: string;
                value: string;
              }>;
            };
          }
        | {
            __typename?: "FieldValueDatetime";
            datetimeValue?: any | null;
            field: {
              __typename?: "Field";
              id: string;
              name: string;
              position: number;
              valueType: FieldValueTypeEnum;
              enumOptions: Array<{
                __typename?: "FieldEnumOption";
                id: string;
                value: string;
              }>;
            };
          }
        | {
            __typename?: "FieldValueEnum";
            fieldEnumOptionId?: string | null;
            enumValue?: string | null;
            field: {
              __typename?: "Field";
              id: string;
              name: string;
              position: number;
              valueType: FieldValueTypeEnum;
              enumOptions: Array<{
                __typename?: "FieldEnumOption";
                id: string;
                value: string;
              }>;
            };
          }
        | {
            __typename?: "FieldValueNumber";
            numberValue?: number | null;
            field: {
              __typename?: "Field";
              id: string;
              name: string;
              position: number;
              valueType: FieldValueTypeEnum;
              enumOptions: Array<{
                __typename?: "FieldEnumOption";
                id: string;
                value: string;
              }>;
            };
          }
        | {
            __typename?: "FieldValueText";
            textValue?: string | null;
            field: {
              __typename?: "Field";
              id: string;
              name: string;
              position: number;
              valueType: FieldValueTypeEnum;
              enumOptions: Array<{
                __typename?: "FieldEnumOption";
                id: string;
                value: string;
              }>;
            };
          }
      >;
    }>;
  } | null;
};

export type ScreenApartment_BodyTenancyQueryVariables = Exact<{
  apartmentId: Scalars["ID"]["input"];
  tenancyId: Scalars["ID"]["input"];
  archived: Scalars["Boolean"]["input"];
}>;

export type ScreenApartment_BodyTenancyQuery = {
  __typename?: "Query";
  apartment?: {
    __typename?: "Apartment";
    id: string;
    tenancy?:
      | ({
          __typename?: "Tenancy";
          id: string;
          startDate: string;
          endDate?: string | null;
          canUpdate: boolean;
          economic: { __typename?: "TenancyEconomic" } & {
            " $fragmentRefs"?: {
              ScreenApartment_EconomicFragment: ScreenApartment_EconomicFragment;
            };
          };
          roles: Array<{
            __typename?: "TenancyRole";
            id: string;
            user: {
              __typename?: "User";
              id: string;
              name: string;
              isPhoneConfirmed: boolean;
            };
          }>;
          notes: { __typename?: "TenancyNoteList" } & {
            " $fragmentRefs"?: {
              ScreenApartment_ApartmentJournalFragment: ScreenApartment_ApartmentJournalFragment;
            };
          };
          cases: {
            __typename?: "CaseList";
            records: Array<
              | ({ __typename?: "CleaningService" } & {
                  " $fragmentRefs"?: {
                    ScreenApartment_Case_CleaningService_Fragment: ScreenApartment_Case_CleaningService_Fragment;
                  };
                })
              | ({ __typename?: "CreateTenancy" } & {
                  " $fragmentRefs"?: {
                    ScreenApartment_Case_CreateTenancy_Fragment: ScreenApartment_Case_CreateTenancy_Fragment;
                  };
                })
              | ({ __typename?: "EndTenancy" } & {
                  " $fragmentRefs"?: {
                    ScreenApartment_Case_EndTenancy_Fragment: ScreenApartment_Case_EndTenancy_Fragment;
                  };
                })
              | ({ __typename?: "FindTenancyAdministration" } & {
                  " $fragmentRefs"?: {
                    ScreenApartment_Case_FindTenancyAdministration_Fragment: ScreenApartment_Case_FindTenancyAdministration_Fragment;
                  };
                })
              | ({ __typename?: "MiscAdministration" } & {
                  " $fragmentRefs"?: {
                    ScreenApartment_Case_MiscAdministration_Fragment: ScreenApartment_Case_MiscAdministration_Fragment;
                  };
                })
              | ({ __typename?: "MiscService" } & {
                  " $fragmentRefs"?: {
                    ScreenApartment_Case_MiscService_Fragment: ScreenApartment_Case_MiscService_Fragment;
                  };
                })
              | ({ __typename?: "MovingInService" } & {
                  " $fragmentRefs"?: {
                    ScreenApartment_Case_MovingInService_Fragment: ScreenApartment_Case_MovingInService_Fragment;
                  };
                })
              | ({ __typename?: "MovingInTenancy" } & {
                  " $fragmentRefs"?: {
                    ScreenApartment_Case_MovingInTenancy_Fragment: ScreenApartment_Case_MovingInTenancy_Fragment;
                  };
                })
              | ({ __typename?: "MovingOutService" } & {
                  " $fragmentRefs"?: {
                    ScreenApartment_Case_MovingOutService_Fragment: ScreenApartment_Case_MovingOutService_Fragment;
                  };
                })
              | ({ __typename?: "MovingOutTenancy" } & {
                  " $fragmentRefs"?: {
                    ScreenApartment_Case_MovingOutTenancy_Fragment: ScreenApartment_Case_MovingOutTenancy_Fragment;
                  };
                })
              | ({ __typename?: "MovingSettlementAdministration" } & {
                  " $fragmentRefs"?: {
                    ScreenApartment_Case_MovingSettlementAdministration_Fragment: ScreenApartment_Case_MovingSettlementAdministration_Fragment;
                  };
                })
              | ({ __typename?: "PreparationService" } & {
                  " $fragmentRefs"?: {
                    ScreenApartment_Case_PreparationService_Fragment: ScreenApartment_Case_PreparationService_Fragment;
                  };
                })
              | ({ __typename?: "RequestTenancy" } & {
                  " $fragmentRefs"?: {
                    ScreenApartment_Case_RequestTenancy_Fragment: ScreenApartment_Case_RequestTenancy_Fragment;
                  };
                })
              | ({ __typename?: "UtilityAdministration" } & {
                  " $fragmentRefs"?: {
                    ScreenApartment_Case_UtilityAdministration_Fragment: ScreenApartment_Case_UtilityAdministration_Fragment;
                  };
                })
            >;
          };
          documents?: Array<
            { __typename?: "Document" } & {
              " $fragmentRefs"?: {
                ScreenApartment_DocumentFragment: ScreenApartment_DocumentFragment;
              };
            }
          > | null;
          fieldGroups: Array<{
            __typename?: "TenancyFieldGroup";
            id: string;
            name: string;
            position: number;
            values: Array<
              | {
                  __typename?: "FieldValueBoolean";
                  booleanValue?: boolean | null;
                  field: {
                    __typename?: "Field";
                    id: string;
                    name: string;
                    position: number;
                    valueType: FieldValueTypeEnum;
                    enumOptions: Array<{
                      __typename?: "FieldEnumOption";
                      id: string;
                      value: string;
                    }>;
                  };
                }
              | {
                  __typename?: "FieldValueDatetime";
                  datetimeValue?: any | null;
                  field: {
                    __typename?: "Field";
                    id: string;
                    name: string;
                    position: number;
                    valueType: FieldValueTypeEnum;
                    enumOptions: Array<{
                      __typename?: "FieldEnumOption";
                      id: string;
                      value: string;
                    }>;
                  };
                }
              | {
                  __typename?: "FieldValueEnum";
                  fieldEnumOptionId?: string | null;
                  enumValue?: string | null;
                  field: {
                    __typename?: "Field";
                    id: string;
                    name: string;
                    position: number;
                    valueType: FieldValueTypeEnum;
                    enumOptions: Array<{
                      __typename?: "FieldEnumOption";
                      id: string;
                      value: string;
                    }>;
                  };
                }
              | {
                  __typename?: "FieldValueNumber";
                  numberValue?: number | null;
                  field: {
                    __typename?: "Field";
                    id: string;
                    name: string;
                    position: number;
                    valueType: FieldValueTypeEnum;
                    enumOptions: Array<{
                      __typename?: "FieldEnumOption";
                      id: string;
                      value: string;
                    }>;
                  };
                }
              | {
                  __typename?: "FieldValueText";
                  textValue?: string | null;
                  field: {
                    __typename?: "Field";
                    id: string;
                    name: string;
                    position: number;
                    valueType: FieldValueTypeEnum;
                    enumOptions: Array<{
                      __typename?: "FieldEnumOption";
                      id: string;
                      value: string;
                    }>;
                  };
                }
            >;
          }>;
        } & {
          " $fragmentRefs"?: {
            ScreenApartment_ManageTenantsAndResidentsFragment: ScreenApartment_ManageTenantsAndResidentsFragment;
            ScreenApartment_ContractFragment: ScreenApartment_ContractFragment;
          };
        })
      | null;
  } | null;
};

type ScreenApartment_Case_CleaningService_Fragment = {
  __typename: "CleaningService";
  scheduledDate?: string | null;
  unreadCommentsCount: number;
  id: string;
  attention: CaseAttentionEnum;
  awaiting?: string | null;
  body: string;
  completeBefore?: string | null;
  createdAt: any;
  icon: string;
  isArchived: boolean;
  name: string;
  scheduledTime?: string | null;
  state: string;
  stateText: string;
  startAfter?: string | null;
  type: CaseTypeEnum;
  parent?:
    | {
        __typename?: "CleaningService";
        title: string;
        scheduledDate?: string | null;
      }
    | {
        __typename?: "CreateTenancy";
        title: string;
        scheduledDate?: string | null;
      }
    | {
        __typename?: "EndTenancy";
        title: string;
        scheduledDate?: string | null;
      }
    | {
        __typename?: "FindTenancyAdministration";
        title: string;
        scheduledDate?: string | null;
      }
    | {
        __typename?: "MiscAdministration";
        title: string;
        scheduledDate?: string | null;
      }
    | {
        __typename?: "MiscService";
        title: string;
        scheduledDate?: string | null;
      }
    | {
        __typename?: "MovingInService";
        title: string;
        scheduledDate?: string | null;
      }
    | {
        __typename?: "MovingInTenancy";
        title: string;
        scheduledDate?: string | null;
      }
    | {
        __typename?: "MovingOutService";
        title: string;
        scheduledDate?: string | null;
      }
    | {
        __typename?: "MovingOutTenancy";
        title: string;
        scheduledDate?: string | null;
      }
    | {
        __typename?: "MovingSettlementAdministration";
        title: string;
        scheduledDate?: string | null;
      }
    | {
        __typename?: "PreparationService";
        title: string;
        scheduledDate?: string | null;
      }
    | {
        __typename?: "RequestTenancy";
        title: string;
        scheduledDate?: string | null;
      }
    | {
        __typename?: "UtilityAdministration";
        title: string;
        scheduledDate?: string | null;
      }
    | null;
  apartment?: { __typename?: "Apartment"; address: string } | null;
  responsible?: { __typename?: "CaseUser"; name: string } | null;
} & { " $fragmentName"?: "ScreenApartment_Case_CleaningService_Fragment" };

type ScreenApartment_Case_CreateTenancy_Fragment = {
  __typename: "CreateTenancy";
  unreadCommentsCount: number;
  id: string;
  attention: CaseAttentionEnum;
  awaiting?: string | null;
  body: string;
  completeBefore?: string | null;
  createdAt: any;
  icon: string;
  isArchived: boolean;
  name: string;
  scheduledTime?: string | null;
  state: string;
  stateText: string;
  startAfter?: string | null;
  type: CaseTypeEnum;
  apartment?: { __typename?: "Apartment"; address: string } | null;
  responsible?: { __typename?: "CaseUser"; name: string } | null;
} & { " $fragmentName"?: "ScreenApartment_Case_CreateTenancy_Fragment" };

type ScreenApartment_Case_EndTenancy_Fragment = {
  __typename: "EndTenancy";
  awaiting?: string | null;
  id: string;
  attention: CaseAttentionEnum;
  body: string;
  completeBefore?: string | null;
  createdAt: any;
  icon: string;
  isArchived: boolean;
  name: string;
  scheduledTime?: string | null;
  state: string;
  stateText: string;
  startAfter?: string | null;
  type: CaseTypeEnum;
  apartment?: { __typename?: "Apartment"; address: string } | null;
  responsible?: { __typename?: "CaseUser"; name: string } | null;
} & { " $fragmentName"?: "ScreenApartment_Case_EndTenancy_Fragment" };

type ScreenApartment_Case_FindTenancyAdministration_Fragment = {
  __typename: "FindTenancyAdministration";
  id: string;
  attention: CaseAttentionEnum;
  awaiting?: string | null;
  body: string;
  completeBefore?: string | null;
  createdAt: any;
  icon: string;
  isArchived: boolean;
  name: string;
  scheduledTime?: string | null;
  state: string;
  stateText: string;
  startAfter?: string | null;
  type: CaseTypeEnum;
  parent?:
    | {
        __typename?: "CleaningService";
        title: string;
        scheduledDate?: string | null;
      }
    | {
        __typename?: "CreateTenancy";
        title: string;
        scheduledDate?: string | null;
      }
    | {
        __typename?: "EndTenancy";
        title: string;
        scheduledDate?: string | null;
      }
    | {
        __typename?: "FindTenancyAdministration";
        title: string;
        scheduledDate?: string | null;
      }
    | {
        __typename?: "MiscAdministration";
        title: string;
        scheduledDate?: string | null;
      }
    | {
        __typename?: "MiscService";
        title: string;
        scheduledDate?: string | null;
      }
    | {
        __typename?: "MovingInService";
        title: string;
        scheduledDate?: string | null;
      }
    | {
        __typename?: "MovingInTenancy";
        title: string;
        scheduledDate?: string | null;
      }
    | {
        __typename?: "MovingOutService";
        title: string;
        scheduledDate?: string | null;
      }
    | {
        __typename?: "MovingOutTenancy";
        title: string;
        scheduledDate?: string | null;
      }
    | {
        __typename?: "MovingSettlementAdministration";
        title: string;
        scheduledDate?: string | null;
      }
    | {
        __typename?: "PreparationService";
        title: string;
        scheduledDate?: string | null;
      }
    | {
        __typename?: "RequestTenancy";
        title: string;
        scheduledDate?: string | null;
      }
    | {
        __typename?: "UtilityAdministration";
        title: string;
        scheduledDate?: string | null;
      }
    | null;
  apartment?: { __typename?: "Apartment"; address: string } | null;
  responsible?: { __typename?: "CaseUser"; name: string } | null;
} & {
  " $fragmentName"?: "ScreenApartment_Case_FindTenancyAdministration_Fragment";
};

type ScreenApartment_Case_MiscAdministration_Fragment = {
  __typename: "MiscAdministration";
  scheduledDate?: string | null;
  unreadCommentsCount: number;
  id: string;
  attention: CaseAttentionEnum;
  awaiting?: string | null;
  body: string;
  completeBefore?: string | null;
  createdAt: any;
  icon: string;
  isArchived: boolean;
  name: string;
  scheduledTime?: string | null;
  state: string;
  stateText: string;
  startAfter?: string | null;
  type: CaseTypeEnum;
  parent?:
    | {
        __typename?: "CleaningService";
        scheduledDate?: string | null;
        title: string;
        apartment?: { __typename?: "Apartment"; address: string } | null;
      }
    | {
        __typename?: "CreateTenancy";
        scheduledDate?: string | null;
        title: string;
        apartment?: { __typename?: "Apartment"; address: string } | null;
      }
    | {
        __typename?: "EndTenancy";
        scheduledDate?: string | null;
        title: string;
        apartment?: { __typename?: "Apartment"; address: string } | null;
      }
    | {
        __typename?: "FindTenancyAdministration";
        scheduledDate?: string | null;
        title: string;
        apartment?: { __typename?: "Apartment"; address: string } | null;
      }
    | {
        __typename?: "MiscAdministration";
        scheduledDate?: string | null;
        title: string;
        apartment?: { __typename?: "Apartment"; address: string } | null;
      }
    | {
        __typename?: "MiscService";
        scheduledDate?: string | null;
        title: string;
        apartment?: { __typename?: "Apartment"; address: string } | null;
      }
    | {
        __typename?: "MovingInService";
        scheduledDate?: string | null;
        title: string;
        apartment?: { __typename?: "Apartment"; address: string } | null;
      }
    | {
        __typename?: "MovingInTenancy";
        scheduledDate?: string | null;
        title: string;
        apartment?: { __typename?: "Apartment"; address: string } | null;
      }
    | {
        __typename?: "MovingOutService";
        scheduledDate?: string | null;
        title: string;
        apartment?: { __typename?: "Apartment"; address: string } | null;
      }
    | {
        __typename?: "MovingOutTenancy";
        scheduledDate?: string | null;
        title: string;
        apartment?: { __typename?: "Apartment"; address: string } | null;
      }
    | {
        __typename?: "MovingSettlementAdministration";
        scheduledDate?: string | null;
        title: string;
        apartment?: { __typename?: "Apartment"; address: string } | null;
      }
    | {
        __typename?: "PreparationService";
        scheduledDate?: string | null;
        title: string;
        apartment?: { __typename?: "Apartment"; address: string } | null;
      }
    | {
        __typename?: "RequestTenancy";
        scheduledDate?: string | null;
        title: string;
        apartment?: { __typename?: "Apartment"; address: string } | null;
      }
    | {
        __typename?: "UtilityAdministration";
        scheduledDate?: string | null;
        title: string;
        apartment?: { __typename?: "Apartment"; address: string } | null;
      }
    | null;
  apartment?: { __typename?: "Apartment"; address: string } | null;
  responsible?: { __typename?: "CaseUser"; name: string } | null;
} & { " $fragmentName"?: "ScreenApartment_Case_MiscAdministration_Fragment" };

type ScreenApartment_Case_MiscService_Fragment = {
  __typename: "MiscService";
  scheduledDate?: string | null;
  unreadCommentsCount: number;
  id: string;
  attention: CaseAttentionEnum;
  awaiting?: string | null;
  body: string;
  completeBefore?: string | null;
  createdAt: any;
  icon: string;
  isArchived: boolean;
  name: string;
  scheduledTime?: string | null;
  state: string;
  stateText: string;
  startAfter?: string | null;
  type: CaseTypeEnum;
  parent?:
    | {
        __typename?: "CleaningService";
        scheduledDate?: string | null;
        title: string;
        apartment?: { __typename?: "Apartment"; address: string } | null;
      }
    | {
        __typename?: "CreateTenancy";
        scheduledDate?: string | null;
        title: string;
        apartment?: { __typename?: "Apartment"; address: string } | null;
      }
    | {
        __typename?: "EndTenancy";
        scheduledDate?: string | null;
        title: string;
        apartment?: { __typename?: "Apartment"; address: string } | null;
      }
    | {
        __typename?: "FindTenancyAdministration";
        scheduledDate?: string | null;
        title: string;
        apartment?: { __typename?: "Apartment"; address: string } | null;
      }
    | {
        __typename?: "MiscAdministration";
        scheduledDate?: string | null;
        title: string;
        apartment?: { __typename?: "Apartment"; address: string } | null;
      }
    | {
        __typename?: "MiscService";
        scheduledDate?: string | null;
        title: string;
        apartment?: { __typename?: "Apartment"; address: string } | null;
      }
    | {
        __typename?: "MovingInService";
        scheduledDate?: string | null;
        title: string;
        apartment?: { __typename?: "Apartment"; address: string } | null;
      }
    | {
        __typename?: "MovingInTenancy";
        scheduledDate?: string | null;
        title: string;
        apartment?: { __typename?: "Apartment"; address: string } | null;
      }
    | {
        __typename?: "MovingOutService";
        scheduledDate?: string | null;
        title: string;
        apartment?: { __typename?: "Apartment"; address: string } | null;
      }
    | {
        __typename?: "MovingOutTenancy";
        scheduledDate?: string | null;
        title: string;
        apartment?: { __typename?: "Apartment"; address: string } | null;
      }
    | {
        __typename?: "MovingSettlementAdministration";
        scheduledDate?: string | null;
        title: string;
        apartment?: { __typename?: "Apartment"; address: string } | null;
      }
    | {
        __typename?: "PreparationService";
        scheduledDate?: string | null;
        title: string;
        apartment?: { __typename?: "Apartment"; address: string } | null;
      }
    | {
        __typename?: "RequestTenancy";
        scheduledDate?: string | null;
        title: string;
        apartment?: { __typename?: "Apartment"; address: string } | null;
      }
    | {
        __typename?: "UtilityAdministration";
        scheduledDate?: string | null;
        title: string;
        apartment?: { __typename?: "Apartment"; address: string } | null;
      }
    | null;
  apartment?: { __typename?: "Apartment"; address: string } | null;
  responsible?: { __typename?: "CaseUser"; name: string } | null;
} & { " $fragmentName"?: "ScreenApartment_Case_MiscService_Fragment" };

type ScreenApartment_Case_MovingInService_Fragment = {
  __typename: "MovingInService";
  isAttending?: boolean | null;
  unreadCommentsCount: number;
  id: string;
  attention: CaseAttentionEnum;
  awaiting?: string | null;
  body: string;
  completeBefore?: string | null;
  createdAt: any;
  icon: string;
  isArchived: boolean;
  name: string;
  scheduledTime?: string | null;
  state: string;
  stateText: string;
  startAfter?: string | null;
  type: CaseTypeEnum;
  parent?:
    | {
        __typename?: "CleaningService";
        scheduledDate?: string | null;
        title: string;
        apartment?: { __typename?: "Apartment"; address: string } | null;
      }
    | {
        __typename?: "CreateTenancy";
        scheduledDate?: string | null;
        title: string;
        apartment?: { __typename?: "Apartment"; address: string } | null;
      }
    | {
        __typename?: "EndTenancy";
        scheduledDate?: string | null;
        title: string;
        apartment?: { __typename?: "Apartment"; address: string } | null;
      }
    | {
        __typename?: "FindTenancyAdministration";
        scheduledDate?: string | null;
        title: string;
        apartment?: { __typename?: "Apartment"; address: string } | null;
      }
    | {
        __typename?: "MiscAdministration";
        scheduledDate?: string | null;
        title: string;
        apartment?: { __typename?: "Apartment"; address: string } | null;
      }
    | {
        __typename?: "MiscService";
        scheduledDate?: string | null;
        title: string;
        apartment?: { __typename?: "Apartment"; address: string } | null;
      }
    | {
        __typename?: "MovingInService";
        scheduledDate?: string | null;
        title: string;
        apartment?: { __typename?: "Apartment"; address: string } | null;
      }
    | {
        __typename?: "MovingInTenancy";
        scheduledDate?: string | null;
        title: string;
        apartment?: { __typename?: "Apartment"; address: string } | null;
      }
    | {
        __typename?: "MovingOutService";
        scheduledDate?: string | null;
        title: string;
        apartment?: { __typename?: "Apartment"; address: string } | null;
      }
    | {
        __typename?: "MovingOutTenancy";
        scheduledDate?: string | null;
        title: string;
        apartment?: { __typename?: "Apartment"; address: string } | null;
      }
    | {
        __typename?: "MovingSettlementAdministration";
        scheduledDate?: string | null;
        title: string;
        apartment?: { __typename?: "Apartment"; address: string } | null;
      }
    | {
        __typename?: "PreparationService";
        scheduledDate?: string | null;
        title: string;
        apartment?: { __typename?: "Apartment"; address: string } | null;
      }
    | {
        __typename?: "RequestTenancy";
        scheduledDate?: string | null;
        title: string;
        apartment?: { __typename?: "Apartment"; address: string } | null;
      }
    | {
        __typename?: "UtilityAdministration";
        scheduledDate?: string | null;
        title: string;
        apartment?: { __typename?: "Apartment"; address: string } | null;
      }
    | null;
  apartment?: { __typename?: "Apartment"; address: string } | null;
  responsible?: { __typename?: "CaseUser"; name: string } | null;
} & { " $fragmentName"?: "ScreenApartment_Case_MovingInService_Fragment" };

type ScreenApartment_Case_MovingInTenancy_Fragment = {
  __typename: "MovingInTenancy";
  unreadCommentsCount: number;
  scheduledDate?: string | null;
  id: string;
  attention: CaseAttentionEnum;
  awaiting?: string | null;
  body: string;
  completeBefore?: string | null;
  createdAt: any;
  icon: string;
  isArchived: boolean;
  name: string;
  scheduledTime?: string | null;
  state: string;
  stateText: string;
  startAfter?: string | null;
  type: CaseTypeEnum;
  parent?:
    | {
        __typename?: "CleaningService";
        scheduledDate?: string | null;
        title: string;
      }
    | {
        __typename?: "CreateTenancy";
        scheduledDate?: string | null;
        title: string;
      }
    | {
        __typename?: "EndTenancy";
        scheduledDate?: string | null;
        title: string;
      }
    | {
        __typename?: "FindTenancyAdministration";
        scheduledDate?: string | null;
        title: string;
      }
    | {
        __typename?: "MiscAdministration";
        scheduledDate?: string | null;
        title: string;
      }
    | {
        __typename?: "MiscService";
        scheduledDate?: string | null;
        title: string;
      }
    | {
        __typename?: "MovingInService";
        scheduledDate?: string | null;
        title: string;
      }
    | {
        __typename?: "MovingInTenancy";
        scheduledDate?: string | null;
        title: string;
      }
    | {
        __typename?: "MovingOutService";
        scheduledDate?: string | null;
        title: string;
      }
    | {
        __typename?: "MovingOutTenancy";
        scheduledDate?: string | null;
        title: string;
      }
    | {
        __typename?: "MovingSettlementAdministration";
        scheduledDate?: string | null;
        title: string;
      }
    | {
        __typename?: "PreparationService";
        scheduledDate?: string | null;
        title: string;
      }
    | {
        __typename?: "RequestTenancy";
        scheduledDate?: string | null;
        title: string;
      }
    | {
        __typename?: "UtilityAdministration";
        scheduledDate?: string | null;
        title: string;
      }
    | null;
  apartment?: { __typename?: "Apartment"; address: string } | null;
  responsible?: { __typename?: "CaseUser"; name: string } | null;
} & { " $fragmentName"?: "ScreenApartment_Case_MovingInTenancy_Fragment" };

type ScreenApartment_Case_MovingOutService_Fragment = {
  __typename: "MovingOutService";
  scheduledDate?: string | null;
  unreadCommentsCount: number;
  id: string;
  attention: CaseAttentionEnum;
  awaiting?: string | null;
  body: string;
  completeBefore?: string | null;
  createdAt: any;
  icon: string;
  isArchived: boolean;
  name: string;
  scheduledTime?: string | null;
  state: string;
  stateText: string;
  startAfter?: string | null;
  type: CaseTypeEnum;
  parent?:
    | {
        __typename?: "CleaningService";
        scheduledDate?: string | null;
        title: string;
      }
    | {
        __typename?: "CreateTenancy";
        scheduledDate?: string | null;
        title: string;
      }
    | {
        __typename?: "EndTenancy";
        scheduledDate?: string | null;
        title: string;
      }
    | {
        __typename?: "FindTenancyAdministration";
        scheduledDate?: string | null;
        title: string;
      }
    | {
        __typename?: "MiscAdministration";
        scheduledDate?: string | null;
        title: string;
      }
    | {
        __typename?: "MiscService";
        scheduledDate?: string | null;
        title: string;
      }
    | {
        __typename?: "MovingInService";
        scheduledDate?: string | null;
        title: string;
      }
    | {
        __typename?: "MovingInTenancy";
        scheduledDate?: string | null;
        title: string;
      }
    | {
        __typename?: "MovingOutService";
        scheduledDate?: string | null;
        title: string;
      }
    | {
        __typename?: "MovingOutTenancy";
        scheduledDate?: string | null;
        title: string;
      }
    | {
        __typename?: "MovingSettlementAdministration";
        scheduledDate?: string | null;
        title: string;
      }
    | {
        __typename?: "PreparationService";
        scheduledDate?: string | null;
        title: string;
      }
    | {
        __typename?: "RequestTenancy";
        scheduledDate?: string | null;
        title: string;
      }
    | {
        __typename?: "UtilityAdministration";
        scheduledDate?: string | null;
        title: string;
      }
    | null;
  apartment?: { __typename?: "Apartment"; address: string } | null;
  responsible?: { __typename?: "CaseUser"; name: string } | null;
} & { " $fragmentName"?: "ScreenApartment_Case_MovingOutService_Fragment" };

type ScreenApartment_Case_MovingOutTenancy_Fragment = {
  __typename: "MovingOutTenancy";
  unreadCommentsCount: number;
  id: string;
  attention: CaseAttentionEnum;
  awaiting?: string | null;
  body: string;
  completeBefore?: string | null;
  createdAt: any;
  icon: string;
  isArchived: boolean;
  name: string;
  scheduledTime?: string | null;
  state: string;
  stateText: string;
  startAfter?: string | null;
  type: CaseTypeEnum;
  apartment?: { __typename?: "Apartment"; address: string } | null;
  responsible?: { __typename?: "CaseUser"; name: string } | null;
} & { " $fragmentName"?: "ScreenApartment_Case_MovingOutTenancy_Fragment" };

type ScreenApartment_Case_MovingSettlementAdministration_Fragment = {
  __typename: "MovingSettlementAdministration";
  scheduledDate?: string | null;
  unreadCommentsCount: number;
  id: string;
  attention: CaseAttentionEnum;
  awaiting?: string | null;
  body: string;
  completeBefore?: string | null;
  createdAt: any;
  icon: string;
  isArchived: boolean;
  name: string;
  scheduledTime?: string | null;
  state: string;
  stateText: string;
  startAfter?: string | null;
  type: CaseTypeEnum;
  apartment?: { __typename?: "Apartment"; address: string } | null;
  parent?:
    | {
        __typename?: "CleaningService";
        scheduledDate?: string | null;
        title: string;
      }
    | {
        __typename?: "CreateTenancy";
        scheduledDate?: string | null;
        title: string;
      }
    | {
        __typename?: "EndTenancy";
        scheduledDate?: string | null;
        title: string;
      }
    | {
        __typename?: "FindTenancyAdministration";
        scheduledDate?: string | null;
        title: string;
      }
    | {
        __typename?: "MiscAdministration";
        scheduledDate?: string | null;
        title: string;
      }
    | {
        __typename?: "MiscService";
        scheduledDate?: string | null;
        title: string;
      }
    | {
        __typename?: "MovingInService";
        scheduledDate?: string | null;
        title: string;
      }
    | {
        __typename?: "MovingInTenancy";
        scheduledDate?: string | null;
        title: string;
      }
    | {
        __typename?: "MovingOutService";
        scheduledDate?: string | null;
        title: string;
      }
    | {
        __typename?: "MovingOutTenancy";
        scheduledDate?: string | null;
        title: string;
      }
    | {
        __typename?: "MovingSettlementAdministration";
        scheduledDate?: string | null;
        title: string;
      }
    | {
        __typename?: "PreparationService";
        scheduledDate?: string | null;
        title: string;
      }
    | {
        __typename?: "RequestTenancy";
        scheduledDate?: string | null;
        title: string;
      }
    | {
        __typename?: "UtilityAdministration";
        scheduledDate?: string | null;
        title: string;
      }
    | null;
  responsible?: { __typename?: "CaseUser"; name: string } | null;
} & {
  " $fragmentName"?: "ScreenApartment_Case_MovingSettlementAdministration_Fragment";
};

type ScreenApartment_Case_PreparationService_Fragment = {
  __typename: "PreparationService";
  scheduledDate?: string | null;
  unreadCommentsCount: number;
  id: string;
  attention: CaseAttentionEnum;
  awaiting?: string | null;
  body: string;
  completeBefore?: string | null;
  createdAt: any;
  icon: string;
  isArchived: boolean;
  name: string;
  scheduledTime?: string | null;
  state: string;
  stateText: string;
  startAfter?: string | null;
  type: CaseTypeEnum;
  apartment?: { __typename?: "Apartment"; address: string } | null;
  parent?:
    | {
        __typename?: "CleaningService";
        scheduledDate?: string | null;
        title: string;
      }
    | {
        __typename?: "CreateTenancy";
        scheduledDate?: string | null;
        title: string;
      }
    | {
        __typename?: "EndTenancy";
        scheduledDate?: string | null;
        title: string;
      }
    | {
        __typename?: "FindTenancyAdministration";
        scheduledDate?: string | null;
        title: string;
      }
    | {
        __typename?: "MiscAdministration";
        scheduledDate?: string | null;
        title: string;
      }
    | {
        __typename?: "MiscService";
        scheduledDate?: string | null;
        title: string;
      }
    | {
        __typename?: "MovingInService";
        scheduledDate?: string | null;
        title: string;
      }
    | {
        __typename?: "MovingInTenancy";
        scheduledDate?: string | null;
        title: string;
      }
    | {
        __typename?: "MovingOutService";
        scheduledDate?: string | null;
        title: string;
      }
    | {
        __typename?: "MovingOutTenancy";
        scheduledDate?: string | null;
        title: string;
      }
    | {
        __typename?: "MovingSettlementAdministration";
        scheduledDate?: string | null;
        title: string;
      }
    | {
        __typename?: "PreparationService";
        scheduledDate?: string | null;
        title: string;
      }
    | {
        __typename?: "RequestTenancy";
        scheduledDate?: string | null;
        title: string;
      }
    | {
        __typename?: "UtilityAdministration";
        scheduledDate?: string | null;
        title: string;
      }
    | null;
  responsible?: { __typename?: "CaseUser"; name: string } | null;
} & { " $fragmentName"?: "ScreenApartment_Case_PreparationService_Fragment" };

type ScreenApartment_Case_RequestTenancy_Fragment = {
  __typename: "RequestTenancy";
  unreadCommentsCount: number;
  id: string;
  attention: CaseAttentionEnum;
  awaiting?: string | null;
  body: string;
  completeBefore?: string | null;
  createdAt: any;
  icon: string;
  isArchived: boolean;
  name: string;
  scheduledTime?: string | null;
  state: string;
  stateText: string;
  startAfter?: string | null;
  type: CaseTypeEnum;
  apartment?: { __typename?: "Apartment"; address: string } | null;
  responsible?: { __typename?: "CaseUser"; name: string } | null;
} & { " $fragmentName"?: "ScreenApartment_Case_RequestTenancy_Fragment" };

type ScreenApartment_Case_UtilityAdministration_Fragment = {
  __typename: "UtilityAdministration";
  unreadCommentsCount: number;
  id: string;
  attention: CaseAttentionEnum;
  awaiting?: string | null;
  body: string;
  completeBefore?: string | null;
  createdAt: any;
  icon: string;
  isArchived: boolean;
  name: string;
  scheduledTime?: string | null;
  state: string;
  stateText: string;
  startAfter?: string | null;
  type: CaseTypeEnum;
  parent?:
    | {
        __typename?: "CleaningService";
        scheduledDate?: string | null;
        title: string;
      }
    | {
        __typename?: "CreateTenancy";
        scheduledDate?: string | null;
        title: string;
      }
    | {
        __typename?: "EndTenancy";
        scheduledDate?: string | null;
        title: string;
      }
    | {
        __typename?: "FindTenancyAdministration";
        scheduledDate?: string | null;
        title: string;
      }
    | {
        __typename?: "MiscAdministration";
        scheduledDate?: string | null;
        title: string;
      }
    | {
        __typename?: "MiscService";
        scheduledDate?: string | null;
        title: string;
      }
    | {
        __typename?: "MovingInService";
        scheduledDate?: string | null;
        title: string;
      }
    | {
        __typename?: "MovingInTenancy";
        scheduledDate?: string | null;
        title: string;
      }
    | {
        __typename?: "MovingOutService";
        scheduledDate?: string | null;
        title: string;
      }
    | {
        __typename?: "MovingOutTenancy";
        scheduledDate?: string | null;
        title: string;
      }
    | {
        __typename?: "MovingSettlementAdministration";
        scheduledDate?: string | null;
        title: string;
      }
    | {
        __typename?: "PreparationService";
        scheduledDate?: string | null;
        title: string;
      }
    | {
        __typename?: "RequestTenancy";
        scheduledDate?: string | null;
        title: string;
      }
    | {
        __typename?: "UtilityAdministration";
        scheduledDate?: string | null;
        title: string;
      }
    | null;
  apartment?: { __typename?: "Apartment"; address: string } | null;
  responsible?: { __typename?: "CaseUser"; name: string } | null;
} & {
  " $fragmentName"?: "ScreenApartment_Case_UtilityAdministration_Fragment";
};

export type ScreenApartment_CaseFragment =
  | ScreenApartment_Case_CleaningService_Fragment
  | ScreenApartment_Case_CreateTenancy_Fragment
  | ScreenApartment_Case_EndTenancy_Fragment
  | ScreenApartment_Case_FindTenancyAdministration_Fragment
  | ScreenApartment_Case_MiscAdministration_Fragment
  | ScreenApartment_Case_MiscService_Fragment
  | ScreenApartment_Case_MovingInService_Fragment
  | ScreenApartment_Case_MovingInTenancy_Fragment
  | ScreenApartment_Case_MovingOutService_Fragment
  | ScreenApartment_Case_MovingOutTenancy_Fragment
  | ScreenApartment_Case_MovingSettlementAdministration_Fragment
  | ScreenApartment_Case_PreparationService_Fragment
  | ScreenApartment_Case_RequestTenancy_Fragment
  | ScreenApartment_Case_UtilityAdministration_Fragment;

export type CasesByParentQueryVariables = Exact<{
  ids?: InputMaybe<Array<Scalars["ID"]["input"]> | Scalars["ID"]["input"]>;
}>;

export type CasesByParentQuery = {
  __typename?: "Query";
  cases: {
    __typename?: "CaseList";
    records: Array<
      | {
          __typename?: "CleaningService";
          id: string;
          icon: string;
          attention: CaseAttentionEnum;
          awaiting?: string | null;
          stateText: string;
          state: string;
          title: string;
          type: CaseTypeEnum;
        }
      | {
          __typename?: "CreateTenancy";
          id: string;
          icon: string;
          attention: CaseAttentionEnum;
          awaiting?: string | null;
          stateText: string;
          state: string;
          title: string;
          type: CaseTypeEnum;
        }
      | {
          __typename?: "EndTenancy";
          id: string;
          icon: string;
          attention: CaseAttentionEnum;
          awaiting?: string | null;
          stateText: string;
          state: string;
          title: string;
          type: CaseTypeEnum;
        }
      | {
          __typename?: "FindTenancyAdministration";
          id: string;
          icon: string;
          attention: CaseAttentionEnum;
          awaiting?: string | null;
          stateText: string;
          state: string;
          title: string;
          type: CaseTypeEnum;
        }
      | {
          __typename?: "MiscAdministration";
          id: string;
          icon: string;
          attention: CaseAttentionEnum;
          awaiting?: string | null;
          stateText: string;
          state: string;
          title: string;
          type: CaseTypeEnum;
        }
      | {
          __typename?: "MiscService";
          id: string;
          icon: string;
          attention: CaseAttentionEnum;
          awaiting?: string | null;
          stateText: string;
          state: string;
          title: string;
          type: CaseTypeEnum;
        }
      | {
          __typename?: "MovingInService";
          id: string;
          icon: string;
          attention: CaseAttentionEnum;
          awaiting?: string | null;
          stateText: string;
          state: string;
          title: string;
          type: CaseTypeEnum;
        }
      | {
          __typename?: "MovingInTenancy";
          id: string;
          icon: string;
          attention: CaseAttentionEnum;
          awaiting?: string | null;
          stateText: string;
          state: string;
          title: string;
          type: CaseTypeEnum;
        }
      | {
          __typename?: "MovingOutService";
          id: string;
          icon: string;
          attention: CaseAttentionEnum;
          awaiting?: string | null;
          stateText: string;
          state: string;
          title: string;
          type: CaseTypeEnum;
        }
      | {
          __typename?: "MovingOutTenancy";
          id: string;
          icon: string;
          attention: CaseAttentionEnum;
          awaiting?: string | null;
          stateText: string;
          state: string;
          title: string;
          type: CaseTypeEnum;
        }
      | {
          __typename?: "MovingSettlementAdministration";
          id: string;
          icon: string;
          attention: CaseAttentionEnum;
          awaiting?: string | null;
          stateText: string;
          state: string;
          title: string;
          type: CaseTypeEnum;
        }
      | {
          __typename?: "PreparationService";
          id: string;
          icon: string;
          attention: CaseAttentionEnum;
          awaiting?: string | null;
          stateText: string;
          state: string;
          title: string;
          type: CaseTypeEnum;
        }
      | {
          __typename?: "RequestTenancy";
          id: string;
          icon: string;
          attention: CaseAttentionEnum;
          awaiting?: string | null;
          stateText: string;
          state: string;
          title: string;
          type: CaseTypeEnum;
        }
      | {
          __typename?: "UtilityAdministration";
          id: string;
          icon: string;
          attention: CaseAttentionEnum;
          awaiting?: string | null;
          stateText: string;
          state: string;
          title: string;
          type: CaseTypeEnum;
        }
    >;
  };
};

export type ApartmentContractEditMutationVariables = Exact<{
  depositAmount: Scalars["Float"]["input"];
  intervalAmount: Scalars["Float"]["input"];
  startDate: Scalars["ISO8601Date"]["input"];
  endDate?: InputMaybe<Scalars["ISO8601Date"]["input"]>;
  endTenancyTerms: Scalars["String"]["input"];
  tenancyId: Scalars["ID"]["input"];
}>;

export type ApartmentContractEditMutation = {
  __typename?: "Mutation";
  tenancyUpdate?: {
    __typename?: "TenancyUpdateMutationPayload";
    errors?: Array<string> | null;
    tenancy?: { __typename?: "Tenancy"; id: string } | null;
  } | null;
};

export type ApartmentContractTerminateModal_EndTenancyTermsQueryVariables =
  Exact<{
    tenancyId: Scalars["ID"]["input"];
    endDate?: InputMaybe<Scalars["ISO8601Date"]["input"]>;
  }>;

export type ApartmentContractTerminateModal_EndTenancyTermsQuery = {
  __typename?: "Query";
  tenancy?: {
    __typename?: "Tenancy";
    endTenancyTerms?: {
      __typename?: "TenancyTerms";
      endDate?: string | null;
      earlyEndDate?: boolean | null;
      endDateLongFormat?: string | null;
      lastRentDate?: string | null;
      lastRentDateLongFormat?: string | null;
      leaveDate?: string | null;
      leaveDateLongFormat?: string | null;
    } | null;
  } | null;
  endTenancyReasons: Array<{
    __typename?: "EndTenancyReason";
    id: string;
    label: string;
    isOther: boolean;
  }>;
};

export type ApartmentContractTerminateModal_CreateEndTenancyMutationVariables =
  Exact<{
    endDate: Scalars["ISO8601Date"]["input"];
    comment?: InputMaybe<Scalars["String"]["input"]>;
    tenancyId: Scalars["ID"]["input"];
    endTenancyReasons?: InputMaybe<
      Array<Scalars["String"]["input"]> | Scalars["String"]["input"]
    >;
    otherReasonNote?: InputMaybe<Scalars["String"]["input"]>;
  }>;

export type ApartmentContractTerminateModal_CreateEndTenancyMutation = {
  __typename?: "Mutation";
  tenancyEnd?: {
    __typename?: "EndTenancyMutationPayload";
    errors?: Array<string> | null;
    case?: { __typename?: "EndTenancy"; id: string } | null;
  } | null;
};

export type ScreenApartment_ContractFragment = {
  __typename?: "Tenancy";
  id: string;
  startDate: string;
  endDate?: string | null;
  intervalAmount?: number | null;
  intervalAmountType: TenancyIntervalAmountTypeEnum;
  depositAmount?: number | null;
  hasEndTenancyCase: boolean;
  endTenancyTermsCondition?: string | null;
  contractCase?: {
    __typename?: "CreateTenancy";
    id: string;
    state: string;
    contract?: { __typename?: "Document"; url: string } | null;
  } | null;
} & { " $fragmentName"?: "ScreenApartment_ContractFragment" };

export type ScreenApartment_DocumentFragment = {
  __typename?: "Document";
  id: string;
  title: string;
  type: DocumentTypeEnum;
  url: string;
  createdAt: any;
} & { " $fragmentName"?: "ScreenApartment_DocumentFragment" };

export type EconomicDebtorsQueryVariables = Exact<{
  tenancyId?: InputMaybe<Scalars["ID"]["input"]>;
}>;

export type EconomicDebtorsQuery = {
  __typename?: "Query";
  economicDebtors: {
    __typename?: "EconomicDebtorList";
    records: Array<{
      __typename?: "EconomicDebtor";
      id: string;
      name: string;
      addressText?: string | null;
    }>;
  };
};

export type TenancyDebtorLinkMutationVariables = Exact<{
  tenancyId: Scalars["ID"]["input"];
  debtorId: Scalars["ID"]["input"];
}>;

export type TenancyDebtorLinkMutation = {
  __typename?: "Mutation";
  tenancyDebtorLink?: {
    __typename?: "TenancyDebtorLinkMutationPayload";
    isLinked?: boolean | null;
    errors?: Array<string> | null;
  } | null;
};

export type ScreenApartment_EconomicHistoryQueryVariables = Exact<{
  tenancyId: Scalars["ID"]["input"];
  subscriptionId: Scalars["ID"]["input"];
}>;

export type ScreenApartment_EconomicHistoryQuery = {
  __typename?: "Query";
  tenancy?: {
    __typename?: "Tenancy";
    economic: {
      __typename?: "TenancyEconomic";
      subscription?: {
        __typename?: "TenancyEconomicSubscription";
        name: string;
        history?: Array<{
          __typename?: "EconomicSubscriber";
          id: string;
          intervalStartAt?: any | null;
          intervalEndAt?: any | null;
          amount: number;
        }> | null;
      } | null;
    };
  } | null;
};

export type ScreenApartment_EconomicFragment = {
  __typename: "TenancyEconomic";
  deposit?: number | null;
  prepaidRent?: number | null;
  companySyncedAt?: any | null;
  debtor?: {
    __typename?: "EconomicDebtor";
    id: string;
    name: string;
    addressText?: string | null;
  } | null;
  subscriptions?: Array<{
    __typename?: "TenancyEconomicSubscription";
    id: string;
    name: string;
    interval?: EconomicSubscriptionIntervalEnum | null;
    currentAmount?: number | null;
  }> | null;
} & { " $fragmentName"?: "ScreenApartment_EconomicFragment" };

export type ScreenApartment_LandlordFragment = {
  __typename?: "Property";
  name: string;
  owner: {
    __typename?: "Company";
    name: string;
    phone?: string | null;
    email?: string | null;
    address?: string | null;
    postalCode?: string | null;
    city?: string | null;
  };
} & { " $fragmentName"?: "ScreenApartment_LandlordFragment" };

export type LookupUserMutationVariables = Exact<{
  email: Scalars["String"]["input"];
}>;

export type LookupUserMutation = {
  __typename?: "Mutation";
  lookupUser?: {
    __typename?: "User";
    email: string;
    id: string;
    name: string;
    phone?: string | null;
  } | null;
};

export type PhoneConfirmMutationVariables = Exact<{
  userId: Scalars["ID"]["input"];
}>;

export type PhoneConfirmMutation = {
  __typename?: "Mutation";
  result?: {
    __typename?: "PhoneConfirmMutationPayload";
    errors: Array<string>;
    user?: { __typename?: "User"; id: string } | null;
  } | null;
};

export type UpdateExternalUserMutationVariables = Exact<{
  userId: Scalars["ID"]["input"];
  email?: InputMaybe<Scalars["String"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  phone?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type UpdateExternalUserMutation = {
  __typename?: "Mutation";
  result?: {
    __typename?: "UpdateExternalUserMutationPayload";
    errors?: Array<string> | null;
    user?: {
      __typename?: "User";
      id: string;
      name: string;
      email: string;
      phone?: string | null;
    } | null;
  } | null;
};

export type ManageTenantsAndResidentsRemoveTenancyMutationVariables = Exact<{
  tenancyId: Scalars["ID"]["input"];
}>;

export type ManageTenantsAndResidentsRemoveTenancyMutation = {
  __typename?: "Mutation";
  tenancyRemove?: {
    __typename?: "TenancyRemoveMutationPayload";
    errors: Array<string>;
    tenancy?:
      | ({ __typename?: "Tenancy" } & {
          " $fragmentRefs"?: {
            ScreenApartment_ManageTenantsAndResidentsFragment: ScreenApartment_ManageTenantsAndResidentsFragment;
          };
        })
      | null;
  } | null;
};

export type ScreenApartment_ManageTenantsAndResidentsFragment = {
  __typename?: "Tenancy";
  id: string;
  removable: boolean;
  residents: Array<{
    __typename?: "Resident";
    id?: string | null;
    name: string;
    email?: string | null;
    phone?: string | null;
  }>;
  roles: Array<{
    __typename?: "TenancyRole";
    id: string;
    isPrimary: boolean;
    isResident: boolean;
    user: {
      __typename?: "User";
      id: string;
      name: string;
      email: string;
      phone?: string | null;
      protected: boolean;
      isPhoneConfirmed: boolean;
      isExternal: boolean;
    };
  }>;
} & { " $fragmentName"?: "ScreenApartment_ManageTenantsAndResidentsFragment" };

export type TenancyResidentCreateMutationVariables = Exact<{
  tenancyId: Scalars["ID"]["input"];
  name?: InputMaybe<Scalars["String"]["input"]>;
  email?: InputMaybe<Scalars["String"]["input"]>;
  phone?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type TenancyResidentCreateMutation = {
  __typename?: "Mutation";
  tenancyResidentCreate?: {
    __typename?: "TenancyResidentCreateMutationPayload";
    errors?: Array<string> | null;
    resident?: {
      __typename?: "Resident";
      id?: string | null;
      name: string;
      email?: string | null;
    } | null;
  } | null;
};

export type TenancyResidentUpdateMutationVariables = Exact<{
  residentId: Scalars["ID"]["input"];
  name?: InputMaybe<Scalars["String"]["input"]>;
  email?: InputMaybe<Scalars["String"]["input"]>;
  phone?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type TenancyResidentUpdateMutation = {
  __typename?: "Mutation";
  tenancyResidentUpdate?: {
    __typename?: "TenancyResidentUpdateMutationPayload";
    errors?: Array<string> | null;
    resident?: {
      __typename?: "Resident";
      id?: string | null;
      name: string;
      email?: string | null;
    } | null;
  } | null;
};

export type TenancyResidentRemoveMutationVariables = Exact<{
  residentId: Scalars["ID"]["input"];
}>;

export type TenancyResidentRemoveMutation = {
  __typename?: "Mutation";
  tenancyResidentRemove?: {
    __typename?: "TenancyResidentRemoveMutationPayload";
    errors?: Array<string> | null;
    resident?: {
      __typename?: "Resident";
      id?: string | null;
      name: string;
      email?: string | null;
    } | null;
  } | null;
};

export type TenancyRoleCreateMutationVariables = Exact<{
  tenancyId: Scalars["ID"]["input"];
  userId?: InputMaybe<Scalars["ID"]["input"]>;
  isPrimary?: InputMaybe<Scalars["Boolean"]["input"]>;
  isResident?: InputMaybe<Scalars["Boolean"]["input"]>;
  email?: InputMaybe<Scalars["String"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  phone?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type TenancyRoleCreateMutation = {
  __typename?: "Mutation";
  tenancyRoleCreate?: {
    __typename?: "TenancyRoleCreateMutationPayload";
    errors?: Array<string> | null;
    tenancyRole?: {
      __typename?: "TenancyRole";
      isPrimary: boolean;
      isResident: boolean;
      user: { __typename?: "User"; name: string };
    } | null;
  } | null;
};

export type TenancyRoleUpdateMutationVariables = Exact<{
  tenancyRoleId: Scalars["ID"]["input"];
  isPrimary?: InputMaybe<Scalars["Boolean"]["input"]>;
  isResident?: InputMaybe<Scalars["Boolean"]["input"]>;
}>;

export type TenancyRoleUpdateMutation = {
  __typename?: "Mutation";
  tenancyRoleUpdate?: {
    __typename?: "TenancyRoleUpdateMutationPayload";
    errors?: Array<string> | null;
    tenancyRole?: {
      __typename?: "TenancyRole";
      isPrimary: boolean;
      isResident: boolean;
      user: { __typename?: "User"; id: string; name: string };
    } | null;
  } | null;
};

export type TenancyRoleRemoveMutationVariables = Exact<{
  tenancyRoleId: Scalars["ID"]["input"];
}>;

export type TenancyRoleRemoveMutation = {
  __typename?: "Mutation";
  tenancyRoleRemove?: {
    __typename?: "TenancyRoleRemoveMutationPayload";
    errors?: Array<string> | null;
    tenancyRole?: {
      __typename?: "TenancyRole";
      isPrimary: boolean;
      isResident: boolean;
      user: { __typename?: "User"; name: string };
    } | null;
  } | null;
};

export type ScreenApartment_MessageFragment = {
  __typename?: "Message";
  id: string;
  title: string;
  body: string;
  authorId: string;
  createdAt: any;
  updatedAt: any;
  emailsSentAt?: any | null;
  smsSentAt?: any | null;
  apartment?: string | null;
  property: { __typename?: "Property"; id: string; name: string };
} & { " $fragmentName"?: "ScreenApartment_MessageFragment" };

export type ScreenApartmentQueryVariables = Exact<{
  apartmentId: Scalars["ID"]["input"];
}>;

export type ScreenApartmentQuery = {
  __typename?: "Query";
  apartment?: {
    __typename?: "Apartment";
    id: string;
    address: string;
    tenancies: {
      __typename?: "TenancyList";
      records: Array<{
        __typename?: "Tenancy";
        id: string;
        startDate: string;
        endDate?: string | null;
        roles: Array<{
          __typename?: "TenancyRole";
          id: string;
          user: { __typename?: "User"; id: string; name: string };
        }>;
      }>;
    };
  } | null;
};

export type ApartmentsQueryVariables = Exact<{
  where: ApartmentWhereInput;
  orderBy: ApartmentOrderByEnum;
  offset: Scalars["Int"]["input"];
  limit: Scalars["Int"]["input"];
}>;

export type ApartmentsQuery = {
  __typename?: "Query";
  apartments: {
    __typename?: "ApartmentList";
    total: number;
    records: Array<
      {
        __typename?: "Apartment";
        id: string;
        address: string;
        property: { __typename?: "Property"; id: string; name: string };
      } & {
        " $fragmentRefs"?: {
          DataTableApartmentsFragment: DataTableApartmentsFragment;
        };
      }
    >;
  };
};

export type CasesCountQueryVariables = Exact<{ [key: string]: never }>;

export type CasesCountQuery = {
  __typename?: "Query";
  new: { __typename?: "CaseList"; total: number };
  comments: { __typename?: "CaseList"; total: number };
  flagged: { __typename?: "CaseList"; total: number };
};

export type CasesQueryVariables = Exact<{
  where: CaseWhereInput;
  orderBy: CaseOrderByEnum;
  offset: Scalars["Int"]["input"];
  limit: Scalars["Int"]["input"];
}>;

export type CasesQuery = {
  __typename?: "Query";
  cases: {
    __typename?: "CaseList";
    total: number;
    records: Array<
      | ({ __typename?: "CleaningService" } & {
          " $fragmentRefs"?: {
            DataTableCases_CleaningService_Fragment: DataTableCases_CleaningService_Fragment;
          };
        })
      | ({ __typename?: "CreateTenancy" } & {
          " $fragmentRefs"?: {
            DataTableCases_CreateTenancy_Fragment: DataTableCases_CreateTenancy_Fragment;
          };
        })
      | ({ __typename?: "EndTenancy" } & {
          " $fragmentRefs"?: {
            DataTableCases_EndTenancy_Fragment: DataTableCases_EndTenancy_Fragment;
          };
        })
      | ({ __typename?: "FindTenancyAdministration" } & {
          " $fragmentRefs"?: {
            DataTableCases_FindTenancyAdministration_Fragment: DataTableCases_FindTenancyAdministration_Fragment;
          };
        })
      | ({ __typename?: "MiscAdministration" } & {
          " $fragmentRefs"?: {
            DataTableCases_MiscAdministration_Fragment: DataTableCases_MiscAdministration_Fragment;
          };
        })
      | ({ __typename?: "MiscService" } & {
          " $fragmentRefs"?: {
            DataTableCases_MiscService_Fragment: DataTableCases_MiscService_Fragment;
          };
        })
      | ({ __typename?: "MovingInService" } & {
          " $fragmentRefs"?: {
            DataTableCases_MovingInService_Fragment: DataTableCases_MovingInService_Fragment;
          };
        })
      | ({ __typename?: "MovingInTenancy" } & {
          " $fragmentRefs"?: {
            DataTableCases_MovingInTenancy_Fragment: DataTableCases_MovingInTenancy_Fragment;
          };
        })
      | ({ __typename?: "MovingOutService" } & {
          " $fragmentRefs"?: {
            DataTableCases_MovingOutService_Fragment: DataTableCases_MovingOutService_Fragment;
          };
        })
      | ({ __typename?: "MovingOutTenancy" } & {
          " $fragmentRefs"?: {
            DataTableCases_MovingOutTenancy_Fragment: DataTableCases_MovingOutTenancy_Fragment;
          };
        })
      | ({ __typename?: "MovingSettlementAdministration" } & {
          " $fragmentRefs"?: {
            DataTableCases_MovingSettlementAdministration_Fragment: DataTableCases_MovingSettlementAdministration_Fragment;
          };
        })
      | ({ __typename?: "PreparationService" } & {
          " $fragmentRefs"?: {
            DataTableCases_PreparationService_Fragment: DataTableCases_PreparationService_Fragment;
          };
        })
      | ({ __typename?: "RequestTenancy" } & {
          " $fragmentRefs"?: {
            DataTableCases_RequestTenancy_Fragment: DataTableCases_RequestTenancy_Fragment;
          };
        })
      | ({ __typename?: "UtilityAdministration" } & {
          " $fragmentRefs"?: {
            DataTableCases_UtilityAdministration_Fragment: DataTableCases_UtilityAdministration_Fragment;
          };
        })
    >;
  };
};

type ServiceCaseScreen_CleaningService_Fragment = {
  __typename?: "CleaningService";
  id: string;
  type: CaseTypeEnum;
  completed?: boolean | null;
  inspected?: boolean | null;
  processing?: boolean | null;
  tenancy?: {
    __typename?: "Tenancy";
    user: { __typename?: "User"; id: string; name: string };
  } | null;
  inspection?: {
    __typename?: "Inspection";
    mayProcess: boolean;
    canProcess: boolean;
    cleaning?: string | null;
    other?: string | null;
    tenantSignature?: string | null;
    tenantSignedBy?: string | null;
    landlordSignature?: string | null;
    landlordSignedBy?: string | null;
    answers: Array<{
      __typename?: "InspectionAnswer";
      rating?: number | null;
      position: number;
      note?: string | null;
      area: { __typename?: "InspectionArea"; id: string; name: string };
      subject: {
        __typename?: "InspectionSubject";
        id: string;
        name: string;
        description?: string | null;
      };
    }>;
    keys: Array<{
      __typename?: "InspectionKey";
      id?: string | null;
      description: string;
      keyMissing?: number | null;
      count: number;
      total: number;
    }>;
    meters: Array<{
      __typename?: "InspectionMeter";
      id: string;
      description: string;
      value: number;
    }>;
    document?: { __typename?: "Document"; url: string } | null;
  } | null;
} & { " $fragmentName"?: "ServiceCaseScreen_CleaningService_Fragment" };

type ServiceCaseScreen_CreateTenancy_Fragment = {
  __typename?: "CreateTenancy";
  id: string;
  type: CaseTypeEnum;
  completed?: boolean | null;
  inspected?: boolean | null;
  processing?: boolean | null;
  tenancy?: {
    __typename?: "Tenancy";
    user: { __typename?: "User"; id: string; name: string };
  } | null;
  inspection?: {
    __typename?: "Inspection";
    mayProcess: boolean;
    canProcess: boolean;
    cleaning?: string | null;
    other?: string | null;
    tenantSignature?: string | null;
    tenantSignedBy?: string | null;
    landlordSignature?: string | null;
    landlordSignedBy?: string | null;
    answers: Array<{
      __typename?: "InspectionAnswer";
      rating?: number | null;
      position: number;
      note?: string | null;
      area: { __typename?: "InspectionArea"; id: string; name: string };
      subject: {
        __typename?: "InspectionSubject";
        id: string;
        name: string;
        description?: string | null;
      };
    }>;
    keys: Array<{
      __typename?: "InspectionKey";
      id?: string | null;
      description: string;
      keyMissing?: number | null;
      count: number;
      total: number;
    }>;
    meters: Array<{
      __typename?: "InspectionMeter";
      id: string;
      description: string;
      value: number;
    }>;
    document?: { __typename?: "Document"; url: string } | null;
  } | null;
} & { " $fragmentName"?: "ServiceCaseScreen_CreateTenancy_Fragment" };

type ServiceCaseScreen_EndTenancy_Fragment = {
  __typename?: "EndTenancy";
  id: string;
  type: CaseTypeEnum;
  completed?: boolean | null;
  inspected?: boolean | null;
  processing?: boolean | null;
  tenancy?: {
    __typename?: "Tenancy";
    user: { __typename?: "User"; id: string; name: string };
  } | null;
  inspection?: {
    __typename?: "Inspection";
    mayProcess: boolean;
    canProcess: boolean;
    cleaning?: string | null;
    other?: string | null;
    tenantSignature?: string | null;
    tenantSignedBy?: string | null;
    landlordSignature?: string | null;
    landlordSignedBy?: string | null;
    answers: Array<{
      __typename?: "InspectionAnswer";
      rating?: number | null;
      position: number;
      note?: string | null;
      area: { __typename?: "InspectionArea"; id: string; name: string };
      subject: {
        __typename?: "InspectionSubject";
        id: string;
        name: string;
        description?: string | null;
      };
    }>;
    keys: Array<{
      __typename?: "InspectionKey";
      id?: string | null;
      description: string;
      keyMissing?: number | null;
      count: number;
      total: number;
    }>;
    meters: Array<{
      __typename?: "InspectionMeter";
      id: string;
      description: string;
      value: number;
    }>;
    document?: { __typename?: "Document"; url: string } | null;
  } | null;
} & { " $fragmentName"?: "ServiceCaseScreen_EndTenancy_Fragment" };

type ServiceCaseScreen_FindTenancyAdministration_Fragment = {
  __typename?: "FindTenancyAdministration";
  id: string;
  type: CaseTypeEnum;
  completed?: boolean | null;
  inspected?: boolean | null;
  processing?: boolean | null;
  tenancy?: {
    __typename?: "Tenancy";
    user: { __typename?: "User"; id: string; name: string };
  } | null;
  inspection?: {
    __typename?: "Inspection";
    mayProcess: boolean;
    canProcess: boolean;
    cleaning?: string | null;
    other?: string | null;
    tenantSignature?: string | null;
    tenantSignedBy?: string | null;
    landlordSignature?: string | null;
    landlordSignedBy?: string | null;
    answers: Array<{
      __typename?: "InspectionAnswer";
      rating?: number | null;
      position: number;
      note?: string | null;
      area: { __typename?: "InspectionArea"; id: string; name: string };
      subject: {
        __typename?: "InspectionSubject";
        id: string;
        name: string;
        description?: string | null;
      };
    }>;
    keys: Array<{
      __typename?: "InspectionKey";
      id?: string | null;
      description: string;
      keyMissing?: number | null;
      count: number;
      total: number;
    }>;
    meters: Array<{
      __typename?: "InspectionMeter";
      id: string;
      description: string;
      value: number;
    }>;
    document?: { __typename?: "Document"; url: string } | null;
  } | null;
} & {
  " $fragmentName"?: "ServiceCaseScreen_FindTenancyAdministration_Fragment";
};

type ServiceCaseScreen_MiscAdministration_Fragment = {
  __typename?: "MiscAdministration";
  id: string;
  type: CaseTypeEnum;
  completed?: boolean | null;
  inspected?: boolean | null;
  processing?: boolean | null;
  tenancy?: {
    __typename?: "Tenancy";
    user: { __typename?: "User"; id: string; name: string };
  } | null;
  inspection?: {
    __typename?: "Inspection";
    mayProcess: boolean;
    canProcess: boolean;
    cleaning?: string | null;
    other?: string | null;
    tenantSignature?: string | null;
    tenantSignedBy?: string | null;
    landlordSignature?: string | null;
    landlordSignedBy?: string | null;
    answers: Array<{
      __typename?: "InspectionAnswer";
      rating?: number | null;
      position: number;
      note?: string | null;
      area: { __typename?: "InspectionArea"; id: string; name: string };
      subject: {
        __typename?: "InspectionSubject";
        id: string;
        name: string;
        description?: string | null;
      };
    }>;
    keys: Array<{
      __typename?: "InspectionKey";
      id?: string | null;
      description: string;
      keyMissing?: number | null;
      count: number;
      total: number;
    }>;
    meters: Array<{
      __typename?: "InspectionMeter";
      id: string;
      description: string;
      value: number;
    }>;
    document?: { __typename?: "Document"; url: string } | null;
  } | null;
} & { " $fragmentName"?: "ServiceCaseScreen_MiscAdministration_Fragment" };

type ServiceCaseScreen_MiscService_Fragment = {
  __typename?: "MiscService";
  id: string;
  type: CaseTypeEnum;
  completed?: boolean | null;
  inspected?: boolean | null;
  processing?: boolean | null;
  tenancy?: {
    __typename?: "Tenancy";
    user: { __typename?: "User"; id: string; name: string };
  } | null;
  inspection?: {
    __typename?: "Inspection";
    mayProcess: boolean;
    canProcess: boolean;
    cleaning?: string | null;
    other?: string | null;
    tenantSignature?: string | null;
    tenantSignedBy?: string | null;
    landlordSignature?: string | null;
    landlordSignedBy?: string | null;
    answers: Array<{
      __typename?: "InspectionAnswer";
      rating?: number | null;
      position: number;
      note?: string | null;
      area: { __typename?: "InspectionArea"; id: string; name: string };
      subject: {
        __typename?: "InspectionSubject";
        id: string;
        name: string;
        description?: string | null;
      };
    }>;
    keys: Array<{
      __typename?: "InspectionKey";
      id?: string | null;
      description: string;
      keyMissing?: number | null;
      count: number;
      total: number;
    }>;
    meters: Array<{
      __typename?: "InspectionMeter";
      id: string;
      description: string;
      value: number;
    }>;
    document?: { __typename?: "Document"; url: string } | null;
  } | null;
} & { " $fragmentName"?: "ServiceCaseScreen_MiscService_Fragment" };

type ServiceCaseScreen_MovingInService_Fragment = {
  __typename?: "MovingInService";
  id: string;
  type: CaseTypeEnum;
  completed?: boolean | null;
  inspected?: boolean | null;
  processing?: boolean | null;
  tenancy?: {
    __typename?: "Tenancy";
    user: { __typename?: "User"; id: string; name: string };
  } | null;
  inspection?: {
    __typename?: "Inspection";
    mayProcess: boolean;
    canProcess: boolean;
    cleaning?: string | null;
    other?: string | null;
    tenantSignature?: string | null;
    tenantSignedBy?: string | null;
    landlordSignature?: string | null;
    landlordSignedBy?: string | null;
    answers: Array<{
      __typename?: "InspectionAnswer";
      rating?: number | null;
      position: number;
      note?: string | null;
      area: { __typename?: "InspectionArea"; id: string; name: string };
      subject: {
        __typename?: "InspectionSubject";
        id: string;
        name: string;
        description?: string | null;
      };
    }>;
    keys: Array<{
      __typename?: "InspectionKey";
      id?: string | null;
      description: string;
      keyMissing?: number | null;
      count: number;
      total: number;
    }>;
    meters: Array<{
      __typename?: "InspectionMeter";
      id: string;
      description: string;
      value: number;
    }>;
    document?: { __typename?: "Document"; url: string } | null;
  } | null;
} & { " $fragmentName"?: "ServiceCaseScreen_MovingInService_Fragment" };

type ServiceCaseScreen_MovingInTenancy_Fragment = {
  __typename?: "MovingInTenancy";
  id: string;
  type: CaseTypeEnum;
  completed?: boolean | null;
  inspected?: boolean | null;
  processing?: boolean | null;
  tenancy?: {
    __typename?: "Tenancy";
    user: { __typename?: "User"; id: string; name: string };
  } | null;
  inspection?: {
    __typename?: "Inspection";
    mayProcess: boolean;
    canProcess: boolean;
    cleaning?: string | null;
    other?: string | null;
    tenantSignature?: string | null;
    tenantSignedBy?: string | null;
    landlordSignature?: string | null;
    landlordSignedBy?: string | null;
    answers: Array<{
      __typename?: "InspectionAnswer";
      rating?: number | null;
      position: number;
      note?: string | null;
      area: { __typename?: "InspectionArea"; id: string; name: string };
      subject: {
        __typename?: "InspectionSubject";
        id: string;
        name: string;
        description?: string | null;
      };
    }>;
    keys: Array<{
      __typename?: "InspectionKey";
      id?: string | null;
      description: string;
      keyMissing?: number | null;
      count: number;
      total: number;
    }>;
    meters: Array<{
      __typename?: "InspectionMeter";
      id: string;
      description: string;
      value: number;
    }>;
    document?: { __typename?: "Document"; url: string } | null;
  } | null;
} & { " $fragmentName"?: "ServiceCaseScreen_MovingInTenancy_Fragment" };

type ServiceCaseScreen_MovingOutService_Fragment = {
  __typename?: "MovingOutService";
  id: string;
  type: CaseTypeEnum;
  completed?: boolean | null;
  inspected?: boolean | null;
  processing?: boolean | null;
  tenancy?: {
    __typename?: "Tenancy";
    user: { __typename?: "User"; id: string; name: string };
  } | null;
  inspection?: {
    __typename?: "Inspection";
    mayProcess: boolean;
    canProcess: boolean;
    cleaning?: string | null;
    other?: string | null;
    tenantSignature?: string | null;
    tenantSignedBy?: string | null;
    landlordSignature?: string | null;
    landlordSignedBy?: string | null;
    answers: Array<{
      __typename?: "InspectionAnswer";
      rating?: number | null;
      position: number;
      note?: string | null;
      area: { __typename?: "InspectionArea"; id: string; name: string };
      subject: {
        __typename?: "InspectionSubject";
        id: string;
        name: string;
        description?: string | null;
      };
    }>;
    keys: Array<{
      __typename?: "InspectionKey";
      id?: string | null;
      description: string;
      keyMissing?: number | null;
      count: number;
      total: number;
    }>;
    meters: Array<{
      __typename?: "InspectionMeter";
      id: string;
      description: string;
      value: number;
    }>;
    document?: { __typename?: "Document"; url: string } | null;
  } | null;
} & { " $fragmentName"?: "ServiceCaseScreen_MovingOutService_Fragment" };

type ServiceCaseScreen_MovingOutTenancy_Fragment = {
  __typename?: "MovingOutTenancy";
  id: string;
  type: CaseTypeEnum;
  completed?: boolean | null;
  inspected?: boolean | null;
  processing?: boolean | null;
  tenancy?: {
    __typename?: "Tenancy";
    user: { __typename?: "User"; id: string; name: string };
  } | null;
  inspection?: {
    __typename?: "Inspection";
    mayProcess: boolean;
    canProcess: boolean;
    cleaning?: string | null;
    other?: string | null;
    tenantSignature?: string | null;
    tenantSignedBy?: string | null;
    landlordSignature?: string | null;
    landlordSignedBy?: string | null;
    answers: Array<{
      __typename?: "InspectionAnswer";
      rating?: number | null;
      position: number;
      note?: string | null;
      area: { __typename?: "InspectionArea"; id: string; name: string };
      subject: {
        __typename?: "InspectionSubject";
        id: string;
        name: string;
        description?: string | null;
      };
    }>;
    keys: Array<{
      __typename?: "InspectionKey";
      id?: string | null;
      description: string;
      keyMissing?: number | null;
      count: number;
      total: number;
    }>;
    meters: Array<{
      __typename?: "InspectionMeter";
      id: string;
      description: string;
      value: number;
    }>;
    document?: { __typename?: "Document"; url: string } | null;
  } | null;
} & { " $fragmentName"?: "ServiceCaseScreen_MovingOutTenancy_Fragment" };

type ServiceCaseScreen_MovingSettlementAdministration_Fragment = {
  __typename?: "MovingSettlementAdministration";
  id: string;
  type: CaseTypeEnum;
  completed?: boolean | null;
  inspected?: boolean | null;
  processing?: boolean | null;
  tenancy?: {
    __typename?: "Tenancy";
    user: { __typename?: "User"; id: string; name: string };
  } | null;
  inspection?: {
    __typename?: "Inspection";
    mayProcess: boolean;
    canProcess: boolean;
    cleaning?: string | null;
    other?: string | null;
    tenantSignature?: string | null;
    tenantSignedBy?: string | null;
    landlordSignature?: string | null;
    landlordSignedBy?: string | null;
    answers: Array<{
      __typename?: "InspectionAnswer";
      rating?: number | null;
      position: number;
      note?: string | null;
      area: { __typename?: "InspectionArea"; id: string; name: string };
      subject: {
        __typename?: "InspectionSubject";
        id: string;
        name: string;
        description?: string | null;
      };
    }>;
    keys: Array<{
      __typename?: "InspectionKey";
      id?: string | null;
      description: string;
      keyMissing?: number | null;
      count: number;
      total: number;
    }>;
    meters: Array<{
      __typename?: "InspectionMeter";
      id: string;
      description: string;
      value: number;
    }>;
    document?: { __typename?: "Document"; url: string } | null;
  } | null;
} & {
  " $fragmentName"?: "ServiceCaseScreen_MovingSettlementAdministration_Fragment";
};

type ServiceCaseScreen_PreparationService_Fragment = {
  __typename?: "PreparationService";
  id: string;
  type: CaseTypeEnum;
  completed?: boolean | null;
  inspected?: boolean | null;
  processing?: boolean | null;
  tenancy?: {
    __typename?: "Tenancy";
    user: { __typename?: "User"; id: string; name: string };
  } | null;
  inspection?: {
    __typename?: "Inspection";
    mayProcess: boolean;
    canProcess: boolean;
    cleaning?: string | null;
    other?: string | null;
    tenantSignature?: string | null;
    tenantSignedBy?: string | null;
    landlordSignature?: string | null;
    landlordSignedBy?: string | null;
    answers: Array<{
      __typename?: "InspectionAnswer";
      rating?: number | null;
      position: number;
      note?: string | null;
      area: { __typename?: "InspectionArea"; id: string; name: string };
      subject: {
        __typename?: "InspectionSubject";
        id: string;
        name: string;
        description?: string | null;
      };
    }>;
    keys: Array<{
      __typename?: "InspectionKey";
      id?: string | null;
      description: string;
      keyMissing?: number | null;
      count: number;
      total: number;
    }>;
    meters: Array<{
      __typename?: "InspectionMeter";
      id: string;
      description: string;
      value: number;
    }>;
    document?: { __typename?: "Document"; url: string } | null;
  } | null;
} & { " $fragmentName"?: "ServiceCaseScreen_PreparationService_Fragment" };

type ServiceCaseScreen_RequestTenancy_Fragment = {
  __typename?: "RequestTenancy";
  id: string;
  type: CaseTypeEnum;
  completed?: boolean | null;
  inspected?: boolean | null;
  processing?: boolean | null;
  tenancy?: {
    __typename?: "Tenancy";
    user: { __typename?: "User"; id: string; name: string };
  } | null;
  inspection?: {
    __typename?: "Inspection";
    mayProcess: boolean;
    canProcess: boolean;
    cleaning?: string | null;
    other?: string | null;
    tenantSignature?: string | null;
    tenantSignedBy?: string | null;
    landlordSignature?: string | null;
    landlordSignedBy?: string | null;
    answers: Array<{
      __typename?: "InspectionAnswer";
      rating?: number | null;
      position: number;
      note?: string | null;
      area: { __typename?: "InspectionArea"; id: string; name: string };
      subject: {
        __typename?: "InspectionSubject";
        id: string;
        name: string;
        description?: string | null;
      };
    }>;
    keys: Array<{
      __typename?: "InspectionKey";
      id?: string | null;
      description: string;
      keyMissing?: number | null;
      count: number;
      total: number;
    }>;
    meters: Array<{
      __typename?: "InspectionMeter";
      id: string;
      description: string;
      value: number;
    }>;
    document?: { __typename?: "Document"; url: string } | null;
  } | null;
} & { " $fragmentName"?: "ServiceCaseScreen_RequestTenancy_Fragment" };

type ServiceCaseScreen_UtilityAdministration_Fragment = {
  __typename?: "UtilityAdministration";
  id: string;
  type: CaseTypeEnum;
  completed?: boolean | null;
  inspected?: boolean | null;
  processing?: boolean | null;
  tenancy?: {
    __typename?: "Tenancy";
    user: { __typename?: "User"; id: string; name: string };
  } | null;
  inspection?: {
    __typename?: "Inspection";
    mayProcess: boolean;
    canProcess: boolean;
    cleaning?: string | null;
    other?: string | null;
    tenantSignature?: string | null;
    tenantSignedBy?: string | null;
    landlordSignature?: string | null;
    landlordSignedBy?: string | null;
    answers: Array<{
      __typename?: "InspectionAnswer";
      rating?: number | null;
      position: number;
      note?: string | null;
      area: { __typename?: "InspectionArea"; id: string; name: string };
      subject: {
        __typename?: "InspectionSubject";
        id: string;
        name: string;
        description?: string | null;
      };
    }>;
    keys: Array<{
      __typename?: "InspectionKey";
      id?: string | null;
      description: string;
      keyMissing?: number | null;
      count: number;
      total: number;
    }>;
    meters: Array<{
      __typename?: "InspectionMeter";
      id: string;
      description: string;
      value: number;
    }>;
    document?: { __typename?: "Document"; url: string } | null;
  } | null;
} & { " $fragmentName"?: "ServiceCaseScreen_UtilityAdministration_Fragment" };

export type ServiceCaseScreenFragment =
  | ServiceCaseScreen_CleaningService_Fragment
  | ServiceCaseScreen_CreateTenancy_Fragment
  | ServiceCaseScreen_EndTenancy_Fragment
  | ServiceCaseScreen_FindTenancyAdministration_Fragment
  | ServiceCaseScreen_MiscAdministration_Fragment
  | ServiceCaseScreen_MiscService_Fragment
  | ServiceCaseScreen_MovingInService_Fragment
  | ServiceCaseScreen_MovingInTenancy_Fragment
  | ServiceCaseScreen_MovingOutService_Fragment
  | ServiceCaseScreen_MovingOutTenancy_Fragment
  | ServiceCaseScreen_MovingSettlementAdministration_Fragment
  | ServiceCaseScreen_PreparationService_Fragment
  | ServiceCaseScreen_RequestTenancy_Fragment
  | ServiceCaseScreen_UtilityAdministration_Fragment;

export type SaveInspectionMutationVariables = Exact<{
  input: BaseInspectionInput;
}>;

export type SaveInspectionMutation = {
  __typename?: "Mutation";
  caseInspectionSave?: {
    __typename?: "CaseInspectionSaveMutationPayload";
    errors: Array<string>;
  } | null;
};

export type ProcessInspectionMutationVariables = Exact<{
  input: BaseInspectionInput;
}>;

export type ProcessInspectionMutation = {
  __typename?: "Mutation";
  caseInspectionProcess?: {
    __typename?: "CaseInspectionProcessMutationPayload";
    errors: Array<string>;
  } | null;
};

export type SaveInspectionAnswerMutationVariables = Exact<{
  caseId: Scalars["ID"]["input"];
  areaId: Scalars["ID"]["input"];
  subjectId: Scalars["ID"]["input"];
  rating: Scalars["Int"]["input"];
  position: Scalars["Int"]["input"];
  note?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type SaveInspectionAnswerMutation = {
  __typename?: "Mutation";
  saveInspectionAnswer?: {
    __typename?: "SaveInspectionAnswerMutationPayload";
    errors: Array<string>;
  } | null;
};

export type DeleteInspectionAnswerMutationVariables = Exact<{
  caseId: Scalars["ID"]["input"];
  areaId: Scalars["ID"]["input"];
  subjectId: Scalars["ID"]["input"];
}>;

export type DeleteInspectionAnswerMutation = {
  __typename?: "Mutation";
  deleteInspectionAnswer?: {
    __typename?: "DeleteInspectionAnswerMutationPayload";
    errors: Array<string>;
  } | null;
};

export type ToggleCaseFlagMutationVariables = Exact<{
  caseId: Scalars["ID"]["input"];
  flagged?: InputMaybe<Scalars["Boolean"]["input"]>;
}>;

export type ToggleCaseFlagMutation = {
  __typename?: "Mutation";
  toggleCaseFlag?: {
    __typename?: "ToggleCaseFlagMutationPayload";
    errors: Array<string>;
  } | null;
};

export type CasePlanningUpdateMutationVariables = Exact<{
  caseId: Scalars["ID"]["input"];
  startAfter?: InputMaybe<Scalars["ISO8601Date"]["input"]>;
  completeBefore?: InputMaybe<Scalars["ISO8601Date"]["input"]>;
  scheduledDate?: InputMaybe<Scalars["ISO8601Date"]["input"]>;
  scheduledTime?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type CasePlanningUpdateMutation = {
  __typename?: "Mutation";
  casePlanningUpdate?: {
    __typename?: "CasePlanningUpdateMutationPayload";
    errors: Array<string>;
  } | null;
};

export type CaseCommentReadMutationVariables = Exact<{
  caseId: Scalars["ID"]["input"];
  senderId: Scalars["ID"]["input"];
}>;

export type CaseCommentReadMutation = {
  __typename?: "Mutation";
  caseCommentRead?: {
    __typename?: "CaseCommentReadMutationPayload";
    errors: Array<string>;
  } | null;
};

export type SaveTextMacroMutationVariables = Exact<{
  id?: InputMaybe<Scalars["Int"]["input"]>;
  name: Scalars["String"]["input"];
  content: Scalars["String"]["input"];
  available: Scalars["String"]["input"];
}>;

export type SaveTextMacroMutation = {
  __typename?: "Mutation";
  saveTextMacro?: {
    __typename?: "SaveTextMacroMutationPayload";
    errors: Array<string>;
    textMacro?: {
      __typename?: "TextMacro";
      id: number;
      name: string;
      content: string;
    } | null;
  } | null;
};

export type DeleteTextMacroMutationVariables = Exact<{
  id: Scalars["Int"]["input"];
}>;

export type DeleteTextMacroMutation = {
  __typename?: "Mutation";
  deleteTextMacro?: {
    __typename?: "DeleteTextMacroMutationPayload";
    id: number;
    errors: Array<string>;
  } | null;
};

export type CaseCreateMutationVariables = Exact<{
  type: CaseTypeEnum;
  propertyId?: InputMaybe<Scalars["ID"]["input"]>;
  apartmentId?: InputMaybe<Scalars["ID"]["input"]>;
  tenancyId?: InputMaybe<Scalars["ID"]["input"]>;
  parentId?: InputMaybe<Scalars["ID"]["input"]>;
  requester?: InputMaybe<Scalars["String"]["input"]>;
  input?: InputMaybe<CaseEventInput>;
}>;

export type CaseCreateMutation = {
  __typename?: "Mutation";
  caseCreate?: {
    __typename?: "CaseCreateMutationPayload";
    errors: Array<string>;
    result?:
      | { __typename?: "CleaningService"; id: string }
      | { __typename?: "CreateTenancy"; id: string }
      | { __typename?: "EndTenancy"; id: string }
      | { __typename?: "FindTenancyAdministration"; id: string }
      | { __typename?: "MiscAdministration"; id: string }
      | { __typename?: "MiscService"; id: string }
      | { __typename?: "MovingInService"; id: string }
      | { __typename?: "MovingInTenancy"; id: string }
      | { __typename?: "MovingOutService"; id: string }
      | { __typename?: "MovingOutTenancy"; id: string }
      | { __typename?: "MovingSettlementAdministration"; id: string }
      | { __typename?: "PreparationService"; id: string }
      | { __typename?: "RequestTenancy"; id: string }
      | { __typename?: "UtilityAdministration"; id: string }
      | null;
  } | null;
};

export type CaseUpdateMutationVariables = Exact<{
  caseId: Scalars["ID"]["input"];
  event: CaseEventEnum;
  input?: InputMaybe<CaseEventInput>;
}>;

export type CaseUpdateMutation = {
  __typename?: "Mutation";
  caseUpdate?: {
    __typename?: "CaseUpdateMutationPayload";
    errors: Array<string>;
  } | null;
};

export type CaseEndTenancyUpdateReasonsMutationVariables = Exact<{
  caseId: Scalars["ID"]["input"];
  reasons:
    | Array<EndTenancyReasonSelectionInput>
    | EndTenancyReasonSelectionInput;
}>;

export type CaseEndTenancyUpdateReasonsMutation = {
  __typename?: "Mutation";
  caseEndTenancyUpdateReasons?: {
    __typename?: "CaseEndTenancyUpdateReasonsMutationPayload";
    errors: Array<string>;
  } | null;
};

export type CaseShareCreateMutationVariables = Exact<{
  caseId: Scalars["ID"]["input"];
  selection: CaseShareSelectionInput;
  description: Scalars["String"]["input"];
  note: Scalars["String"]["input"];
  expiresAt?: InputMaybe<Scalars["ISO8601DateTime"]["input"]>;
}>;

export type CaseShareCreateMutation = {
  __typename?: "Mutation";
  caseShareCreate?: {
    __typename?: "CaseShareCreateMutationPayload";
    errors: Array<string>;
    result?: { __typename?: "CaseShare"; id: string; url: string } | null;
  } | null;
};

export type CaseShareRevokeMutationVariables = Exact<{
  shareId: Scalars["ID"]["input"];
}>;

export type CaseShareRevokeMutation = {
  __typename?: "Mutation";
  caseShareRevoke?: {
    __typename?: "CaseShareRevokeMutationPayload";
    errors: Array<string>;
    result?: { __typename?: "CaseShare"; id: string; isActive: boolean } | null;
  } | null;
};

export type CaseShareSendMutationVariables = Exact<{
  shareId: Scalars["ID"]["input"];
  emails?: InputMaybe<
    Array<Scalars["String"]["input"]> | Scalars["String"]["input"]
  >;
  phones?: InputMaybe<
    Array<Scalars["String"]["input"]> | Scalars["String"]["input"]
  >;
}>;

export type CaseShareSendMutation = {
  __typename?: "Mutation";
  caseShareSend?: {
    __typename?: "CaseShareSendMutationPayload";
    errors: Array<string>;
    result?: { __typename?: "CaseShare"; id: string } | null;
  } | null;
};

export type ScreenCaseQueryVariables = Exact<{
  caseId: Scalars["ID"]["input"];
}>;

export type ScreenCaseQuery = {
  __typename?: "Query";
  case?:
    | { __typename?: "CleaningService"; id: string; type: CaseTypeEnum }
    | { __typename?: "CreateTenancy"; id: string; type: CaseTypeEnum }
    | { __typename?: "EndTenancy"; id: string; type: CaseTypeEnum }
    | {
        __typename?: "FindTenancyAdministration";
        id: string;
        type: CaseTypeEnum;
      }
    | { __typename?: "MiscAdministration"; id: string; type: CaseTypeEnum }
    | { __typename?: "MiscService"; id: string; type: CaseTypeEnum }
    | { __typename?: "MovingInService"; id: string; type: CaseTypeEnum }
    | { __typename?: "MovingInTenancy"; id: string; type: CaseTypeEnum }
    | { __typename?: "MovingOutService"; id: string; type: CaseTypeEnum }
    | { __typename?: "MovingOutTenancy"; id: string; type: CaseTypeEnum }
    | {
        __typename?: "MovingSettlementAdministration";
        id: string;
        type: CaseTypeEnum;
      }
    | { __typename?: "PreparationService"; id: string; type: CaseTypeEnum }
    | { __typename?: "RequestTenancy"; id: string; type: CaseTypeEnum }
    | { __typename?: "UtilityAdministration"; id: string; type: CaseTypeEnum }
    | null;
};

export type ScreenServiceCaseQueryVariables = Exact<{
  caseId: Scalars["ID"]["input"];
}>;

export type ScreenServiceCaseQuery = {
  __typename?: "Query";
  case?:
    | ({
        __typename: "CleaningService";
        canReceive: boolean;
        mayReceive: boolean;
        maySchedule: boolean;
        mayReschedule: boolean;
        mayCancelScheduled: boolean;
        canSchedule: boolean;
        canReschedule: boolean;
        canCancelScheduled: boolean;
        mayTenantWillAttendYes: boolean;
        mayTenantWillAttendNo: boolean;
        canTenantWillAttendYes: boolean;
        canTenantWillAttendNo: boolean;
        canChangeServiceTeam: boolean;
        mayChangeServiceTeam: boolean;
        canChangeTask: boolean;
        mayChangeTask: boolean;
        id: string;
        type: CaseTypeEnum;
        state: string;
        stateText: string;
        createdAt: any;
        stateLastChangedAt?: any | null;
        name: string;
        titleRaw?: string | null;
        body: string;
        icon: string;
        attention: CaseAttentionEnum;
        flaggedByCurrentUser: boolean;
        awaiting?: string | null;
        startAfter?: string | null;
        completeBefore?: string | null;
        scheduledDate?: string | null;
        scheduledTime?: string | null;
        tenantWillAttend?: boolean | null;
        isArchived: boolean;
        archivedAt?: any | null;
        cancelledMessage?: string | null;
        repeatSteps?: number | null;
        repeatPeriod?: string | null;
        repeatResponsible: boolean;
        repeating: boolean;
        tenantMayAttend: boolean;
        canUpdate: boolean;
        canComplete: boolean;
        mayComplete: boolean;
        canReopen: boolean;
        mayReopen: boolean;
        canCancel: boolean;
        mayCancel: boolean;
        canAddComment: boolean;
        mayAddComment: boolean;
        canAddTimelog: boolean;
        mayAddTimelog: boolean;
        canShowTimelogs: boolean;
        canAddFollower: boolean;
        mayAddFollower: boolean;
        canRemoveFollower: boolean;
        mayRemoveFollower: boolean;
        canAddAttachment: boolean;
        mayAddAttachment: boolean;
        canRemoveAttachment: boolean;
        mayRemoveAttachment: boolean;
        canChangeResponsible: boolean;
        mayChangeResponsible: boolean;
        canConfigureRepeat: boolean;
        mayConfigureRepeat: boolean;
        canToggleCheck: boolean;
        mayToggleCheck: boolean;
        canAwait: boolean;
        mayAwait: boolean;
        canShare: boolean;
        whyAttention: Array<{
          __typename?: "CaseAttentionCondition";
          texts: Array<string>;
        }>;
        archivedBy?: {
          __typename?: "CaseUser";
          id: string;
          name: string;
        } | null;
        tenancy?: {
          __typename?: "Tenancy";
          id: string;
          startDate: string;
          endDate?: string | null;
          user: { __typename?: "User"; id: string; name: string };
          roles: Array<{
            __typename?: "TenancyRole";
            user: {
              __typename?: "User";
              id: string;
              name: string;
              email: string;
              phone?: string | null;
              business: boolean;
              company?: string | null;
              showSensitiveInfo: boolean;
              cpr?: string | null;
              protected: boolean;
            };
          }>;
        } | null;
        apartment?: {
          __typename?: "Apartment";
          id: string;
          address: string;
          publicId: string;
          postalCode: string;
          city: string;
        } | null;
        property?: {
          __typename?: "Property";
          id: string;
          name: string;
          administrator: { __typename?: "Company"; id: string; name: string };
          owner: {
            __typename?: "Company";
            id: string;
            name: string;
            address?: string | null;
            postalCode?: string | null;
            city?: string | null;
            vat?: string | null;
          };
        } | null;
        requester?: {
          __typename?: "User";
          id: string;
          name: string;
          email: string;
        } | null;
        responsible?: {
          __typename?: "CaseUser";
          id: string;
          name: string;
        } | null;
        availableResponsibleUsers: Array<{
          __typename?: "CaseUser";
          id: string;
          name: string;
        }>;
        availableResponsibleTeams: Array<{
          __typename?: "AvailableResponsibleTeam";
          id: string;
          name: string;
          users: Array<{ __typename?: "CaseUser"; id: string; name: string }>;
        }>;
        serviceTeam?: {
          __typename?: "ServiceTeam";
          id: string;
          name: string;
        } | null;
        availableTeams: Array<
          | { __typename?: "AdministrationTeam"; id: string; name: string }
          | { __typename?: "ServiceTeam"; id: string; name: string }
        >;
        assignableServiceTeams: Array<{
          __typename?: "ServiceTeam";
          id: string;
          name: string;
        }>;
        parent?:
          | { __typename: "CleaningService"; id: string; displayName: string }
          | { __typename: "CreateTenancy"; id: string; displayName: string }
          | { __typename: "EndTenancy"; id: string; displayName: string }
          | {
              __typename: "FindTenancyAdministration";
              id: string;
              displayName: string;
            }
          | {
              __typename: "MiscAdministration";
              id: string;
              displayName: string;
            }
          | { __typename: "MiscService"; id: string; displayName: string }
          | { __typename: "MovingInService"; id: string; displayName: string }
          | { __typename: "MovingInTenancy"; id: string; displayName: string }
          | { __typename: "MovingOutService"; id: string; displayName: string }
          | { __typename: "MovingOutTenancy"; id: string; displayName: string }
          | {
              __typename: "MovingSettlementAdministration";
              id: string;
              displayName: string;
            }
          | {
              __typename: "PreparationService";
              id: string;
              displayName: string;
            }
          | {
              __typename: "RequestTenancy";
              startDate: any;
              endDate?: any | null;
              daysBetween?: string | null;
              numberOfResidents: number;
              comment?: string | null;
              id: string;
              displayName: string;
              apartment?: {
                __typename?: "Apartment";
                id: string;
                publicId: string;
                address: string;
              } | null;
              partnerProduct?: {
                __typename?: "PartnerProduct";
                name: string;
                partner: string;
              } | null;
              residents: Array<{
                __typename?: "Resident";
                name: string;
                email?: string | null;
                phone?: string | null;
              }>;
            }
          | {
              __typename: "UtilityAdministration";
              id: string;
              displayName: string;
            }
          | null;
        checks?: Array<{
          __typename?: "CaseCheck";
          id: string;
          label: string;
          value?: boolean | null;
          type: string;
        }> | null;
        comments: Array<{
          __typename?: "CaseComment";
          id: string;
          type: CaseCommentTypeEnum;
          subject?: string | null;
          message: string;
          smsMessage: boolean;
          emailMessage: boolean;
          createdAt: any;
          stateFrom?: string | null;
          stateTo?: string | null;
          stateDescription: string;
          important: boolean;
          readAt?: any | null;
          mayReply: boolean;
          sender: { __typename?: "User"; id: string; name: string };
          recipient?: { __typename?: "User"; id: string; name: string } | null;
          assets: Array<{
            __typename?: "File";
            id: string;
            fileName: string;
            url: string;
          }>;
        }>;
        commentUsers: Array<{
          __typename?: "CaseCommentUserOption";
          id: string;
          label: string;
        }>;
        attachments: Array<{
          __typename?: "CaseAttachment";
          id: string;
          fileName: string;
          fileType: string;
          fileSize: number;
          originalUrl: string;
          thumbUrl: string;
          largeUrl: string;
          isPdf: boolean;
          isImage: boolean;
          createdAt: any;
          category?: {
            __typename?: "AttachmentCategory";
            id: string;
            nameDa: string;
            nameEn: string;
          } | null;
        }>;
        timelogs: Array<{
          __typename?: "Timelog";
          id: string;
          date: any;
          hoursWithoutMinutes: number;
          minutesWithoutHours: number;
          note?: string | null;
          user: { __typename?: "User"; id: string; name: string };
          category: {
            __typename?: "TimelogCategory";
            id: string;
            name: string;
          };
          account: { __typename?: "TimelogAccount"; id: string; name: string };
        }>;
        timelogAccount?: {
          __typename?: "TimelogAccount";
          id: string;
          name: string;
          categories: Array<{
            __typename?: "TimelogCategory";
            id: string;
            name: string;
          }>;
        } | null;
        availableTimelogAccounts: Array<{
          __typename?: "TimelogAccount";
          id: string;
          name: string;
        }>;
        followers: Array<{
          __typename?: "Follower";
          id: string;
          user: { __typename?: "CaseUser"; id: string; name: string };
        }>;
        availableFollowers: Array<{
          __typename?: "CaseUser";
          id: string;
          name: string;
        }>;
      } & {
        " $fragmentRefs"?: {
          ServiceCaseScreen_CleaningService_Fragment: ServiceCaseScreen_CleaningService_Fragment;
        };
      })
    | ({
        __typename: "CreateTenancy";
        canCreateContract: boolean;
        mayCreateContract: boolean;
        canPopulateContract: boolean;
        mayPopulateContract: boolean;
        canChangeContract: boolean;
        mayChangeContract: boolean;
        canSendContract: boolean;
        maySendContract: boolean;
        canCancelContract: boolean;
        mayCancelContract: boolean;
        canLandlordSignContract: boolean;
        mayLandlordSignContract: boolean;
        mayTenantSignContract: boolean;
        canShowEndTenancyTerms: boolean;
        canUpdateEconomic: boolean;
        mayUpdateEconomic: boolean;
        hasEconomicAgreement: boolean;
        availableDebtorCount: number;
        canShowMovingInCaseResponsible: boolean;
        hasCompleteSettings: boolean;
        isContractIssued: boolean;
        daysBetween?: string | null;
        endTenancyTermsText?: string | null;
        intervalAmount?: number | null;
        depositAmount?: number | null;
        contractValues?: any | null;
        id: string;
        type: CaseTypeEnum;
        state: string;
        stateText: string;
        createdAt: any;
        stateLastChangedAt?: any | null;
        name: string;
        titleRaw?: string | null;
        body: string;
        icon: string;
        attention: CaseAttentionEnum;
        flaggedByCurrentUser: boolean;
        awaiting?: string | null;
        startAfter?: string | null;
        completeBefore?: string | null;
        scheduledDate?: string | null;
        scheduledTime?: string | null;
        tenantWillAttend?: boolean | null;
        isArchived: boolean;
        archivedAt?: any | null;
        cancelledMessage?: string | null;
        repeatSteps?: number | null;
        repeatPeriod?: string | null;
        repeatResponsible: boolean;
        repeating: boolean;
        tenantMayAttend: boolean;
        canUpdate: boolean;
        canComplete: boolean;
        mayComplete: boolean;
        canReopen: boolean;
        mayReopen: boolean;
        canCancel: boolean;
        mayCancel: boolean;
        canAddComment: boolean;
        mayAddComment: boolean;
        canAddTimelog: boolean;
        mayAddTimelog: boolean;
        canShowTimelogs: boolean;
        canAddFollower: boolean;
        mayAddFollower: boolean;
        canRemoveFollower: boolean;
        mayRemoveFollower: boolean;
        canAddAttachment: boolean;
        mayAddAttachment: boolean;
        canRemoveAttachment: boolean;
        mayRemoveAttachment: boolean;
        canChangeResponsible: boolean;
        mayChangeResponsible: boolean;
        canConfigureRepeat: boolean;
        mayConfigureRepeat: boolean;
        canToggleCheck: boolean;
        mayToggleCheck: boolean;
        canAwait: boolean;
        mayAwait: boolean;
        canShare: boolean;
        signatures: Array<{
          __typename?: "CaseSignature";
          signature?: string | null;
          signedAt: any;
          signedBy?: string | null;
          signerRole: string;
        }>;
        economicDebtor?: {
          __typename?: "EconomicDebtor";
          id: string;
          name: string;
        } | null;
        movingInCase?: {
          __typename?: "MovingInTenancy";
          id: string;
          stateText: string;
          responsible?: {
            __typename?: "CaseUser";
            id: string;
            name: string;
          } | null;
          property?: {
            __typename?: "Property";
            id: string;
            administrator: { __typename?: "Company"; id: string; name: string };
          } | null;
        } | null;
        contract?: { __typename?: "Document"; id: string; url: string } | null;
        contractSettings: {
          __typename?: "CaseContractSettings";
          apartment?: string | null;
          type?: ContractTypeEnum | null;
          startDate?: any | null;
          endDate?: any | null;
          endTenancyTerms?: EndTenancyTermsEnum | null;
          locale?: ContractLocaleEnum | null;
          residents: Array<{
            __typename?: "Resident";
            name: string;
            email?: string | null;
            phone?: string | null;
          }>;
          tenancyRoles: Array<{
            __typename?: "CaseContractRole";
            email?: string | null;
            primary: boolean;
          }>;
        };
        availableTemplates: Array<{
          __typename?: "DocumentTemplate";
          id: string;
          name: string;
        }>;
        contractForm?: {
          __typename?: "ContractForm";
          type: string;
          sections: Array<{
            __typename?: "ContractFormSection";
            key: string;
            title?: string | null;
            repeating: boolean;
            ordered: boolean;
            fields: Array<{
              __typename?: "ContractFormField";
              name: string;
              type: ContractFieldTypeEnum;
              multiline: boolean;
              required: boolean;
              label?: string | null;
              currency: boolean;
              readonly: boolean;
              suffix?: string | null;
              computed?: any | null;
              follows?: string | null;
              options: Array<{
                __typename?: "ContractFormOption";
                value: string;
                label?: string | null;
              }>;
              condition?: {
                __typename?: "ContractFormCondition";
                field: string;
                is: string;
              } | null;
              requiredWhen?: {
                __typename?: "ContractFormCondition";
                field: string;
                is: string;
              } | null;
            }>;
          }>;
        } | null;
        whyAttention: Array<{
          __typename?: "CaseAttentionCondition";
          texts: Array<string>;
        }>;
        archivedBy?: {
          __typename?: "CaseUser";
          id: string;
          name: string;
        } | null;
        tenancy?: {
          __typename?: "Tenancy";
          id: string;
          startDate: string;
          endDate?: string | null;
          user: { __typename?: "User"; id: string; name: string };
          roles: Array<{
            __typename?: "TenancyRole";
            user: {
              __typename?: "User";
              id: string;
              name: string;
              email: string;
              phone?: string | null;
              business: boolean;
              company?: string | null;
              showSensitiveInfo: boolean;
              cpr?: string | null;
              protected: boolean;
            };
          }>;
        } | null;
        apartment?: {
          __typename?: "Apartment";
          id: string;
          address: string;
          publicId: string;
          postalCode: string;
          city: string;
        } | null;
        property?: {
          __typename?: "Property";
          id: string;
          name: string;
          administrator: { __typename?: "Company"; id: string; name: string };
          owner: {
            __typename?: "Company";
            id: string;
            name: string;
            address?: string | null;
            postalCode?: string | null;
            city?: string | null;
            vat?: string | null;
          };
        } | null;
        requester?: {
          __typename?: "User";
          id: string;
          name: string;
          email: string;
        } | null;
        responsible?: {
          __typename?: "CaseUser";
          id: string;
          name: string;
        } | null;
        availableResponsibleUsers: Array<{
          __typename?: "CaseUser";
          id: string;
          name: string;
        }>;
        availableResponsibleTeams: Array<{
          __typename?: "AvailableResponsibleTeam";
          id: string;
          name: string;
          users: Array<{ __typename?: "CaseUser"; id: string; name: string }>;
        }>;
        serviceTeam?: {
          __typename?: "ServiceTeam";
          id: string;
          name: string;
        } | null;
        availableTeams: Array<
          | { __typename?: "AdministrationTeam"; id: string; name: string }
          | { __typename?: "ServiceTeam"; id: string; name: string }
        >;
        assignableServiceTeams: Array<{
          __typename?: "ServiceTeam";
          id: string;
          name: string;
        }>;
        parent?:
          | { __typename: "CleaningService"; id: string; displayName: string }
          | { __typename: "CreateTenancy"; id: string; displayName: string }
          | { __typename: "EndTenancy"; id: string; displayName: string }
          | {
              __typename: "FindTenancyAdministration";
              id: string;
              displayName: string;
            }
          | {
              __typename: "MiscAdministration";
              id: string;
              displayName: string;
            }
          | { __typename: "MiscService"; id: string; displayName: string }
          | { __typename: "MovingInService"; id: string; displayName: string }
          | { __typename: "MovingInTenancy"; id: string; displayName: string }
          | { __typename: "MovingOutService"; id: string; displayName: string }
          | { __typename: "MovingOutTenancy"; id: string; displayName: string }
          | {
              __typename: "MovingSettlementAdministration";
              id: string;
              displayName: string;
            }
          | {
              __typename: "PreparationService";
              id: string;
              displayName: string;
            }
          | {
              __typename: "RequestTenancy";
              startDate: any;
              endDate?: any | null;
              daysBetween?: string | null;
              numberOfResidents: number;
              comment?: string | null;
              id: string;
              displayName: string;
              apartment?: {
                __typename?: "Apartment";
                id: string;
                publicId: string;
                address: string;
              } | null;
              partnerProduct?: {
                __typename?: "PartnerProduct";
                name: string;
                partner: string;
              } | null;
              residents: Array<{
                __typename?: "Resident";
                name: string;
                email?: string | null;
                phone?: string | null;
              }>;
            }
          | {
              __typename: "UtilityAdministration";
              id: string;
              displayName: string;
            }
          | null;
        checks?: Array<{
          __typename?: "CaseCheck";
          id: string;
          label: string;
          value?: boolean | null;
          type: string;
        }> | null;
        comments: Array<{
          __typename?: "CaseComment";
          id: string;
          type: CaseCommentTypeEnum;
          subject?: string | null;
          message: string;
          smsMessage: boolean;
          emailMessage: boolean;
          createdAt: any;
          stateFrom?: string | null;
          stateTo?: string | null;
          stateDescription: string;
          important: boolean;
          readAt?: any | null;
          mayReply: boolean;
          sender: { __typename?: "User"; id: string; name: string };
          recipient?: { __typename?: "User"; id: string; name: string } | null;
          assets: Array<{
            __typename?: "File";
            id: string;
            fileName: string;
            url: string;
          }>;
        }>;
        commentUsers: Array<{
          __typename?: "CaseCommentUserOption";
          id: string;
          label: string;
        }>;
        attachments: Array<{
          __typename?: "CaseAttachment";
          id: string;
          fileName: string;
          fileType: string;
          fileSize: number;
          originalUrl: string;
          thumbUrl: string;
          largeUrl: string;
          isPdf: boolean;
          isImage: boolean;
          createdAt: any;
          category?: {
            __typename?: "AttachmentCategory";
            id: string;
            nameDa: string;
            nameEn: string;
          } | null;
        }>;
        timelogs: Array<{
          __typename?: "Timelog";
          id: string;
          date: any;
          hoursWithoutMinutes: number;
          minutesWithoutHours: number;
          note?: string | null;
          user: { __typename?: "User"; id: string; name: string };
          category: {
            __typename?: "TimelogCategory";
            id: string;
            name: string;
          };
          account: { __typename?: "TimelogAccount"; id: string; name: string };
        }>;
        timelogAccount?: {
          __typename?: "TimelogAccount";
          id: string;
          name: string;
          categories: Array<{
            __typename?: "TimelogCategory";
            id: string;
            name: string;
          }>;
        } | null;
        availableTimelogAccounts: Array<{
          __typename?: "TimelogAccount";
          id: string;
          name: string;
        }>;
        followers: Array<{
          __typename?: "Follower";
          id: string;
          user: { __typename?: "CaseUser"; id: string; name: string };
        }>;
        availableFollowers: Array<{
          __typename?: "CaseUser";
          id: string;
          name: string;
        }>;
      } & {
        " $fragmentRefs"?: {
          ServiceCaseScreen_CreateTenancy_Fragment: ServiceCaseScreen_CreateTenancy_Fragment;
        };
      })
    | ({
        __typename: "EndTenancy";
        endDate?: any | null;
        earlyEndDate: boolean;
        endDateByTerms?: any | null;
        comment?: string | null;
        cancelled: boolean;
        endDateChanged: boolean;
        applicationEndDate?: any | null;
        lastRentDate?: any | null;
        leaveDate?: any | null;
        canReceive: boolean;
        mayReceive: boolean;
        canChangeEndDate: boolean;
        mayChangeEndDate: boolean;
        canUpdateReasons: boolean;
        mayUpdateReasons: boolean;
        canShowMovingOutCase: boolean;
        canShowMovingOutCaseResponsible: boolean;
        id: string;
        type: CaseTypeEnum;
        state: string;
        stateText: string;
        createdAt: any;
        stateLastChangedAt?: any | null;
        name: string;
        titleRaw?: string | null;
        body: string;
        icon: string;
        attention: CaseAttentionEnum;
        flaggedByCurrentUser: boolean;
        awaiting?: string | null;
        startAfter?: string | null;
        completeBefore?: string | null;
        scheduledDate?: string | null;
        scheduledTime?: string | null;
        tenantWillAttend?: boolean | null;
        isArchived: boolean;
        archivedAt?: any | null;
        cancelledMessage?: string | null;
        repeatSteps?: number | null;
        repeatPeriod?: string | null;
        repeatResponsible: boolean;
        repeating: boolean;
        tenantMayAttend: boolean;
        canUpdate: boolean;
        canComplete: boolean;
        mayComplete: boolean;
        canReopen: boolean;
        mayReopen: boolean;
        canCancel: boolean;
        mayCancel: boolean;
        canAddComment: boolean;
        mayAddComment: boolean;
        canAddTimelog: boolean;
        mayAddTimelog: boolean;
        canShowTimelogs: boolean;
        canAddFollower: boolean;
        mayAddFollower: boolean;
        canRemoveFollower: boolean;
        mayRemoveFollower: boolean;
        canAddAttachment: boolean;
        mayAddAttachment: boolean;
        canRemoveAttachment: boolean;
        mayRemoveAttachment: boolean;
        canChangeResponsible: boolean;
        mayChangeResponsible: boolean;
        canConfigureRepeat: boolean;
        mayConfigureRepeat: boolean;
        canToggleCheck: boolean;
        mayToggleCheck: boolean;
        canAwait: boolean;
        mayAwait: boolean;
        canShare: boolean;
        reasons: Array<{
          __typename?: "EndTenancyReasonSelection";
          id: string;
          label: string;
          note?: string | null;
        }>;
        tenancy?: {
          __typename?: "Tenancy";
          id: string;
          startDate: string;
          endDate?: string | null;
          movingOutCase?: {
            __typename?: "Case";
            id: string;
            state: string;
            stateText: string;
            responsible?: { __typename?: "User"; name: string } | null;
            property?: {
              __typename?: "Property";
              administrator: { __typename?: "Company"; name: string };
            } | null;
          } | null;
          user: { __typename?: "User"; id: string; name: string };
          roles: Array<{
            __typename?: "TenancyRole";
            user: {
              __typename?: "User";
              id: string;
              name: string;
              email: string;
              phone?: string | null;
              business: boolean;
              company?: string | null;
              showSensitiveInfo: boolean;
              cpr?: string | null;
              protected: boolean;
            };
          }>;
        } | null;
        whyAttention: Array<{
          __typename?: "CaseAttentionCondition";
          texts: Array<string>;
        }>;
        archivedBy?: {
          __typename?: "CaseUser";
          id: string;
          name: string;
        } | null;
        apartment?: {
          __typename?: "Apartment";
          id: string;
          address: string;
          publicId: string;
          postalCode: string;
          city: string;
        } | null;
        property?: {
          __typename?: "Property";
          id: string;
          name: string;
          administrator: { __typename?: "Company"; id: string; name: string };
          owner: {
            __typename?: "Company";
            id: string;
            name: string;
            address?: string | null;
            postalCode?: string | null;
            city?: string | null;
            vat?: string | null;
          };
        } | null;
        requester?: {
          __typename?: "User";
          id: string;
          name: string;
          email: string;
        } | null;
        responsible?: {
          __typename?: "CaseUser";
          id: string;
          name: string;
        } | null;
        availableResponsibleUsers: Array<{
          __typename?: "CaseUser";
          id: string;
          name: string;
        }>;
        availableResponsibleTeams: Array<{
          __typename?: "AvailableResponsibleTeam";
          id: string;
          name: string;
          users: Array<{ __typename?: "CaseUser"; id: string; name: string }>;
        }>;
        serviceTeam?: {
          __typename?: "ServiceTeam";
          id: string;
          name: string;
        } | null;
        availableTeams: Array<
          | { __typename?: "AdministrationTeam"; id: string; name: string }
          | { __typename?: "ServiceTeam"; id: string; name: string }
        >;
        assignableServiceTeams: Array<{
          __typename?: "ServiceTeam";
          id: string;
          name: string;
        }>;
        parent?:
          | { __typename: "CleaningService"; id: string; displayName: string }
          | { __typename: "CreateTenancy"; id: string; displayName: string }
          | { __typename: "EndTenancy"; id: string; displayName: string }
          | {
              __typename: "FindTenancyAdministration";
              id: string;
              displayName: string;
            }
          | {
              __typename: "MiscAdministration";
              id: string;
              displayName: string;
            }
          | { __typename: "MiscService"; id: string; displayName: string }
          | { __typename: "MovingInService"; id: string; displayName: string }
          | { __typename: "MovingInTenancy"; id: string; displayName: string }
          | { __typename: "MovingOutService"; id: string; displayName: string }
          | { __typename: "MovingOutTenancy"; id: string; displayName: string }
          | {
              __typename: "MovingSettlementAdministration";
              id: string;
              displayName: string;
            }
          | {
              __typename: "PreparationService";
              id: string;
              displayName: string;
            }
          | {
              __typename: "RequestTenancy";
              startDate: any;
              endDate?: any | null;
              daysBetween?: string | null;
              numberOfResidents: number;
              comment?: string | null;
              id: string;
              displayName: string;
              apartment?: {
                __typename?: "Apartment";
                id: string;
                publicId: string;
                address: string;
              } | null;
              partnerProduct?: {
                __typename?: "PartnerProduct";
                name: string;
                partner: string;
              } | null;
              residents: Array<{
                __typename?: "Resident";
                name: string;
                email?: string | null;
                phone?: string | null;
              }>;
            }
          | {
              __typename: "UtilityAdministration";
              id: string;
              displayName: string;
            }
          | null;
        checks?: Array<{
          __typename?: "CaseCheck";
          id: string;
          label: string;
          value?: boolean | null;
          type: string;
        }> | null;
        comments: Array<{
          __typename?: "CaseComment";
          id: string;
          type: CaseCommentTypeEnum;
          subject?: string | null;
          message: string;
          smsMessage: boolean;
          emailMessage: boolean;
          createdAt: any;
          stateFrom?: string | null;
          stateTo?: string | null;
          stateDescription: string;
          important: boolean;
          readAt?: any | null;
          mayReply: boolean;
          sender: { __typename?: "User"; id: string; name: string };
          recipient?: { __typename?: "User"; id: string; name: string } | null;
          assets: Array<{
            __typename?: "File";
            id: string;
            fileName: string;
            url: string;
          }>;
        }>;
        commentUsers: Array<{
          __typename?: "CaseCommentUserOption";
          id: string;
          label: string;
        }>;
        attachments: Array<{
          __typename?: "CaseAttachment";
          id: string;
          fileName: string;
          fileType: string;
          fileSize: number;
          originalUrl: string;
          thumbUrl: string;
          largeUrl: string;
          isPdf: boolean;
          isImage: boolean;
          createdAt: any;
          category?: {
            __typename?: "AttachmentCategory";
            id: string;
            nameDa: string;
            nameEn: string;
          } | null;
        }>;
        timelogs: Array<{
          __typename?: "Timelog";
          id: string;
          date: any;
          hoursWithoutMinutes: number;
          minutesWithoutHours: number;
          note?: string | null;
          user: { __typename?: "User"; id: string; name: string };
          category: {
            __typename?: "TimelogCategory";
            id: string;
            name: string;
          };
          account: { __typename?: "TimelogAccount"; id: string; name: string };
        }>;
        timelogAccount?: {
          __typename?: "TimelogAccount";
          id: string;
          name: string;
          categories: Array<{
            __typename?: "TimelogCategory";
            id: string;
            name: string;
          }>;
        } | null;
        availableTimelogAccounts: Array<{
          __typename?: "TimelogAccount";
          id: string;
          name: string;
        }>;
        followers: Array<{
          __typename?: "Follower";
          id: string;
          user: { __typename?: "CaseUser"; id: string; name: string };
        }>;
        availableFollowers: Array<{
          __typename?: "CaseUser";
          id: string;
          name: string;
        }>;
      } & {
        " $fragmentRefs"?: {
          ServiceCaseScreen_EndTenancy_Fragment: ServiceCaseScreen_EndTenancy_Fragment;
        };
      })
    | ({
        __typename: "FindTenancyAdministration";
        intervalAmount?: number | null;
        depositAmount?: number | null;
        canShowRentInfo: boolean;
        canReceive: boolean;
        mayReceive: boolean;
        canReopen: boolean;
        mayReopen: boolean;
        canChangeTask: boolean;
        mayChangeTask: boolean;
        id: string;
        type: CaseTypeEnum;
        state: string;
        stateText: string;
        createdAt: any;
        stateLastChangedAt?: any | null;
        name: string;
        titleRaw?: string | null;
        body: string;
        icon: string;
        attention: CaseAttentionEnum;
        flaggedByCurrentUser: boolean;
        awaiting?: string | null;
        startAfter?: string | null;
        completeBefore?: string | null;
        scheduledDate?: string | null;
        scheduledTime?: string | null;
        tenantWillAttend?: boolean | null;
        isArchived: boolean;
        archivedAt?: any | null;
        cancelledMessage?: string | null;
        repeatSteps?: number | null;
        repeatPeriod?: string | null;
        repeatResponsible: boolean;
        repeating: boolean;
        tenantMayAttend: boolean;
        canUpdate: boolean;
        canComplete: boolean;
        mayComplete: boolean;
        canCancel: boolean;
        mayCancel: boolean;
        canAddComment: boolean;
        mayAddComment: boolean;
        canAddTimelog: boolean;
        mayAddTimelog: boolean;
        canShowTimelogs: boolean;
        canAddFollower: boolean;
        mayAddFollower: boolean;
        canRemoveFollower: boolean;
        mayRemoveFollower: boolean;
        canAddAttachment: boolean;
        mayAddAttachment: boolean;
        canRemoveAttachment: boolean;
        mayRemoveAttachment: boolean;
        canChangeResponsible: boolean;
        mayChangeResponsible: boolean;
        canConfigureRepeat: boolean;
        mayConfigureRepeat: boolean;
        canToggleCheck: boolean;
        mayToggleCheck: boolean;
        canAwait: boolean;
        mayAwait: boolean;
        canShare: boolean;
        findTenancyStartDate?: any | null;
        whyAttention: Array<{
          __typename?: "CaseAttentionCondition";
          texts: Array<string>;
        }>;
        archivedBy?: {
          __typename?: "CaseUser";
          id: string;
          name: string;
        } | null;
        tenancy?: {
          __typename?: "Tenancy";
          id: string;
          startDate: string;
          endDate?: string | null;
          user: { __typename?: "User"; id: string; name: string };
          roles: Array<{
            __typename?: "TenancyRole";
            user: {
              __typename?: "User";
              id: string;
              name: string;
              email: string;
              phone?: string | null;
              business: boolean;
              company?: string | null;
              showSensitiveInfo: boolean;
              cpr?: string | null;
              protected: boolean;
            };
          }>;
        } | null;
        apartment?: {
          __typename?: "Apartment";
          id: string;
          address: string;
          publicId: string;
          postalCode: string;
          city: string;
        } | null;
        property?: {
          __typename?: "Property";
          id: string;
          name: string;
          administrator: { __typename?: "Company"; id: string; name: string };
          owner: {
            __typename?: "Company";
            id: string;
            name: string;
            address?: string | null;
            postalCode?: string | null;
            city?: string | null;
            vat?: string | null;
          };
        } | null;
        requester?: {
          __typename?: "User";
          id: string;
          name: string;
          email: string;
        } | null;
        responsible?: {
          __typename?: "CaseUser";
          id: string;
          name: string;
        } | null;
        availableResponsibleUsers: Array<{
          __typename?: "CaseUser";
          id: string;
          name: string;
        }>;
        availableResponsibleTeams: Array<{
          __typename?: "AvailableResponsibleTeam";
          id: string;
          name: string;
          users: Array<{ __typename?: "CaseUser"; id: string; name: string }>;
        }>;
        serviceTeam?: {
          __typename?: "ServiceTeam";
          id: string;
          name: string;
        } | null;
        availableTeams: Array<
          | { __typename?: "AdministrationTeam"; id: string; name: string }
          | { __typename?: "ServiceTeam"; id: string; name: string }
        >;
        assignableServiceTeams: Array<{
          __typename?: "ServiceTeam";
          id: string;
          name: string;
        }>;
        parent?:
          | { __typename: "CleaningService"; id: string; displayName: string }
          | { __typename: "CreateTenancy"; id: string; displayName: string }
          | { __typename: "EndTenancy"; id: string; displayName: string }
          | {
              __typename: "FindTenancyAdministration";
              id: string;
              displayName: string;
            }
          | {
              __typename: "MiscAdministration";
              id: string;
              displayName: string;
            }
          | { __typename: "MiscService"; id: string; displayName: string }
          | { __typename: "MovingInService"; id: string; displayName: string }
          | { __typename: "MovingInTenancy"; id: string; displayName: string }
          | { __typename: "MovingOutService"; id: string; displayName: string }
          | { __typename: "MovingOutTenancy"; id: string; displayName: string }
          | {
              __typename: "MovingSettlementAdministration";
              id: string;
              displayName: string;
            }
          | {
              __typename: "PreparationService";
              id: string;
              displayName: string;
            }
          | {
              __typename: "RequestTenancy";
              startDate: any;
              endDate?: any | null;
              daysBetween?: string | null;
              numberOfResidents: number;
              comment?: string | null;
              id: string;
              displayName: string;
              apartment?: {
                __typename?: "Apartment";
                id: string;
                publicId: string;
                address: string;
              } | null;
              partnerProduct?: {
                __typename?: "PartnerProduct";
                name: string;
                partner: string;
              } | null;
              residents: Array<{
                __typename?: "Resident";
                name: string;
                email?: string | null;
                phone?: string | null;
              }>;
            }
          | {
              __typename: "UtilityAdministration";
              id: string;
              displayName: string;
            }
          | null;
        checks?: Array<{
          __typename?: "CaseCheck";
          id: string;
          label: string;
          value?: boolean | null;
          type: string;
        }> | null;
        comments: Array<{
          __typename?: "CaseComment";
          id: string;
          type: CaseCommentTypeEnum;
          subject?: string | null;
          message: string;
          smsMessage: boolean;
          emailMessage: boolean;
          createdAt: any;
          stateFrom?: string | null;
          stateTo?: string | null;
          stateDescription: string;
          important: boolean;
          readAt?: any | null;
          mayReply: boolean;
          sender: { __typename?: "User"; id: string; name: string };
          recipient?: { __typename?: "User"; id: string; name: string } | null;
          assets: Array<{
            __typename?: "File";
            id: string;
            fileName: string;
            url: string;
          }>;
        }>;
        commentUsers: Array<{
          __typename?: "CaseCommentUserOption";
          id: string;
          label: string;
        }>;
        attachments: Array<{
          __typename?: "CaseAttachment";
          id: string;
          fileName: string;
          fileType: string;
          fileSize: number;
          originalUrl: string;
          thumbUrl: string;
          largeUrl: string;
          isPdf: boolean;
          isImage: boolean;
          createdAt: any;
          category?: {
            __typename?: "AttachmentCategory";
            id: string;
            nameDa: string;
            nameEn: string;
          } | null;
        }>;
        timelogs: Array<{
          __typename?: "Timelog";
          id: string;
          date: any;
          hoursWithoutMinutes: number;
          minutesWithoutHours: number;
          note?: string | null;
          user: { __typename?: "User"; id: string; name: string };
          category: {
            __typename?: "TimelogCategory";
            id: string;
            name: string;
          };
          account: { __typename?: "TimelogAccount"; id: string; name: string };
        }>;
        timelogAccount?: {
          __typename?: "TimelogAccount";
          id: string;
          name: string;
          categories: Array<{
            __typename?: "TimelogCategory";
            id: string;
            name: string;
          }>;
        } | null;
        availableTimelogAccounts: Array<{
          __typename?: "TimelogAccount";
          id: string;
          name: string;
        }>;
        followers: Array<{
          __typename?: "Follower";
          id: string;
          user: { __typename?: "CaseUser"; id: string; name: string };
        }>;
        availableFollowers: Array<{
          __typename?: "CaseUser";
          id: string;
          name: string;
        }>;
      } & {
        " $fragmentRefs"?: {
          ServiceCaseScreen_FindTenancyAdministration_Fragment: ServiceCaseScreen_FindTenancyAdministration_Fragment;
        };
      })
    | ({
        __typename: "MiscAdministration";
        canStart: boolean;
        mayStart: boolean;
        canChangeTask: boolean;
        mayChangeTask: boolean;
        id: string;
        type: CaseTypeEnum;
        state: string;
        stateText: string;
        createdAt: any;
        stateLastChangedAt?: any | null;
        name: string;
        titleRaw?: string | null;
        body: string;
        icon: string;
        attention: CaseAttentionEnum;
        flaggedByCurrentUser: boolean;
        awaiting?: string | null;
        startAfter?: string | null;
        completeBefore?: string | null;
        scheduledDate?: string | null;
        scheduledTime?: string | null;
        tenantWillAttend?: boolean | null;
        isArchived: boolean;
        archivedAt?: any | null;
        cancelledMessage?: string | null;
        repeatSteps?: number | null;
        repeatPeriod?: string | null;
        repeatResponsible: boolean;
        repeating: boolean;
        tenantMayAttend: boolean;
        canUpdate: boolean;
        canComplete: boolean;
        mayComplete: boolean;
        canReopen: boolean;
        mayReopen: boolean;
        canCancel: boolean;
        mayCancel: boolean;
        canAddComment: boolean;
        mayAddComment: boolean;
        canAddTimelog: boolean;
        mayAddTimelog: boolean;
        canShowTimelogs: boolean;
        canAddFollower: boolean;
        mayAddFollower: boolean;
        canRemoveFollower: boolean;
        mayRemoveFollower: boolean;
        canAddAttachment: boolean;
        mayAddAttachment: boolean;
        canRemoveAttachment: boolean;
        mayRemoveAttachment: boolean;
        canChangeResponsible: boolean;
        mayChangeResponsible: boolean;
        canConfigureRepeat: boolean;
        mayConfigureRepeat: boolean;
        canToggleCheck: boolean;
        mayToggleCheck: boolean;
        canAwait: boolean;
        mayAwait: boolean;
        canShare: boolean;
        whyAttention: Array<{
          __typename?: "CaseAttentionCondition";
          texts: Array<string>;
        }>;
        archivedBy?: {
          __typename?: "CaseUser";
          id: string;
          name: string;
        } | null;
        tenancy?: {
          __typename?: "Tenancy";
          id: string;
          startDate: string;
          endDate?: string | null;
          user: { __typename?: "User"; id: string; name: string };
          roles: Array<{
            __typename?: "TenancyRole";
            user: {
              __typename?: "User";
              id: string;
              name: string;
              email: string;
              phone?: string | null;
              business: boolean;
              company?: string | null;
              showSensitiveInfo: boolean;
              cpr?: string | null;
              protected: boolean;
            };
          }>;
        } | null;
        apartment?: {
          __typename?: "Apartment";
          id: string;
          address: string;
          publicId: string;
          postalCode: string;
          city: string;
        } | null;
        property?: {
          __typename?: "Property";
          id: string;
          name: string;
          administrator: { __typename?: "Company"; id: string; name: string };
          owner: {
            __typename?: "Company";
            id: string;
            name: string;
            address?: string | null;
            postalCode?: string | null;
            city?: string | null;
            vat?: string | null;
          };
        } | null;
        requester?: {
          __typename?: "User";
          id: string;
          name: string;
          email: string;
        } | null;
        responsible?: {
          __typename?: "CaseUser";
          id: string;
          name: string;
        } | null;
        availableResponsibleUsers: Array<{
          __typename?: "CaseUser";
          id: string;
          name: string;
        }>;
        availableResponsibleTeams: Array<{
          __typename?: "AvailableResponsibleTeam";
          id: string;
          name: string;
          users: Array<{ __typename?: "CaseUser"; id: string; name: string }>;
        }>;
        serviceTeam?: {
          __typename?: "ServiceTeam";
          id: string;
          name: string;
        } | null;
        availableTeams: Array<
          | { __typename?: "AdministrationTeam"; id: string; name: string }
          | { __typename?: "ServiceTeam"; id: string; name: string }
        >;
        assignableServiceTeams: Array<{
          __typename?: "ServiceTeam";
          id: string;
          name: string;
        }>;
        parent?:
          | { __typename: "CleaningService"; id: string; displayName: string }
          | { __typename: "CreateTenancy"; id: string; displayName: string }
          | { __typename: "EndTenancy"; id: string; displayName: string }
          | {
              __typename: "FindTenancyAdministration";
              id: string;
              displayName: string;
            }
          | {
              __typename: "MiscAdministration";
              id: string;
              displayName: string;
            }
          | { __typename: "MiscService"; id: string; displayName: string }
          | { __typename: "MovingInService"; id: string; displayName: string }
          | { __typename: "MovingInTenancy"; id: string; displayName: string }
          | { __typename: "MovingOutService"; id: string; displayName: string }
          | { __typename: "MovingOutTenancy"; id: string; displayName: string }
          | {
              __typename: "MovingSettlementAdministration";
              id: string;
              displayName: string;
            }
          | {
              __typename: "PreparationService";
              id: string;
              displayName: string;
            }
          | {
              __typename: "RequestTenancy";
              startDate: any;
              endDate?: any | null;
              daysBetween?: string | null;
              numberOfResidents: number;
              comment?: string | null;
              id: string;
              displayName: string;
              apartment?: {
                __typename?: "Apartment";
                id: string;
                publicId: string;
                address: string;
              } | null;
              partnerProduct?: {
                __typename?: "PartnerProduct";
                name: string;
                partner: string;
              } | null;
              residents: Array<{
                __typename?: "Resident";
                name: string;
                email?: string | null;
                phone?: string | null;
              }>;
            }
          | {
              __typename: "UtilityAdministration";
              id: string;
              displayName: string;
            }
          | null;
        checks?: Array<{
          __typename?: "CaseCheck";
          id: string;
          label: string;
          value?: boolean | null;
          type: string;
        }> | null;
        comments: Array<{
          __typename?: "CaseComment";
          id: string;
          type: CaseCommentTypeEnum;
          subject?: string | null;
          message: string;
          smsMessage: boolean;
          emailMessage: boolean;
          createdAt: any;
          stateFrom?: string | null;
          stateTo?: string | null;
          stateDescription: string;
          important: boolean;
          readAt?: any | null;
          mayReply: boolean;
          sender: { __typename?: "User"; id: string; name: string };
          recipient?: { __typename?: "User"; id: string; name: string } | null;
          assets: Array<{
            __typename?: "File";
            id: string;
            fileName: string;
            url: string;
          }>;
        }>;
        commentUsers: Array<{
          __typename?: "CaseCommentUserOption";
          id: string;
          label: string;
        }>;
        attachments: Array<{
          __typename?: "CaseAttachment";
          id: string;
          fileName: string;
          fileType: string;
          fileSize: number;
          originalUrl: string;
          thumbUrl: string;
          largeUrl: string;
          isPdf: boolean;
          isImage: boolean;
          createdAt: any;
          category?: {
            __typename?: "AttachmentCategory";
            id: string;
            nameDa: string;
            nameEn: string;
          } | null;
        }>;
        timelogs: Array<{
          __typename?: "Timelog";
          id: string;
          date: any;
          hoursWithoutMinutes: number;
          minutesWithoutHours: number;
          note?: string | null;
          user: { __typename?: "User"; id: string; name: string };
          category: {
            __typename?: "TimelogCategory";
            id: string;
            name: string;
          };
          account: { __typename?: "TimelogAccount"; id: string; name: string };
        }>;
        timelogAccount?: {
          __typename?: "TimelogAccount";
          id: string;
          name: string;
          categories: Array<{
            __typename?: "TimelogCategory";
            id: string;
            name: string;
          }>;
        } | null;
        availableTimelogAccounts: Array<{
          __typename?: "TimelogAccount";
          id: string;
          name: string;
        }>;
        followers: Array<{
          __typename?: "Follower";
          id: string;
          user: { __typename?: "CaseUser"; id: string; name: string };
        }>;
        availableFollowers: Array<{
          __typename?: "CaseUser";
          id: string;
          name: string;
        }>;
      } & {
        " $fragmentRefs"?: {
          ServiceCaseScreen_MiscAdministration_Fragment: ServiceCaseScreen_MiscAdministration_Fragment;
        };
      })
    | ({
        __typename: "MiscService";
        canReceive: boolean;
        mayReceive: boolean;
        maySchedule: boolean;
        mayReschedule: boolean;
        mayCancelScheduled: boolean;
        canSchedule: boolean;
        canReschedule: boolean;
        canCancelScheduled: boolean;
        mayTenantWillAttendYes: boolean;
        mayTenantWillAttendNo: boolean;
        canTenantWillAttendYes: boolean;
        canTenantWillAttendNo: boolean;
        canChangeServiceTeam: boolean;
        mayChangeServiceTeam: boolean;
        canChangeTask: boolean;
        mayChangeTask: boolean;
        id: string;
        type: CaseTypeEnum;
        state: string;
        stateText: string;
        createdAt: any;
        stateLastChangedAt?: any | null;
        name: string;
        titleRaw?: string | null;
        body: string;
        icon: string;
        attention: CaseAttentionEnum;
        flaggedByCurrentUser: boolean;
        awaiting?: string | null;
        startAfter?: string | null;
        completeBefore?: string | null;
        scheduledDate?: string | null;
        scheduledTime?: string | null;
        tenantWillAttend?: boolean | null;
        isArchived: boolean;
        archivedAt?: any | null;
        cancelledMessage?: string | null;
        repeatSteps?: number | null;
        repeatPeriod?: string | null;
        repeatResponsible: boolean;
        repeating: boolean;
        tenantMayAttend: boolean;
        canUpdate: boolean;
        canComplete: boolean;
        mayComplete: boolean;
        canReopen: boolean;
        mayReopen: boolean;
        canCancel: boolean;
        mayCancel: boolean;
        canAddComment: boolean;
        mayAddComment: boolean;
        canAddTimelog: boolean;
        mayAddTimelog: boolean;
        canShowTimelogs: boolean;
        canAddFollower: boolean;
        mayAddFollower: boolean;
        canRemoveFollower: boolean;
        mayRemoveFollower: boolean;
        canAddAttachment: boolean;
        mayAddAttachment: boolean;
        canRemoveAttachment: boolean;
        mayRemoveAttachment: boolean;
        canChangeResponsible: boolean;
        mayChangeResponsible: boolean;
        canConfigureRepeat: boolean;
        mayConfigureRepeat: boolean;
        canToggleCheck: boolean;
        mayToggleCheck: boolean;
        canAwait: boolean;
        mayAwait: boolean;
        canShare: boolean;
        whyAttention: Array<{
          __typename?: "CaseAttentionCondition";
          texts: Array<string>;
        }>;
        archivedBy?: {
          __typename?: "CaseUser";
          id: string;
          name: string;
        } | null;
        tenancy?: {
          __typename?: "Tenancy";
          id: string;
          startDate: string;
          endDate?: string | null;
          user: { __typename?: "User"; id: string; name: string };
          roles: Array<{
            __typename?: "TenancyRole";
            user: {
              __typename?: "User";
              id: string;
              name: string;
              email: string;
              phone?: string | null;
              business: boolean;
              company?: string | null;
              showSensitiveInfo: boolean;
              cpr?: string | null;
              protected: boolean;
            };
          }>;
        } | null;
        apartment?: {
          __typename?: "Apartment";
          id: string;
          address: string;
          publicId: string;
          postalCode: string;
          city: string;
        } | null;
        property?: {
          __typename?: "Property";
          id: string;
          name: string;
          administrator: { __typename?: "Company"; id: string; name: string };
          owner: {
            __typename?: "Company";
            id: string;
            name: string;
            address?: string | null;
            postalCode?: string | null;
            city?: string | null;
            vat?: string | null;
          };
        } | null;
        requester?: {
          __typename?: "User";
          id: string;
          name: string;
          email: string;
        } | null;
        responsible?: {
          __typename?: "CaseUser";
          id: string;
          name: string;
        } | null;
        availableResponsibleUsers: Array<{
          __typename?: "CaseUser";
          id: string;
          name: string;
        }>;
        availableResponsibleTeams: Array<{
          __typename?: "AvailableResponsibleTeam";
          id: string;
          name: string;
          users: Array<{ __typename?: "CaseUser"; id: string; name: string }>;
        }>;
        serviceTeam?: {
          __typename?: "ServiceTeam";
          id: string;
          name: string;
        } | null;
        availableTeams: Array<
          | { __typename?: "AdministrationTeam"; id: string; name: string }
          | { __typename?: "ServiceTeam"; id: string; name: string }
        >;
        assignableServiceTeams: Array<{
          __typename?: "ServiceTeam";
          id: string;
          name: string;
        }>;
        parent?:
          | { __typename: "CleaningService"; id: string; displayName: string }
          | { __typename: "CreateTenancy"; id: string; displayName: string }
          | { __typename: "EndTenancy"; id: string; displayName: string }
          | {
              __typename: "FindTenancyAdministration";
              id: string;
              displayName: string;
            }
          | {
              __typename: "MiscAdministration";
              id: string;
              displayName: string;
            }
          | { __typename: "MiscService"; id: string; displayName: string }
          | { __typename: "MovingInService"; id: string; displayName: string }
          | { __typename: "MovingInTenancy"; id: string; displayName: string }
          | { __typename: "MovingOutService"; id: string; displayName: string }
          | { __typename: "MovingOutTenancy"; id: string; displayName: string }
          | {
              __typename: "MovingSettlementAdministration";
              id: string;
              displayName: string;
            }
          | {
              __typename: "PreparationService";
              id: string;
              displayName: string;
            }
          | {
              __typename: "RequestTenancy";
              startDate: any;
              endDate?: any | null;
              daysBetween?: string | null;
              numberOfResidents: number;
              comment?: string | null;
              id: string;
              displayName: string;
              apartment?: {
                __typename?: "Apartment";
                id: string;
                publicId: string;
                address: string;
              } | null;
              partnerProduct?: {
                __typename?: "PartnerProduct";
                name: string;
                partner: string;
              } | null;
              residents: Array<{
                __typename?: "Resident";
                name: string;
                email?: string | null;
                phone?: string | null;
              }>;
            }
          | {
              __typename: "UtilityAdministration";
              id: string;
              displayName: string;
            }
          | null;
        checks?: Array<{
          __typename?: "CaseCheck";
          id: string;
          label: string;
          value?: boolean | null;
          type: string;
        }> | null;
        comments: Array<{
          __typename?: "CaseComment";
          id: string;
          type: CaseCommentTypeEnum;
          subject?: string | null;
          message: string;
          smsMessage: boolean;
          emailMessage: boolean;
          createdAt: any;
          stateFrom?: string | null;
          stateTo?: string | null;
          stateDescription: string;
          important: boolean;
          readAt?: any | null;
          mayReply: boolean;
          sender: { __typename?: "User"; id: string; name: string };
          recipient?: { __typename?: "User"; id: string; name: string } | null;
          assets: Array<{
            __typename?: "File";
            id: string;
            fileName: string;
            url: string;
          }>;
        }>;
        commentUsers: Array<{
          __typename?: "CaseCommentUserOption";
          id: string;
          label: string;
        }>;
        attachments: Array<{
          __typename?: "CaseAttachment";
          id: string;
          fileName: string;
          fileType: string;
          fileSize: number;
          originalUrl: string;
          thumbUrl: string;
          largeUrl: string;
          isPdf: boolean;
          isImage: boolean;
          createdAt: any;
          category?: {
            __typename?: "AttachmentCategory";
            id: string;
            nameDa: string;
            nameEn: string;
          } | null;
        }>;
        timelogs: Array<{
          __typename?: "Timelog";
          id: string;
          date: any;
          hoursWithoutMinutes: number;
          minutesWithoutHours: number;
          note?: string | null;
          user: { __typename?: "User"; id: string; name: string };
          category: {
            __typename?: "TimelogCategory";
            id: string;
            name: string;
          };
          account: { __typename?: "TimelogAccount"; id: string; name: string };
        }>;
        timelogAccount?: {
          __typename?: "TimelogAccount";
          id: string;
          name: string;
          categories: Array<{
            __typename?: "TimelogCategory";
            id: string;
            name: string;
          }>;
        } | null;
        availableTimelogAccounts: Array<{
          __typename?: "TimelogAccount";
          id: string;
          name: string;
        }>;
        followers: Array<{
          __typename?: "Follower";
          id: string;
          user: { __typename?: "CaseUser"; id: string; name: string };
        }>;
        availableFollowers: Array<{
          __typename?: "CaseUser";
          id: string;
          name: string;
        }>;
      } & {
        " $fragmentRefs"?: {
          ServiceCaseScreen_MiscService_Fragment: ServiceCaseScreen_MiscService_Fragment;
        };
      })
    | ({
        __typename: "MovingInService";
        canReceive: boolean;
        mayReceive: boolean;
        maySchedule: boolean;
        mayReschedule: boolean;
        mayCancelScheduled: boolean;
        canSchedule: boolean;
        canReschedule: boolean;
        canCancelScheduled: boolean;
        mayTenantWillAttendYes: boolean;
        mayTenantWillAttendNo: boolean;
        canTenantWillAttendYes: boolean;
        canTenantWillAttendNo: boolean;
        canChangeServiceTeam: boolean;
        mayChangeServiceTeam: boolean;
        canChangeTask: boolean;
        mayChangeTask: boolean;
        id: string;
        type: CaseTypeEnum;
        state: string;
        stateText: string;
        createdAt: any;
        stateLastChangedAt?: any | null;
        name: string;
        titleRaw?: string | null;
        body: string;
        icon: string;
        attention: CaseAttentionEnum;
        flaggedByCurrentUser: boolean;
        awaiting?: string | null;
        startAfter?: string | null;
        completeBefore?: string | null;
        scheduledDate?: string | null;
        scheduledTime?: string | null;
        tenantWillAttend?: boolean | null;
        isArchived: boolean;
        archivedAt?: any | null;
        cancelledMessage?: string | null;
        repeatSteps?: number | null;
        repeatPeriod?: string | null;
        repeatResponsible: boolean;
        repeating: boolean;
        tenantMayAttend: boolean;
        canUpdate: boolean;
        canComplete: boolean;
        mayComplete: boolean;
        canReopen: boolean;
        mayReopen: boolean;
        canCancel: boolean;
        mayCancel: boolean;
        canAddComment: boolean;
        mayAddComment: boolean;
        canAddTimelog: boolean;
        mayAddTimelog: boolean;
        canShowTimelogs: boolean;
        canAddFollower: boolean;
        mayAddFollower: boolean;
        canRemoveFollower: boolean;
        mayRemoveFollower: boolean;
        canAddAttachment: boolean;
        mayAddAttachment: boolean;
        canRemoveAttachment: boolean;
        mayRemoveAttachment: boolean;
        canChangeResponsible: boolean;
        mayChangeResponsible: boolean;
        canConfigureRepeat: boolean;
        mayConfigureRepeat: boolean;
        canToggleCheck: boolean;
        mayToggleCheck: boolean;
        canAwait: boolean;
        mayAwait: boolean;
        canShare: boolean;
        whyAttention: Array<{
          __typename?: "CaseAttentionCondition";
          texts: Array<string>;
        }>;
        archivedBy?: {
          __typename?: "CaseUser";
          id: string;
          name: string;
        } | null;
        tenancy?: {
          __typename?: "Tenancy";
          id: string;
          startDate: string;
          endDate?: string | null;
          user: { __typename?: "User"; id: string; name: string };
          roles: Array<{
            __typename?: "TenancyRole";
            user: {
              __typename?: "User";
              id: string;
              name: string;
              email: string;
              phone?: string | null;
              business: boolean;
              company?: string | null;
              showSensitiveInfo: boolean;
              cpr?: string | null;
              protected: boolean;
            };
          }>;
        } | null;
        apartment?: {
          __typename?: "Apartment";
          id: string;
          address: string;
          publicId: string;
          postalCode: string;
          city: string;
        } | null;
        property?: {
          __typename?: "Property";
          id: string;
          name: string;
          administrator: { __typename?: "Company"; id: string; name: string };
          owner: {
            __typename?: "Company";
            id: string;
            name: string;
            address?: string | null;
            postalCode?: string | null;
            city?: string | null;
            vat?: string | null;
          };
        } | null;
        requester?: {
          __typename?: "User";
          id: string;
          name: string;
          email: string;
        } | null;
        responsible?: {
          __typename?: "CaseUser";
          id: string;
          name: string;
        } | null;
        availableResponsibleUsers: Array<{
          __typename?: "CaseUser";
          id: string;
          name: string;
        }>;
        availableResponsibleTeams: Array<{
          __typename?: "AvailableResponsibleTeam";
          id: string;
          name: string;
          users: Array<{ __typename?: "CaseUser"; id: string; name: string }>;
        }>;
        serviceTeam?: {
          __typename?: "ServiceTeam";
          id: string;
          name: string;
        } | null;
        availableTeams: Array<
          | { __typename?: "AdministrationTeam"; id: string; name: string }
          | { __typename?: "ServiceTeam"; id: string; name: string }
        >;
        assignableServiceTeams: Array<{
          __typename?: "ServiceTeam";
          id: string;
          name: string;
        }>;
        parent?:
          | { __typename: "CleaningService"; id: string; displayName: string }
          | { __typename: "CreateTenancy"; id: string; displayName: string }
          | { __typename: "EndTenancy"; id: string; displayName: string }
          | {
              __typename: "FindTenancyAdministration";
              id: string;
              displayName: string;
            }
          | {
              __typename: "MiscAdministration";
              id: string;
              displayName: string;
            }
          | { __typename: "MiscService"; id: string; displayName: string }
          | { __typename: "MovingInService"; id: string; displayName: string }
          | { __typename: "MovingInTenancy"; id: string; displayName: string }
          | { __typename: "MovingOutService"; id: string; displayName: string }
          | { __typename: "MovingOutTenancy"; id: string; displayName: string }
          | {
              __typename: "MovingSettlementAdministration";
              id: string;
              displayName: string;
            }
          | {
              __typename: "PreparationService";
              id: string;
              displayName: string;
            }
          | {
              __typename: "RequestTenancy";
              startDate: any;
              endDate?: any | null;
              daysBetween?: string | null;
              numberOfResidents: number;
              comment?: string | null;
              id: string;
              displayName: string;
              apartment?: {
                __typename?: "Apartment";
                id: string;
                publicId: string;
                address: string;
              } | null;
              partnerProduct?: {
                __typename?: "PartnerProduct";
                name: string;
                partner: string;
              } | null;
              residents: Array<{
                __typename?: "Resident";
                name: string;
                email?: string | null;
                phone?: string | null;
              }>;
            }
          | {
              __typename: "UtilityAdministration";
              id: string;
              displayName: string;
            }
          | null;
        checks?: Array<{
          __typename?: "CaseCheck";
          id: string;
          label: string;
          value?: boolean | null;
          type: string;
        }> | null;
        comments: Array<{
          __typename?: "CaseComment";
          id: string;
          type: CaseCommentTypeEnum;
          subject?: string | null;
          message: string;
          smsMessage: boolean;
          emailMessage: boolean;
          createdAt: any;
          stateFrom?: string | null;
          stateTo?: string | null;
          stateDescription: string;
          important: boolean;
          readAt?: any | null;
          mayReply: boolean;
          sender: { __typename?: "User"; id: string; name: string };
          recipient?: { __typename?: "User"; id: string; name: string } | null;
          assets: Array<{
            __typename?: "File";
            id: string;
            fileName: string;
            url: string;
          }>;
        }>;
        commentUsers: Array<{
          __typename?: "CaseCommentUserOption";
          id: string;
          label: string;
        }>;
        attachments: Array<{
          __typename?: "CaseAttachment";
          id: string;
          fileName: string;
          fileType: string;
          fileSize: number;
          originalUrl: string;
          thumbUrl: string;
          largeUrl: string;
          isPdf: boolean;
          isImage: boolean;
          createdAt: any;
          category?: {
            __typename?: "AttachmentCategory";
            id: string;
            nameDa: string;
            nameEn: string;
          } | null;
        }>;
        timelogs: Array<{
          __typename?: "Timelog";
          id: string;
          date: any;
          hoursWithoutMinutes: number;
          minutesWithoutHours: number;
          note?: string | null;
          user: { __typename?: "User"; id: string; name: string };
          category: {
            __typename?: "TimelogCategory";
            id: string;
            name: string;
          };
          account: { __typename?: "TimelogAccount"; id: string; name: string };
        }>;
        timelogAccount?: {
          __typename?: "TimelogAccount";
          id: string;
          name: string;
          categories: Array<{
            __typename?: "TimelogCategory";
            id: string;
            name: string;
          }>;
        } | null;
        availableTimelogAccounts: Array<{
          __typename?: "TimelogAccount";
          id: string;
          name: string;
        }>;
        followers: Array<{
          __typename?: "Follower";
          id: string;
          user: { __typename?: "CaseUser"; id: string; name: string };
        }>;
        availableFollowers: Array<{
          __typename?: "CaseUser";
          id: string;
          name: string;
        }>;
      } & {
        " $fragmentRefs"?: {
          ServiceCaseScreen_MovingInService_Fragment: ServiceCaseScreen_MovingInService_Fragment;
        };
      })
    | ({
        __typename: "MovingInTenancy";
        canReceive: boolean;
        mayReceive: boolean;
        canSchedule: boolean;
        maySchedule: boolean;
        id: string;
        type: CaseTypeEnum;
        state: string;
        stateText: string;
        createdAt: any;
        stateLastChangedAt?: any | null;
        name: string;
        titleRaw?: string | null;
        body: string;
        icon: string;
        attention: CaseAttentionEnum;
        flaggedByCurrentUser: boolean;
        awaiting?: string | null;
        startAfter?: string | null;
        completeBefore?: string | null;
        scheduledDate?: string | null;
        scheduledTime?: string | null;
        tenantWillAttend?: boolean | null;
        isArchived: boolean;
        archivedAt?: any | null;
        cancelledMessage?: string | null;
        repeatSteps?: number | null;
        repeatPeriod?: string | null;
        repeatResponsible: boolean;
        repeating: boolean;
        tenantMayAttend: boolean;
        canUpdate: boolean;
        canComplete: boolean;
        mayComplete: boolean;
        canReopen: boolean;
        mayReopen: boolean;
        canCancel: boolean;
        mayCancel: boolean;
        canAddComment: boolean;
        mayAddComment: boolean;
        canAddTimelog: boolean;
        mayAddTimelog: boolean;
        canShowTimelogs: boolean;
        canAddFollower: boolean;
        mayAddFollower: boolean;
        canRemoveFollower: boolean;
        mayRemoveFollower: boolean;
        canAddAttachment: boolean;
        mayAddAttachment: boolean;
        canRemoveAttachment: boolean;
        mayRemoveAttachment: boolean;
        canChangeResponsible: boolean;
        mayChangeResponsible: boolean;
        canConfigureRepeat: boolean;
        mayConfigureRepeat: boolean;
        canToggleCheck: boolean;
        mayToggleCheck: boolean;
        canAwait: boolean;
        mayAwait: boolean;
        canShare: boolean;
        tenancy?: {
          __typename?: "Tenancy";
          id: string;
          startDate: string;
          endDate?: string | null;
          expectedMovingInCases: Array<{
            __typename?: "CaseDefinition";
            type: CaseTypeEnum;
            name: string;
          }>;
          user: { __typename?: "User"; id: string; name: string };
          roles: Array<{
            __typename?: "TenancyRole";
            user: {
              __typename?: "User";
              id: string;
              name: string;
              email: string;
              phone?: string | null;
              business: boolean;
              company?: string | null;
              showSensitiveInfo: boolean;
              cpr?: string | null;
              protected: boolean;
            };
          }>;
        } | null;
        whyAttention: Array<{
          __typename?: "CaseAttentionCondition";
          texts: Array<string>;
        }>;
        archivedBy?: {
          __typename?: "CaseUser";
          id: string;
          name: string;
        } | null;
        apartment?: {
          __typename?: "Apartment";
          id: string;
          address: string;
          publicId: string;
          postalCode: string;
          city: string;
        } | null;
        property?: {
          __typename?: "Property";
          id: string;
          name: string;
          administrator: { __typename?: "Company"; id: string; name: string };
          owner: {
            __typename?: "Company";
            id: string;
            name: string;
            address?: string | null;
            postalCode?: string | null;
            city?: string | null;
            vat?: string | null;
          };
        } | null;
        requester?: {
          __typename?: "User";
          id: string;
          name: string;
          email: string;
        } | null;
        responsible?: {
          __typename?: "CaseUser";
          id: string;
          name: string;
        } | null;
        availableResponsibleUsers: Array<{
          __typename?: "CaseUser";
          id: string;
          name: string;
        }>;
        availableResponsibleTeams: Array<{
          __typename?: "AvailableResponsibleTeam";
          id: string;
          name: string;
          users: Array<{ __typename?: "CaseUser"; id: string; name: string }>;
        }>;
        serviceTeam?: {
          __typename?: "ServiceTeam";
          id: string;
          name: string;
        } | null;
        availableTeams: Array<
          | { __typename?: "AdministrationTeam"; id: string; name: string }
          | { __typename?: "ServiceTeam"; id: string; name: string }
        >;
        assignableServiceTeams: Array<{
          __typename?: "ServiceTeam";
          id: string;
          name: string;
        }>;
        parent?:
          | { __typename: "CleaningService"; id: string; displayName: string }
          | { __typename: "CreateTenancy"; id: string; displayName: string }
          | { __typename: "EndTenancy"; id: string; displayName: string }
          | {
              __typename: "FindTenancyAdministration";
              id: string;
              displayName: string;
            }
          | {
              __typename: "MiscAdministration";
              id: string;
              displayName: string;
            }
          | { __typename: "MiscService"; id: string; displayName: string }
          | { __typename: "MovingInService"; id: string; displayName: string }
          | { __typename: "MovingInTenancy"; id: string; displayName: string }
          | { __typename: "MovingOutService"; id: string; displayName: string }
          | { __typename: "MovingOutTenancy"; id: string; displayName: string }
          | {
              __typename: "MovingSettlementAdministration";
              id: string;
              displayName: string;
            }
          | {
              __typename: "PreparationService";
              id: string;
              displayName: string;
            }
          | {
              __typename: "RequestTenancy";
              startDate: any;
              endDate?: any | null;
              daysBetween?: string | null;
              numberOfResidents: number;
              comment?: string | null;
              id: string;
              displayName: string;
              apartment?: {
                __typename?: "Apartment";
                id: string;
                publicId: string;
                address: string;
              } | null;
              partnerProduct?: {
                __typename?: "PartnerProduct";
                name: string;
                partner: string;
              } | null;
              residents: Array<{
                __typename?: "Resident";
                name: string;
                email?: string | null;
                phone?: string | null;
              }>;
            }
          | {
              __typename: "UtilityAdministration";
              id: string;
              displayName: string;
            }
          | null;
        checks?: Array<{
          __typename?: "CaseCheck";
          id: string;
          label: string;
          value?: boolean | null;
          type: string;
        }> | null;
        comments: Array<{
          __typename?: "CaseComment";
          id: string;
          type: CaseCommentTypeEnum;
          subject?: string | null;
          message: string;
          smsMessage: boolean;
          emailMessage: boolean;
          createdAt: any;
          stateFrom?: string | null;
          stateTo?: string | null;
          stateDescription: string;
          important: boolean;
          readAt?: any | null;
          mayReply: boolean;
          sender: { __typename?: "User"; id: string; name: string };
          recipient?: { __typename?: "User"; id: string; name: string } | null;
          assets: Array<{
            __typename?: "File";
            id: string;
            fileName: string;
            url: string;
          }>;
        }>;
        commentUsers: Array<{
          __typename?: "CaseCommentUserOption";
          id: string;
          label: string;
        }>;
        attachments: Array<{
          __typename?: "CaseAttachment";
          id: string;
          fileName: string;
          fileType: string;
          fileSize: number;
          originalUrl: string;
          thumbUrl: string;
          largeUrl: string;
          isPdf: boolean;
          isImage: boolean;
          createdAt: any;
          category?: {
            __typename?: "AttachmentCategory";
            id: string;
            nameDa: string;
            nameEn: string;
          } | null;
        }>;
        timelogs: Array<{
          __typename?: "Timelog";
          id: string;
          date: any;
          hoursWithoutMinutes: number;
          minutesWithoutHours: number;
          note?: string | null;
          user: { __typename?: "User"; id: string; name: string };
          category: {
            __typename?: "TimelogCategory";
            id: string;
            name: string;
          };
          account: { __typename?: "TimelogAccount"; id: string; name: string };
        }>;
        timelogAccount?: {
          __typename?: "TimelogAccount";
          id: string;
          name: string;
          categories: Array<{
            __typename?: "TimelogCategory";
            id: string;
            name: string;
          }>;
        } | null;
        availableTimelogAccounts: Array<{
          __typename?: "TimelogAccount";
          id: string;
          name: string;
        }>;
        followers: Array<{
          __typename?: "Follower";
          id: string;
          user: { __typename?: "CaseUser"; id: string; name: string };
        }>;
        availableFollowers: Array<{
          __typename?: "CaseUser";
          id: string;
          name: string;
        }>;
      } & {
        " $fragmentRefs"?: {
          ServiceCaseScreen_MovingInTenancy_Fragment: ServiceCaseScreen_MovingInTenancy_Fragment;
        };
      })
    | ({
        __typename: "MovingOutService";
        canReceive: boolean;
        mayReceive: boolean;
        maySchedule: boolean;
        mayReschedule: boolean;
        mayCancelScheduled: boolean;
        canSchedule: boolean;
        canReschedule: boolean;
        canCancelScheduled: boolean;
        mayTenantWillAttendYes: boolean;
        mayTenantWillAttendNo: boolean;
        canTenantWillAttendYes: boolean;
        canTenantWillAttendNo: boolean;
        canChangeServiceTeam: boolean;
        mayChangeServiceTeam: boolean;
        canChangeTask: boolean;
        mayChangeTask: boolean;
        id: string;
        type: CaseTypeEnum;
        state: string;
        stateText: string;
        createdAt: any;
        stateLastChangedAt?: any | null;
        name: string;
        titleRaw?: string | null;
        body: string;
        icon: string;
        attention: CaseAttentionEnum;
        flaggedByCurrentUser: boolean;
        awaiting?: string | null;
        startAfter?: string | null;
        completeBefore?: string | null;
        scheduledDate?: string | null;
        scheduledTime?: string | null;
        tenantWillAttend?: boolean | null;
        isArchived: boolean;
        archivedAt?: any | null;
        cancelledMessage?: string | null;
        repeatSteps?: number | null;
        repeatPeriod?: string | null;
        repeatResponsible: boolean;
        repeating: boolean;
        tenantMayAttend: boolean;
        canUpdate: boolean;
        canComplete: boolean;
        mayComplete: boolean;
        canReopen: boolean;
        mayReopen: boolean;
        canCancel: boolean;
        mayCancel: boolean;
        canAddComment: boolean;
        mayAddComment: boolean;
        canAddTimelog: boolean;
        mayAddTimelog: boolean;
        canShowTimelogs: boolean;
        canAddFollower: boolean;
        mayAddFollower: boolean;
        canRemoveFollower: boolean;
        mayRemoveFollower: boolean;
        canAddAttachment: boolean;
        mayAddAttachment: boolean;
        canRemoveAttachment: boolean;
        mayRemoveAttachment: boolean;
        canChangeResponsible: boolean;
        mayChangeResponsible: boolean;
        canConfigureRepeat: boolean;
        mayConfigureRepeat: boolean;
        canToggleCheck: boolean;
        mayToggleCheck: boolean;
        canAwait: boolean;
        mayAwait: boolean;
        canShare: boolean;
        whyAttention: Array<{
          __typename?: "CaseAttentionCondition";
          texts: Array<string>;
        }>;
        archivedBy?: {
          __typename?: "CaseUser";
          id: string;
          name: string;
        } | null;
        tenancy?: {
          __typename?: "Tenancy";
          id: string;
          startDate: string;
          endDate?: string | null;
          user: { __typename?: "User"; id: string; name: string };
          roles: Array<{
            __typename?: "TenancyRole";
            user: {
              __typename?: "User";
              id: string;
              name: string;
              email: string;
              phone?: string | null;
              business: boolean;
              company?: string | null;
              showSensitiveInfo: boolean;
              cpr?: string | null;
              protected: boolean;
            };
          }>;
        } | null;
        apartment?: {
          __typename?: "Apartment";
          id: string;
          address: string;
          publicId: string;
          postalCode: string;
          city: string;
        } | null;
        property?: {
          __typename?: "Property";
          id: string;
          name: string;
          administrator: { __typename?: "Company"; id: string; name: string };
          owner: {
            __typename?: "Company";
            id: string;
            name: string;
            address?: string | null;
            postalCode?: string | null;
            city?: string | null;
            vat?: string | null;
          };
        } | null;
        requester?: {
          __typename?: "User";
          id: string;
          name: string;
          email: string;
        } | null;
        responsible?: {
          __typename?: "CaseUser";
          id: string;
          name: string;
        } | null;
        availableResponsibleUsers: Array<{
          __typename?: "CaseUser";
          id: string;
          name: string;
        }>;
        availableResponsibleTeams: Array<{
          __typename?: "AvailableResponsibleTeam";
          id: string;
          name: string;
          users: Array<{ __typename?: "CaseUser"; id: string; name: string }>;
        }>;
        serviceTeam?: {
          __typename?: "ServiceTeam";
          id: string;
          name: string;
        } | null;
        availableTeams: Array<
          | { __typename?: "AdministrationTeam"; id: string; name: string }
          | { __typename?: "ServiceTeam"; id: string; name: string }
        >;
        assignableServiceTeams: Array<{
          __typename?: "ServiceTeam";
          id: string;
          name: string;
        }>;
        parent?:
          | { __typename: "CleaningService"; id: string; displayName: string }
          | { __typename: "CreateTenancy"; id: string; displayName: string }
          | { __typename: "EndTenancy"; id: string; displayName: string }
          | {
              __typename: "FindTenancyAdministration";
              id: string;
              displayName: string;
            }
          | {
              __typename: "MiscAdministration";
              id: string;
              displayName: string;
            }
          | { __typename: "MiscService"; id: string; displayName: string }
          | { __typename: "MovingInService"; id: string; displayName: string }
          | { __typename: "MovingInTenancy"; id: string; displayName: string }
          | { __typename: "MovingOutService"; id: string; displayName: string }
          | { __typename: "MovingOutTenancy"; id: string; displayName: string }
          | {
              __typename: "MovingSettlementAdministration";
              id: string;
              displayName: string;
            }
          | {
              __typename: "PreparationService";
              id: string;
              displayName: string;
            }
          | {
              __typename: "RequestTenancy";
              startDate: any;
              endDate?: any | null;
              daysBetween?: string | null;
              numberOfResidents: number;
              comment?: string | null;
              id: string;
              displayName: string;
              apartment?: {
                __typename?: "Apartment";
                id: string;
                publicId: string;
                address: string;
              } | null;
              partnerProduct?: {
                __typename?: "PartnerProduct";
                name: string;
                partner: string;
              } | null;
              residents: Array<{
                __typename?: "Resident";
                name: string;
                email?: string | null;
                phone?: string | null;
              }>;
            }
          | {
              __typename: "UtilityAdministration";
              id: string;
              displayName: string;
            }
          | null;
        checks?: Array<{
          __typename?: "CaseCheck";
          id: string;
          label: string;
          value?: boolean | null;
          type: string;
        }> | null;
        comments: Array<{
          __typename?: "CaseComment";
          id: string;
          type: CaseCommentTypeEnum;
          subject?: string | null;
          message: string;
          smsMessage: boolean;
          emailMessage: boolean;
          createdAt: any;
          stateFrom?: string | null;
          stateTo?: string | null;
          stateDescription: string;
          important: boolean;
          readAt?: any | null;
          mayReply: boolean;
          sender: { __typename?: "User"; id: string; name: string };
          recipient?: { __typename?: "User"; id: string; name: string } | null;
          assets: Array<{
            __typename?: "File";
            id: string;
            fileName: string;
            url: string;
          }>;
        }>;
        commentUsers: Array<{
          __typename?: "CaseCommentUserOption";
          id: string;
          label: string;
        }>;
        attachments: Array<{
          __typename?: "CaseAttachment";
          id: string;
          fileName: string;
          fileType: string;
          fileSize: number;
          originalUrl: string;
          thumbUrl: string;
          largeUrl: string;
          isPdf: boolean;
          isImage: boolean;
          createdAt: any;
          category?: {
            __typename?: "AttachmentCategory";
            id: string;
            nameDa: string;
            nameEn: string;
          } | null;
        }>;
        timelogs: Array<{
          __typename?: "Timelog";
          id: string;
          date: any;
          hoursWithoutMinutes: number;
          minutesWithoutHours: number;
          note?: string | null;
          user: { __typename?: "User"; id: string; name: string };
          category: {
            __typename?: "TimelogCategory";
            id: string;
            name: string;
          };
          account: { __typename?: "TimelogAccount"; id: string; name: string };
        }>;
        timelogAccount?: {
          __typename?: "TimelogAccount";
          id: string;
          name: string;
          categories: Array<{
            __typename?: "TimelogCategory";
            id: string;
            name: string;
          }>;
        } | null;
        availableTimelogAccounts: Array<{
          __typename?: "TimelogAccount";
          id: string;
          name: string;
        }>;
        followers: Array<{
          __typename?: "Follower";
          id: string;
          user: { __typename?: "CaseUser"; id: string; name: string };
        }>;
        availableFollowers: Array<{
          __typename?: "CaseUser";
          id: string;
          name: string;
        }>;
      } & {
        " $fragmentRefs"?: {
          ServiceCaseScreen_MovingOutService_Fragment: ServiceCaseScreen_MovingOutService_Fragment;
        };
      })
    | ({
        __typename: "MovingOutTenancy";
        canReceive: boolean;
        mayReceive: boolean;
        canSchedule: boolean;
        maySchedule: boolean;
        id: string;
        type: CaseTypeEnum;
        state: string;
        stateText: string;
        createdAt: any;
        stateLastChangedAt?: any | null;
        name: string;
        titleRaw?: string | null;
        body: string;
        icon: string;
        attention: CaseAttentionEnum;
        flaggedByCurrentUser: boolean;
        awaiting?: string | null;
        startAfter?: string | null;
        completeBefore?: string | null;
        scheduledDate?: string | null;
        scheduledTime?: string | null;
        tenantWillAttend?: boolean | null;
        isArchived: boolean;
        archivedAt?: any | null;
        cancelledMessage?: string | null;
        repeatSteps?: number | null;
        repeatPeriod?: string | null;
        repeatResponsible: boolean;
        repeating: boolean;
        tenantMayAttend: boolean;
        canUpdate: boolean;
        canComplete: boolean;
        mayComplete: boolean;
        canReopen: boolean;
        mayReopen: boolean;
        canCancel: boolean;
        mayCancel: boolean;
        canAddComment: boolean;
        mayAddComment: boolean;
        canAddTimelog: boolean;
        mayAddTimelog: boolean;
        canShowTimelogs: boolean;
        canAddFollower: boolean;
        mayAddFollower: boolean;
        canRemoveFollower: boolean;
        mayRemoveFollower: boolean;
        canAddAttachment: boolean;
        mayAddAttachment: boolean;
        canRemoveAttachment: boolean;
        mayRemoveAttachment: boolean;
        canChangeResponsible: boolean;
        mayChangeResponsible: boolean;
        canConfigureRepeat: boolean;
        mayConfigureRepeat: boolean;
        canToggleCheck: boolean;
        mayToggleCheck: boolean;
        canAwait: boolean;
        mayAwait: boolean;
        canShare: boolean;
        tenancy?: {
          __typename?: "Tenancy";
          id: string;
          startDate: string;
          endDate?: string | null;
          expectedMovingOutCases: Array<{
            __typename?: "CaseDefinition";
            type: CaseTypeEnum;
            name: string;
          }>;
          user: {
            __typename?: "User";
            address?: string | null;
            id: string;
            name: string;
          };
          roles: Array<{
            __typename?: "TenancyRole";
            user: {
              __typename?: "User";
              id: string;
              name: string;
              email: string;
              phone?: string | null;
              business: boolean;
              company?: string | null;
              showSensitiveInfo: boolean;
              cpr?: string | null;
              protected: boolean;
            };
          }>;
        } | null;
        whyAttention: Array<{
          __typename?: "CaseAttentionCondition";
          texts: Array<string>;
        }>;
        archivedBy?: {
          __typename?: "CaseUser";
          id: string;
          name: string;
        } | null;
        apartment?: {
          __typename?: "Apartment";
          id: string;
          address: string;
          publicId: string;
          postalCode: string;
          city: string;
        } | null;
        property?: {
          __typename?: "Property";
          id: string;
          name: string;
          administrator: { __typename?: "Company"; id: string; name: string };
          owner: {
            __typename?: "Company";
            id: string;
            name: string;
            address?: string | null;
            postalCode?: string | null;
            city?: string | null;
            vat?: string | null;
          };
        } | null;
        requester?: {
          __typename?: "User";
          id: string;
          name: string;
          email: string;
        } | null;
        responsible?: {
          __typename?: "CaseUser";
          id: string;
          name: string;
        } | null;
        availableResponsibleUsers: Array<{
          __typename?: "CaseUser";
          id: string;
          name: string;
        }>;
        availableResponsibleTeams: Array<{
          __typename?: "AvailableResponsibleTeam";
          id: string;
          name: string;
          users: Array<{ __typename?: "CaseUser"; id: string; name: string }>;
        }>;
        serviceTeam?: {
          __typename?: "ServiceTeam";
          id: string;
          name: string;
        } | null;
        availableTeams: Array<
          | { __typename?: "AdministrationTeam"; id: string; name: string }
          | { __typename?: "ServiceTeam"; id: string; name: string }
        >;
        assignableServiceTeams: Array<{
          __typename?: "ServiceTeam";
          id: string;
          name: string;
        }>;
        parent?:
          | { __typename: "CleaningService"; id: string; displayName: string }
          | { __typename: "CreateTenancy"; id: string; displayName: string }
          | { __typename: "EndTenancy"; id: string; displayName: string }
          | {
              __typename: "FindTenancyAdministration";
              id: string;
              displayName: string;
            }
          | {
              __typename: "MiscAdministration";
              id: string;
              displayName: string;
            }
          | { __typename: "MiscService"; id: string; displayName: string }
          | { __typename: "MovingInService"; id: string; displayName: string }
          | { __typename: "MovingInTenancy"; id: string; displayName: string }
          | { __typename: "MovingOutService"; id: string; displayName: string }
          | { __typename: "MovingOutTenancy"; id: string; displayName: string }
          | {
              __typename: "MovingSettlementAdministration";
              id: string;
              displayName: string;
            }
          | {
              __typename: "PreparationService";
              id: string;
              displayName: string;
            }
          | {
              __typename: "RequestTenancy";
              startDate: any;
              endDate?: any | null;
              daysBetween?: string | null;
              numberOfResidents: number;
              comment?: string | null;
              id: string;
              displayName: string;
              apartment?: {
                __typename?: "Apartment";
                id: string;
                publicId: string;
                address: string;
              } | null;
              partnerProduct?: {
                __typename?: "PartnerProduct";
                name: string;
                partner: string;
              } | null;
              residents: Array<{
                __typename?: "Resident";
                name: string;
                email?: string | null;
                phone?: string | null;
              }>;
            }
          | {
              __typename: "UtilityAdministration";
              id: string;
              displayName: string;
            }
          | null;
        checks?: Array<{
          __typename?: "CaseCheck";
          id: string;
          label: string;
          value?: boolean | null;
          type: string;
        }> | null;
        comments: Array<{
          __typename?: "CaseComment";
          id: string;
          type: CaseCommentTypeEnum;
          subject?: string | null;
          message: string;
          smsMessage: boolean;
          emailMessage: boolean;
          createdAt: any;
          stateFrom?: string | null;
          stateTo?: string | null;
          stateDescription: string;
          important: boolean;
          readAt?: any | null;
          mayReply: boolean;
          sender: { __typename?: "User"; id: string; name: string };
          recipient?: { __typename?: "User"; id: string; name: string } | null;
          assets: Array<{
            __typename?: "File";
            id: string;
            fileName: string;
            url: string;
          }>;
        }>;
        commentUsers: Array<{
          __typename?: "CaseCommentUserOption";
          id: string;
          label: string;
        }>;
        attachments: Array<{
          __typename?: "CaseAttachment";
          id: string;
          fileName: string;
          fileType: string;
          fileSize: number;
          originalUrl: string;
          thumbUrl: string;
          largeUrl: string;
          isPdf: boolean;
          isImage: boolean;
          createdAt: any;
          category?: {
            __typename?: "AttachmentCategory";
            id: string;
            nameDa: string;
            nameEn: string;
          } | null;
        }>;
        timelogs: Array<{
          __typename?: "Timelog";
          id: string;
          date: any;
          hoursWithoutMinutes: number;
          minutesWithoutHours: number;
          note?: string | null;
          user: { __typename?: "User"; id: string; name: string };
          category: {
            __typename?: "TimelogCategory";
            id: string;
            name: string;
          };
          account: { __typename?: "TimelogAccount"; id: string; name: string };
        }>;
        timelogAccount?: {
          __typename?: "TimelogAccount";
          id: string;
          name: string;
          categories: Array<{
            __typename?: "TimelogCategory";
            id: string;
            name: string;
          }>;
        } | null;
        availableTimelogAccounts: Array<{
          __typename?: "TimelogAccount";
          id: string;
          name: string;
        }>;
        followers: Array<{
          __typename?: "Follower";
          id: string;
          user: { __typename?: "CaseUser"; id: string; name: string };
        }>;
        availableFollowers: Array<{
          __typename?: "CaseUser";
          id: string;
          name: string;
        }>;
      } & {
        " $fragmentRefs"?: {
          ServiceCaseScreen_MovingOutTenancy_Fragment: ServiceCaseScreen_MovingOutTenancy_Fragment;
        };
      })
    | ({
        __typename: "MovingSettlementAdministration";
        canReceive: boolean;
        mayReceive: boolean;
        canRequestTenantInformation: boolean;
        mayRequestTenantInformation: boolean;
        canSendTenantInformation: boolean;
        canReopen: boolean;
        mayReopen: boolean;
        id: string;
        type: CaseTypeEnum;
        state: string;
        stateText: string;
        createdAt: any;
        stateLastChangedAt?: any | null;
        name: string;
        titleRaw?: string | null;
        body: string;
        icon: string;
        attention: CaseAttentionEnum;
        flaggedByCurrentUser: boolean;
        awaiting?: string | null;
        startAfter?: string | null;
        completeBefore?: string | null;
        scheduledDate?: string | null;
        scheduledTime?: string | null;
        tenantWillAttend?: boolean | null;
        isArchived: boolean;
        archivedAt?: any | null;
        cancelledMessage?: string | null;
        repeatSteps?: number | null;
        repeatPeriod?: string | null;
        repeatResponsible: boolean;
        repeating: boolean;
        tenantMayAttend: boolean;
        canUpdate: boolean;
        canComplete: boolean;
        mayComplete: boolean;
        canCancel: boolean;
        mayCancel: boolean;
        canAddComment: boolean;
        mayAddComment: boolean;
        canAddTimelog: boolean;
        mayAddTimelog: boolean;
        canShowTimelogs: boolean;
        canAddFollower: boolean;
        mayAddFollower: boolean;
        canRemoveFollower: boolean;
        mayRemoveFollower: boolean;
        canAddAttachment: boolean;
        mayAddAttachment: boolean;
        canRemoveAttachment: boolean;
        mayRemoveAttachment: boolean;
        canChangeResponsible: boolean;
        mayChangeResponsible: boolean;
        canConfigureRepeat: boolean;
        mayConfigureRepeat: boolean;
        canToggleCheck: boolean;
        mayToggleCheck: boolean;
        canAwait: boolean;
        mayAwait: boolean;
        canShare: boolean;
        nextTenancy?: {
          __typename?: "Tenancy";
          startDate: string;
          user: { __typename?: "User"; name: string };
        } | null;
        tenancy?: {
          __typename?: "Tenancy";
          id: string;
          startDate: string;
          endDate?: string | null;
          contractCases: {
            __typename?: "CaseList";
            records: Array<
              | { __typename?: "CleaningService"; id: string }
              | {
                  __typename?: "CreateTenancy";
                  endTenancyTermsText?: string | null;
                  id: string;
                  contract?: {
                    __typename?: "Document";
                    id: string;
                    url: string;
                  } | null;
                  tenancy?: {
                    __typename?: "Tenancy";
                    intervalAmount?: number | null;
                    depositAmount?: number | null;
                  } | null;
                }
              | { __typename?: "EndTenancy"; id: string }
              | { __typename?: "FindTenancyAdministration"; id: string }
              | { __typename?: "MiscAdministration"; id: string }
              | { __typename?: "MiscService"; id: string }
              | { __typename?: "MovingInService"; id: string }
              | { __typename?: "MovingInTenancy"; id: string }
              | { __typename?: "MovingOutService"; id: string }
              | { __typename?: "MovingOutTenancy"; id: string }
              | { __typename?: "MovingSettlementAdministration"; id: string }
              | { __typename?: "PreparationService"; id: string }
              | { __typename?: "RequestTenancy"; id: string }
              | { __typename?: "UtilityAdministration"; id: string }
            >;
          };
          terminationCases: {
            __typename?: "CaseList";
            records: Array<
              | { __typename?: "CleaningService"; id: string; createdAt: any }
              | { __typename?: "CreateTenancy"; id: string; createdAt: any }
              | {
                  __typename?: "EndTenancy";
                  endDate?: any | null;
                  id: string;
                  createdAt: any;
                }
              | {
                  __typename?: "FindTenancyAdministration";
                  id: string;
                  createdAt: any;
                }
              | {
                  __typename?: "MiscAdministration";
                  id: string;
                  createdAt: any;
                }
              | { __typename?: "MiscService"; id: string; createdAt: any }
              | { __typename?: "MovingInService"; id: string; createdAt: any }
              | { __typename?: "MovingInTenancy"; id: string; createdAt: any }
              | { __typename?: "MovingOutService"; id: string; createdAt: any }
              | { __typename?: "MovingOutTenancy"; id: string; createdAt: any }
              | {
                  __typename?: "MovingSettlementAdministration";
                  id: string;
                  createdAt: any;
                }
              | {
                  __typename?: "PreparationService";
                  id: string;
                  createdAt: any;
                }
              | { __typename?: "RequestTenancy"; id: string; createdAt: any }
              | {
                  __typename?: "UtilityAdministration";
                  id: string;
                  createdAt: any;
                }
            >;
          };
          serviceCases: {
            __typename?: "CaseList";
            records: Array<
              | {
                  __typename?: "CleaningService";
                  id: string;
                  shortName: string;
                  stateText: string;
                }
              | {
                  __typename?: "CreateTenancy";
                  id: string;
                  shortName: string;
                  stateText: string;
                }
              | {
                  __typename?: "EndTenancy";
                  id: string;
                  shortName: string;
                  stateText: string;
                }
              | {
                  __typename?: "FindTenancyAdministration";
                  id: string;
                  shortName: string;
                  stateText: string;
                }
              | {
                  __typename?: "MiscAdministration";
                  id: string;
                  shortName: string;
                  stateText: string;
                }
              | {
                  __typename?: "MiscService";
                  id: string;
                  shortName: string;
                  stateText: string;
                }
              | {
                  __typename?: "MovingInService";
                  id: string;
                  shortName: string;
                  stateText: string;
                }
              | {
                  __typename?: "MovingInTenancy";
                  id: string;
                  shortName: string;
                  stateText: string;
                }
              | {
                  __typename?: "MovingOutService";
                  id: string;
                  shortName: string;
                  stateText: string;
                }
              | {
                  __typename?: "MovingOutTenancy";
                  id: string;
                  shortName: string;
                  stateText: string;
                }
              | {
                  __typename?: "MovingSettlementAdministration";
                  id: string;
                  shortName: string;
                  stateText: string;
                }
              | {
                  __typename?: "PreparationService";
                  id: string;
                  shortName: string;
                  stateText: string;
                }
              | {
                  __typename?: "RequestTenancy";
                  id: string;
                  shortName: string;
                  stateText: string;
                }
              | {
                  __typename?: "UtilityAdministration";
                  id: string;
                  shortName: string;
                  stateText: string;
                }
            >;
          };
          user: { __typename?: "User"; id: string; name: string };
          roles: Array<{
            __typename?: "TenancyRole";
            user: {
              __typename?: "User";
              id: string;
              name: string;
              email: string;
              phone?: string | null;
              business: boolean;
              company?: string | null;
              showSensitiveInfo: boolean;
              cpr?: string | null;
              protected: boolean;
            };
          }>;
        } | null;
        tenantInformation?: {
          __typename?: "MovingSettlementTenantInformation";
          name: string;
          email?: string | null;
          phone?: string | null;
          address?: string | null;
          postalCode?: string | null;
          city?: string | null;
          countryName?: string | null;
          bankAccount?: {
            __typename?: "BankAccount";
            bankName?: string | null;
            reg?: string | null;
            account?: string | null;
          } | null;
        } | null;
        whyAttention: Array<{
          __typename?: "CaseAttentionCondition";
          texts: Array<string>;
        }>;
        archivedBy?: {
          __typename?: "CaseUser";
          id: string;
          name: string;
        } | null;
        apartment?: {
          __typename?: "Apartment";
          id: string;
          address: string;
          publicId: string;
          postalCode: string;
          city: string;
        } | null;
        property?: {
          __typename?: "Property";
          id: string;
          name: string;
          administrator: { __typename?: "Company"; id: string; name: string };
          owner: {
            __typename?: "Company";
            id: string;
            name: string;
            address?: string | null;
            postalCode?: string | null;
            city?: string | null;
            vat?: string | null;
          };
        } | null;
        requester?: {
          __typename?: "User";
          id: string;
          name: string;
          email: string;
        } | null;
        responsible?: {
          __typename?: "CaseUser";
          id: string;
          name: string;
        } | null;
        availableResponsibleUsers: Array<{
          __typename?: "CaseUser";
          id: string;
          name: string;
        }>;
        availableResponsibleTeams: Array<{
          __typename?: "AvailableResponsibleTeam";
          id: string;
          name: string;
          users: Array<{ __typename?: "CaseUser"; id: string; name: string }>;
        }>;
        serviceTeam?: {
          __typename?: "ServiceTeam";
          id: string;
          name: string;
        } | null;
        availableTeams: Array<
          | { __typename?: "AdministrationTeam"; id: string; name: string }
          | { __typename?: "ServiceTeam"; id: string; name: string }
        >;
        assignableServiceTeams: Array<{
          __typename?: "ServiceTeam";
          id: string;
          name: string;
        }>;
        parent?:
          | { __typename: "CleaningService"; id: string; displayName: string }
          | { __typename: "CreateTenancy"; id: string; displayName: string }
          | { __typename: "EndTenancy"; id: string; displayName: string }
          | {
              __typename: "FindTenancyAdministration";
              id: string;
              displayName: string;
            }
          | {
              __typename: "MiscAdministration";
              id: string;
              displayName: string;
            }
          | { __typename: "MiscService"; id: string; displayName: string }
          | { __typename: "MovingInService"; id: string; displayName: string }
          | { __typename: "MovingInTenancy"; id: string; displayName: string }
          | { __typename: "MovingOutService"; id: string; displayName: string }
          | { __typename: "MovingOutTenancy"; id: string; displayName: string }
          | {
              __typename: "MovingSettlementAdministration";
              id: string;
              displayName: string;
            }
          | {
              __typename: "PreparationService";
              id: string;
              displayName: string;
            }
          | {
              __typename: "RequestTenancy";
              startDate: any;
              endDate?: any | null;
              daysBetween?: string | null;
              numberOfResidents: number;
              comment?: string | null;
              id: string;
              displayName: string;
              apartment?: {
                __typename?: "Apartment";
                id: string;
                publicId: string;
                address: string;
              } | null;
              partnerProduct?: {
                __typename?: "PartnerProduct";
                name: string;
                partner: string;
              } | null;
              residents: Array<{
                __typename?: "Resident";
                name: string;
                email?: string | null;
                phone?: string | null;
              }>;
            }
          | {
              __typename: "UtilityAdministration";
              id: string;
              displayName: string;
            }
          | null;
        checks?: Array<{
          __typename?: "CaseCheck";
          id: string;
          label: string;
          value?: boolean | null;
          type: string;
        }> | null;
        comments: Array<{
          __typename?: "CaseComment";
          id: string;
          type: CaseCommentTypeEnum;
          subject?: string | null;
          message: string;
          smsMessage: boolean;
          emailMessage: boolean;
          createdAt: any;
          stateFrom?: string | null;
          stateTo?: string | null;
          stateDescription: string;
          important: boolean;
          readAt?: any | null;
          mayReply: boolean;
          sender: { __typename?: "User"; id: string; name: string };
          recipient?: { __typename?: "User"; id: string; name: string } | null;
          assets: Array<{
            __typename?: "File";
            id: string;
            fileName: string;
            url: string;
          }>;
        }>;
        commentUsers: Array<{
          __typename?: "CaseCommentUserOption";
          id: string;
          label: string;
        }>;
        attachments: Array<{
          __typename?: "CaseAttachment";
          id: string;
          fileName: string;
          fileType: string;
          fileSize: number;
          originalUrl: string;
          thumbUrl: string;
          largeUrl: string;
          isPdf: boolean;
          isImage: boolean;
          createdAt: any;
          category?: {
            __typename?: "AttachmentCategory";
            id: string;
            nameDa: string;
            nameEn: string;
          } | null;
        }>;
        timelogs: Array<{
          __typename?: "Timelog";
          id: string;
          date: any;
          hoursWithoutMinutes: number;
          minutesWithoutHours: number;
          note?: string | null;
          user: { __typename?: "User"; id: string; name: string };
          category: {
            __typename?: "TimelogCategory";
            id: string;
            name: string;
          };
          account: { __typename?: "TimelogAccount"; id: string; name: string };
        }>;
        timelogAccount?: {
          __typename?: "TimelogAccount";
          id: string;
          name: string;
          categories: Array<{
            __typename?: "TimelogCategory";
            id: string;
            name: string;
          }>;
        } | null;
        availableTimelogAccounts: Array<{
          __typename?: "TimelogAccount";
          id: string;
          name: string;
        }>;
        followers: Array<{
          __typename?: "Follower";
          id: string;
          user: { __typename?: "CaseUser"; id: string; name: string };
        }>;
        availableFollowers: Array<{
          __typename?: "CaseUser";
          id: string;
          name: string;
        }>;
      } & {
        " $fragmentRefs"?: {
          ServiceCaseScreen_MovingSettlementAdministration_Fragment: ServiceCaseScreen_MovingSettlementAdministration_Fragment;
        };
      })
    | ({
        __typename: "PreparationService";
        canReceive: boolean;
        mayReceive: boolean;
        maySchedule: boolean;
        mayReschedule: boolean;
        mayCancelScheduled: boolean;
        canSchedule: boolean;
        canReschedule: boolean;
        canCancelScheduled: boolean;
        mayTenantWillAttendYes: boolean;
        mayTenantWillAttendNo: boolean;
        canTenantWillAttendYes: boolean;
        canTenantWillAttendNo: boolean;
        canChangeServiceTeam: boolean;
        mayChangeServiceTeam: boolean;
        canChangeTask: boolean;
        mayChangeTask: boolean;
        id: string;
        type: CaseTypeEnum;
        state: string;
        stateText: string;
        createdAt: any;
        stateLastChangedAt?: any | null;
        name: string;
        titleRaw?: string | null;
        body: string;
        icon: string;
        attention: CaseAttentionEnum;
        flaggedByCurrentUser: boolean;
        awaiting?: string | null;
        startAfter?: string | null;
        completeBefore?: string | null;
        scheduledDate?: string | null;
        scheduledTime?: string | null;
        tenantWillAttend?: boolean | null;
        isArchived: boolean;
        archivedAt?: any | null;
        cancelledMessage?: string | null;
        repeatSteps?: number | null;
        repeatPeriod?: string | null;
        repeatResponsible: boolean;
        repeating: boolean;
        tenantMayAttend: boolean;
        canUpdate: boolean;
        canComplete: boolean;
        mayComplete: boolean;
        canReopen: boolean;
        mayReopen: boolean;
        canCancel: boolean;
        mayCancel: boolean;
        canAddComment: boolean;
        mayAddComment: boolean;
        canAddTimelog: boolean;
        mayAddTimelog: boolean;
        canShowTimelogs: boolean;
        canAddFollower: boolean;
        mayAddFollower: boolean;
        canRemoveFollower: boolean;
        mayRemoveFollower: boolean;
        canAddAttachment: boolean;
        mayAddAttachment: boolean;
        canRemoveAttachment: boolean;
        mayRemoveAttachment: boolean;
        canChangeResponsible: boolean;
        mayChangeResponsible: boolean;
        canConfigureRepeat: boolean;
        mayConfigureRepeat: boolean;
        canToggleCheck: boolean;
        mayToggleCheck: boolean;
        canAwait: boolean;
        mayAwait: boolean;
        canShare: boolean;
        whyAttention: Array<{
          __typename?: "CaseAttentionCondition";
          texts: Array<string>;
        }>;
        archivedBy?: {
          __typename?: "CaseUser";
          id: string;
          name: string;
        } | null;
        tenancy?: {
          __typename?: "Tenancy";
          id: string;
          startDate: string;
          endDate?: string | null;
          user: { __typename?: "User"; id: string; name: string };
          roles: Array<{
            __typename?: "TenancyRole";
            user: {
              __typename?: "User";
              id: string;
              name: string;
              email: string;
              phone?: string | null;
              business: boolean;
              company?: string | null;
              showSensitiveInfo: boolean;
              cpr?: string | null;
              protected: boolean;
            };
          }>;
        } | null;
        apartment?: {
          __typename?: "Apartment";
          id: string;
          address: string;
          publicId: string;
          postalCode: string;
          city: string;
        } | null;
        property?: {
          __typename?: "Property";
          id: string;
          name: string;
          administrator: { __typename?: "Company"; id: string; name: string };
          owner: {
            __typename?: "Company";
            id: string;
            name: string;
            address?: string | null;
            postalCode?: string | null;
            city?: string | null;
            vat?: string | null;
          };
        } | null;
        requester?: {
          __typename?: "User";
          id: string;
          name: string;
          email: string;
        } | null;
        responsible?: {
          __typename?: "CaseUser";
          id: string;
          name: string;
        } | null;
        availableResponsibleUsers: Array<{
          __typename?: "CaseUser";
          id: string;
          name: string;
        }>;
        availableResponsibleTeams: Array<{
          __typename?: "AvailableResponsibleTeam";
          id: string;
          name: string;
          users: Array<{ __typename?: "CaseUser"; id: string; name: string }>;
        }>;
        serviceTeam?: {
          __typename?: "ServiceTeam";
          id: string;
          name: string;
        } | null;
        availableTeams: Array<
          | { __typename?: "AdministrationTeam"; id: string; name: string }
          | { __typename?: "ServiceTeam"; id: string; name: string }
        >;
        assignableServiceTeams: Array<{
          __typename?: "ServiceTeam";
          id: string;
          name: string;
        }>;
        parent?:
          | { __typename: "CleaningService"; id: string; displayName: string }
          | { __typename: "CreateTenancy"; id: string; displayName: string }
          | { __typename: "EndTenancy"; id: string; displayName: string }
          | {
              __typename: "FindTenancyAdministration";
              id: string;
              displayName: string;
            }
          | {
              __typename: "MiscAdministration";
              id: string;
              displayName: string;
            }
          | { __typename: "MiscService"; id: string; displayName: string }
          | { __typename: "MovingInService"; id: string; displayName: string }
          | { __typename: "MovingInTenancy"; id: string; displayName: string }
          | { __typename: "MovingOutService"; id: string; displayName: string }
          | { __typename: "MovingOutTenancy"; id: string; displayName: string }
          | {
              __typename: "MovingSettlementAdministration";
              id: string;
              displayName: string;
            }
          | {
              __typename: "PreparationService";
              id: string;
              displayName: string;
            }
          | {
              __typename: "RequestTenancy";
              startDate: any;
              endDate?: any | null;
              daysBetween?: string | null;
              numberOfResidents: number;
              comment?: string | null;
              id: string;
              displayName: string;
              apartment?: {
                __typename?: "Apartment";
                id: string;
                publicId: string;
                address: string;
              } | null;
              partnerProduct?: {
                __typename?: "PartnerProduct";
                name: string;
                partner: string;
              } | null;
              residents: Array<{
                __typename?: "Resident";
                name: string;
                email?: string | null;
                phone?: string | null;
              }>;
            }
          | {
              __typename: "UtilityAdministration";
              id: string;
              displayName: string;
            }
          | null;
        checks?: Array<{
          __typename?: "CaseCheck";
          id: string;
          label: string;
          value?: boolean | null;
          type: string;
        }> | null;
        comments: Array<{
          __typename?: "CaseComment";
          id: string;
          type: CaseCommentTypeEnum;
          subject?: string | null;
          message: string;
          smsMessage: boolean;
          emailMessage: boolean;
          createdAt: any;
          stateFrom?: string | null;
          stateTo?: string | null;
          stateDescription: string;
          important: boolean;
          readAt?: any | null;
          mayReply: boolean;
          sender: { __typename?: "User"; id: string; name: string };
          recipient?: { __typename?: "User"; id: string; name: string } | null;
          assets: Array<{
            __typename?: "File";
            id: string;
            fileName: string;
            url: string;
          }>;
        }>;
        commentUsers: Array<{
          __typename?: "CaseCommentUserOption";
          id: string;
          label: string;
        }>;
        attachments: Array<{
          __typename?: "CaseAttachment";
          id: string;
          fileName: string;
          fileType: string;
          fileSize: number;
          originalUrl: string;
          thumbUrl: string;
          largeUrl: string;
          isPdf: boolean;
          isImage: boolean;
          createdAt: any;
          category?: {
            __typename?: "AttachmentCategory";
            id: string;
            nameDa: string;
            nameEn: string;
          } | null;
        }>;
        timelogs: Array<{
          __typename?: "Timelog";
          id: string;
          date: any;
          hoursWithoutMinutes: number;
          minutesWithoutHours: number;
          note?: string | null;
          user: { __typename?: "User"; id: string; name: string };
          category: {
            __typename?: "TimelogCategory";
            id: string;
            name: string;
          };
          account: { __typename?: "TimelogAccount"; id: string; name: string };
        }>;
        timelogAccount?: {
          __typename?: "TimelogAccount";
          id: string;
          name: string;
          categories: Array<{
            __typename?: "TimelogCategory";
            id: string;
            name: string;
          }>;
        } | null;
        availableTimelogAccounts: Array<{
          __typename?: "TimelogAccount";
          id: string;
          name: string;
        }>;
        followers: Array<{
          __typename?: "Follower";
          id: string;
          user: { __typename?: "CaseUser"; id: string; name: string };
        }>;
        availableFollowers: Array<{
          __typename?: "CaseUser";
          id: string;
          name: string;
        }>;
      } & {
        " $fragmentRefs"?: {
          ServiceCaseScreen_PreparationService_Fragment: ServiceCaseScreen_PreparationService_Fragment;
        };
      })
    | ({
        __typename: "RequestTenancy";
        canReceive: boolean;
        mayReceive: boolean;
        canReopen: boolean;
        mayReopen: boolean;
        daysBetween?: string | null;
        startDate: any;
        endDate?: any | null;
        comment?: string | null;
        numberOfResidents: number;
        canCreateTenancy: boolean;
        id: string;
        type: CaseTypeEnum;
        state: string;
        stateText: string;
        createdAt: any;
        stateLastChangedAt?: any | null;
        name: string;
        titleRaw?: string | null;
        body: string;
        icon: string;
        attention: CaseAttentionEnum;
        flaggedByCurrentUser: boolean;
        awaiting?: string | null;
        startAfter?: string | null;
        completeBefore?: string | null;
        scheduledDate?: string | null;
        scheduledTime?: string | null;
        tenantWillAttend?: boolean | null;
        isArchived: boolean;
        archivedAt?: any | null;
        cancelledMessage?: string | null;
        repeatSteps?: number | null;
        repeatPeriod?: string | null;
        repeatResponsible: boolean;
        repeating: boolean;
        tenantMayAttend: boolean;
        canUpdate: boolean;
        canComplete: boolean;
        mayComplete: boolean;
        canCancel: boolean;
        mayCancel: boolean;
        canAddComment: boolean;
        mayAddComment: boolean;
        canAddTimelog: boolean;
        mayAddTimelog: boolean;
        canShowTimelogs: boolean;
        canAddFollower: boolean;
        mayAddFollower: boolean;
        canRemoveFollower: boolean;
        mayRemoveFollower: boolean;
        canAddAttachment: boolean;
        mayAddAttachment: boolean;
        canRemoveAttachment: boolean;
        mayRemoveAttachment: boolean;
        canChangeResponsible: boolean;
        mayChangeResponsible: boolean;
        canConfigureRepeat: boolean;
        mayConfigureRepeat: boolean;
        canToggleCheck: boolean;
        mayToggleCheck: boolean;
        canAwait: boolean;
        mayAwait: boolean;
        canShare: boolean;
        requester?: {
          __typename?: "User";
          address?: string | null;
          postalCode?: string | null;
          city?: string | null;
          countryName?: string | null;
          business: boolean;
          company?: string | null;
          vat?: string | null;
          cpr?: string | null;
          phone?: string | null;
          id: string;
          name: string;
          email: string;
        } | null;
        apartment?: {
          __typename?: "Apartment";
          id: string;
          address: string;
          publicId: string;
          postalCode: string;
          city: string;
        } | null;
        partnerProduct?: {
          __typename?: "PartnerProduct";
          name: string;
          partner: string;
        } | null;
        residents: Array<{
          __typename?: "Resident";
          name: string;
          email?: string | null;
          phone?: string | null;
        }>;
        createTenancyCases: Array<{
          __typename?: "CreateTenancy";
          id: string;
          startDate?: any | null;
          endDate?: any | null;
          daysBetween?: string | null;
          state: string;
          stateText: string;
          apartment?: { __typename?: "Apartment"; address: string } | null;
          requester?: { __typename?: "User"; name: string } | null;
        }>;
        whyAttention: Array<{
          __typename?: "CaseAttentionCondition";
          texts: Array<string>;
        }>;
        archivedBy?: {
          __typename?: "CaseUser";
          id: string;
          name: string;
        } | null;
        tenancy?: {
          __typename?: "Tenancy";
          id: string;
          startDate: string;
          endDate?: string | null;
          user: { __typename?: "User"; id: string; name: string };
          roles: Array<{
            __typename?: "TenancyRole";
            user: {
              __typename?: "User";
              id: string;
              name: string;
              email: string;
              phone?: string | null;
              business: boolean;
              company?: string | null;
              showSensitiveInfo: boolean;
              cpr?: string | null;
              protected: boolean;
            };
          }>;
        } | null;
        property?: {
          __typename?: "Property";
          id: string;
          name: string;
          administrator: { __typename?: "Company"; id: string; name: string };
          owner: {
            __typename?: "Company";
            id: string;
            name: string;
            address?: string | null;
            postalCode?: string | null;
            city?: string | null;
            vat?: string | null;
          };
        } | null;
        responsible?: {
          __typename?: "CaseUser";
          id: string;
          name: string;
        } | null;
        availableResponsibleUsers: Array<{
          __typename?: "CaseUser";
          id: string;
          name: string;
        }>;
        availableResponsibleTeams: Array<{
          __typename?: "AvailableResponsibleTeam";
          id: string;
          name: string;
          users: Array<{ __typename?: "CaseUser"; id: string; name: string }>;
        }>;
        serviceTeam?: {
          __typename?: "ServiceTeam";
          id: string;
          name: string;
        } | null;
        availableTeams: Array<
          | { __typename?: "AdministrationTeam"; id: string; name: string }
          | { __typename?: "ServiceTeam"; id: string; name: string }
        >;
        assignableServiceTeams: Array<{
          __typename?: "ServiceTeam";
          id: string;
          name: string;
        }>;
        parent?:
          | { __typename: "CleaningService"; id: string; displayName: string }
          | { __typename: "CreateTenancy"; id: string; displayName: string }
          | { __typename: "EndTenancy"; id: string; displayName: string }
          | {
              __typename: "FindTenancyAdministration";
              id: string;
              displayName: string;
            }
          | {
              __typename: "MiscAdministration";
              id: string;
              displayName: string;
            }
          | { __typename: "MiscService"; id: string; displayName: string }
          | { __typename: "MovingInService"; id: string; displayName: string }
          | { __typename: "MovingInTenancy"; id: string; displayName: string }
          | { __typename: "MovingOutService"; id: string; displayName: string }
          | { __typename: "MovingOutTenancy"; id: string; displayName: string }
          | {
              __typename: "MovingSettlementAdministration";
              id: string;
              displayName: string;
            }
          | {
              __typename: "PreparationService";
              id: string;
              displayName: string;
            }
          | {
              __typename: "RequestTenancy";
              startDate: any;
              endDate?: any | null;
              daysBetween?: string | null;
              numberOfResidents: number;
              comment?: string | null;
              id: string;
              displayName: string;
              apartment?: {
                __typename?: "Apartment";
                id: string;
                publicId: string;
                address: string;
              } | null;
              partnerProduct?: {
                __typename?: "PartnerProduct";
                name: string;
                partner: string;
              } | null;
              residents: Array<{
                __typename?: "Resident";
                name: string;
                email?: string | null;
                phone?: string | null;
              }>;
            }
          | {
              __typename: "UtilityAdministration";
              id: string;
              displayName: string;
            }
          | null;
        checks?: Array<{
          __typename?: "CaseCheck";
          id: string;
          label: string;
          value?: boolean | null;
          type: string;
        }> | null;
        comments: Array<{
          __typename?: "CaseComment";
          id: string;
          type: CaseCommentTypeEnum;
          subject?: string | null;
          message: string;
          smsMessage: boolean;
          emailMessage: boolean;
          createdAt: any;
          stateFrom?: string | null;
          stateTo?: string | null;
          stateDescription: string;
          important: boolean;
          readAt?: any | null;
          mayReply: boolean;
          sender: { __typename?: "User"; id: string; name: string };
          recipient?: { __typename?: "User"; id: string; name: string } | null;
          assets: Array<{
            __typename?: "File";
            id: string;
            fileName: string;
            url: string;
          }>;
        }>;
        commentUsers: Array<{
          __typename?: "CaseCommentUserOption";
          id: string;
          label: string;
        }>;
        attachments: Array<{
          __typename?: "CaseAttachment";
          id: string;
          fileName: string;
          fileType: string;
          fileSize: number;
          originalUrl: string;
          thumbUrl: string;
          largeUrl: string;
          isPdf: boolean;
          isImage: boolean;
          createdAt: any;
          category?: {
            __typename?: "AttachmentCategory";
            id: string;
            nameDa: string;
            nameEn: string;
          } | null;
        }>;
        timelogs: Array<{
          __typename?: "Timelog";
          id: string;
          date: any;
          hoursWithoutMinutes: number;
          minutesWithoutHours: number;
          note?: string | null;
          user: { __typename?: "User"; id: string; name: string };
          category: {
            __typename?: "TimelogCategory";
            id: string;
            name: string;
          };
          account: { __typename?: "TimelogAccount"; id: string; name: string };
        }>;
        timelogAccount?: {
          __typename?: "TimelogAccount";
          id: string;
          name: string;
          categories: Array<{
            __typename?: "TimelogCategory";
            id: string;
            name: string;
          }>;
        } | null;
        availableTimelogAccounts: Array<{
          __typename?: "TimelogAccount";
          id: string;
          name: string;
        }>;
        followers: Array<{
          __typename?: "Follower";
          id: string;
          user: { __typename?: "CaseUser"; id: string; name: string };
        }>;
        availableFollowers: Array<{
          __typename?: "CaseUser";
          id: string;
          name: string;
        }>;
      } & {
        " $fragmentRefs"?: {
          ServiceCaseScreen_RequestTenancy_Fragment: ServiceCaseScreen_RequestTenancy_Fragment;
        };
      })
    | ({
        __typename: "UtilityAdministration";
        canReceive: boolean;
        mayReceive: boolean;
        canReopen: boolean;
        mayReopen: boolean;
        canChangeTask: boolean;
        mayChangeTask: boolean;
        id: string;
        type: CaseTypeEnum;
        state: string;
        stateText: string;
        createdAt: any;
        stateLastChangedAt?: any | null;
        name: string;
        titleRaw?: string | null;
        body: string;
        icon: string;
        attention: CaseAttentionEnum;
        flaggedByCurrentUser: boolean;
        awaiting?: string | null;
        startAfter?: string | null;
        completeBefore?: string | null;
        scheduledDate?: string | null;
        scheduledTime?: string | null;
        tenantWillAttend?: boolean | null;
        isArchived: boolean;
        archivedAt?: any | null;
        cancelledMessage?: string | null;
        repeatSteps?: number | null;
        repeatPeriod?: string | null;
        repeatResponsible: boolean;
        repeating: boolean;
        tenantMayAttend: boolean;
        canUpdate: boolean;
        canComplete: boolean;
        mayComplete: boolean;
        canCancel: boolean;
        mayCancel: boolean;
        canAddComment: boolean;
        mayAddComment: boolean;
        canAddTimelog: boolean;
        mayAddTimelog: boolean;
        canShowTimelogs: boolean;
        canAddFollower: boolean;
        mayAddFollower: boolean;
        canRemoveFollower: boolean;
        mayRemoveFollower: boolean;
        canAddAttachment: boolean;
        mayAddAttachment: boolean;
        canRemoveAttachment: boolean;
        mayRemoveAttachment: boolean;
        canChangeResponsible: boolean;
        mayChangeResponsible: boolean;
        canConfigureRepeat: boolean;
        mayConfigureRepeat: boolean;
        canToggleCheck: boolean;
        mayToggleCheck: boolean;
        canAwait: boolean;
        mayAwait: boolean;
        canShare: boolean;
        whyAttention: Array<{
          __typename?: "CaseAttentionCondition";
          texts: Array<string>;
        }>;
        archivedBy?: {
          __typename?: "CaseUser";
          id: string;
          name: string;
        } | null;
        tenancy?: {
          __typename?: "Tenancy";
          id: string;
          startDate: string;
          endDate?: string | null;
          user: { __typename?: "User"; id: string; name: string };
          roles: Array<{
            __typename?: "TenancyRole";
            user: {
              __typename?: "User";
              id: string;
              name: string;
              email: string;
              phone?: string | null;
              business: boolean;
              company?: string | null;
              showSensitiveInfo: boolean;
              cpr?: string | null;
              protected: boolean;
            };
          }>;
        } | null;
        apartment?: {
          __typename?: "Apartment";
          id: string;
          address: string;
          publicId: string;
          postalCode: string;
          city: string;
        } | null;
        property?: {
          __typename?: "Property";
          id: string;
          name: string;
          administrator: { __typename?: "Company"; id: string; name: string };
          owner: {
            __typename?: "Company";
            id: string;
            name: string;
            address?: string | null;
            postalCode?: string | null;
            city?: string | null;
            vat?: string | null;
          };
        } | null;
        requester?: {
          __typename?: "User";
          id: string;
          name: string;
          email: string;
        } | null;
        responsible?: {
          __typename?: "CaseUser";
          id: string;
          name: string;
        } | null;
        availableResponsibleUsers: Array<{
          __typename?: "CaseUser";
          id: string;
          name: string;
        }>;
        availableResponsibleTeams: Array<{
          __typename?: "AvailableResponsibleTeam";
          id: string;
          name: string;
          users: Array<{ __typename?: "CaseUser"; id: string; name: string }>;
        }>;
        serviceTeam?: {
          __typename?: "ServiceTeam";
          id: string;
          name: string;
        } | null;
        availableTeams: Array<
          | { __typename?: "AdministrationTeam"; id: string; name: string }
          | { __typename?: "ServiceTeam"; id: string; name: string }
        >;
        assignableServiceTeams: Array<{
          __typename?: "ServiceTeam";
          id: string;
          name: string;
        }>;
        parent?:
          | { __typename: "CleaningService"; id: string; displayName: string }
          | { __typename: "CreateTenancy"; id: string; displayName: string }
          | { __typename: "EndTenancy"; id: string; displayName: string }
          | {
              __typename: "FindTenancyAdministration";
              id: string;
              displayName: string;
            }
          | {
              __typename: "MiscAdministration";
              id: string;
              displayName: string;
            }
          | { __typename: "MiscService"; id: string; displayName: string }
          | { __typename: "MovingInService"; id: string; displayName: string }
          | { __typename: "MovingInTenancy"; id: string; displayName: string }
          | { __typename: "MovingOutService"; id: string; displayName: string }
          | { __typename: "MovingOutTenancy"; id: string; displayName: string }
          | {
              __typename: "MovingSettlementAdministration";
              id: string;
              displayName: string;
            }
          | {
              __typename: "PreparationService";
              id: string;
              displayName: string;
            }
          | {
              __typename: "RequestTenancy";
              startDate: any;
              endDate?: any | null;
              daysBetween?: string | null;
              numberOfResidents: number;
              comment?: string | null;
              id: string;
              displayName: string;
              apartment?: {
                __typename?: "Apartment";
                id: string;
                publicId: string;
                address: string;
              } | null;
              partnerProduct?: {
                __typename?: "PartnerProduct";
                name: string;
                partner: string;
              } | null;
              residents: Array<{
                __typename?: "Resident";
                name: string;
                email?: string | null;
                phone?: string | null;
              }>;
            }
          | {
              __typename: "UtilityAdministration";
              id: string;
              displayName: string;
            }
          | null;
        checks?: Array<{
          __typename?: "CaseCheck";
          id: string;
          label: string;
          value?: boolean | null;
          type: string;
        }> | null;
        comments: Array<{
          __typename?: "CaseComment";
          id: string;
          type: CaseCommentTypeEnum;
          subject?: string | null;
          message: string;
          smsMessage: boolean;
          emailMessage: boolean;
          createdAt: any;
          stateFrom?: string | null;
          stateTo?: string | null;
          stateDescription: string;
          important: boolean;
          readAt?: any | null;
          mayReply: boolean;
          sender: { __typename?: "User"; id: string; name: string };
          recipient?: { __typename?: "User"; id: string; name: string } | null;
          assets: Array<{
            __typename?: "File";
            id: string;
            fileName: string;
            url: string;
          }>;
        }>;
        commentUsers: Array<{
          __typename?: "CaseCommentUserOption";
          id: string;
          label: string;
        }>;
        attachments: Array<{
          __typename?: "CaseAttachment";
          id: string;
          fileName: string;
          fileType: string;
          fileSize: number;
          originalUrl: string;
          thumbUrl: string;
          largeUrl: string;
          isPdf: boolean;
          isImage: boolean;
          createdAt: any;
          category?: {
            __typename?: "AttachmentCategory";
            id: string;
            nameDa: string;
            nameEn: string;
          } | null;
        }>;
        timelogs: Array<{
          __typename?: "Timelog";
          id: string;
          date: any;
          hoursWithoutMinutes: number;
          minutesWithoutHours: number;
          note?: string | null;
          user: { __typename?: "User"; id: string; name: string };
          category: {
            __typename?: "TimelogCategory";
            id: string;
            name: string;
          };
          account: { __typename?: "TimelogAccount"; id: string; name: string };
        }>;
        timelogAccount?: {
          __typename?: "TimelogAccount";
          id: string;
          name: string;
          categories: Array<{
            __typename?: "TimelogCategory";
            id: string;
            name: string;
          }>;
        } | null;
        availableTimelogAccounts: Array<{
          __typename?: "TimelogAccount";
          id: string;
          name: string;
        }>;
        followers: Array<{
          __typename?: "Follower";
          id: string;
          user: { __typename?: "CaseUser"; id: string; name: string };
        }>;
        availableFollowers: Array<{
          __typename?: "CaseUser";
          id: string;
          name: string;
        }>;
      } & {
        " $fragmentRefs"?: {
          ServiceCaseScreen_UtilityAdministration_Fragment: ServiceCaseScreen_UtilityAdministration_Fragment;
        };
      })
    | null;
};

export type CaseChildrenQueryVariables = Exact<{
  parentId: Scalars["ID"]["input"];
}>;

export type CaseChildrenQuery = {
  __typename?: "Query";
  cases: {
    __typename?: "CaseList";
    records: Array<
      | {
          __typename?: "CleaningService";
          id: string;
          type: CaseTypeEnum;
          shortName: string;
          state: string;
          stateText: string;
          attention: CaseAttentionEnum;
          awaiting?: string | null;
          isArchived: boolean;
          responsible?: { __typename?: "CaseUser"; name: string } | null;
        }
      | {
          __typename?: "CreateTenancy";
          id: string;
          type: CaseTypeEnum;
          shortName: string;
          state: string;
          stateText: string;
          attention: CaseAttentionEnum;
          awaiting?: string | null;
          isArchived: boolean;
          responsible?: { __typename?: "CaseUser"; name: string } | null;
        }
      | {
          __typename?: "EndTenancy";
          id: string;
          type: CaseTypeEnum;
          shortName: string;
          state: string;
          stateText: string;
          attention: CaseAttentionEnum;
          awaiting?: string | null;
          isArchived: boolean;
          responsible?: { __typename?: "CaseUser"; name: string } | null;
        }
      | {
          __typename?: "FindTenancyAdministration";
          id: string;
          type: CaseTypeEnum;
          shortName: string;
          state: string;
          stateText: string;
          attention: CaseAttentionEnum;
          awaiting?: string | null;
          isArchived: boolean;
          responsible?: { __typename?: "CaseUser"; name: string } | null;
        }
      | {
          __typename?: "MiscAdministration";
          id: string;
          type: CaseTypeEnum;
          shortName: string;
          state: string;
          stateText: string;
          attention: CaseAttentionEnum;
          awaiting?: string | null;
          isArchived: boolean;
          responsible?: { __typename?: "CaseUser"; name: string } | null;
        }
      | {
          __typename?: "MiscService";
          id: string;
          type: CaseTypeEnum;
          shortName: string;
          state: string;
          stateText: string;
          attention: CaseAttentionEnum;
          awaiting?: string | null;
          isArchived: boolean;
          responsible?: { __typename?: "CaseUser"; name: string } | null;
        }
      | {
          __typename?: "MovingInService";
          id: string;
          type: CaseTypeEnum;
          shortName: string;
          state: string;
          stateText: string;
          attention: CaseAttentionEnum;
          awaiting?: string | null;
          isArchived: boolean;
          responsible?: { __typename?: "CaseUser"; name: string } | null;
        }
      | {
          __typename?: "MovingInTenancy";
          id: string;
          type: CaseTypeEnum;
          shortName: string;
          state: string;
          stateText: string;
          attention: CaseAttentionEnum;
          awaiting?: string | null;
          isArchived: boolean;
          responsible?: { __typename?: "CaseUser"; name: string } | null;
        }
      | {
          __typename?: "MovingOutService";
          id: string;
          type: CaseTypeEnum;
          shortName: string;
          state: string;
          stateText: string;
          attention: CaseAttentionEnum;
          awaiting?: string | null;
          isArchived: boolean;
          responsible?: { __typename?: "CaseUser"; name: string } | null;
        }
      | {
          __typename?: "MovingOutTenancy";
          id: string;
          type: CaseTypeEnum;
          shortName: string;
          state: string;
          stateText: string;
          attention: CaseAttentionEnum;
          awaiting?: string | null;
          isArchived: boolean;
          responsible?: { __typename?: "CaseUser"; name: string } | null;
        }
      | {
          __typename?: "MovingSettlementAdministration";
          id: string;
          type: CaseTypeEnum;
          shortName: string;
          state: string;
          stateText: string;
          attention: CaseAttentionEnum;
          awaiting?: string | null;
          isArchived: boolean;
          responsible?: { __typename?: "CaseUser"; name: string } | null;
        }
      | {
          __typename?: "PreparationService";
          id: string;
          type: CaseTypeEnum;
          shortName: string;
          state: string;
          stateText: string;
          attention: CaseAttentionEnum;
          awaiting?: string | null;
          isArchived: boolean;
          responsible?: { __typename?: "CaseUser"; name: string } | null;
        }
      | {
          __typename?: "RequestTenancy";
          id: string;
          type: CaseTypeEnum;
          shortName: string;
          state: string;
          stateText: string;
          attention: CaseAttentionEnum;
          awaiting?: string | null;
          isArchived: boolean;
          responsible?: { __typename?: "CaseUser"; name: string } | null;
        }
      | {
          __typename?: "UtilityAdministration";
          id: string;
          type: CaseTypeEnum;
          shortName: string;
          state: string;
          stateText: string;
          attention: CaseAttentionEnum;
          awaiting?: string | null;
          isArchived: boolean;
          responsible?: { __typename?: "CaseUser"; name: string } | null;
        }
    >;
  };
};

export type CaseCreatableTypesQueryVariables = Exact<{ [key: string]: never }>;

export type CaseCreatableTypesQuery = {
  __typename?: "Query";
  caseDefinitions: Array<{
    __typename?: "CaseDefinition";
    type: CaseTypeEnum;
    name: string;
    canCreate: boolean;
  }>;
};

export type CaseTextMacrosQueryVariables = Exact<{
  available: Array<Scalars["String"]["input"]> | Scalars["String"]["input"];
}>;

export type CaseTextMacrosQuery = {
  __typename?: "Query";
  textMacros: Array<{
    __typename?: "TextMacro";
    id: number;
    name: string;
    content: string;
  }>;
};

export type AttachmentCategoriesQueryVariables = Exact<{
  lang: Scalars["String"]["input"];
}>;

export type AttachmentCategoriesQuery = {
  __typename?: "Query";
  attachmentCategories: Array<{
    __typename?: "AttachmentCategory";
    id: string;
    nameDa: string;
    nameEn: string;
  }>;
};

export type EndTenancyReasonsQueryVariables = Exact<{ [key: string]: never }>;

export type EndTenancyReasonsQuery = {
  __typename?: "Query";
  endTenancyReasons: Array<{
    __typename?: "EndTenancyReason";
    id: string;
    label: string;
    isOther: boolean;
  }>;
};

export type CaseCreateFormQueryVariables = Exact<{
  propertyId: Scalars["ID"]["input"];
  includeApartments: Scalars["Boolean"]["input"];
  apartmentId: Scalars["ID"]["input"];
  includeTenancies: Scalars["Boolean"]["input"];
}>;

export type CaseCreateFormQuery = {
  __typename?: "Query";
  properties: {
    __typename?: "PropertyList";
    records: Array<{ __typename?: "Property"; id: string; name: string }>;
  };
  apartments?: {
    __typename?: "ApartmentList";
    records: Array<{ __typename?: "Apartment"; id: string; address: string }>;
  };
  tenancies?: {
    __typename?: "TenancyList";
    records: Array<{
      __typename?: "Tenancy";
      id: string;
      startDate: string;
      roles: Array<{
        __typename?: "TenancyRole";
        user: { __typename?: "User"; id: string; name: string };
      }>;
    }>;
  };
  timelogAccounts: Array<{
    __typename?: "TimelogAccount";
    id: string;
    name: string;
  }>;
};

export type ContractOptionsQueryVariables = Exact<{ [key: string]: never }>;

export type ContractOptionsQuery = {
  __typename?: "Query";
  contractOptions: {
    __typename?: "ContractOptions";
    types: Array<ContractTypeEnum>;
    endTenancyTerms: Array<EndTenancyTermsEnum>;
    locales: Array<ContractLocaleEnum>;
  };
};

export type CaseEconomicDebtorsQueryVariables = Exact<{
  tenancyId: Scalars["ID"]["input"];
}>;

export type CaseEconomicDebtorsQuery = {
  __typename?: "Query";
  economicDebtors: {
    __typename?: "EconomicDebtorList";
    records: Array<{
      __typename?: "EconomicDebtor";
      id: string;
      externalId: number;
      name: string;
      addressText?: string | null;
    }>;
  };
};

export type CaseShareFragment = {
  __typename?: "CaseShare";
  id: string;
  url: string;
  description: string;
  note: string;
  createdAt: any;
  expiresAt: any;
  revokedAt?: any | null;
  isActive: boolean;
  openedAt: Array<any>;
  deliveries: Array<{
    __typename?: "CaseShareDelivery";
    channel: CaseShareChannelEnum;
    recipient: string;
    sentAt: any;
  }>;
  selection: {
    __typename?: "CaseShareSelection";
    case: boolean;
    property: boolean;
    apartment: boolean;
    tenant: boolean;
    comments: boolean;
    inspection: boolean;
    attachments: {
      __typename?: "CaseShareItems";
      all: boolean;
      ids: Array<string>;
    };
    documents: {
      __typename?: "CaseShareItems";
      all: boolean;
      ids: Array<string>;
    };
    fieldGroups: {
      __typename?: "CaseShareGroups";
      property: Array<{
        __typename?: "CaseShareGroup";
        id: string;
        all: boolean;
        fieldIds: Array<string>;
      }>;
      apartment: Array<{
        __typename?: "CaseShareGroup";
        id: string;
        all: boolean;
        fieldIds: Array<string>;
      }>;
    };
  };
} & { " $fragmentName"?: "CaseShareFragment" };

export type CaseSharesQueryVariables = Exact<{
  caseId: Scalars["ID"]["input"];
}>;

export type CaseSharesQuery = {
  __typename?: "Query";
  case?:
    | {
        __typename?: "CleaningService";
        id: string;
        property?:
          | ({ __typename?: "Property" } & {
              " $fragmentRefs"?: {
                PropertyFieldGroupsFragment: PropertyFieldGroupsFragment;
              };
            })
          | null;
        apartment?:
          | ({ __typename?: "Apartment" } & {
              " $fragmentRefs"?: {
                ApartmentFieldGroupsFragment: ApartmentFieldGroupsFragment;
              };
            })
          | null;
        tenancy?: { __typename?: "Tenancy"; id: string } | null;
        inspection?: { __typename?: "Inspection"; createdAt: any } | null;
        attachments: Array<{
          __typename?: "CaseAttachment";
          id: string;
          fileName: string;
          thumbUrl: string;
          isImage: boolean;
          isPdf: boolean;
        }>;
        shareableDocuments: Array<{
          __typename?: "Document";
          id: string;
          title: string;
          createdAt: any;
        }>;
        shares: Array<
          { __typename?: "CaseShare" } & {
            " $fragmentRefs"?: { CaseShareFragment: CaseShareFragment };
          }
        >;
      }
    | {
        __typename?: "CreateTenancy";
        id: string;
        property?:
          | ({ __typename?: "Property" } & {
              " $fragmentRefs"?: {
                PropertyFieldGroupsFragment: PropertyFieldGroupsFragment;
              };
            })
          | null;
        apartment?:
          | ({ __typename?: "Apartment" } & {
              " $fragmentRefs"?: {
                ApartmentFieldGroupsFragment: ApartmentFieldGroupsFragment;
              };
            })
          | null;
        tenancy?: { __typename?: "Tenancy"; id: string } | null;
        inspection?: { __typename?: "Inspection"; createdAt: any } | null;
        attachments: Array<{
          __typename?: "CaseAttachment";
          id: string;
          fileName: string;
          thumbUrl: string;
          isImage: boolean;
          isPdf: boolean;
        }>;
        shareableDocuments: Array<{
          __typename?: "Document";
          id: string;
          title: string;
          createdAt: any;
        }>;
        shares: Array<
          { __typename?: "CaseShare" } & {
            " $fragmentRefs"?: { CaseShareFragment: CaseShareFragment };
          }
        >;
      }
    | {
        __typename?: "EndTenancy";
        id: string;
        property?:
          | ({ __typename?: "Property" } & {
              " $fragmentRefs"?: {
                PropertyFieldGroupsFragment: PropertyFieldGroupsFragment;
              };
            })
          | null;
        apartment?:
          | ({ __typename?: "Apartment" } & {
              " $fragmentRefs"?: {
                ApartmentFieldGroupsFragment: ApartmentFieldGroupsFragment;
              };
            })
          | null;
        tenancy?: { __typename?: "Tenancy"; id: string } | null;
        inspection?: { __typename?: "Inspection"; createdAt: any } | null;
        attachments: Array<{
          __typename?: "CaseAttachment";
          id: string;
          fileName: string;
          thumbUrl: string;
          isImage: boolean;
          isPdf: boolean;
        }>;
        shareableDocuments: Array<{
          __typename?: "Document";
          id: string;
          title: string;
          createdAt: any;
        }>;
        shares: Array<
          { __typename?: "CaseShare" } & {
            " $fragmentRefs"?: { CaseShareFragment: CaseShareFragment };
          }
        >;
      }
    | {
        __typename?: "FindTenancyAdministration";
        id: string;
        property?:
          | ({ __typename?: "Property" } & {
              " $fragmentRefs"?: {
                PropertyFieldGroupsFragment: PropertyFieldGroupsFragment;
              };
            })
          | null;
        apartment?:
          | ({ __typename?: "Apartment" } & {
              " $fragmentRefs"?: {
                ApartmentFieldGroupsFragment: ApartmentFieldGroupsFragment;
              };
            })
          | null;
        tenancy?: { __typename?: "Tenancy"; id: string } | null;
        inspection?: { __typename?: "Inspection"; createdAt: any } | null;
        attachments: Array<{
          __typename?: "CaseAttachment";
          id: string;
          fileName: string;
          thumbUrl: string;
          isImage: boolean;
          isPdf: boolean;
        }>;
        shareableDocuments: Array<{
          __typename?: "Document";
          id: string;
          title: string;
          createdAt: any;
        }>;
        shares: Array<
          { __typename?: "CaseShare" } & {
            " $fragmentRefs"?: { CaseShareFragment: CaseShareFragment };
          }
        >;
      }
    | {
        __typename?: "MiscAdministration";
        id: string;
        property?:
          | ({ __typename?: "Property" } & {
              " $fragmentRefs"?: {
                PropertyFieldGroupsFragment: PropertyFieldGroupsFragment;
              };
            })
          | null;
        apartment?:
          | ({ __typename?: "Apartment" } & {
              " $fragmentRefs"?: {
                ApartmentFieldGroupsFragment: ApartmentFieldGroupsFragment;
              };
            })
          | null;
        tenancy?: { __typename?: "Tenancy"; id: string } | null;
        inspection?: { __typename?: "Inspection"; createdAt: any } | null;
        attachments: Array<{
          __typename?: "CaseAttachment";
          id: string;
          fileName: string;
          thumbUrl: string;
          isImage: boolean;
          isPdf: boolean;
        }>;
        shareableDocuments: Array<{
          __typename?: "Document";
          id: string;
          title: string;
          createdAt: any;
        }>;
        shares: Array<
          { __typename?: "CaseShare" } & {
            " $fragmentRefs"?: { CaseShareFragment: CaseShareFragment };
          }
        >;
      }
    | {
        __typename?: "MiscService";
        id: string;
        property?:
          | ({ __typename?: "Property" } & {
              " $fragmentRefs"?: {
                PropertyFieldGroupsFragment: PropertyFieldGroupsFragment;
              };
            })
          | null;
        apartment?:
          | ({ __typename?: "Apartment" } & {
              " $fragmentRefs"?: {
                ApartmentFieldGroupsFragment: ApartmentFieldGroupsFragment;
              };
            })
          | null;
        tenancy?: { __typename?: "Tenancy"; id: string } | null;
        inspection?: { __typename?: "Inspection"; createdAt: any } | null;
        attachments: Array<{
          __typename?: "CaseAttachment";
          id: string;
          fileName: string;
          thumbUrl: string;
          isImage: boolean;
          isPdf: boolean;
        }>;
        shareableDocuments: Array<{
          __typename?: "Document";
          id: string;
          title: string;
          createdAt: any;
        }>;
        shares: Array<
          { __typename?: "CaseShare" } & {
            " $fragmentRefs"?: { CaseShareFragment: CaseShareFragment };
          }
        >;
      }
    | {
        __typename?: "MovingInService";
        id: string;
        property?:
          | ({ __typename?: "Property" } & {
              " $fragmentRefs"?: {
                PropertyFieldGroupsFragment: PropertyFieldGroupsFragment;
              };
            })
          | null;
        apartment?:
          | ({ __typename?: "Apartment" } & {
              " $fragmentRefs"?: {
                ApartmentFieldGroupsFragment: ApartmentFieldGroupsFragment;
              };
            })
          | null;
        tenancy?: { __typename?: "Tenancy"; id: string } | null;
        inspection?: { __typename?: "Inspection"; createdAt: any } | null;
        attachments: Array<{
          __typename?: "CaseAttachment";
          id: string;
          fileName: string;
          thumbUrl: string;
          isImage: boolean;
          isPdf: boolean;
        }>;
        shareableDocuments: Array<{
          __typename?: "Document";
          id: string;
          title: string;
          createdAt: any;
        }>;
        shares: Array<
          { __typename?: "CaseShare" } & {
            " $fragmentRefs"?: { CaseShareFragment: CaseShareFragment };
          }
        >;
      }
    | {
        __typename?: "MovingInTenancy";
        id: string;
        property?:
          | ({ __typename?: "Property" } & {
              " $fragmentRefs"?: {
                PropertyFieldGroupsFragment: PropertyFieldGroupsFragment;
              };
            })
          | null;
        apartment?:
          | ({ __typename?: "Apartment" } & {
              " $fragmentRefs"?: {
                ApartmentFieldGroupsFragment: ApartmentFieldGroupsFragment;
              };
            })
          | null;
        tenancy?: { __typename?: "Tenancy"; id: string } | null;
        inspection?: { __typename?: "Inspection"; createdAt: any } | null;
        attachments: Array<{
          __typename?: "CaseAttachment";
          id: string;
          fileName: string;
          thumbUrl: string;
          isImage: boolean;
          isPdf: boolean;
        }>;
        shareableDocuments: Array<{
          __typename?: "Document";
          id: string;
          title: string;
          createdAt: any;
        }>;
        shares: Array<
          { __typename?: "CaseShare" } & {
            " $fragmentRefs"?: { CaseShareFragment: CaseShareFragment };
          }
        >;
      }
    | {
        __typename?: "MovingOutService";
        id: string;
        property?:
          | ({ __typename?: "Property" } & {
              " $fragmentRefs"?: {
                PropertyFieldGroupsFragment: PropertyFieldGroupsFragment;
              };
            })
          | null;
        apartment?:
          | ({ __typename?: "Apartment" } & {
              " $fragmentRefs"?: {
                ApartmentFieldGroupsFragment: ApartmentFieldGroupsFragment;
              };
            })
          | null;
        tenancy?: { __typename?: "Tenancy"; id: string } | null;
        inspection?: { __typename?: "Inspection"; createdAt: any } | null;
        attachments: Array<{
          __typename?: "CaseAttachment";
          id: string;
          fileName: string;
          thumbUrl: string;
          isImage: boolean;
          isPdf: boolean;
        }>;
        shareableDocuments: Array<{
          __typename?: "Document";
          id: string;
          title: string;
          createdAt: any;
        }>;
        shares: Array<
          { __typename?: "CaseShare" } & {
            " $fragmentRefs"?: { CaseShareFragment: CaseShareFragment };
          }
        >;
      }
    | {
        __typename?: "MovingOutTenancy";
        id: string;
        property?:
          | ({ __typename?: "Property" } & {
              " $fragmentRefs"?: {
                PropertyFieldGroupsFragment: PropertyFieldGroupsFragment;
              };
            })
          | null;
        apartment?:
          | ({ __typename?: "Apartment" } & {
              " $fragmentRefs"?: {
                ApartmentFieldGroupsFragment: ApartmentFieldGroupsFragment;
              };
            })
          | null;
        tenancy?: { __typename?: "Tenancy"; id: string } | null;
        inspection?: { __typename?: "Inspection"; createdAt: any } | null;
        attachments: Array<{
          __typename?: "CaseAttachment";
          id: string;
          fileName: string;
          thumbUrl: string;
          isImage: boolean;
          isPdf: boolean;
        }>;
        shareableDocuments: Array<{
          __typename?: "Document";
          id: string;
          title: string;
          createdAt: any;
        }>;
        shares: Array<
          { __typename?: "CaseShare" } & {
            " $fragmentRefs"?: { CaseShareFragment: CaseShareFragment };
          }
        >;
      }
    | {
        __typename?: "MovingSettlementAdministration";
        id: string;
        property?:
          | ({ __typename?: "Property" } & {
              " $fragmentRefs"?: {
                PropertyFieldGroupsFragment: PropertyFieldGroupsFragment;
              };
            })
          | null;
        apartment?:
          | ({ __typename?: "Apartment" } & {
              " $fragmentRefs"?: {
                ApartmentFieldGroupsFragment: ApartmentFieldGroupsFragment;
              };
            })
          | null;
        tenancy?: { __typename?: "Tenancy"; id: string } | null;
        inspection?: { __typename?: "Inspection"; createdAt: any } | null;
        attachments: Array<{
          __typename?: "CaseAttachment";
          id: string;
          fileName: string;
          thumbUrl: string;
          isImage: boolean;
          isPdf: boolean;
        }>;
        shareableDocuments: Array<{
          __typename?: "Document";
          id: string;
          title: string;
          createdAt: any;
        }>;
        shares: Array<
          { __typename?: "CaseShare" } & {
            " $fragmentRefs"?: { CaseShareFragment: CaseShareFragment };
          }
        >;
      }
    | {
        __typename?: "PreparationService";
        id: string;
        property?:
          | ({ __typename?: "Property" } & {
              " $fragmentRefs"?: {
                PropertyFieldGroupsFragment: PropertyFieldGroupsFragment;
              };
            })
          | null;
        apartment?:
          | ({ __typename?: "Apartment" } & {
              " $fragmentRefs"?: {
                ApartmentFieldGroupsFragment: ApartmentFieldGroupsFragment;
              };
            })
          | null;
        tenancy?: { __typename?: "Tenancy"; id: string } | null;
        inspection?: { __typename?: "Inspection"; createdAt: any } | null;
        attachments: Array<{
          __typename?: "CaseAttachment";
          id: string;
          fileName: string;
          thumbUrl: string;
          isImage: boolean;
          isPdf: boolean;
        }>;
        shareableDocuments: Array<{
          __typename?: "Document";
          id: string;
          title: string;
          createdAt: any;
        }>;
        shares: Array<
          { __typename?: "CaseShare" } & {
            " $fragmentRefs"?: { CaseShareFragment: CaseShareFragment };
          }
        >;
      }
    | {
        __typename?: "RequestTenancy";
        id: string;
        property?:
          | ({ __typename?: "Property" } & {
              " $fragmentRefs"?: {
                PropertyFieldGroupsFragment: PropertyFieldGroupsFragment;
              };
            })
          | null;
        apartment?:
          | ({ __typename?: "Apartment" } & {
              " $fragmentRefs"?: {
                ApartmentFieldGroupsFragment: ApartmentFieldGroupsFragment;
              };
            })
          | null;
        tenancy?: { __typename?: "Tenancy"; id: string } | null;
        inspection?: { __typename?: "Inspection"; createdAt: any } | null;
        attachments: Array<{
          __typename?: "CaseAttachment";
          id: string;
          fileName: string;
          thumbUrl: string;
          isImage: boolean;
          isPdf: boolean;
        }>;
        shareableDocuments: Array<{
          __typename?: "Document";
          id: string;
          title: string;
          createdAt: any;
        }>;
        shares: Array<
          { __typename?: "CaseShare" } & {
            " $fragmentRefs"?: { CaseShareFragment: CaseShareFragment };
          }
        >;
      }
    | {
        __typename?: "UtilityAdministration";
        id: string;
        property?:
          | ({ __typename?: "Property" } & {
              " $fragmentRefs"?: {
                PropertyFieldGroupsFragment: PropertyFieldGroupsFragment;
              };
            })
          | null;
        apartment?:
          | ({ __typename?: "Apartment" } & {
              " $fragmentRefs"?: {
                ApartmentFieldGroupsFragment: ApartmentFieldGroupsFragment;
              };
            })
          | null;
        tenancy?: { __typename?: "Tenancy"; id: string } | null;
        inspection?: { __typename?: "Inspection"; createdAt: any } | null;
        attachments: Array<{
          __typename?: "CaseAttachment";
          id: string;
          fileName: string;
          thumbUrl: string;
          isImage: boolean;
          isPdf: boolean;
        }>;
        shareableDocuments: Array<{
          __typename?: "Document";
          id: string;
          title: string;
          createdAt: any;
        }>;
        shares: Array<
          { __typename?: "CaseShare" } & {
            " $fragmentRefs"?: { CaseShareFragment: CaseShareFragment };
          }
        >;
      }
    | null;
};

export type DataTableInterestListFragment = {
  __typename?: "InterestListPerson";
  id: string;
  name: string;
  email: string;
  phone: string;
  isBlacklisted: boolean;
  hasNewEntries: boolean;
  isProcessed: boolean;
  createdAt: any;
  properties: Array<{ __typename?: "Property"; id: string; name: string }>;
} & { " $fragmentName"?: "DataTableInterestListFragment" };

export type InterestListEntryCreateMutationVariables = Exact<{
  name: Scalars["String"]["input"];
  email: Scalars["String"]["input"];
  phone: Scalars["String"]["input"];
  message?: InputMaybe<Scalars["String"]["input"]>;
  channel?: InputMaybe<Scalars["String"]["input"]>;
  propertyIds: Array<Scalars["ID"]["input"]> | Scalars["ID"]["input"];
  failOnDuplicate?: InputMaybe<Scalars["Boolean"]["input"]>;
}>;

export type InterestListEntryCreateMutation = {
  __typename?: "Mutation";
  interestListEntryCreate?: {
    __typename?: "InterestListEntryCreateMutationPayload";
    personCreated?: boolean | null;
    duplicatePersonName?: string | null;
    errors?: Array<string> | null;
  } | null;
};

export type InterestListEntryDeleteMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
  note: Scalars["String"]["input"];
}>;

export type InterestListEntryDeleteMutation = {
  __typename?: "Mutation";
  interestListEntryDelete?: {
    __typename?: "InterestListEntryDeleteMutationPayload";
    errors: Array<string>;
  } | null;
};

export type InterestListNoteCreateMutationVariables = Exact<{
  entryId: Scalars["ID"]["input"];
  note: Scalars["String"]["input"];
}>;

export type InterestListNoteCreateMutation = {
  __typename?: "Mutation";
  interestListNoteCreate?: {
    __typename?: "InterestListNoteCreateMutationPayload";
    errors: Array<string>;
  } | null;
};

export type InterestListEntryUpdateMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
  seenAt?: InputMaybe<Scalars["ISO8601DateTime"]["input"]>;
}>;

export type InterestListEntryUpdateMutation = {
  __typename?: "Mutation";
  interestListEntryUpdate?: {
    __typename?: "InterestListEntryUpdateMutationPayload";
    errors: Array<string>;
  } | null;
};

export type InterestListPersonDeleteMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
  isBlacklisted?: InputMaybe<Scalars["Boolean"]["input"]>;
}>;

export type InterestListPersonDeleteMutation = {
  __typename?: "Mutation";
  interestListPersonDelete?: {
    __typename?: "InterestListPersonDeleteMutationPayload";
    errors: Array<string>;
  } | null;
};

export type InterestListPersonUpdateMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
  name?: InputMaybe<Scalars["String"]["input"]>;
  email?: InputMaybe<Scalars["String"]["input"]>;
  phone?: InputMaybe<Scalars["String"]["input"]>;
  isBlacklisted?: InputMaybe<Scalars["Boolean"]["input"]>;
}>;

export type InterestListPersonUpdateMutation = {
  __typename?: "Mutation";
  interestListPersonUpdate?: {
    __typename?: "InterestListPersonUpdateMutationPayload";
    errors: Array<string>;
  } | null;
};

export type InterestListPeopleQueryVariables = Exact<{
  offset: Scalars["Int"]["input"];
  limit: Scalars["Int"]["input"];
  orderBy: InterestListPersonOrderByEnum;
  where?: InputMaybe<InterestListPersonWhereInput>;
}>;

export type InterestListPeopleQuery = {
  __typename?: "Query";
  interestListPeople: {
    __typename?: "InterestListPersonList";
    total: number;
    records: Array<
      { __typename?: "InterestListPerson" } & {
        " $fragmentRefs"?: {
          DataTableInterestListFragment: DataTableInterestListFragment;
        };
      }
    >;
  };
};

export type InterestListPersonQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type InterestListPersonQuery = {
  __typename?: "Query";
  interestListPerson?: {
    __typename?: "InterestListPerson";
    id: string;
    name: string;
    email: string;
    phone: string;
    isBlacklisted: boolean;
    createdAt: any;
    entries: Array<{
      __typename?: "InterestListEntry";
      id: string;
      name: string;
      email: string;
      phone: string;
      message?: string | null;
      channel?: string | null;
      createdAt: any;
      seenAt?: any | null;
      deletedAt?: any | null;
      deletedReason?: string | null;
      deletedBy?: { __typename?: "User"; name: string } | null;
      properties: Array<{ __typename?: "Property"; id: string; name: string }>;
    }>;
    notes: Array<{
      __typename?: "InterestListNote";
      id: string;
      note: string;
      createdAt: any;
      user: { __typename?: "User"; id: string; name: string };
    }>;
  } | null;
};

export type InterestListEntryPropertiesQueryVariables = Exact<{
  [key: string]: never;
}>;

export type InterestListEntryPropertiesQuery = {
  __typename?: "Query";
  properties: {
    __typename?: "PropertyList";
    records: Array<{ __typename?: "Property"; id: string; name: string }>;
  };
};

export type CompaniesQueryVariables = Exact<{ [key: string]: never }>;

export type CompaniesQuery = {
  __typename?: "Query";
  companies: {
    __typename?: "CompanyList";
    records: Array<{
      __typename?: "Company";
      id: string;
      name: string;
      isOwner: boolean;
      isAdministrator: boolean;
    }>;
  };
};

export type PropertiesQueryVariables = Exact<{
  where: PropertyWhereInput;
  orderBy: PropertyOrderByEnum;
  offset: Scalars["Int"]["input"];
  limit: Scalars["Int"]["input"];
}>;

export type PropertiesQuery = {
  __typename?: "Query";
  properties: {
    __typename?: "PropertyList";
    total: number;
    records: Array<
      { __typename?: "Property" } & {
        " $fragmentRefs"?: {
          DataTablePropertiesFragment: DataTablePropertiesFragment;
        };
      }
    >;
  };
};

export type ScreenPropertyApartmentFragment = {
  __typename: "Apartment";
  id: string;
  publicId: string;
  address: string;
  city: string;
  key?: string | null;
  inactive?: boolean | null;
} & { " $fragmentName"?: "ScreenPropertyApartmentFragment" };

export type ScreenPropertyDetailsQueryVariables = Exact<{
  propertyId: Scalars["ID"]["input"];
}>;

export type ScreenPropertyDetailsQuery = {
  __typename?: "Query";
  properties: {
    __typename?: "PropertyList";
    records: Array<
      { __typename?: "Property" } & {
        " $fragmentRefs"?: {
          PropertyWithFieldGroupsFragment: PropertyWithFieldGroupsFragment;
        };
      }
    >;
  };
};

export type ScreenPropertyQueryVariables = Exact<{
  propertyId: Scalars["ID"]["input"];
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<ApartmentOrderByEnum>;
}>;

export type ScreenPropertyQuery = {
  __typename?: "Query";
  apartments: {
    __typename?: "ApartmentList";
    total: number;
    count: number;
    records: Array<
      { __typename?: "Apartment"; id: string } & {
        " $fragmentRefs"?: {
          ScreenPropertyApartmentFragment: ScreenPropertyApartmentFragment;
        };
      }
    >;
  };
};

export type FieldFragment = {
  __typename?: "Field";
  id: string;
  name: string;
  valueType: FieldValueTypeEnum;
  position: number;
  availableInProperty: boolean;
  availableInApartment: boolean;
  availableInTenancy: boolean;
  availableInService: boolean;
  enumOptions: Array<{
    __typename?: "FieldEnumOption";
    id: string;
    value: string;
  }>;
} & { " $fragmentName"?: "FieldFragment" };

export type CompanyFragment = {
  __typename?: "Company";
  name: string;
  email?: string | null;
  phone?: string | null;
  address?: string | null;
  city?: string | null;
  postalCode?: string | null;
} & { " $fragmentName"?: "CompanyFragment" };

export type PropertyWithFieldGroupsFragment = {
  __typename?: "Property";
  id: string;
  name: string;
  canUpdate: boolean;
  administrator: { __typename?: "Company" } & {
    " $fragmentRefs"?: { CompanyFragment: CompanyFragment };
  };
  owner: { __typename?: "Company" } & {
    " $fragmentRefs"?: { CompanyFragment: CompanyFragment };
  };
  fieldGroups: Array<{
    __typename?: "PropertyFieldGroup";
    id: string;
    name: string;
    position: number;
    values: Array<
      | {
          __typename?: "FieldValueBoolean";
          booleanValue?: boolean | null;
          field: { __typename?: "Field" } & {
            " $fragmentRefs"?: { FieldFragment: FieldFragment };
          };
        }
      | {
          __typename?: "FieldValueDatetime";
          datetimeValue?: any | null;
          field: { __typename?: "Field" } & {
            " $fragmentRefs"?: { FieldFragment: FieldFragment };
          };
        }
      | {
          __typename?: "FieldValueEnum";
          fieldEnumOptionId?: string | null;
          enumValue?: string | null;
          field: { __typename?: "Field" } & {
            " $fragmentRefs"?: { FieldFragment: FieldFragment };
          };
        }
      | {
          __typename?: "FieldValueNumber";
          numberValue?: number | null;
          field: { __typename?: "Field" } & {
            " $fragmentRefs"?: { FieldFragment: FieldFragment };
          };
        }
      | {
          __typename?: "FieldValueText";
          textValue?: string | null;
          field: { __typename?: "Field" } & {
            " $fragmentRefs"?: { FieldFragment: FieldFragment };
          };
        }
    >;
  }>;
} & { " $fragmentName"?: "PropertyWithFieldGroupsFragment" };

export type TenancyCreateMutationVariables = Exact<{
  apartment: Scalars["String"]["input"];
  startDate?: InputMaybe<Scalars["ISO8601Date"]["input"]>;
  endDate?: InputMaybe<Scalars["ISO8601Date"]["input"]>;
  depositAmount?: InputMaybe<Scalars["Float"]["input"]>;
  endTenancyTerms?: InputMaybe<Scalars["String"]["input"]>;
  user: TenancyUserInput;
}>;

export type TenancyCreateMutation = {
  __typename?: "Mutation";
  tenancyCreate?: {
    __typename?: "TenancyCreateMutationPayload";
    errors?: Array<string> | null;
    tenancy?: { __typename?: "Tenancy"; id: string } | null;
  } | null;
};

export type TenanciesQueryVariables = Exact<{
  where: TenancyWhereInput;
  orderBy: TenancyOrderByEnum;
  offset: Scalars["Int"]["input"];
  limit: Scalars["Int"]["input"];
}>;

export type TenanciesQuery = {
  __typename?: "Query";
  tenancies: {
    __typename?: "TenancyList";
    total: number;
    records: Array<
      { __typename?: "Tenancy" } & {
        " $fragmentRefs"?: {
          DataTableTenanciesFragment: DataTableTenanciesFragment;
        };
      }
    >;
  };
};

export type ScreenTenancyQueryVariables = Exact<{
  tenancyId: Scalars["ID"]["input"];
}>;

export type ScreenTenancyQuery = {
  __typename?: "Query";
  tenancy?: {
    __typename?: "Tenancy";
    id: string;
    apartment: { __typename?: "Apartment"; id: string };
  } | null;
};

export type AvailableFieldGroupsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type AvailableFieldGroupsQuery = {
  __typename?: "Query";
  fieldGroups: {
    __typename?: "FieldGroupList";
    records: Array<{
      __typename?: "FieldGroup";
      id: string;
      name: string;
      position: number;
      fields: Array<
        { __typename?: "Field" } & {
          " $fragmentRefs"?: { FieldFragment: FieldFragment };
        }
      >;
    }>;
  };
};

export type AvailableFieldGroupsPropertyQueryVariables = Exact<{
  propertyId: Scalars["ID"]["input"];
}>;

export type AvailableFieldGroupsPropertyQuery = {
  __typename?: "Query";
  property?: {
    __typename?: "Property";
    name: string;
    fieldGroups: Array<{
      __typename?: "PropertyFieldGroup";
      id: string;
      name: string;
      position: number;
    }>;
    availableFieldGroups: Array<{
      __typename?: "FieldGroup";
      id: string;
      name: string;
      position: number;
      fields: Array<
        { __typename?: "Field" } & {
          " $fragmentRefs"?: { FieldFragment: FieldFragment };
        }
      >;
    }>;
  } | null;
};

export type AvailableFieldGroupsApartmentQueryVariables = Exact<{
  apartmentId: Scalars["ID"]["input"];
}>;

export type AvailableFieldGroupsApartmentQuery = {
  __typename?: "Query";
  apartment?: {
    __typename?: "Apartment";
    publicId: string;
    fieldGroups: Array<{
      __typename?: "ApartmentFieldGroup";
      id: string;
      name: string;
      position: number;
    }>;
    availableFieldGroups: Array<{
      __typename?: "FieldGroup";
      id: string;
      name: string;
      position: number;
      fields: Array<
        { __typename?: "Field" } & {
          " $fragmentRefs"?: { FieldFragment: FieldFragment };
        }
      >;
    }>;
  } | null;
};

export type AvailableFieldGroupsTenancyQueryVariables = Exact<{
  tenancyId: Scalars["ID"]["input"];
}>;

export type AvailableFieldGroupsTenancyQuery = {
  __typename?: "Query";
  tenancy?: {
    __typename?: "Tenancy";
    id: string;
    fieldGroups: Array<{
      __typename?: "TenancyFieldGroup";
      id: string;
      name: string;
      position: number;
    }>;
    availableFieldGroups: Array<{
      __typename?: "FieldGroup";
      id: string;
      name: string;
      position: number;
      fields: Array<
        { __typename?: "Field" } & {
          " $fragmentRefs"?: { FieldFragment: FieldFragment };
        }
      >;
    }>;
  } | null;
};

export type PropertyUpdateMutationVariables = Exact<{
  propertyId: Scalars["ID"]["input"];
  fields?: InputMaybe<Array<FieldValueInput> | FieldValueInput>;
}>;

export type PropertyUpdateMutation = {
  __typename?: "Mutation";
  propertyUpdate?: {
    __typename?: "PropertyUpdateMutationPayload";
    errors: Array<string>;
    property?: {
      __typename?: "Property";
      id: string;
      fieldGroups: Array<{
        __typename?: "PropertyFieldGroup";
        id: string;
        name: string;
        position: number;
        values: Array<
          | {
              __typename?: "FieldValueBoolean";
              booleanValue?: boolean | null;
              field: { __typename?: "Field" } & {
                " $fragmentRefs"?: { FieldFragment: FieldFragment };
              };
            }
          | {
              __typename?: "FieldValueDatetime";
              datetimeValue?: any | null;
              field: { __typename?: "Field" } & {
                " $fragmentRefs"?: { FieldFragment: FieldFragment };
              };
            }
          | {
              __typename?: "FieldValueEnum";
              fieldEnumOptionId?: string | null;
              enumValue?: string | null;
              field: { __typename?: "Field" } & {
                " $fragmentRefs"?: { FieldFragment: FieldFragment };
              };
            }
          | {
              __typename?: "FieldValueNumber";
              numberValue?: number | null;
              field: { __typename?: "Field" } & {
                " $fragmentRefs"?: { FieldFragment: FieldFragment };
              };
            }
          | {
              __typename?: "FieldValueText";
              textValue?: string | null;
              field: { __typename?: "Field" } & {
                " $fragmentRefs"?: { FieldFragment: FieldFragment };
              };
            }
        >;
      }>;
    } | null;
  } | null;
};

export type ApartmentUpdateMutationVariables = Exact<{
  apartmentId: Scalars["ID"]["input"];
  fields?: InputMaybe<Array<FieldValueInput> | FieldValueInput>;
}>;

export type ApartmentUpdateMutation = {
  __typename?: "Mutation";
  apartmentUpdate?: {
    __typename?: "ApartmentUpdateMutationPayload";
    errors: Array<string>;
    apartment?: {
      __typename?: "Apartment";
      id: string;
      fieldGroups: Array<{
        __typename?: "ApartmentFieldGroup";
        id: string;
        name: string;
        position: number;
        values: Array<
          | {
              __typename?: "FieldValueBoolean";
              booleanValue?: boolean | null;
              field: { __typename?: "Field" } & {
                " $fragmentRefs"?: { FieldFragment: FieldFragment };
              };
            }
          | {
              __typename?: "FieldValueDatetime";
              datetimeValue?: any | null;
              field: { __typename?: "Field" } & {
                " $fragmentRefs"?: { FieldFragment: FieldFragment };
              };
            }
          | {
              __typename?: "FieldValueEnum";
              fieldEnumOptionId?: string | null;
              enumValue?: string | null;
              field: { __typename?: "Field" } & {
                " $fragmentRefs"?: { FieldFragment: FieldFragment };
              };
            }
          | {
              __typename?: "FieldValueNumber";
              numberValue?: number | null;
              field: { __typename?: "Field" } & {
                " $fragmentRefs"?: { FieldFragment: FieldFragment };
              };
            }
          | {
              __typename?: "FieldValueText";
              textValue?: string | null;
              field: { __typename?: "Field" } & {
                " $fragmentRefs"?: { FieldFragment: FieldFragment };
              };
            }
        >;
      }>;
    } | null;
  } | null;
};

export type TenancyUpdateMutationVariables = Exact<{
  tenancyId: Scalars["ID"]["input"];
  fields?: InputMaybe<Array<FieldValueInput> | FieldValueInput>;
}>;

export type TenancyUpdateMutation = {
  __typename?: "Mutation";
  tenancyUpdate?: {
    __typename?: "TenancyUpdateMutationPayload";
    errors?: Array<string> | null;
    tenancy?: {
      __typename?: "Tenancy";
      id: string;
      fieldGroups: Array<{
        __typename?: "TenancyFieldGroup";
        id: string;
        name: string;
        position: number;
        values: Array<
          | {
              __typename?: "FieldValueBoolean";
              booleanValue?: boolean | null;
              field: { __typename?: "Field" } & {
                " $fragmentRefs"?: { FieldFragment: FieldFragment };
              };
            }
          | {
              __typename?: "FieldValueDatetime";
              datetimeValue?: any | null;
              field: { __typename?: "Field" } & {
                " $fragmentRefs"?: { FieldFragment: FieldFragment };
              };
            }
          | {
              __typename?: "FieldValueEnum";
              fieldEnumOptionId?: string | null;
              enumValue?: string | null;
              field: { __typename?: "Field" } & {
                " $fragmentRefs"?: { FieldFragment: FieldFragment };
              };
            }
          | {
              __typename?: "FieldValueNumber";
              numberValue?: number | null;
              field: { __typename?: "Field" } & {
                " $fragmentRefs"?: { FieldFragment: FieldFragment };
              };
            }
          | {
              __typename?: "FieldValueText";
              textValue?: string | null;
              field: { __typename?: "Field" } & {
                " $fragmentRefs"?: { FieldFragment: FieldFragment };
              };
            }
        >;
      }>;
    } | null;
  } | null;
};

export type PropertyFieldGroupsFragment = {
  __typename?: "Property";
  id: string;
  fieldGroups: Array<{
    __typename?: "PropertyFieldGroup";
    id: string;
    name: string;
    position: number;
    values: Array<
      | {
          __typename?: "FieldValueBoolean";
          booleanValue?: boolean | null;
          field: { __typename?: "Field" } & {
            " $fragmentRefs"?: { FieldFragment: FieldFragment };
          };
        }
      | {
          __typename?: "FieldValueDatetime";
          datetimeValue?: any | null;
          field: { __typename?: "Field" } & {
            " $fragmentRefs"?: { FieldFragment: FieldFragment };
          };
        }
      | {
          __typename?: "FieldValueEnum";
          fieldEnumOptionId?: string | null;
          enumValue?: string | null;
          field: { __typename?: "Field" } & {
            " $fragmentRefs"?: { FieldFragment: FieldFragment };
          };
        }
      | {
          __typename?: "FieldValueNumber";
          numberValue?: number | null;
          field: { __typename?: "Field" } & {
            " $fragmentRefs"?: { FieldFragment: FieldFragment };
          };
        }
      | {
          __typename?: "FieldValueText";
          textValue?: string | null;
          field: { __typename?: "Field" } & {
            " $fragmentRefs"?: { FieldFragment: FieldFragment };
          };
        }
    >;
  }>;
} & { " $fragmentName"?: "PropertyFieldGroupsFragment" };

export type ApartmentFieldGroupsFragment = {
  __typename?: "Apartment";
  id: string;
  fieldGroups: Array<{
    __typename?: "ApartmentFieldGroup";
    id: string;
    name: string;
    position: number;
    values: Array<
      | {
          __typename?: "FieldValueBoolean";
          booleanValue?: boolean | null;
          field: { __typename?: "Field" } & {
            " $fragmentRefs"?: { FieldFragment: FieldFragment };
          };
        }
      | {
          __typename?: "FieldValueDatetime";
          datetimeValue?: any | null;
          field: { __typename?: "Field" } & {
            " $fragmentRefs"?: { FieldFragment: FieldFragment };
          };
        }
      | {
          __typename?: "FieldValueEnum";
          fieldEnumOptionId?: string | null;
          enumValue?: string | null;
          field: { __typename?: "Field" } & {
            " $fragmentRefs"?: { FieldFragment: FieldFragment };
          };
        }
      | {
          __typename?: "FieldValueNumber";
          numberValue?: number | null;
          field: { __typename?: "Field" } & {
            " $fragmentRefs"?: { FieldFragment: FieldFragment };
          };
        }
      | {
          __typename?: "FieldValueText";
          textValue?: string | null;
          field: { __typename?: "Field" } & {
            " $fragmentRefs"?: { FieldFragment: FieldFragment };
          };
        }
    >;
  }>;
} & { " $fragmentName"?: "ApartmentFieldGroupsFragment" };

export type ApartmentInheritedFieldsQueryVariables = Exact<{
  apartmentId: Scalars["ID"]["input"];
}>;

export type ApartmentInheritedFieldsQuery = {
  __typename?: "Query";
  apartment?: {
    __typename?: "Apartment";
    id: string;
    property: { __typename?: "Property" } & {
      " $fragmentRefs"?: {
        PropertyFieldGroupsFragment: PropertyFieldGroupsFragment;
      };
    };
  } | null;
};

export type TenancyInheritedFieldsQueryVariables = Exact<{
  apartmentId: Scalars["ID"]["input"];
}>;

export type TenancyInheritedFieldsQuery = {
  __typename?: "Query";
  apartment?:
    | ({
        __typename?: "Apartment";
        id: string;
        property: { __typename?: "Property" } & {
          " $fragmentRefs"?: {
            PropertyFieldGroupsFragment: PropertyFieldGroupsFragment;
          };
        };
      } & {
        " $fragmentRefs"?: {
          ApartmentFieldGroupsFragment: ApartmentFieldGroupsFragment;
        };
      })
    | null;
};

export type CurrentUserQueryVariables = Exact<{ [key: string]: never }>;

export type CurrentUserQuery = {
  __typename?: "Query";
  currentUser?:
    | ({ __typename?: "User" } & {
        " $fragmentRefs"?: {
          CurrentUserFragmentFragment: CurrentUserFragmentFragment;
        };
      })
    | null;
};

export type CurrentUserFragmentFragment = {
  __typename: "User";
  id: string;
  name: string;
  email: string;
  isSystemAdministrator: boolean;
  isServiceAdministrator: boolean;
  isServiceCaseWorker: boolean;
  isAdministrator: boolean;
  locale: string;
} & { " $fragmentName"?: "CurrentUserFragmentFragment" };

export type ShortcutFragmentFragment = {
  __typename?: "Shortcut";
  id: string;
  type: string;
  name: string;
  state: any;
} & { " $fragmentName"?: "ShortcutFragmentFragment" };

export type ShortcutQueryVariables = Exact<{
  shortcutId: Scalars["ID"]["input"];
}>;

export type ShortcutQuery = {
  __typename?: "Query";
  currentUser?: {
    __typename?: "User";
    shortcut?:
      | ({ __typename?: "Shortcut" } & {
          " $fragmentRefs"?: {
            ShortcutFragmentFragment: ShortcutFragmentFragment;
          };
        })
      | null;
  } | null;
};

export const PersonalAccessTokenTokenFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PersonalAccessTokenTokenFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "PersonalAccessToken" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "token" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PersonalAccessTokenTokenFragmentFragment, unknown>;
export const DataTableApartmentsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DataTableApartments" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Apartment" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "publicId" } },
          { kind: "Field", name: { kind: "Name", value: "address" } },
          { kind: "Field", name: { kind: "Name", value: "city" } },
          { kind: "Field", name: { kind: "Name", value: "key" } },
          {
            kind: "Field",
            alias: { kind: "Name", value: "service" },
            name: { kind: "Name", value: "activeServiceCasesCount" },
          },
          { kind: "Field", name: { kind: "Name", value: "inactive" } },
          { kind: "Field", name: { kind: "Name", value: "inactiveStartDate" } },
          { kind: "Field", name: { kind: "Name", value: "inactiveEndDate" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "inactiveDescription" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "property" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "previousTenancy" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "startDate" } },
                { kind: "Field", name: { kind: "Name", value: "endDate" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "requestedEndDate" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "intervalAmount" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "intervalAmountType" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "depositAmount" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "depositDueDate" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "heatingAmount" },
                },
                { kind: "Field", name: { kind: "Name", value: "waterAmount" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "electricityAmount" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                      { kind: "Field", name: { kind: "Name", value: "phone" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "protected" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "expectedMovingInCases" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "icon" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "expectedMovingOutCases" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "icon" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "movingInCase" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "icon" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "attention" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "children" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "type" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "shortName" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "icon" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "attention" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "movingOutCase" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "icon" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "attention" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "children" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "type" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "shortName" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "icon" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "attention" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "contractCase" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "attention" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "awaiting" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "stateText" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "economic" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "debtor" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "externalId" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "rentAmount" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "parkingAmount" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "rentReductionAmount" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "regulationDepositAmount",
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "regulationPrepaidRentAmount",
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "advanceWasteWaterAmount",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "advanceWaterAmount" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "advanceHeatingAmount" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "advanceElectricityAmount",
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "settlementWasteWaterAmount",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "settlementWaterAmount" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "settlementHeatingAmount",
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "settlementElectricityAmount",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "otherAmount" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "companySyncedAt" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "deposit" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "prepaidRent" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "currentTenancy" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "startDate" } },
                { kind: "Field", name: { kind: "Name", value: "endDate" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "requestedEndDate" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "depositAmount" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "intervalAmount" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "intervalAmountType" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "depositDueDate" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "heatingAmount" },
                },
                { kind: "Field", name: { kind: "Name", value: "waterAmount" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "electricityAmount" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                      { kind: "Field", name: { kind: "Name", value: "phone" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "protected" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "expectedMovingInCases" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "icon" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "expectedMovingOutCases" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "icon" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "movingInCase" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "icon" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "attention" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "children" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "type" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "shortName" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "icon" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "attention" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "movingOutCase" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "icon" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "attention" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "children" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "type" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "shortName" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "icon" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "attention" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "contractCase" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "attention" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "awaiting" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "stateText" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "economic" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "debtor" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "externalId" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "rentAmount" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "parkingAmount" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "rentReductionAmount" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "regulationDepositAmount",
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "regulationPrepaidRentAmount",
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "advanceWasteWaterAmount",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "advanceWaterAmount" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "advanceHeatingAmount" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "advanceElectricityAmount",
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "settlementWasteWaterAmount",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "settlementWaterAmount" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "settlementHeatingAmount",
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "settlementElectricityAmount",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "otherAmount" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "companySyncedAt" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "deposit" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "prepaidRent" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "nextTenancy" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "startDate" } },
                { kind: "Field", name: { kind: "Name", value: "endDate" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "requestedEndDate" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "intervalAmount" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "intervalAmountType" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "depositAmount" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "depositDueDate" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "heatingAmount" },
                },
                { kind: "Field", name: { kind: "Name", value: "waterAmount" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "electricityAmount" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                      { kind: "Field", name: { kind: "Name", value: "phone" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "protected" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "expectedMovingInCases" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "icon" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "expectedMovingOutCases" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "icon" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "movingInCase" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "icon" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "attention" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "children" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "type" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "shortName" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "icon" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "attention" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "movingOutCase" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "icon" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "attention" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "children" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "type" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "shortName" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "icon" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "attention" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "contractCase" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "attention" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "awaiting" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "stateText" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "economic" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "debtor" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "externalId" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "rentAmount" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "parkingAmount" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "rentReductionAmount" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "regulationDepositAmount",
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "regulationPrepaidRentAmount",
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "advanceWasteWaterAmount",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "advanceWaterAmount" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "advanceHeatingAmount" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "advanceElectricityAmount",
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "settlementWasteWaterAmount",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "settlementWaterAmount" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "settlementHeatingAmount",
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "settlementElectricityAmount",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "otherAmount" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "companySyncedAt" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "deposit" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "prepaidRent" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DataTableApartmentsFragment, unknown>;
export const DataTableCasesFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DataTableCases" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CaseInterface" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "icon" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "shortName" } },
          { kind: "Field", name: { kind: "Name", value: "state" } },
          { kind: "Field", name: { kind: "Name", value: "stateText" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "stateLastChangedAt" },
          },
          { kind: "Field", name: { kind: "Name", value: "attention" } },
          { kind: "Field", name: { kind: "Name", value: "awaiting" } },
          { kind: "Field", name: { kind: "Name", value: "startAfter" } },
          { kind: "Field", name: { kind: "Name", value: "completeBefore" } },
          { kind: "Field", name: { kind: "Name", value: "scheduledDate" } },
          { kind: "Field", name: { kind: "Name", value: "scheduledTime" } },
          { kind: "Field", name: { kind: "Name", value: "isAttending" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "serviceTeam" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "requester" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "email" } },
                { kind: "Field", name: { kind: "Name", value: "phone" } },
                { kind: "Field", name: { kind: "Name", value: "protected" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "responsible" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "email" } },
                { kind: "Field", name: { kind: "Name", value: "phone" } },
                { kind: "Field", name: { kind: "Name", value: "protected" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "property" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "apartment" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "publicId" } },
                { kind: "Field", name: { kind: "Name", value: "address" } },
                { kind: "Field", name: { kind: "Name", value: "postalCode" } },
                { kind: "Field", name: { kind: "Name", value: "city" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "tenancy" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "startDate" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "requestedEndDate" },
                },
                { kind: "Field", name: { kind: "Name", value: "endDate" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                      { kind: "Field", name: { kind: "Name", value: "phone" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "protected" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DataTableCasesFragment, unknown>;
export const EconomicSubscriberFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "EconomicSubscriber" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "EconomicSubscriber" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "price" } },
          { kind: "Field", name: { kind: "Name", value: "canceledAt" } },
          { kind: "Field", name: { kind: "Name", value: "intervalStartAt" } },
          { kind: "Field", name: { kind: "Name", value: "intervalEndAt" } },
          { kind: "Field", name: { kind: "Name", value: "signedUpAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "debtor" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "addressText" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "subscription" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "intervalType" },
                },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<EconomicSubscriberFragment, unknown>;
export const DataTablePropertiesFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DataTableProperties" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Property" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "activeServiceCasesCount" },
          },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "administrator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "owner" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DataTablePropertiesFragment, unknown>;
export const DataTableTenanciesFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DataTableTenancies" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Tenancy" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "startDate" } },
          { kind: "Field", name: { kind: "Name", value: "endDate" } },
          { kind: "Field", name: { kind: "Name", value: "requestedEndDate" } },
          { kind: "Field", name: { kind: "Name", value: "depositAmount" } },
          { kind: "Field", name: { kind: "Name", value: "depositDueDate" } },
          { kind: "Field", name: { kind: "Name", value: "intervalAmount" } },
          { kind: "Field", name: { kind: "Name", value: "heatingAmount" } },
          { kind: "Field", name: { kind: "Name", value: "waterAmount" } },
          { kind: "Field", name: { kind: "Name", value: "electricityAmount" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "expectedMovingInCases" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "type" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "icon" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "expectedMovingOutCases" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "type" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "icon" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "movingInCase" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "icon" } },
                { kind: "Field", name: { kind: "Name", value: "attention" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "children" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "shortName" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "icon" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "attention" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "movingOutCase" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "icon" } },
                { kind: "Field", name: { kind: "Name", value: "attention" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "children" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "shortName" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "icon" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "attention" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contractCase" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "icon" } },
                { kind: "Field", name: { kind: "Name", value: "attention" } },
                { kind: "Field", name: { kind: "Name", value: "stateText" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "phone" } },
                { kind: "Field", name: { kind: "Name", value: "email" } },
                { kind: "Field", name: { kind: "Name", value: "protected" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "apartment" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "publicId" } },
                { kind: "Field", name: { kind: "Name", value: "address" } },
                { kind: "Field", name: { kind: "Name", value: "city" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "economic" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "debtor" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "externalId" },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "deposit" } },
                { kind: "Field", name: { kind: "Name", value: "prepaidRent" } },
                { kind: "Field", name: { kind: "Name", value: "rentAmount" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "parkingAmount" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "rentReductionAmount" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "regulationDepositAmount" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "regulationPrepaidRentAmount" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "advanceWasteWaterAmount" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "advanceWaterAmount" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "advanceHeatingAmount" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "advanceElectricityAmount" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "settlementWasteWaterAmount" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "settlementWaterAmount" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "settlementHeatingAmount" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "settlementElectricityAmount" },
                },
                { kind: "Field", name: { kind: "Name", value: "otherAmount" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "companySyncedAt" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DataTableTenanciesFragment, unknown>;
export const CaseDefinitionCaseFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CaseDefinitionCaseFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CaseInterface" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "shortName" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "icon" } },
          { kind: "Field", name: { kind: "Name", value: "attention" } },
          { kind: "Field", name: { kind: "Name", value: "awaiting" } },
          { kind: "Field", name: { kind: "Name", value: "state" } },
          { kind: "Field", name: { kind: "Name", value: "stateText" } },
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CaseDefinitionCaseFragmentFragment, unknown>;
export const CaseDefinitionInfoFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CaseDefinitionInfoFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CaseDefinition" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "icon" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CaseDefinitionInfoFragmentFragment, unknown>;
export const ShortcutsListShortcutFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ShortcutsListShortcut" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Shortcut" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ShortcutsListShortcutFragment, unknown>;
export const ScreenApartment_ApartmentJournalFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ScreenApartment_ApartmentJournal" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "TenancyNoteList" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "records" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "content" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "attachments" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "fileName" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ScreenApartment_ApartmentJournalFragment, unknown>;
export const ScreenApartment_CaseFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ScreenApartment_Case" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CaseInterface" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "attention" } },
          { kind: "Field", name: { kind: "Name", value: "awaiting" } },
          { kind: "Field", name: { kind: "Name", value: "body" } },
          { kind: "Field", name: { kind: "Name", value: "completeBefore" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "icon" } },
          { kind: "Field", name: { kind: "Name", value: "isArchived" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "scheduledTime" } },
          { kind: "Field", name: { kind: "Name", value: "state" } },
          { kind: "Field", name: { kind: "Name", value: "stateText" } },
          { kind: "Field", name: { kind: "Name", value: "startAfter" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "apartment" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "address" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "responsible" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "CleaningService" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "parent" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "scheduledDate" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "scheduledDate" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "unreadCommentsCount" },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "CreateTenancy" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "unreadCommentsCount" },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "EndTenancy" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "awaiting" } },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "FindTenancyAdministration" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "parent" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "scheduledDate" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "MiscAdministration" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "parent" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "apartment" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "address" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "scheduledDate" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "scheduledDate" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "unreadCommentsCount" },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "MiscService" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "parent" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "apartment" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "address" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "scheduledDate" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "scheduledDate" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "unreadCommentsCount" },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "MovingInService" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "isAttending" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "unreadCommentsCount" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "parent" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "apartment" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "address" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "scheduledDate" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "MovingInTenancy" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "unreadCommentsCount" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "scheduledDate" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "parent" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "scheduledDate" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "MovingOutService" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "parent" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "scheduledDate" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "scheduledDate" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "unreadCommentsCount" },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "MovingOutTenancy" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "unreadCommentsCount" },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "MovingSettlementAdministration" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "apartment" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "address" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "parent" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "scheduledDate" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "scheduledDate" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "unreadCommentsCount" },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "PreparationService" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "scheduledDate" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "apartment" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "address" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "parent" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "scheduledDate" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "unreadCommentsCount" },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "RequestTenancy" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "unreadCommentsCount" },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "UtilityAdministration" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "parent" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "scheduledDate" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "unreadCommentsCount" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ScreenApartment_CaseFragment, unknown>;
export const ScreenApartment_ContractFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ScreenApartment_Contract" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Tenancy" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "startDate" } },
          { kind: "Field", name: { kind: "Name", value: "endDate" } },
          { kind: "Field", name: { kind: "Name", value: "intervalAmount" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "intervalAmountType" },
          },
          { kind: "Field", name: { kind: "Name", value: "depositAmount" } },
          { kind: "Field", name: { kind: "Name", value: "hasEndTenancyCase" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "endTenancyTermsCondition" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contractCase" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "state" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "contract" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ScreenApartment_ContractFragment, unknown>;
export const ScreenApartment_DocumentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ScreenApartment_Document" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Document" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ScreenApartment_DocumentFragment, unknown>;
export const ScreenApartment_EconomicFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ScreenApartment_Economic" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "TenancyEconomic" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "debtor" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "addressText" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "subscriptions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "interval" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "currentAmount" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "deposit" } },
          { kind: "Field", name: { kind: "Name", value: "prepaidRent" } },
          { kind: "Field", name: { kind: "Name", value: "companySyncedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ScreenApartment_EconomicFragment, unknown>;
export const ScreenApartment_LandlordFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ScreenApartment_Landlord" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Property" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "name" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "owner" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "phone" } },
                { kind: "Field", name: { kind: "Name", value: "email" } },
                { kind: "Field", name: { kind: "Name", value: "address" } },
                { kind: "Field", name: { kind: "Name", value: "postalCode" } },
                { kind: "Field", name: { kind: "Name", value: "city" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ScreenApartment_LandlordFragment, unknown>;
export const ScreenApartment_ManageTenantsAndResidentsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: {
        kind: "Name",
        value: "ScreenApartment_ManageTenantsAndResidents",
      },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Tenancy" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "residents" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "email" } },
                { kind: "Field", name: { kind: "Name", value: "phone" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "roles" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "isPrimary" } },
                { kind: "Field", name: { kind: "Name", value: "isResident" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                      { kind: "Field", name: { kind: "Name", value: "phone" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "protected" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "isPhoneConfirmed" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "isExternal" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "removable" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ScreenApartment_ManageTenantsAndResidentsFragment,
  unknown
>;
export const ScreenApartment_MessageFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ScreenApartment_Message" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Message" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "body" } },
          { kind: "Field", name: { kind: "Name", value: "authorId" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "emailsSentAt" } },
          { kind: "Field", name: { kind: "Name", value: "smsSentAt" } },
          { kind: "Field", name: { kind: "Name", value: "apartment" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "property" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ScreenApartment_MessageFragment, unknown>;
export const ServiceCaseScreenFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ServiceCaseScreen" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CaseInterface" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "completed" } },
          { kind: "Field", name: { kind: "Name", value: "inspected" } },
          { kind: "Field", name: { kind: "Name", value: "processing" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "tenancy" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "inspection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "mayProcess" } },
                { kind: "Field", name: { kind: "Name", value: "canProcess" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "answers" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "area" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "subject" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "description" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "rating" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "position" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "note" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "cleaning" } },
                { kind: "Field", name: { kind: "Name", value: "other" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "keys" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "description" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "keyMissing" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "count" } },
                      { kind: "Field", name: { kind: "Name", value: "total" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "meters" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "description" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "tenantSignature" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "tenantSignedBy" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "landlordSignature" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "landlordSignedBy" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "document" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ServiceCaseScreenFragment, unknown>;
export const CaseShareFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CaseShare" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CaseShare" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "note" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "expiresAt" } },
          { kind: "Field", name: { kind: "Name", value: "revokedAt" } },
          { kind: "Field", name: { kind: "Name", value: "isActive" } },
          { kind: "Field", name: { kind: "Name", value: "openedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "deliveries" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "channel" } },
                { kind: "Field", name: { kind: "Name", value: "recipient" } },
                { kind: "Field", name: { kind: "Name", value: "sentAt" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "selection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "case" } },
                { kind: "Field", name: { kind: "Name", value: "property" } },
                { kind: "Field", name: { kind: "Name", value: "apartment" } },
                { kind: "Field", name: { kind: "Name", value: "tenant" } },
                { kind: "Field", name: { kind: "Name", value: "comments" } },
                { kind: "Field", name: { kind: "Name", value: "inspection" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "attachments" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "all" } },
                      { kind: "Field", name: { kind: "Name", value: "ids" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "documents" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "all" } },
                      { kind: "Field", name: { kind: "Name", value: "ids" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "fieldGroups" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "property" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "all" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "fieldIds" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "apartment" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "all" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "fieldIds" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CaseShareFragment, unknown>;
export const DataTableInterestListFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DataTableInterestList" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "InterestListPerson" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "phone" } },
          { kind: "Field", name: { kind: "Name", value: "isBlacklisted" } },
          { kind: "Field", name: { kind: "Name", value: "hasNewEntries" } },
          { kind: "Field", name: { kind: "Name", value: "isProcessed" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "properties" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DataTableInterestListFragment, unknown>;
export const ScreenPropertyApartmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ScreenPropertyApartment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Apartment" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "publicId" } },
          { kind: "Field", name: { kind: "Name", value: "address" } },
          { kind: "Field", name: { kind: "Name", value: "city" } },
          { kind: "Field", name: { kind: "Name", value: "key" } },
          { kind: "Field", name: { kind: "Name", value: "inactive" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ScreenPropertyApartmentFragment, unknown>;
export const CompanyFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Company" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Company" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "phone" } },
          { kind: "Field", name: { kind: "Name", value: "address" } },
          { kind: "Field", name: { kind: "Name", value: "city" } },
          { kind: "Field", name: { kind: "Name", value: "postalCode" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CompanyFragment, unknown>;
export const FieldFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Field" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Field" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "valueType" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "enumOptions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "value" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "position" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "availableInProperty" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "availableInApartment" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "availableInTenancy" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "availableInService" },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FieldFragment, unknown>;
export const PropertyWithFieldGroupsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PropertyWithFieldGroups" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Property" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "canUpdate" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "administrator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Company" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "owner" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Company" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "fieldGroups" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "position" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "values" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "field" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "Field" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "FieldValueText" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              alias: { kind: "Name", value: "textValue" },
                              name: { kind: "Name", value: "value" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "FieldValueNumber" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              alias: { kind: "Name", value: "numberValue" },
                              name: { kind: "Name", value: "value" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "FieldValueBoolean" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              alias: { kind: "Name", value: "booleanValue" },
                              name: { kind: "Name", value: "value" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "FieldValueEnum" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              alias: { kind: "Name", value: "enumValue" },
                              name: { kind: "Name", value: "value" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "fieldEnumOptionId",
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "FieldValueDatetime" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              alias: { kind: "Name", value: "datetimeValue" },
                              name: { kind: "Name", value: "value" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Company" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Company" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "phone" } },
          { kind: "Field", name: { kind: "Name", value: "address" } },
          { kind: "Field", name: { kind: "Name", value: "city" } },
          { kind: "Field", name: { kind: "Name", value: "postalCode" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Field" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Field" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "valueType" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "enumOptions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "value" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "position" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "availableInProperty" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "availableInApartment" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "availableInTenancy" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "availableInService" },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PropertyWithFieldGroupsFragment, unknown>;
export const PropertyFieldGroupsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PropertyFieldGroups" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Property" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "fieldGroups" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "position" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "values" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "field" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "Field" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "FieldValueText" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              alias: { kind: "Name", value: "textValue" },
                              name: { kind: "Name", value: "value" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "FieldValueNumber" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              alias: { kind: "Name", value: "numberValue" },
                              name: { kind: "Name", value: "value" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "FieldValueBoolean" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              alias: { kind: "Name", value: "booleanValue" },
                              name: { kind: "Name", value: "value" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "FieldValueEnum" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              alias: { kind: "Name", value: "enumValue" },
                              name: { kind: "Name", value: "value" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "fieldEnumOptionId",
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "FieldValueDatetime" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              alias: { kind: "Name", value: "datetimeValue" },
                              name: { kind: "Name", value: "value" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Field" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Field" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "valueType" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "enumOptions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "value" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "position" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "availableInProperty" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "availableInApartment" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "availableInTenancy" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "availableInService" },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PropertyFieldGroupsFragment, unknown>;
export const ApartmentFieldGroupsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ApartmentFieldGroups" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Apartment" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "fieldGroups" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "position" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "values" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "field" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "Field" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "FieldValueText" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              alias: { kind: "Name", value: "textValue" },
                              name: { kind: "Name", value: "value" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "FieldValueNumber" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              alias: { kind: "Name", value: "numberValue" },
                              name: { kind: "Name", value: "value" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "FieldValueBoolean" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              alias: { kind: "Name", value: "booleanValue" },
                              name: { kind: "Name", value: "value" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "FieldValueEnum" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              alias: { kind: "Name", value: "enumValue" },
                              name: { kind: "Name", value: "value" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "fieldEnumOptionId",
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "FieldValueDatetime" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              alias: { kind: "Name", value: "datetimeValue" },
                              name: { kind: "Name", value: "value" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Field" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Field" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "valueType" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "enumOptions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "value" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "position" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "availableInProperty" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "availableInApartment" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "availableInTenancy" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "availableInService" },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ApartmentFieldGroupsFragment, unknown>;
export const CurrentUserFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CurrentUserFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "isSystemAdministrator" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "isServiceAdministrator" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "isServiceCaseWorker" },
          },
          { kind: "Field", name: { kind: "Name", value: "isAdministrator" } },
          { kind: "Field", name: { kind: "Name", value: "locale" } },
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CurrentUserFragmentFragment, unknown>;
export const ShortcutFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ShortcutFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Shortcut" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "state" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ShortcutFragmentFragment, unknown>;
export const PersonalAccessTokensQueryDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "PersonalAccessTokensQuery" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "currentUser" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "personalAccessTokens" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "nodes" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: {
                                kind: "Name",
                                value: "PersonalAccessTokenTokenFragment",
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PersonalAccessTokenTokenFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "PersonalAccessToken" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "token" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PersonalAccessTokensQueryQuery,
  PersonalAccessTokensQueryQueryVariables
>;
export const CreatePersonalAccessTokenDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CreatePersonalAccessToken" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "name" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            alias: { kind: "Name", value: "result" },
            name: { kind: "Name", value: "personalAccessTokenCreate" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "name" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "name" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "errors" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "personalAccessToken" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "token" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreatePersonalAccessTokenMutation,
  CreatePersonalAccessTokenMutationVariables
>;
export const PersonalAccessTokenDeleteDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "PersonalAccessTokenDelete" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "personalAccessTokenDelete" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "errors" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PersonalAccessTokenDeleteMutation,
  PersonalAccessTokenDeleteMutationVariables
>;
export const ApartmentsCalendarDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "ApartmentsCalendar" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "tenancyWhere" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "TenancyWhereInput" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "caseWhere" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "CaseWhereInput" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "tenancies" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "tenancyWhere" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: { kind: "IntValue", value: "1000" },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "records" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "startDate" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "endDate" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "movingInCase" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "attention" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "movingOutCase" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "attention" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "user" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "apartment" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "cases" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "caseWhere" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: { kind: "IntValue", value: "1000" },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "records" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      { kind: "Field", name: { kind: "Name", value: "state" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "attention" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "icon" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "calendarDate" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "awaiting" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "apartment" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ApartmentsCalendarQuery,
  ApartmentsCalendarQueryVariables
>;
export const FilterCaseTypeDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "FilterCaseType" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "caseDefinitions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "states" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
                { kind: "Field", name: { kind: "Name", value: "states" } },
                { kind: "Field", name: { kind: "Name", value: "icon" } },
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FilterCaseTypeQuery, FilterCaseTypeQueryVariables>;
export const FilterCaseWorkerDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "FilterCaseWorker" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "teamMembers" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "caseWorkers" },
                      value: { kind: "BooleanValue", value: true },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "records" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  FilterCaseWorkerQuery,
  FilterCaseWorkerQueryVariables
>;
export const FilterPropertyDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "FilterProperty" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "properties" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "archived" },
                      value: { kind: "BooleanValue", value: false },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: { kind: "IntValue", value: "1000" },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "orderBy" },
                value: { kind: "EnumValue", value: "name_ASC" },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "records" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FilterPropertyQuery, FilterPropertyQueryVariables>;
export const FilterTeamDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "FilterTeam" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "teams" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: { kind: "IntValue", value: "1000" },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "orderBy" },
                value: { kind: "EnumValue", value: "name_ASC" },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "scope" },
                value: { kind: "EnumValue", value: "SERVICE" },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "records" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FilterTeamQuery, FilterTeamQueryVariables>;
export const HeaderActionsDataDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "HeaderActionsData" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            alias: { kind: "Name", value: "inbox" },
            name: { kind: "Name", value: "caseDefinitions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "CaseDefinitionInfoFragment" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "cases" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "where" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "newForCurrentUser" },
                            value: { kind: "BooleanValue", value: true },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "records" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: {
                                kind: "Name",
                                value: "CaseDefinitionCaseFragment",
                              },
                            },
                          ],
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "count" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            alias: { kind: "Name", value: "flagged" },
            name: { kind: "Name", value: "caseDefinitions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "CaseDefinitionInfoFragment" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "cases" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "where" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: {
                              kind: "Name",
                              value: "flaggedForCurrentUser",
                            },
                            value: { kind: "BooleanValue", value: true },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "records" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: {
                                kind: "Name",
                                value: "CaseDefinitionCaseFragment",
                              },
                            },
                          ],
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "count" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            alias: { kind: "Name", value: "messages" },
            name: { kind: "Name", value: "caseDefinitions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "CaseDefinitionInfoFragment" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "cases" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "where" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: {
                              kind: "Name",
                              value: "commentsForCurrentUser",
                            },
                            value: { kind: "BooleanValue", value: true },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "records" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: {
                                kind: "Name",
                                value: "CaseDefinitionCaseFragment",
                              },
                            },
                          ],
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "count" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CaseDefinitionInfoFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CaseDefinition" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "icon" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CaseDefinitionCaseFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CaseInterface" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "shortName" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "icon" } },
          { kind: "Field", name: { kind: "Name", value: "attention" } },
          { kind: "Field", name: { kind: "Name", value: "awaiting" } },
          { kind: "Field", name: { kind: "Name", value: "state" } },
          { kind: "Field", name: { kind: "Name", value: "stateText" } },
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  HeaderActionsDataQuery,
  HeaderActionsDataQueryVariables
>;
export const GlobalSearchQueryDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GlobalSearchQuery" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "searchValue" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "tenancies" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "search" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "searchValue" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "archived" },
                      value: { kind: "BooleanValue", value: false },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: { kind: "IntValue", value: "10" },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "records" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "user" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "__typename" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "apartment" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "address" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "__typename" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "__typename" },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "cases" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "search" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "searchValue" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "archived" },
                      value: { kind: "BooleanValue", value: false },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: { kind: "IntValue", value: "10" },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "records" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "shortName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "stateText" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "apartment" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "address" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "__typename" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "__typename" },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GlobalSearchQueryQuery,
  GlobalSearchQueryQueryVariables
>;
export const ShortcutControlDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "ShortcutControl" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "shortcutId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "currentUser" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "shortcut" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "shortcutId" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "shortcutId" },
                      },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ShortcutControlQuery,
  ShortcutControlQueryVariables
>;
export const ShortcutUpdateDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "ShortcutUpdate" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "shortcutId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "attributes" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "ShortcutAttributesInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "shortcutUpdate" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "shortcutId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "shortcutId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "attributes" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "attributes" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "errors" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ShortcutUpdateMutation,
  ShortcutUpdateMutationVariables
>;
export const ShortcutCreateMutationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "ShortcutCreateMutation" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "attributes" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "ShortcutAttributesInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "shortcutCreate" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "attributes" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "attributes" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "errors" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "shortcut" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ShortcutCreateMutationMutation,
  ShortcutCreateMutationMutationVariables
>;
export const ShortcutRemoveDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "ShortcutRemove" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "shortcutDelete" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "shortcutId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "shortcutId" } },
                { kind: "Field", name: { kind: "Name", value: "errors" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ShortcutRemoveMutation,
  ShortcutRemoveMutationVariables
>;
export const ShortcutsListDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "ShortcutsList" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "where" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "ShortcutWhereInput" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "currentUser" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "shortcuts" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "where" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "where" },
                      },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "nodes" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: {
                                kind: "Name",
                                value: "ShortcutsListShortcut",
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  alias: { kind: "Name", value: "shortcutsTotal" },
                  name: { kind: "Name", value: "shortcuts" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "totalCount" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ShortcutsListShortcut" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Shortcut" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ShortcutsListQuery, ShortcutsListQueryVariables>;
export const AvailableApartmentsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AvailableApartments" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "properties" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: { kind: "Name", value: "ID" },
                },
              },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filter" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "AvailableWithinInput" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "search" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "AvailableWithinInput" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "view" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "AvailableWithinInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "apartments" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "byProperty" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "properties" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "byArchived" },
                      value: { kind: "BooleanValue", value: false },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "byAvailableWithin" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "filter" },
                      },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "orderBy" },
                value: { kind: "EnumValue", value: "publicId_ASC" },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: { kind: "IntValue", value: "500" },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  alias: { kind: "Name", value: "qualifying" },
                  name: { kind: "Name", value: "availability" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "within" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "search" },
                      },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "apartmentId" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "from" } },
                      { kind: "Field", name: { kind: "Name", value: "to" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "records" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "publicId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "address" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "inactive" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "inactiveStartDate" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "inactiveEndDate" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "inactiveDescription" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "occupancy" },
                        arguments: [
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "within" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "view" },
                            },
                          },
                        ],
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "startDate" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "endDate" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "intervalAmount" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "depositAmount" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "user" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "name" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AvailableApartmentsQuery,
  AvailableApartmentsQueryVariables
>;
export const TenancyNoteDeleteDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "TenancyNoteDelete" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "tenancyId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "noteId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "tenancyNoteDelete" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "tenancyId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "tenancyId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "noteId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "noteId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "errors" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  TenancyNoteDeleteMutation,
  TenancyNoteDeleteMutationVariables
>;
export const TenancyNoteCreateDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "TenancyNoteCreate" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "tenancyId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "content" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "attachments" },
          },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: {
                kind: "NamedType",
                name: { kind: "Name", value: "String" },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "tenancyNoteCreate" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "tenancyId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "tenancyId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "content" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "content" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "attachments" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "attachments" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "errors" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "tenancyNote" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "user" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "content" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "attachments" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "fileName" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "url" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "createdAt" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  TenancyNoteCreateMutation,
  TenancyNoteCreateMutationVariables
>;
export const TenancyNoteUpdateDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "TenancyNoteUpdate" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "tenancyId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "noteId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "content" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "attachments" },
          },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: {
                kind: "NamedType",
                name: { kind: "Name", value: "String" },
              },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "attachmentsToRemove" },
          },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: {
                kind: "NamedType",
                name: { kind: "Name", value: "String" },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "tenancyNoteUpdate" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "tenancyId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "tenancyId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "noteId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "noteId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "content" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "content" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "attachments" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "attachments" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "attachmentsToRemove" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "attachmentsToRemove" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "errors" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "tenancyNote" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "user" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "content" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "attachments" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "fileName" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "url" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "createdAt" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  TenancyNoteUpdateMutation,
  TenancyNoteUpdateMutationVariables
>;
export const ScreenApartment_BodyApartmentDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "ScreenApartment_BodyApartment" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "apartmentId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "archived" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Boolean" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "apartment" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "apartmentId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "address" } },
                { kind: "Field", name: { kind: "Name", value: "canUpdate" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "property" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "ScreenApartment_Landlord",
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "messages" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "orderBy" },
                      value: { kind: "EnumValue", value: "createdAt_DESC" },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "records" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: {
                                kind: "Name",
                                value: "ScreenApartment_Message",
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "cases" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "orderBy" },
                      value: { kind: "EnumValue", value: "createdAt_DESC" },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "where" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "withTenancy" },
                            value: { kind: "BooleanValue", value: false },
                          },
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "archived" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "archived" },
                            },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "records" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: {
                                kind: "Name",
                                value: "ScreenApartment_Case",
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "documents" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "ScreenApartment_Document",
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "fieldGroups" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "position" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "values" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "field" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "name" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "position" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "valueType" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "enumOptions",
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "value",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: { kind: "Name", value: "FieldValueText" },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    alias: { kind: "Name", value: "textValue" },
                                    name: { kind: "Name", value: "value" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: {
                                  kind: "Name",
                                  value: "FieldValueNumber",
                                },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    alias: {
                                      kind: "Name",
                                      value: "numberValue",
                                    },
                                    name: { kind: "Name", value: "value" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: {
                                  kind: "Name",
                                  value: "FieldValueBoolean",
                                },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    alias: {
                                      kind: "Name",
                                      value: "booleanValue",
                                    },
                                    name: { kind: "Name", value: "value" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: { kind: "Name", value: "FieldValueEnum" },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    alias: { kind: "Name", value: "enumValue" },
                                    name: { kind: "Name", value: "value" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "fieldEnumOptionId",
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: {
                                  kind: "Name",
                                  value: "FieldValueDatetime",
                                },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    alias: {
                                      kind: "Name",
                                      value: "datetimeValue",
                                    },
                                    name: { kind: "Name", value: "value" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ScreenApartment_Landlord" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Property" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "name" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "owner" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "phone" } },
                { kind: "Field", name: { kind: "Name", value: "email" } },
                { kind: "Field", name: { kind: "Name", value: "address" } },
                { kind: "Field", name: { kind: "Name", value: "postalCode" } },
                { kind: "Field", name: { kind: "Name", value: "city" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ScreenApartment_Message" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Message" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "body" } },
          { kind: "Field", name: { kind: "Name", value: "authorId" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "emailsSentAt" } },
          { kind: "Field", name: { kind: "Name", value: "smsSentAt" } },
          { kind: "Field", name: { kind: "Name", value: "apartment" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "property" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ScreenApartment_Case" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CaseInterface" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "attention" } },
          { kind: "Field", name: { kind: "Name", value: "awaiting" } },
          { kind: "Field", name: { kind: "Name", value: "body" } },
          { kind: "Field", name: { kind: "Name", value: "completeBefore" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "icon" } },
          { kind: "Field", name: { kind: "Name", value: "isArchived" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "scheduledTime" } },
          { kind: "Field", name: { kind: "Name", value: "state" } },
          { kind: "Field", name: { kind: "Name", value: "stateText" } },
          { kind: "Field", name: { kind: "Name", value: "startAfter" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "apartment" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "address" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "responsible" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "CleaningService" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "parent" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "scheduledDate" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "scheduledDate" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "unreadCommentsCount" },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "CreateTenancy" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "unreadCommentsCount" },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "EndTenancy" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "awaiting" } },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "FindTenancyAdministration" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "parent" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "scheduledDate" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "MiscAdministration" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "parent" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "apartment" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "address" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "scheduledDate" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "scheduledDate" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "unreadCommentsCount" },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "MiscService" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "parent" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "apartment" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "address" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "scheduledDate" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "scheduledDate" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "unreadCommentsCount" },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "MovingInService" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "isAttending" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "unreadCommentsCount" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "parent" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "apartment" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "address" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "scheduledDate" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "MovingInTenancy" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "unreadCommentsCount" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "scheduledDate" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "parent" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "scheduledDate" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "MovingOutService" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "parent" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "scheduledDate" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "scheduledDate" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "unreadCommentsCount" },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "MovingOutTenancy" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "unreadCommentsCount" },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "MovingSettlementAdministration" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "apartment" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "address" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "parent" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "scheduledDate" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "scheduledDate" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "unreadCommentsCount" },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "PreparationService" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "scheduledDate" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "apartment" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "address" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "parent" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "scheduledDate" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "unreadCommentsCount" },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "RequestTenancy" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "unreadCommentsCount" },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "UtilityAdministration" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "parent" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "scheduledDate" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "unreadCommentsCount" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ScreenApartment_Document" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Document" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ScreenApartment_BodyApartmentQuery,
  ScreenApartment_BodyApartmentQueryVariables
>;
export const ScreenApartment_BodyTenancyDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "ScreenApartment_BodyTenancy" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "apartmentId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "tenancyId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "archived" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Boolean" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "apartment" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "apartmentId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "tenancy" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "id" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "tenancyId" },
                      },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "ScreenApartment_ManageTenantsAndResidents",
                        },
                      },
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "ScreenApartment_Contract",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "economic" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: {
                                kind: "Name",
                                value: "ScreenApartment_Economic",
                              },
                            },
                          ],
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "startDate" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "endDate" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "canUpdate" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "roles" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "user" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "name" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "isPhoneConfirmed",
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "notes" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: {
                                kind: "Name",
                                value: "ScreenApartment_ApartmentJournal",
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "cases" },
                        arguments: [
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "orderBy" },
                            value: {
                              kind: "EnumValue",
                              value: "createdAt_DESC",
                            },
                          },
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "where" },
                            value: {
                              kind: "ObjectValue",
                              fields: [
                                {
                                  kind: "ObjectField",
                                  name: { kind: "Name", value: "archived" },
                                  value: {
                                    kind: "Variable",
                                    name: { kind: "Name", value: "archived" },
                                  },
                                },
                              ],
                            },
                          },
                        ],
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "records" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "FragmentSpread",
                                    name: {
                                      kind: "Name",
                                      value: "ScreenApartment_Case",
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "documents" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: {
                                kind: "Name",
                                value: "ScreenApartment_Document",
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "fieldGroups" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "position" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "values" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "field" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "name" },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "position",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "valueType",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "enumOptions",
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "id",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "value",
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value: "FieldValueText",
                                      },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          alias: {
                                            kind: "Name",
                                            value: "textValue",
                                          },
                                          name: {
                                            kind: "Name",
                                            value: "value",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value: "FieldValueNumber",
                                      },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          alias: {
                                            kind: "Name",
                                            value: "numberValue",
                                          },
                                          name: {
                                            kind: "Name",
                                            value: "value",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value: "FieldValueBoolean",
                                      },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          alias: {
                                            kind: "Name",
                                            value: "booleanValue",
                                          },
                                          name: {
                                            kind: "Name",
                                            value: "value",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value: "FieldValueEnum",
                                      },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          alias: {
                                            kind: "Name",
                                            value: "enumValue",
                                          },
                                          name: {
                                            kind: "Name",
                                            value: "value",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "fieldEnumOptionId",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value: "FieldValueDatetime",
                                      },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          alias: {
                                            kind: "Name",
                                            value: "datetimeValue",
                                          },
                                          name: {
                                            kind: "Name",
                                            value: "value",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: {
        kind: "Name",
        value: "ScreenApartment_ManageTenantsAndResidents",
      },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Tenancy" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "residents" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "email" } },
                { kind: "Field", name: { kind: "Name", value: "phone" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "roles" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "isPrimary" } },
                { kind: "Field", name: { kind: "Name", value: "isResident" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                      { kind: "Field", name: { kind: "Name", value: "phone" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "protected" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "isPhoneConfirmed" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "isExternal" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "removable" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ScreenApartment_Contract" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Tenancy" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "startDate" } },
          { kind: "Field", name: { kind: "Name", value: "endDate" } },
          { kind: "Field", name: { kind: "Name", value: "intervalAmount" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "intervalAmountType" },
          },
          { kind: "Field", name: { kind: "Name", value: "depositAmount" } },
          { kind: "Field", name: { kind: "Name", value: "hasEndTenancyCase" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "endTenancyTermsCondition" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contractCase" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "state" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "contract" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ScreenApartment_Economic" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "TenancyEconomic" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "debtor" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "addressText" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "subscriptions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "interval" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "currentAmount" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "deposit" } },
          { kind: "Field", name: { kind: "Name", value: "prepaidRent" } },
          { kind: "Field", name: { kind: "Name", value: "companySyncedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ScreenApartment_ApartmentJournal" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "TenancyNoteList" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "records" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "content" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "attachments" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "fileName" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ScreenApartment_Case" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CaseInterface" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "attention" } },
          { kind: "Field", name: { kind: "Name", value: "awaiting" } },
          { kind: "Field", name: { kind: "Name", value: "body" } },
          { kind: "Field", name: { kind: "Name", value: "completeBefore" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "icon" } },
          { kind: "Field", name: { kind: "Name", value: "isArchived" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "scheduledTime" } },
          { kind: "Field", name: { kind: "Name", value: "state" } },
          { kind: "Field", name: { kind: "Name", value: "stateText" } },
          { kind: "Field", name: { kind: "Name", value: "startAfter" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "apartment" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "address" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "responsible" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "CleaningService" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "parent" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "scheduledDate" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "scheduledDate" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "unreadCommentsCount" },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "CreateTenancy" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "unreadCommentsCount" },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "EndTenancy" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "awaiting" } },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "FindTenancyAdministration" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "parent" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "scheduledDate" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "MiscAdministration" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "parent" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "apartment" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "address" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "scheduledDate" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "scheduledDate" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "unreadCommentsCount" },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "MiscService" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "parent" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "apartment" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "address" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "scheduledDate" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "scheduledDate" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "unreadCommentsCount" },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "MovingInService" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "isAttending" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "unreadCommentsCount" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "parent" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "apartment" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "address" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "scheduledDate" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "MovingInTenancy" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "unreadCommentsCount" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "scheduledDate" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "parent" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "scheduledDate" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "MovingOutService" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "parent" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "scheduledDate" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "scheduledDate" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "unreadCommentsCount" },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "MovingOutTenancy" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "unreadCommentsCount" },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "MovingSettlementAdministration" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "apartment" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "address" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "parent" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "scheduledDate" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "scheduledDate" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "unreadCommentsCount" },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "PreparationService" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "scheduledDate" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "apartment" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "address" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "parent" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "scheduledDate" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "unreadCommentsCount" },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "RequestTenancy" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "unreadCommentsCount" },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "UtilityAdministration" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "parent" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "scheduledDate" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "unreadCommentsCount" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ScreenApartment_Document" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Document" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ScreenApartment_BodyTenancyQuery,
  ScreenApartment_BodyTenancyQueryVariables
>;
export const CasesByParentDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "casesByParent" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "ids" } },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "cases" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "orderBy" },
                value: { kind: "EnumValue", value: "apartment_DESC" },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "byParent" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "ids" },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "records" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "icon" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "attention" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "awaiting" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "stateText" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "state" } },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CasesByParentQuery, CasesByParentQueryVariables>;
export const ApartmentContractEditDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "ApartmentContractEdit" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "depositAmount" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Float" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "intervalAmount" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Float" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "startDate" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "ISO8601Date" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "endDate" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "ISO8601Date" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "endTenancyTerms" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "tenancyId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "tenancyUpdate" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "tenancyId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "tenancyId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "endDate" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "endDate" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "startDate" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "startDate" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "depositAmount" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "depositAmount" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "intervalAmount" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "intervalAmount" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "endTenancyTerms" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "endTenancyTerms" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "errors" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "tenancy" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ApartmentContractEditMutation,
  ApartmentContractEditMutationVariables
>;
export const ApartmentContractTerminateModal_EndTenancyTermsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: {
        kind: "Name",
        value: "ApartmentContractTerminateModal_EndTenancyTerms",
      },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "tenancyId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "endDate" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "ISO8601Date" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "tenancy" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "tenancyId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "endTenancyTerms" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "endDate" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "endDate" },
                      },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "endDate" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "earlyEndDate" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "endDateLongFormat" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "lastRentDate" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "lastRentDateLongFormat" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "leaveDate" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "leaveDateLongFormat" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "endTenancyReasons" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "label" } },
                { kind: "Field", name: { kind: "Name", value: "isOther" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ApartmentContractTerminateModal_EndTenancyTermsQuery,
  ApartmentContractTerminateModal_EndTenancyTermsQueryVariables
>;
export const ApartmentContractTerminateModal_CreateEndTenancyDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: {
        kind: "Name",
        value: "ApartmentContractTerminateModal_CreateEndTenancy",
      },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "endDate" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "ISO8601Date" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "comment" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "tenancyId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "endTenancyReasons" },
          },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: {
                kind: "NamedType",
                name: { kind: "Name", value: "String" },
              },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "otherReasonNote" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "tenancyEnd" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "endDate" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "endDate" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "comment" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "comment" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "tenancyId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "tenancyId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "endTenancyReasons" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "endTenancyReasons" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "otherReasonNote" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "otherReasonNote" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "errors" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "case" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ApartmentContractTerminateModal_CreateEndTenancyMutation,
  ApartmentContractTerminateModal_CreateEndTenancyMutationVariables
>;
export const EconomicDebtorsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "economicDebtors" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "tenancyId" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "economicDebtors" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "byTenancy" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "tenancyId" },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "records" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "addressText" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  EconomicDebtorsQuery,
  EconomicDebtorsQueryVariables
>;
export const TenancyDebtorLinkDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "tenancyDebtorLink" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "tenancyId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "debtorId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "tenancyDebtorLink" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "tenancyId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "tenancyId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "debtorId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "debtorId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "isLinked" } },
                { kind: "Field", name: { kind: "Name", value: "errors" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  TenancyDebtorLinkMutation,
  TenancyDebtorLinkMutationVariables
>;
export const ScreenApartment_EconomicHistoryDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "ScreenApartment_EconomicHistory" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "tenancyId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "subscriptionId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "tenancy" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "tenancyId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "economic" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "subscription" },
                        arguments: [
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "id" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "subscriptionId" },
                            },
                          },
                        ],
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "history" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "Field",
                                    alias: { kind: "Name", value: "amount" },
                                    name: { kind: "Name", value: "price" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "intervalStartAt",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "intervalEndAt",
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ScreenApartment_EconomicHistoryQuery,
  ScreenApartment_EconomicHistoryQueryVariables
>;
export const LookupUserDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "lookupUser" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "email" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "lookupUser" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "email" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "email" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "email" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "phone" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LookupUserMutation, LookupUserMutationVariables>;
export const PhoneConfirmDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "PhoneConfirm" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "userId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            alias: { kind: "Name", value: "result" },
            name: { kind: "Name", value: "phoneConfirm" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "userId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "userId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "errors" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PhoneConfirmMutation,
  PhoneConfirmMutationVariables
>;
export const UpdateExternalUserDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdateExternalUser" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "userId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "email" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "name" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "phone" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            alias: { kind: "Name", value: "result" },
            name: { kind: "Name", value: "updateExternalUser" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "userId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "userId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "email" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "email" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "name" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "name" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "phone" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "phone" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "errors" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                      { kind: "Field", name: { kind: "Name", value: "phone" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateExternalUserMutation,
  UpdateExternalUserMutationVariables
>;
export const ManageTenantsAndResidentsRemoveTenancyDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "ManageTenantsAndResidentsRemoveTenancy" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "tenancyId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "tenancyRemove" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "tenancyId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "tenancy" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "ScreenApartment_ManageTenantsAndResidents",
                        },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "errors" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: {
        kind: "Name",
        value: "ScreenApartment_ManageTenantsAndResidents",
      },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Tenancy" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "residents" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "email" } },
                { kind: "Field", name: { kind: "Name", value: "phone" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "roles" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "isPrimary" } },
                { kind: "Field", name: { kind: "Name", value: "isResident" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                      { kind: "Field", name: { kind: "Name", value: "phone" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "protected" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "isPhoneConfirmed" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "isExternal" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "removable" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ManageTenantsAndResidentsRemoveTenancyMutation,
  ManageTenantsAndResidentsRemoveTenancyMutationVariables
>;
export const TenancyResidentCreateDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "tenancyResidentCreate" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "tenancyId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "name" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "email" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "phone" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "tenancyResidentCreate" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "tenancyId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "tenancyId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "name" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "name" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "email" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "email" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "phone" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "phone" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "errors" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "resident" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  TenancyResidentCreateMutation,
  TenancyResidentCreateMutationVariables
>;
export const TenancyResidentUpdateDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "tenancyResidentUpdate" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "residentId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "name" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "email" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "phone" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "tenancyResidentUpdate" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "residentId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "residentId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "name" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "name" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "email" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "email" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "phone" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "phone" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "errors" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "resident" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  TenancyResidentUpdateMutation,
  TenancyResidentUpdateMutationVariables
>;
export const TenancyResidentRemoveDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "tenancyResidentRemove" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "residentId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "tenancyResidentRemove" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "residentId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "residentId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "errors" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "resident" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  TenancyResidentRemoveMutation,
  TenancyResidentRemoveMutationVariables
>;
export const TenancyRoleCreateDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "tenancyRoleCreate" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "tenancyId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "userId" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "isPrimary" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "isResident" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "email" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "name" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "phone" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "tenancyRoleCreate" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "tenancyId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "tenancyId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "userId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "userId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "isPrimary" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "isPrimary" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "isResident" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "isResident" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "email" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "email" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "name" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "name" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "phone" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "phone" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "errors" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "tenancyRole" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "isPrimary" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "isResident" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "user" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  TenancyRoleCreateMutation,
  TenancyRoleCreateMutationVariables
>;
export const TenancyRoleUpdateDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "tenancyRoleUpdate" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "tenancyRoleId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "isPrimary" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "isResident" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "tenancyRoleUpdate" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "tenancyRoleId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "tenancyRoleId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "isPrimary" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "isPrimary" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "isResident" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "isResident" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "errors" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "tenancyRole" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "isPrimary" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "isResident" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "user" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  TenancyRoleUpdateMutation,
  TenancyRoleUpdateMutationVariables
>;
export const TenancyRoleRemoveDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "tenancyRoleRemove" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "tenancyRoleId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "tenancyRoleRemove" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "tenancyRoleId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "tenancyRoleId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "errors" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "tenancyRole" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "isPrimary" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "isResident" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "user" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  TenancyRoleRemoveMutation,
  TenancyRoleRemoveMutationVariables
>;
export const ScreenApartmentDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "ScreenApartment" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "apartmentId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "apartment" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "apartmentId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "address" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "tenancies" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "records" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "startDate" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "endDate" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "roles" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "user" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "name" },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ScreenApartmentQuery,
  ScreenApartmentQueryVariables
>;
export const ApartmentsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "Apartments" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "where" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "ApartmentWhereInput" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "orderBy" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "ApartmentOrderByEnum" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "offset" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "limit" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "apartments" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "where" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "orderBy" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "orderBy" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "offset" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "offset" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "limit" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "records" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "address" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "property" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "DataTableApartments" },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "total" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DataTableApartments" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Apartment" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "publicId" } },
          { kind: "Field", name: { kind: "Name", value: "address" } },
          { kind: "Field", name: { kind: "Name", value: "city" } },
          { kind: "Field", name: { kind: "Name", value: "key" } },
          {
            kind: "Field",
            alias: { kind: "Name", value: "service" },
            name: { kind: "Name", value: "activeServiceCasesCount" },
          },
          { kind: "Field", name: { kind: "Name", value: "inactive" } },
          { kind: "Field", name: { kind: "Name", value: "inactiveStartDate" } },
          { kind: "Field", name: { kind: "Name", value: "inactiveEndDate" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "inactiveDescription" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "property" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "previousTenancy" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "startDate" } },
                { kind: "Field", name: { kind: "Name", value: "endDate" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "requestedEndDate" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "intervalAmount" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "intervalAmountType" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "depositAmount" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "depositDueDate" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "heatingAmount" },
                },
                { kind: "Field", name: { kind: "Name", value: "waterAmount" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "electricityAmount" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                      { kind: "Field", name: { kind: "Name", value: "phone" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "protected" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "expectedMovingInCases" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "icon" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "expectedMovingOutCases" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "icon" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "movingInCase" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "icon" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "attention" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "children" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "type" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "shortName" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "icon" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "attention" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "movingOutCase" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "icon" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "attention" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "children" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "type" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "shortName" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "icon" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "attention" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "contractCase" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "attention" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "awaiting" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "stateText" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "economic" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "debtor" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "externalId" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "rentAmount" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "parkingAmount" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "rentReductionAmount" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "regulationDepositAmount",
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "regulationPrepaidRentAmount",
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "advanceWasteWaterAmount",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "advanceWaterAmount" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "advanceHeatingAmount" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "advanceElectricityAmount",
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "settlementWasteWaterAmount",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "settlementWaterAmount" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "settlementHeatingAmount",
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "settlementElectricityAmount",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "otherAmount" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "companySyncedAt" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "deposit" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "prepaidRent" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "currentTenancy" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "startDate" } },
                { kind: "Field", name: { kind: "Name", value: "endDate" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "requestedEndDate" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "depositAmount" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "intervalAmount" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "intervalAmountType" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "depositDueDate" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "heatingAmount" },
                },
                { kind: "Field", name: { kind: "Name", value: "waterAmount" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "electricityAmount" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                      { kind: "Field", name: { kind: "Name", value: "phone" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "protected" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "expectedMovingInCases" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "icon" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "expectedMovingOutCases" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "icon" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "movingInCase" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "icon" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "attention" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "children" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "type" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "shortName" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "icon" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "attention" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "movingOutCase" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "icon" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "attention" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "children" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "type" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "shortName" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "icon" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "attention" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "contractCase" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "attention" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "awaiting" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "stateText" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "economic" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "debtor" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "externalId" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "rentAmount" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "parkingAmount" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "rentReductionAmount" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "regulationDepositAmount",
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "regulationPrepaidRentAmount",
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "advanceWasteWaterAmount",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "advanceWaterAmount" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "advanceHeatingAmount" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "advanceElectricityAmount",
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "settlementWasteWaterAmount",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "settlementWaterAmount" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "settlementHeatingAmount",
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "settlementElectricityAmount",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "otherAmount" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "companySyncedAt" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "deposit" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "prepaidRent" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "nextTenancy" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "startDate" } },
                { kind: "Field", name: { kind: "Name", value: "endDate" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "requestedEndDate" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "intervalAmount" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "intervalAmountType" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "depositAmount" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "depositDueDate" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "heatingAmount" },
                },
                { kind: "Field", name: { kind: "Name", value: "waterAmount" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "electricityAmount" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                      { kind: "Field", name: { kind: "Name", value: "phone" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "protected" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "expectedMovingInCases" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "icon" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "expectedMovingOutCases" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "icon" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "movingInCase" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "icon" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "attention" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "children" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "type" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "shortName" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "icon" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "attention" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "movingOutCase" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "icon" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "attention" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "children" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "type" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "shortName" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "icon" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "attention" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "contractCase" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "attention" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "awaiting" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "stateText" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "economic" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "debtor" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "externalId" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "rentAmount" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "parkingAmount" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "rentReductionAmount" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "regulationDepositAmount",
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "regulationPrepaidRentAmount",
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "advanceWasteWaterAmount",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "advanceWaterAmount" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "advanceHeatingAmount" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "advanceElectricityAmount",
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "settlementWasteWaterAmount",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "settlementWaterAmount" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "settlementHeatingAmount",
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "settlementElectricityAmount",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "otherAmount" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "companySyncedAt" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "deposit" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "prepaidRent" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ApartmentsQuery, ApartmentsQueryVariables>;
export const CasesCountDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "CasesCount" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            alias: { kind: "Name", value: "new" },
            name: { kind: "Name", value: "cases" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "newForCurrentUser" },
                      value: { kind: "BooleanValue", value: true },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "total" } },
              ],
            },
          },
          {
            kind: "Field",
            alias: { kind: "Name", value: "comments" },
            name: { kind: "Name", value: "cases" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "commentsForCurrentUser" },
                      value: { kind: "BooleanValue", value: true },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "total" } },
              ],
            },
          },
          {
            kind: "Field",
            alias: { kind: "Name", value: "flagged" },
            name: { kind: "Name", value: "cases" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "flaggedForCurrentUser" },
                      value: { kind: "BooleanValue", value: true },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "total" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CasesCountQuery, CasesCountQueryVariables>;
export const CasesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "Cases" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "where" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "CaseWhereInput" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "orderBy" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "CaseOrderByEnum" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "offset" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "limit" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "cases" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "where" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "orderBy" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "orderBy" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "offset" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "offset" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "limit" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "records" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "DataTableCases" },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "total" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DataTableCases" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CaseInterface" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "icon" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "shortName" } },
          { kind: "Field", name: { kind: "Name", value: "state" } },
          { kind: "Field", name: { kind: "Name", value: "stateText" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "stateLastChangedAt" },
          },
          { kind: "Field", name: { kind: "Name", value: "attention" } },
          { kind: "Field", name: { kind: "Name", value: "awaiting" } },
          { kind: "Field", name: { kind: "Name", value: "startAfter" } },
          { kind: "Field", name: { kind: "Name", value: "completeBefore" } },
          { kind: "Field", name: { kind: "Name", value: "scheduledDate" } },
          { kind: "Field", name: { kind: "Name", value: "scheduledTime" } },
          { kind: "Field", name: { kind: "Name", value: "isAttending" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "serviceTeam" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "requester" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "email" } },
                { kind: "Field", name: { kind: "Name", value: "phone" } },
                { kind: "Field", name: { kind: "Name", value: "protected" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "responsible" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "email" } },
                { kind: "Field", name: { kind: "Name", value: "phone" } },
                { kind: "Field", name: { kind: "Name", value: "protected" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "property" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "apartment" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "publicId" } },
                { kind: "Field", name: { kind: "Name", value: "address" } },
                { kind: "Field", name: { kind: "Name", value: "postalCode" } },
                { kind: "Field", name: { kind: "Name", value: "city" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "tenancy" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "startDate" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "requestedEndDate" },
                },
                { kind: "Field", name: { kind: "Name", value: "endDate" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                      { kind: "Field", name: { kind: "Name", value: "phone" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "protected" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CasesQuery, CasesQueryVariables>;
export const SaveInspectionDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "SaveInspection" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "BaseInspectionInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "caseInspectionSave" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "errors" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SaveInspectionMutation,
  SaveInspectionMutationVariables
>;
export const ProcessInspectionDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "ProcessInspection" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "BaseInspectionInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "caseInspectionProcess" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "errors" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ProcessInspectionMutation,
  ProcessInspectionMutationVariables
>;
export const SaveInspectionAnswerDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "SaveInspectionAnswer" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "caseId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "areaId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "subjectId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "rating" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "position" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "note" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "saveInspectionAnswer" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "caseId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "caseId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "areaId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "areaId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "subjectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "subjectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "rating" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "rating" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "position" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "position" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "note" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "note" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "errors" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SaveInspectionAnswerMutation,
  SaveInspectionAnswerMutationVariables
>;
export const DeleteInspectionAnswerDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "DeleteInspectionAnswer" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "caseId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "areaId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "subjectId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteInspectionAnswer" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "caseId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "caseId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "areaId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "areaId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "subjectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "subjectId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "errors" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteInspectionAnswerMutation,
  DeleteInspectionAnswerMutationVariables
>;
export const ToggleCaseFlagDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "ToggleCaseFlag" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "caseId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "flagged" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "toggleCaseFlag" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "caseId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "caseId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "flagged" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "flagged" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "errors" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ToggleCaseFlagMutation,
  ToggleCaseFlagMutationVariables
>;
export const CasePlanningUpdateDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CasePlanningUpdate" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "caseId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "startAfter" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "ISO8601Date" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "completeBefore" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "ISO8601Date" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "scheduledDate" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "ISO8601Date" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "scheduledTime" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "casePlanningUpdate" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "caseId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "caseId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "startAfter" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "startAfter" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "completeBefore" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "completeBefore" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "scheduledDate" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "scheduledDate" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "scheduledTime" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "scheduledTime" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "errors" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CasePlanningUpdateMutation,
  CasePlanningUpdateMutationVariables
>;
export const CaseCommentReadDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CaseCommentRead" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "caseId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "senderId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "caseCommentRead" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "caseId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "caseId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "senderId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "senderId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "errors" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CaseCommentReadMutation,
  CaseCommentReadMutationVariables
>;
export const SaveTextMacroDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "SaveTextMacro" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "name" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "content" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "available" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "saveTextMacro" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "name" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "name" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "content" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "content" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "available" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "available" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "textMacro" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "content" },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "errors" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SaveTextMacroMutation,
  SaveTextMacroMutationVariables
>;
export const DeleteTextMacroDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "DeleteTextMacro" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteTextMacro" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "errors" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteTextMacroMutation,
  DeleteTextMacroMutationVariables
>;
export const CaseCreateDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CaseCreate" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "type" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "CaseTypeEnum" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "propertyId" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "apartmentId" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "tenancyId" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "parentId" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "requester" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "CaseEventInput" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "caseCreate" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "type" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "type" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "propertyId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "propertyId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "apartmentId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "apartmentId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "tenancyId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "tenancyId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "parentId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "parentId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "requester" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "requester" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "errors" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "result" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CaseCreateMutation, CaseCreateMutationVariables>;
export const CaseUpdateDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CaseUpdate" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "caseId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "event" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "CaseEventEnum" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "CaseEventInput" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "caseUpdate" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "caseId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "caseId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "event" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "event" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "errors" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CaseUpdateMutation, CaseUpdateMutationVariables>;
export const CaseEndTenancyUpdateReasonsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CaseEndTenancyUpdateReasons" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "caseId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "reasons" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: {
                    kind: "Name",
                    value: "EndTenancyReasonSelectionInput",
                  },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "caseEndTenancyUpdateReasons" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "caseId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "caseId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "reasons" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "reasons" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "errors" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CaseEndTenancyUpdateReasonsMutation,
  CaseEndTenancyUpdateReasonsMutationVariables
>;
export const CaseShareCreateDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CaseShareCreate" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "caseId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "selection" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "CaseShareSelectionInput" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "description" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "note" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "expiresAt" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "ISO8601DateTime" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "caseShareCreate" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "caseId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "caseId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "selection" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "selection" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "description" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "description" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "note" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "note" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "expiresAt" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "expiresAt" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "result" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "errors" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CaseShareCreateMutation,
  CaseShareCreateMutationVariables
>;
export const CaseShareRevokeDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CaseShareRevoke" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "shareId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "caseShareRevoke" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "shareId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "shareId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "result" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "isActive" },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "errors" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CaseShareRevokeMutation,
  CaseShareRevokeMutationVariables
>;
export const CaseShareSendDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CaseShareSend" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "shareId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "emails" },
          },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: {
                kind: "NamedType",
                name: { kind: "Name", value: "String" },
              },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "phones" },
          },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: {
                kind: "NamedType",
                name: { kind: "Name", value: "String" },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "caseShareSend" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "shareId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "shareId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "emails" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "emails" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "phones" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "phones" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "result" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "errors" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CaseShareSendMutation,
  CaseShareSendMutationVariables
>;
export const ScreenCaseDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "ScreenCase" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "caseId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "case" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "caseId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "caseId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ScreenCaseQuery, ScreenCaseQueryVariables>;
export const ScreenServiceCaseDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "ScreenServiceCase" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "caseId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "case" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "caseId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "caseId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ServiceCaseScreen" },
                },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
                { kind: "Field", name: { kind: "Name", value: "state" } },
                { kind: "Field", name: { kind: "Name", value: "stateText" } },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "stateLastChangedAt" },
                },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "titleRaw" } },
                { kind: "Field", name: { kind: "Name", value: "body" } },
                { kind: "Field", name: { kind: "Name", value: "icon" } },
                { kind: "Field", name: { kind: "Name", value: "attention" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "flaggedByCurrentUser" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "whyAttention" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "texts" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "awaiting" } },
                { kind: "Field", name: { kind: "Name", value: "startAfter" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "completeBefore" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "scheduledDate" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "scheduledTime" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "tenantWillAttend" },
                },
                { kind: "Field", name: { kind: "Name", value: "isArchived" } },
                { kind: "Field", name: { kind: "Name", value: "archivedAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "archivedBy" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "tenancy" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "user" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "cancelledMessage" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "apartment" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "address" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "publicId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "postalCode" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "city" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "property" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "administrator" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "owner" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "address" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "postalCode" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "city" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "vat" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "tenancy" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "startDate" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "endDate" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "roles" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "user" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "name" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "email" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "phone" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "business" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "company" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "showSensitiveInfo",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "cpr" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "protected" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "requester" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "responsible" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "availableResponsibleUsers" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "availableResponsibleTeams" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "users" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "serviceTeam" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "availableTeams" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "forAssignment" },
                      value: { kind: "BooleanValue", value: true },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "assignableServiceTeams" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "parent" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "__typename" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "displayName" },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "RequestTenancy" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "startDate" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "endDate" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "daysBetween" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "numberOfResidents",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "comment" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "apartment" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "publicId" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "address" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "partnerProduct" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "name" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "partner" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "residents" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "name" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "email" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "phone" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "checks" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "label" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "comments" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "subject" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "message" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "smsMessage" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "emailMessage" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "createdAt" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "stateFrom" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "stateTo" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "stateDescription" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "important" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "sender" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "recipient" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "readAt" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "assets" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "fileName" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "url" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "mayReply" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "commentUsers" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "label" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "attachments" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "fileName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "fileType" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "fileSize" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "originalUrl" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "thumbUrl" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "largeUrl" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "isPdf" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "isImage" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "createdAt" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "category" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "nameDa" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "nameEn" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "timelogs" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "date" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "hoursWithoutMinutes" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "minutesWithoutHours" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "note" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "user" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "category" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "account" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "timelogAccount" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "categories" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "availableTimelogAccounts" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "followers" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "user" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "availableFollowers" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "repeatSteps" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "repeatPeriod" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "repeatResponsible" },
                },
                { kind: "Field", name: { kind: "Name", value: "repeating" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "tenantMayAttend" },
                },
                { kind: "Field", name: { kind: "Name", value: "canUpdate" } },
                { kind: "Field", name: { kind: "Name", value: "canComplete" } },
                { kind: "Field", name: { kind: "Name", value: "mayComplete" } },
                { kind: "Field", name: { kind: "Name", value: "canReopen" } },
                { kind: "Field", name: { kind: "Name", value: "mayReopen" } },
                { kind: "Field", name: { kind: "Name", value: "canCancel" } },
                { kind: "Field", name: { kind: "Name", value: "mayCancel" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "canAddComment" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "mayAddComment" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "canAddTimelog" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "mayAddTimelog" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "canShowTimelogs" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "canAddFollower" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "mayAddFollower" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "canRemoveFollower" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "mayRemoveFollower" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "canAddAttachment" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "mayAddAttachment" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "canRemoveAttachment" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "mayRemoveAttachment" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "canChangeResponsible" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "mayChangeResponsible" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "canConfigureRepeat" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "mayConfigureRepeat" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "canToggleCheck" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "mayToggleCheck" },
                },
                { kind: "Field", name: { kind: "Name", value: "canAwait" } },
                { kind: "Field", name: { kind: "Name", value: "mayAwait" } },
                { kind: "Field", name: { kind: "Name", value: "canShare" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "CleaningService" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "canReceive" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "mayReceive" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "maySchedule" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "mayReschedule" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "mayCancelScheduled" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "canSchedule" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "canReschedule" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "canCancelScheduled" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "mayTenantWillAttendYes" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "mayTenantWillAttendNo" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "canTenantWillAttendYes" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "canTenantWillAttendNo" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "canChangeServiceTeam" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "mayChangeServiceTeam" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "canChangeTask" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "mayChangeTask" },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "MiscService" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "canReceive" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "mayReceive" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "maySchedule" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "mayReschedule" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "mayCancelScheduled" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "canSchedule" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "canReschedule" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "canCancelScheduled" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "mayTenantWillAttendYes" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "mayTenantWillAttendNo" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "canTenantWillAttendYes" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "canTenantWillAttendNo" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "canChangeServiceTeam" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "mayChangeServiceTeam" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "canChangeTask" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "mayChangeTask" },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "PreparationService" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "canReceive" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "mayReceive" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "maySchedule" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "mayReschedule" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "mayCancelScheduled" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "canSchedule" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "canReschedule" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "canCancelScheduled" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "mayTenantWillAttendYes" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "mayTenantWillAttendNo" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "canTenantWillAttendYes" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "canTenantWillAttendNo" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "canChangeServiceTeam" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "mayChangeServiceTeam" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "canChangeTask" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "mayChangeTask" },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "MovingInService" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "canReceive" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "mayReceive" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "maySchedule" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "mayReschedule" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "mayCancelScheduled" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "canSchedule" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "canReschedule" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "canCancelScheduled" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "mayTenantWillAttendYes" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "mayTenantWillAttendNo" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "canTenantWillAttendYes" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "canTenantWillAttendNo" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "canChangeServiceTeam" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "mayChangeServiceTeam" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "canChangeTask" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "mayChangeTask" },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "MovingOutService" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "canReceive" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "mayReceive" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "maySchedule" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "mayReschedule" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "mayCancelScheduled" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "canSchedule" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "canReschedule" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "canCancelScheduled" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "mayTenantWillAttendYes" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "mayTenantWillAttendNo" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "canTenantWillAttendYes" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "canTenantWillAttendNo" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "canChangeServiceTeam" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "mayChangeServiceTeam" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "canChangeTask" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "mayChangeTask" },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "RequestTenancy" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "canReceive" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "mayReceive" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "canReopen" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "mayReopen" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "requester" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "address" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "postalCode" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "city" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "countryName" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "business" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "company" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "vat" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "cpr" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "phone" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "daysBetween" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "startDate" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "endDate" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "apartment" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "partnerProduct" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "partner" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "comment" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "numberOfResidents" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "residents" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "email" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "phone" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "createTenancyCases" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "apartment" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "address" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "requester" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "name" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "startDate" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "endDate" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "daysBetween" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "state" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "stateText" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "canCreateTenancy" },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "CreateTenancy" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "canCreateContract" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "mayCreateContract" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "canPopulateContract" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "mayPopulateContract" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "canChangeContract" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "mayChangeContract" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "canSendContract" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "maySendContract" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "canCancelContract" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "mayCancelContract" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "canLandlordSignContract",
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "mayLandlordSignContract",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "mayTenantSignContract" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "canShowEndTenancyTerms" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "canUpdateEconomic" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "mayUpdateEconomic" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "hasEconomicAgreement" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "signatures" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "signature" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "signedAt" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "signedBy" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "signerRole" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "economicDebtor" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "availableDebtorCount" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "canShowMovingInCaseResponsible",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "movingInCase" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "stateText" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "responsible" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "name" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "property" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "administrator",
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "name" },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "hasCompleteSettings" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "isContractIssued" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "daysBetween" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "endTenancyTermsText" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "intervalAmount" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "depositAmount" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "contract" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "url" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "contractSettings" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "apartment" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "type" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "startDate" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "endDate" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "endTenancyTerms" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "locale" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "residents" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "name" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "email" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "phone" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "tenancyRoles" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "email" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "primary" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "availableTemplates" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "contractValues" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "contractForm" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "type" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "sections" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "key" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "title" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "repeating" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "ordered" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "fields" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "name" },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "type" },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "multiline",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "required",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "label",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "options",
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "value",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "label",
                                                },
                                              },
                                            ],
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "currency",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "readonly",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "condition",
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "field",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "is",
                                                },
                                              },
                                            ],
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "requiredWhen",
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "field",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "is",
                                                },
                                              },
                                            ],
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "suffix",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "computed",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "follows",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "EndTenancy" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "endDate" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "earlyEndDate" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "endDateByTerms" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "comment" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "cancelled" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "endDateChanged" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "applicationEndDate" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "lastRentDate" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "leaveDate" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "reasons" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "label" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "note" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "canReceive" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "mayReceive" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "canChangeEndDate" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "mayChangeEndDate" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "canUpdateReasons" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "mayUpdateReasons" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "canShowMovingOutCase" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "canShowMovingOutCaseResponsible",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "tenancy" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "movingOutCase" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "state" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "stateText" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "responsible",
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "name" },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "property" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "administrator",
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "name",
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "MiscAdministration" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "canStart" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "mayStart" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "canChangeTask" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "mayChangeTask" },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "UtilityAdministration" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "canReceive" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "mayReceive" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "canReopen" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "mayReopen" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "canChangeTask" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "mayChangeTask" },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "MovingInTenancy" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "canReceive" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "mayReceive" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "canSchedule" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "maySchedule" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "tenancy" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "expectedMovingInCases",
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "type" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "name" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "MovingOutTenancy" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "canReceive" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "mayReceive" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "canSchedule" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "maySchedule" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "tenancy" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "expectedMovingOutCases",
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "type" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "name" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "user" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "address" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "MovingSettlementAdministration",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "nextTenancy" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "startDate" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "user" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "name" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "tenancy" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              alias: { kind: "Name", value: "contractCases" },
                              name: { kind: "Name", value: "cases" },
                              arguments: [
                                {
                                  kind: "Argument",
                                  name: { kind: "Name", value: "where" },
                                  value: {
                                    kind: "ObjectValue",
                                    fields: [
                                      {
                                        kind: "ObjectField",
                                        name: { kind: "Name", value: "byType" },
                                        value: {
                                          kind: "ListValue",
                                          values: [
                                            {
                                              kind: "StringValue",
                                              value: "create_tenancy",
                                              block: false,
                                            },
                                          ],
                                        },
                                      },
                                      {
                                        kind: "ObjectField",
                                        name: {
                                          kind: "Name",
                                          value: "cancelled",
                                        },
                                        value: {
                                          kind: "BooleanValue",
                                          value: false,
                                        },
                                      },
                                    ],
                                  },
                                },
                              ],
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "records" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" },
                                        },
                                        {
                                          kind: "InlineFragment",
                                          typeCondition: {
                                            kind: "NamedType",
                                            name: {
                                              kind: "Name",
                                              value: "CreateTenancy",
                                            },
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "endTenancyTermsText",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "contract",
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "id",
                                                      },
                                                    },
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "url",
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "tenancy",
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "intervalAmount",
                                                      },
                                                    },
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "depositAmount",
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              alias: {
                                kind: "Name",
                                value: "terminationCases",
                              },
                              name: { kind: "Name", value: "cases" },
                              arguments: [
                                {
                                  kind: "Argument",
                                  name: { kind: "Name", value: "where" },
                                  value: {
                                    kind: "ObjectValue",
                                    fields: [
                                      {
                                        kind: "ObjectField",
                                        name: { kind: "Name", value: "byType" },
                                        value: {
                                          kind: "ListValue",
                                          values: [
                                            {
                                              kind: "StringValue",
                                              value: "end_tenancy",
                                              block: false,
                                            },
                                          ],
                                        },
                                      },
                                      {
                                        kind: "ObjectField",
                                        name: {
                                          kind: "Name",
                                          value: "cancelled",
                                        },
                                        value: {
                                          kind: "BooleanValue",
                                          value: false,
                                        },
                                      },
                                    ],
                                  },
                                },
                              ],
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "records" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "createdAt",
                                          },
                                        },
                                        {
                                          kind: "InlineFragment",
                                          typeCondition: {
                                            kind: "NamedType",
                                            name: {
                                              kind: "Name",
                                              value: "EndTenancy",
                                            },
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "endDate",
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              alias: { kind: "Name", value: "serviceCases" },
                              name: { kind: "Name", value: "cases" },
                              arguments: [
                                {
                                  kind: "Argument",
                                  name: { kind: "Name", value: "where" },
                                  value: {
                                    kind: "ObjectValue",
                                    fields: [
                                      {
                                        kind: "ObjectField",
                                        name: { kind: "Name", value: "byType" },
                                        value: {
                                          kind: "ListValue",
                                          values: [
                                            {
                                              kind: "StringValue",
                                              value: "service",
                                              block: false,
                                            },
                                          ],
                                        },
                                      },
                                      {
                                        kind: "ObjectField",
                                        name: {
                                          kind: "Name",
                                          value: "cancelled",
                                        },
                                        value: {
                                          kind: "BooleanValue",
                                          value: false,
                                        },
                                      },
                                    ],
                                  },
                                },
                                {
                                  kind: "Argument",
                                  name: { kind: "Name", value: "orderBy" },
                                  value: {
                                    kind: "EnumValue",
                                    value: "createdAt_ASC",
                                  },
                                },
                              ],
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "records" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "shortName",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "stateText",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "tenantInformation" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "email" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "phone" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "address" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "postalCode" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "city" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "countryName" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "bankAccount" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "bankName" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "reg" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "account" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "canReceive" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "mayReceive" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "canRequestTenantInformation",
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "mayRequestTenantInformation",
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "canSendTenantInformation",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "canReopen" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "mayReopen" },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "FindTenancyAdministration" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        alias: { kind: "Name", value: "findTenancyStartDate" },
                        name: { kind: "Name", value: "startDate" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "intervalAmount" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "depositAmount" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "canShowRentInfo" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "canReceive" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "mayReceive" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "canReopen" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "mayReopen" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "canChangeTask" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "mayChangeTask" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ServiceCaseScreen" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CaseInterface" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "completed" } },
          { kind: "Field", name: { kind: "Name", value: "inspected" } },
          { kind: "Field", name: { kind: "Name", value: "processing" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "tenancy" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "inspection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "mayProcess" } },
                { kind: "Field", name: { kind: "Name", value: "canProcess" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "answers" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "area" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "subject" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "description" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "rating" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "position" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "note" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "cleaning" } },
                { kind: "Field", name: { kind: "Name", value: "other" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "keys" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "description" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "keyMissing" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "count" } },
                      { kind: "Field", name: { kind: "Name", value: "total" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "meters" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "description" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "tenantSignature" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "tenantSignedBy" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "landlordSignature" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "landlordSignedBy" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "document" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ScreenServiceCaseQuery,
  ScreenServiceCaseQueryVariables
>;
export const CaseChildrenDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "CaseChildren" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "parentId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "cases" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "byParent" },
                      value: {
                        kind: "ListValue",
                        values: [
                          {
                            kind: "Variable",
                            name: { kind: "Name", value: "parentId" },
                          },
                        ],
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "cancelled" },
                      value: { kind: "BooleanValue", value: false },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "orderBy" },
                value: { kind: "EnumValue", value: "id_ASC" },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: { kind: "IntValue", value: "1000" },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "records" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "shortName" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "state" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "stateText" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "attention" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "awaiting" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "isArchived" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "responsible" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CaseChildrenQuery, CaseChildrenQueryVariables>;
export const CaseCreatableTypesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "CaseCreatableTypes" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "caseDefinitions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "type" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "canCreate" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CaseCreatableTypesQuery,
  CaseCreatableTypesQueryVariables
>;
export const CaseTextMacrosDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "CaseTextMacros" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "available" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: { kind: "Name", value: "String" },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "textMacros" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "available" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "available" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "content" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CaseTextMacrosQuery, CaseTextMacrosQueryVariables>;
export const AttachmentCategoriesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AttachmentCategories" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "lang" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "attachmentCategories" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "lang" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "lang" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "nameDa" } },
                { kind: "Field", name: { kind: "Name", value: "nameEn" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AttachmentCategoriesQuery,
  AttachmentCategoriesQueryVariables
>;
export const EndTenancyReasonsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "EndTenancyReasons" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "endTenancyReasons" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "label" } },
                { kind: "Field", name: { kind: "Name", value: "isOther" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  EndTenancyReasonsQuery,
  EndTenancyReasonsQueryVariables
>;
export const CaseCreateFormDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "CaseCreateForm" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "propertyId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "includeApartments" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Boolean" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "apartmentId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "includeTenancies" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Boolean" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "properties" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "forCurrentUser" },
                      value: { kind: "BooleanValue", value: true },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: { kind: "IntValue", value: "1000" },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "orderBy" },
                value: { kind: "EnumValue", value: "name_ASC" },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "records" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "apartments" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "byProperty" },
                      value: {
                        kind: "ListValue",
                        values: [
                          {
                            kind: "Variable",
                            name: { kind: "Name", value: "propertyId" },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: { kind: "IntValue", value: "1000" },
              },
            ],
            directives: [
              {
                kind: "Directive",
                name: { kind: "Name", value: "include" },
                arguments: [
                  {
                    kind: "Argument",
                    name: { kind: "Name", value: "if" },
                    value: {
                      kind: "Variable",
                      name: { kind: "Name", value: "includeApartments" },
                    },
                  },
                ],
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "records" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "address" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "tenancies" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "byApartment" },
                      value: {
                        kind: "ListValue",
                        values: [
                          {
                            kind: "Variable",
                            name: { kind: "Name", value: "apartmentId" },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: { kind: "IntValue", value: "1000" },
              },
            ],
            directives: [
              {
                kind: "Directive",
                name: { kind: "Name", value: "include" },
                arguments: [
                  {
                    kind: "Argument",
                    name: { kind: "Name", value: "if" },
                    value: {
                      kind: "Variable",
                      name: { kind: "Name", value: "includeTenancies" },
                    },
                  },
                ],
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "records" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "startDate" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "roles" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "user" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "name" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "timelogAccounts" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CaseCreateFormQuery, CaseCreateFormQueryVariables>;
export const ContractOptionsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "ContractOptions" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "contractOptions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "types" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "endTenancyTerms" },
                },
                { kind: "Field", name: { kind: "Name", value: "locales" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ContractOptionsQuery,
  ContractOptionsQueryVariables
>;
export const CaseEconomicDebtorsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "CaseEconomicDebtors" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "tenancyId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "economicDebtors" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "byTenancy" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "tenancyId" },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "records" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "externalId" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "addressText" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CaseEconomicDebtorsQuery,
  CaseEconomicDebtorsQueryVariables
>;
export const CaseSharesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "CaseShares" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "caseId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "case" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "caseId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "caseId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "property" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "PropertyFieldGroups" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "apartment" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "ApartmentFieldGroups" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "tenancy" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "inspection" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "createdAt" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "attachments" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "fileName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "thumbUrl" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "isImage" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "isPdf" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "shareableDocuments" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "createdAt" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "shares" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "CaseShare" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Field" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Field" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "valueType" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "enumOptions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "value" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "position" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "availableInProperty" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "availableInApartment" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "availableInTenancy" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "availableInService" },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PropertyFieldGroups" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Property" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "fieldGroups" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "position" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "values" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "field" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "Field" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "FieldValueText" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              alias: { kind: "Name", value: "textValue" },
                              name: { kind: "Name", value: "value" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "FieldValueNumber" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              alias: { kind: "Name", value: "numberValue" },
                              name: { kind: "Name", value: "value" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "FieldValueBoolean" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              alias: { kind: "Name", value: "booleanValue" },
                              name: { kind: "Name", value: "value" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "FieldValueEnum" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              alias: { kind: "Name", value: "enumValue" },
                              name: { kind: "Name", value: "value" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "fieldEnumOptionId",
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "FieldValueDatetime" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              alias: { kind: "Name", value: "datetimeValue" },
                              name: { kind: "Name", value: "value" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ApartmentFieldGroups" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Apartment" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "fieldGroups" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "position" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "values" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "field" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "Field" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "FieldValueText" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              alias: { kind: "Name", value: "textValue" },
                              name: { kind: "Name", value: "value" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "FieldValueNumber" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              alias: { kind: "Name", value: "numberValue" },
                              name: { kind: "Name", value: "value" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "FieldValueBoolean" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              alias: { kind: "Name", value: "booleanValue" },
                              name: { kind: "Name", value: "value" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "FieldValueEnum" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              alias: { kind: "Name", value: "enumValue" },
                              name: { kind: "Name", value: "value" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "fieldEnumOptionId",
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "FieldValueDatetime" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              alias: { kind: "Name", value: "datetimeValue" },
                              name: { kind: "Name", value: "value" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CaseShare" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CaseShare" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "note" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "expiresAt" } },
          { kind: "Field", name: { kind: "Name", value: "revokedAt" } },
          { kind: "Field", name: { kind: "Name", value: "isActive" } },
          { kind: "Field", name: { kind: "Name", value: "openedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "deliveries" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "channel" } },
                { kind: "Field", name: { kind: "Name", value: "recipient" } },
                { kind: "Field", name: { kind: "Name", value: "sentAt" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "selection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "case" } },
                { kind: "Field", name: { kind: "Name", value: "property" } },
                { kind: "Field", name: { kind: "Name", value: "apartment" } },
                { kind: "Field", name: { kind: "Name", value: "tenant" } },
                { kind: "Field", name: { kind: "Name", value: "comments" } },
                { kind: "Field", name: { kind: "Name", value: "inspection" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "attachments" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "all" } },
                      { kind: "Field", name: { kind: "Name", value: "ids" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "documents" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "all" } },
                      { kind: "Field", name: { kind: "Name", value: "ids" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "fieldGroups" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "property" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "all" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "fieldIds" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "apartment" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "all" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "fieldIds" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CaseSharesQuery, CaseSharesQueryVariables>;
export const InterestListEntryCreateDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "InterestListEntryCreate" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "name" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "email" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "phone" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "message" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "channel" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "propertyIds" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: { kind: "Name", value: "ID" },
                },
              },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "failOnDuplicate" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "interestListEntryCreate" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "name" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "name" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "email" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "email" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "phone" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "phone" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "message" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "message" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "channel" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "channel" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "propertyIds" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "propertyIds" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "failOnDuplicate" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "failOnDuplicate" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "personCreated" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "duplicatePersonName" },
                },
                { kind: "Field", name: { kind: "Name", value: "errors" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  InterestListEntryCreateMutation,
  InterestListEntryCreateMutationVariables
>;
export const InterestListEntryDeleteDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "InterestListEntryDelete" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "note" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "interestListEntryDelete" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "note" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "note" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "errors" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  InterestListEntryDeleteMutation,
  InterestListEntryDeleteMutationVariables
>;
export const InterestListNoteCreateDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "InterestListNoteCreate" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "entryId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "note" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "interestListNoteCreate" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "entryId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "entryId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "note" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "note" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "errors" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  InterestListNoteCreateMutation,
  InterestListNoteCreateMutationVariables
>;
export const InterestListEntryUpdateDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "InterestListEntryUpdate" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "seenAt" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "ISO8601DateTime" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "interestListEntryUpdate" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "seenAt" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "seenAt" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "errors" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  InterestListEntryUpdateMutation,
  InterestListEntryUpdateMutationVariables
>;
export const InterestListPersonDeleteDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "InterestListPersonDelete" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "isBlacklisted" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "interestListPersonDelete" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "isBlacklisted" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "isBlacklisted" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "errors" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  InterestListPersonDeleteMutation,
  InterestListPersonDeleteMutationVariables
>;
export const InterestListPersonUpdateDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "InterestListPersonUpdate" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "name" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "email" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "phone" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "isBlacklisted" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "interestListPersonUpdate" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "name" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "name" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "email" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "email" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "phone" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "phone" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "isBlacklisted" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "isBlacklisted" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "errors" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  InterestListPersonUpdateMutation,
  InterestListPersonUpdateMutationVariables
>;
export const InterestListPeopleDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "InterestListPeople" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "offset" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "limit" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "orderBy" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "InterestListPersonOrderByEnum" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "where" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "InterestListPersonWhereInput" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "interestListPeople" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "offset" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "offset" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "limit" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "orderBy" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "orderBy" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "where" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "records" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "DataTableInterestList" },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "total" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DataTableInterestList" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "InterestListPerson" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "phone" } },
          { kind: "Field", name: { kind: "Name", value: "isBlacklisted" } },
          { kind: "Field", name: { kind: "Name", value: "hasNewEntries" } },
          { kind: "Field", name: { kind: "Name", value: "isProcessed" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "properties" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  InterestListPeopleQuery,
  InterestListPeopleQueryVariables
>;
export const InterestListPersonDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "InterestListPerson" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "interestListPerson" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "email" } },
                { kind: "Field", name: { kind: "Name", value: "phone" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "isBlacklisted" },
                },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "entries" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                      { kind: "Field", name: { kind: "Name", value: "phone" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "message" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "channel" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "createdAt" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "seenAt" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "deletedAt" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "deletedBy" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "deletedReason" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "properties" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "notes" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "note" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "createdAt" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "user" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  InterestListPersonQuery,
  InterestListPersonQueryVariables
>;
export const InterestListEntryPropertiesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "InterestListEntryProperties" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "properties" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "archived" },
                      value: { kind: "BooleanValue", value: false },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: { kind: "IntValue", value: "1000" },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "orderBy" },
                value: { kind: "EnumValue", value: "name_ASC" },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "records" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  InterestListEntryPropertiesQuery,
  InterestListEntryPropertiesQueryVariables
>;
export const CompaniesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "Companies" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "companies" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "orderBy" },
                value: { kind: "EnumValue", value: "name_ASC" },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "records" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "isOwner" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "isAdministrator" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CompaniesQuery, CompaniesQueryVariables>;
export const PropertiesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "Properties" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "where" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "PropertyWhereInput" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "orderBy" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "PropertyOrderByEnum" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "offset" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "limit" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "properties" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "where" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "orderBy" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "orderBy" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "offset" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "offset" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "limit" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "records" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "DataTableProperties" },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "total" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DataTableProperties" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Property" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "activeServiceCasesCount" },
          },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "administrator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "owner" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PropertiesQuery, PropertiesQueryVariables>;
export const ScreenPropertyDetailsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "ScreenPropertyDetails" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "propertyId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "properties" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "byId" },
                      value: {
                        kind: "ListValue",
                        values: [
                          {
                            kind: "Variable",
                            name: { kind: "Name", value: "propertyId" },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: { kind: "IntValue", value: "1" },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "records" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "PropertyWithFieldGroups",
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Company" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Company" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "phone" } },
          { kind: "Field", name: { kind: "Name", value: "address" } },
          { kind: "Field", name: { kind: "Name", value: "city" } },
          { kind: "Field", name: { kind: "Name", value: "postalCode" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Field" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Field" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "valueType" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "enumOptions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "value" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "position" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "availableInProperty" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "availableInApartment" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "availableInTenancy" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "availableInService" },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PropertyWithFieldGroups" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Property" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "canUpdate" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "administrator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Company" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "owner" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Company" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "fieldGroups" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "position" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "values" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "field" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "Field" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "FieldValueText" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              alias: { kind: "Name", value: "textValue" },
                              name: { kind: "Name", value: "value" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "FieldValueNumber" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              alias: { kind: "Name", value: "numberValue" },
                              name: { kind: "Name", value: "value" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "FieldValueBoolean" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              alias: { kind: "Name", value: "booleanValue" },
                              name: { kind: "Name", value: "value" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "FieldValueEnum" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              alias: { kind: "Name", value: "enumValue" },
                              name: { kind: "Name", value: "value" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "fieldEnumOptionId",
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "FieldValueDatetime" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              alias: { kind: "Name", value: "datetimeValue" },
                              name: { kind: "Name", value: "value" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ScreenPropertyDetailsQuery,
  ScreenPropertyDetailsQueryVariables
>;
export const ScreenPropertyDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "ScreenProperty" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "propertyId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "limit" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "offset" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "orderBy" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "ApartmentOrderByEnum" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "apartments" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "byProperty" },
                      value: {
                        kind: "ListValue",
                        values: [
                          {
                            kind: "Variable",
                            name: { kind: "Name", value: "propertyId" },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "limit" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "offset" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "offset" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "orderBy" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "orderBy" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "records" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "ScreenPropertyApartment",
                        },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "total" } },
                { kind: "Field", name: { kind: "Name", value: "count" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ScreenPropertyApartment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Apartment" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "publicId" } },
          { kind: "Field", name: { kind: "Name", value: "address" } },
          { kind: "Field", name: { kind: "Name", value: "city" } },
          { kind: "Field", name: { kind: "Name", value: "key" } },
          { kind: "Field", name: { kind: "Name", value: "inactive" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ScreenPropertyQuery, ScreenPropertyQueryVariables>;
export const TenancyCreateDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "TenancyCreate" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "apartment" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "startDate" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "ISO8601Date" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "endDate" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "ISO8601Date" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "depositAmount" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Float" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "endTenancyTerms" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "user" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "TenancyUserInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "tenancyCreate" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "apartment" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "apartment" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "startDate" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "startDate" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "endDate" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "endDate" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "depositAmount" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "depositAmount" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "endTenancyTerms" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "endTenancyTerms" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "user" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "user" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "errors" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "tenancy" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  TenancyCreateMutation,
  TenancyCreateMutationVariables
>;
export const TenanciesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "Tenancies" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "where" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "TenancyWhereInput" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "orderBy" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "TenancyOrderByEnum" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "offset" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "limit" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "tenancies" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "where" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "orderBy" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "orderBy" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "offset" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "offset" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "limit" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "records" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "DataTableTenancies" },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "total" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DataTableTenancies" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Tenancy" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "startDate" } },
          { kind: "Field", name: { kind: "Name", value: "endDate" } },
          { kind: "Field", name: { kind: "Name", value: "requestedEndDate" } },
          { kind: "Field", name: { kind: "Name", value: "depositAmount" } },
          { kind: "Field", name: { kind: "Name", value: "depositDueDate" } },
          { kind: "Field", name: { kind: "Name", value: "intervalAmount" } },
          { kind: "Field", name: { kind: "Name", value: "heatingAmount" } },
          { kind: "Field", name: { kind: "Name", value: "waterAmount" } },
          { kind: "Field", name: { kind: "Name", value: "electricityAmount" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "expectedMovingInCases" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "type" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "icon" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "expectedMovingOutCases" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "type" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "icon" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "movingInCase" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "icon" } },
                { kind: "Field", name: { kind: "Name", value: "attention" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "children" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "shortName" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "icon" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "attention" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "movingOutCase" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "icon" } },
                { kind: "Field", name: { kind: "Name", value: "attention" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "children" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "shortName" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "icon" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "attention" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contractCase" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "icon" } },
                { kind: "Field", name: { kind: "Name", value: "attention" } },
                { kind: "Field", name: { kind: "Name", value: "stateText" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "phone" } },
                { kind: "Field", name: { kind: "Name", value: "email" } },
                { kind: "Field", name: { kind: "Name", value: "protected" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "apartment" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "publicId" } },
                { kind: "Field", name: { kind: "Name", value: "address" } },
                { kind: "Field", name: { kind: "Name", value: "city" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "economic" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "debtor" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "externalId" },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "deposit" } },
                { kind: "Field", name: { kind: "Name", value: "prepaidRent" } },
                { kind: "Field", name: { kind: "Name", value: "rentAmount" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "parkingAmount" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "rentReductionAmount" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "regulationDepositAmount" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "regulationPrepaidRentAmount" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "advanceWasteWaterAmount" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "advanceWaterAmount" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "advanceHeatingAmount" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "advanceElectricityAmount" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "settlementWasteWaterAmount" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "settlementWaterAmount" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "settlementHeatingAmount" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "settlementElectricityAmount" },
                },
                { kind: "Field", name: { kind: "Name", value: "otherAmount" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "companySyncedAt" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TenanciesQuery, TenanciesQueryVariables>;
export const ScreenTenancyDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "ScreenTenancy" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "tenancyId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "tenancy" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "tenancyId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "apartment" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ScreenTenancyQuery, ScreenTenancyQueryVariables>;
export const AvailableFieldGroupsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AvailableFieldGroups" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "fieldGroups" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "records" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "position" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "fields" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "Field" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Field" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Field" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "valueType" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "enumOptions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "value" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "position" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "availableInProperty" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "availableInApartment" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "availableInTenancy" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "availableInService" },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AvailableFieldGroupsQuery,
  AvailableFieldGroupsQueryVariables
>;
export const AvailableFieldGroupsPropertyDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AvailableFieldGroupsProperty" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "propertyId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "property" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "propertyId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "fieldGroups" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "position" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "availableFieldGroups" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "position" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "fields" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "Field" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Field" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Field" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "valueType" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "enumOptions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "value" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "position" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "availableInProperty" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "availableInApartment" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "availableInTenancy" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "availableInService" },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AvailableFieldGroupsPropertyQuery,
  AvailableFieldGroupsPropertyQueryVariables
>;
export const AvailableFieldGroupsApartmentDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AvailableFieldGroupsApartment" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "apartmentId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "apartment" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "apartmentId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "publicId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "fieldGroups" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "position" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "availableFieldGroups" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "position" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "fields" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "Field" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Field" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Field" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "valueType" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "enumOptions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "value" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "position" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "availableInProperty" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "availableInApartment" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "availableInTenancy" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "availableInService" },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AvailableFieldGroupsApartmentQuery,
  AvailableFieldGroupsApartmentQueryVariables
>;
export const AvailableFieldGroupsTenancyDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AvailableFieldGroupsTenancy" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "tenancyId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "tenancy" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "tenancyId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "fieldGroups" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "position" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "availableFieldGroups" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "position" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "fields" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "Field" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Field" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Field" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "valueType" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "enumOptions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "value" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "position" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "availableInProperty" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "availableInApartment" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "availableInTenancy" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "availableInService" },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AvailableFieldGroupsTenancyQuery,
  AvailableFieldGroupsTenancyQueryVariables
>;
export const PropertyUpdateDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "PropertyUpdate" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "propertyId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "fields" },
          },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: {
                kind: "NamedType",
                name: { kind: "Name", value: "FieldValueInput" },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "propertyUpdate" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "propertyId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "propertyId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "fields" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "fields" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "property" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "fieldGroups" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "position" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "values" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "field" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "FragmentSpread",
                                          name: {
                                            kind: "Name",
                                            value: "Field",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value: "FieldValueText",
                                      },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          alias: {
                                            kind: "Name",
                                            value: "textValue",
                                          },
                                          name: {
                                            kind: "Name",
                                            value: "value",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value: "FieldValueNumber",
                                      },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          alias: {
                                            kind: "Name",
                                            value: "numberValue",
                                          },
                                          name: {
                                            kind: "Name",
                                            value: "value",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value: "FieldValueBoolean",
                                      },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          alias: {
                                            kind: "Name",
                                            value: "booleanValue",
                                          },
                                          name: {
                                            kind: "Name",
                                            value: "value",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value: "FieldValueEnum",
                                      },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          alias: {
                                            kind: "Name",
                                            value: "enumValue",
                                          },
                                          name: {
                                            kind: "Name",
                                            value: "value",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "fieldEnumOptionId",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value: "FieldValueDatetime",
                                      },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          alias: {
                                            kind: "Name",
                                            value: "datetimeValue",
                                          },
                                          name: {
                                            kind: "Name",
                                            value: "value",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "errors" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Field" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Field" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "valueType" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "enumOptions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "value" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "position" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "availableInProperty" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "availableInApartment" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "availableInTenancy" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "availableInService" },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PropertyUpdateMutation,
  PropertyUpdateMutationVariables
>;
export const ApartmentUpdateDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "ApartmentUpdate" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "apartmentId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "fields" },
          },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: {
                kind: "NamedType",
                name: { kind: "Name", value: "FieldValueInput" },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "apartmentUpdate" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "apartmentId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "apartmentId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "fields" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "fields" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "apartment" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "fieldGroups" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "position" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "values" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "field" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "FragmentSpread",
                                          name: {
                                            kind: "Name",
                                            value: "Field",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value: "FieldValueText",
                                      },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          alias: {
                                            kind: "Name",
                                            value: "textValue",
                                          },
                                          name: {
                                            kind: "Name",
                                            value: "value",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value: "FieldValueNumber",
                                      },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          alias: {
                                            kind: "Name",
                                            value: "numberValue",
                                          },
                                          name: {
                                            kind: "Name",
                                            value: "value",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value: "FieldValueBoolean",
                                      },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          alias: {
                                            kind: "Name",
                                            value: "booleanValue",
                                          },
                                          name: {
                                            kind: "Name",
                                            value: "value",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value: "FieldValueEnum",
                                      },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          alias: {
                                            kind: "Name",
                                            value: "enumValue",
                                          },
                                          name: {
                                            kind: "Name",
                                            value: "value",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "fieldEnumOptionId",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value: "FieldValueDatetime",
                                      },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          alias: {
                                            kind: "Name",
                                            value: "datetimeValue",
                                          },
                                          name: {
                                            kind: "Name",
                                            value: "value",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "errors" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Field" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Field" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "valueType" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "enumOptions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "value" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "position" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "availableInProperty" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "availableInApartment" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "availableInTenancy" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "availableInService" },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ApartmentUpdateMutation,
  ApartmentUpdateMutationVariables
>;
export const TenancyUpdateDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "TenancyUpdate" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "tenancyId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "fields" },
          },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: {
                kind: "NamedType",
                name: { kind: "Name", value: "FieldValueInput" },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "tenancyUpdate" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "tenancyId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "tenancyId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "fields" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "fields" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "tenancy" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "fieldGroups" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "position" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "values" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "field" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "FragmentSpread",
                                          name: {
                                            kind: "Name",
                                            value: "Field",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value: "FieldValueText",
                                      },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          alias: {
                                            kind: "Name",
                                            value: "textValue",
                                          },
                                          name: {
                                            kind: "Name",
                                            value: "value",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value: "FieldValueNumber",
                                      },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          alias: {
                                            kind: "Name",
                                            value: "numberValue",
                                          },
                                          name: {
                                            kind: "Name",
                                            value: "value",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value: "FieldValueBoolean",
                                      },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          alias: {
                                            kind: "Name",
                                            value: "booleanValue",
                                          },
                                          name: {
                                            kind: "Name",
                                            value: "value",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value: "FieldValueEnum",
                                      },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          alias: {
                                            kind: "Name",
                                            value: "enumValue",
                                          },
                                          name: {
                                            kind: "Name",
                                            value: "value",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "fieldEnumOptionId",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value: "FieldValueDatetime",
                                      },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          alias: {
                                            kind: "Name",
                                            value: "datetimeValue",
                                          },
                                          name: {
                                            kind: "Name",
                                            value: "value",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "errors" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Field" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Field" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "valueType" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "enumOptions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "value" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "position" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "availableInProperty" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "availableInApartment" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "availableInTenancy" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "availableInService" },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  TenancyUpdateMutation,
  TenancyUpdateMutationVariables
>;
export const ApartmentInheritedFieldsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "ApartmentInheritedFields" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "apartmentId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "apartment" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "apartmentId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "property" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "PropertyFieldGroups" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Field" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Field" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "valueType" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "enumOptions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "value" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "position" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "availableInProperty" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "availableInApartment" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "availableInTenancy" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "availableInService" },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PropertyFieldGroups" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Property" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "fieldGroups" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "position" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "values" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "field" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "Field" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "FieldValueText" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              alias: { kind: "Name", value: "textValue" },
                              name: { kind: "Name", value: "value" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "FieldValueNumber" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              alias: { kind: "Name", value: "numberValue" },
                              name: { kind: "Name", value: "value" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "FieldValueBoolean" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              alias: { kind: "Name", value: "booleanValue" },
                              name: { kind: "Name", value: "value" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "FieldValueEnum" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              alias: { kind: "Name", value: "enumValue" },
                              name: { kind: "Name", value: "value" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "fieldEnumOptionId",
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "FieldValueDatetime" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              alias: { kind: "Name", value: "datetimeValue" },
                              name: { kind: "Name", value: "value" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ApartmentInheritedFieldsQuery,
  ApartmentInheritedFieldsQueryVariables
>;
export const TenancyInheritedFieldsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "TenancyInheritedFields" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "apartmentId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "apartment" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "apartmentId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ApartmentFieldGroups" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "property" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "PropertyFieldGroups" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Field" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Field" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "valueType" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "enumOptions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "value" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "position" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "availableInProperty" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "availableInApartment" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "availableInTenancy" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "availableInService" },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ApartmentFieldGroups" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Apartment" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "fieldGroups" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "position" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "values" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "field" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "Field" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "FieldValueText" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              alias: { kind: "Name", value: "textValue" },
                              name: { kind: "Name", value: "value" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "FieldValueNumber" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              alias: { kind: "Name", value: "numberValue" },
                              name: { kind: "Name", value: "value" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "FieldValueBoolean" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              alias: { kind: "Name", value: "booleanValue" },
                              name: { kind: "Name", value: "value" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "FieldValueEnum" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              alias: { kind: "Name", value: "enumValue" },
                              name: { kind: "Name", value: "value" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "fieldEnumOptionId",
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "FieldValueDatetime" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              alias: { kind: "Name", value: "datetimeValue" },
                              name: { kind: "Name", value: "value" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PropertyFieldGroups" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Property" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "fieldGroups" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "position" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "values" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "field" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "Field" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "FieldValueText" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              alias: { kind: "Name", value: "textValue" },
                              name: { kind: "Name", value: "value" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "FieldValueNumber" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              alias: { kind: "Name", value: "numberValue" },
                              name: { kind: "Name", value: "value" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "FieldValueBoolean" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              alias: { kind: "Name", value: "booleanValue" },
                              name: { kind: "Name", value: "value" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "FieldValueEnum" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              alias: { kind: "Name", value: "enumValue" },
                              name: { kind: "Name", value: "value" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "fieldEnumOptionId",
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "FieldValueDatetime" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              alias: { kind: "Name", value: "datetimeValue" },
                              name: { kind: "Name", value: "value" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  TenancyInheritedFieldsQuery,
  TenancyInheritedFieldsQueryVariables
>;
export const CurrentUserDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "CurrentUser" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "currentUser" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "CurrentUserFragment" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CurrentUserFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "isSystemAdministrator" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "isServiceAdministrator" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "isServiceCaseWorker" },
          },
          { kind: "Field", name: { kind: "Name", value: "isAdministrator" } },
          { kind: "Field", name: { kind: "Name", value: "locale" } },
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CurrentUserQuery, CurrentUserQueryVariables>;
export const ShortcutDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "Shortcut" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "shortcutId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "currentUser" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "shortcut" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "shortcutId" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "shortcutId" },
                      },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "ShortcutFragment" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ShortcutFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Shortcut" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "state" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ShortcutQuery, ShortcutQueryVariables>;
